(() => {
const $a1bb008553eac0d1$var$tagName = "hero-button";
var $a1bb008553eac0d1$var$css = /*css*/ `
    ${$a1bb008553eac0d1$var$tagName} {
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--light-blue-gradient);
        border-radius: 10px;
        color: white;
        width: fit-content;
    }
    ${$a1bb008553eac0d1$var$tagName}[no-border] {
        padding: 0px;
    }
    ${$a1bb008553eac0d1$var$tagName}[use-shadow] {
        box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
    }
    ${$a1bb008553eac0d1$var$tagName} .inner {
        padding: 0.9em 1.8em;
        background: var(--gray-brand-gradient);
        border-radius: 5px;
        transition: 200ms;
    }
    body.has-hover a:hover ${$a1bb008553eac0d1$var$tagName} .inner {
        opacity: 0.95;
    }
    ${$a1bb008553eac0d1$var$tagName} .text {
        display: block;
        font-family: 'inter-medium', 'sans-serif';
        text-align: center;
        transition: 200ms;
    }
    ${$a1bb008553eac0d1$var$tagName} .text span {
        border-bottom: 2px solid var(--blue-brand);
    }
    body.has-hover a:hover ${$a1bb008553eac0d1$var$tagName} .text {
        transform: translateY(-0.05em);
        color: rgb(148, 231, 243);
    }
    body.has-hover a:hover ${$a1bb008553eac0d1$var$tagName} .text span{
        color: rgb(148, 231, 243);
    }
    body.has-hover a:hover ${$a1bb008553eac0d1$var$tagName} .text span {
        border-bottom: 2px solid rgb(148, 231, 243);
    }
`;
const $a1bb008553eac0d1$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="inner">
            <span class="text">${options.text}</span>
        </div>
        <style>${$a1bb008553eac0d1$var$css}</style>
    `;
};
class $a1bb008553eac0d1$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $a1bb008553eac0d1$var$renderInnerHTML(this.options);
        if (this.options.noBorder) this.setAttribute("no-border", "");
        if (this.options.shadow) this.setAttribute("use-shadow", "");
        this.removeAttribute("element-options");
    // setTimeout(()=>{
    //     this.setAttribute('delayed-style', true);
    // }, 1);
    }
}
customElements.define($a1bb008553eac0d1$var$tagName, $a1bb008553eac0d1$var$CustomElem);
function $a1bb008553eac0d1$var$render(text, options) {
    var useOptions = {
        text: text
    };
    if (options) Object.keys(options).forEach((optionKey)=>{
        useOptions[optionKey] = options[optionKey];
    });
    var e = window.encodeURIComponent;
    return `<${$a1bb008553eac0d1$var$tagName} element-options="${e(JSON.stringify(useOptions))}"></${$a1bb008553eac0d1$var$tagName}>`;
}
var $a1bb008553eac0d1$export$2e2bcd8739ae039 = $a1bb008553eac0d1$var$render;


function $12dc7fa94ad8b497$var$checkIsFriendCode(code) {
    var validChars = "ABCDEFGHKLMNPQRSTUVWXYZ";
    if (typeof code != "string") return false;
    if (code.length != 6) return false;
    for(let i = 0; i < code.length; i++){
        if (!validChars.includes(code[i].toUpperCase())) return false;
    }
    return true;
}
function $12dc7fa94ad8b497$var$getLocalCookieValue(cookieName) {
    try {
        return document.cookie.split("; ").filter((cookie)=>cookie.startsWith(`${cookieName}=`))[0].split("=")[1];
    } catch (e) {
        return null;
    }
}
function $12dc7fa94ad8b497$var$getFbxData() {
    var fbpValue = $12dc7fa94ad8b497$var$getLocalCookieValue("_fbp");
    var fbcValue = $12dc7fa94ad8b497$var$getLocalCookieValue("_fbc");
    var res = {};
    if (fbpValue) res.fbp = fbpValue;
    if (fbcValue) res.fbc = fbcValue;
    else {
        var queryStr = location.search;
        if (queryStr) {
            queryStr = queryStr.slice(1);
            var params = queryStr.split("&");
            var fbcParam = params.filter((param)=>param.startsWith("fbclid="))[0];
            if (fbcParam) {
                var fbcParamValue = fbcParam.split("=")[1];
                var fbcCookieValue = `fb.1.${new Date().getTime()}.${fbcParamValue}`;
                res.fbc = fbcCookieValue;
            }
        }
    }
    return res;
}
function $12dc7fa94ad8b497$var$store(options = null) {
    try {
        var qString = location.href.split("?")[1];
        var res = {};
        if (qString) {
            var params = qString.split("&");
            params.forEach((param)=>{
                if (param.includes("utm_source")) res.utm_source = param.split("=")[1];
                if (param.includes("utm_medium")) res.utm_medium = param.split("=")[1];
                if (param.includes("utm_campaign")) res.utm_campaign = param.split("=")[1];
                if (param.includes("utm_content")) res.utm_content = param.split("=")[1];
                if (param.includes("fc")) {
                    var value = param.split("=")[1];
                    if ($12dc7fa94ad8b497$var$checkIsFriendCode(value)) res.fc = value;
                }
            });
        }
        if (options) {
            if (options.meinnowCourseData) {
                if (options.meinnowCourseData.id) res.meinnow_course_id = options.meinnowCourseData.id;
                if (options.meinnowCourseData.type) res.meinnow_course_type = options.meinnowCourseData.type;
                if (options.meinnowCourseData.duration) res.meinnow_course_duration = options.meinnowCourseData.duration;
            }
            if (options.blogData) {
                if (options.blogData.id) res.website_blog_id = options.blogData.id;
                if (options.blogData.slug) res.website_blog_slug = options.blogData.slug;
            }
        }
        var fbxData = $12dc7fa94ad8b497$var$getFbxData();
        if (fbxData.fbp) res.fbx_p = fbxData.fbp;
        if (fbxData.fbc) res.fbx_c = fbxData.fbc;
        if (Object.keys(res).length == 0) return;
        var resString = btoa(btoa(JSON.stringify(res)));
        sessionStorage.setItem("utm_carry", resString);
    } catch (e) {
        console.log("err @ utm-carry: " + e);
    }
}
function $12dc7fa94ad8b497$var$load(prefix = "") {
    var res = "";
    var defaultUTMSource = "website-cta";
    try {
        var utmString = atob(atob(sessionStorage.getItem("utm_carry")));
        var utmObject = JSON.parse(utmString);
        if (!utmObject.utm_source) utmObject.utm_source = defaultUTMSource;
        else utmObject.utm_source = `${defaultUTMSource}__${utmObject.utm_source}`;
        var hashedParamNames = [
            "fc",
            "meinnow_course_id",
            "meinnow_course_type",
            "meinnow_course_duration",
            "fbx_p",
            "fbx_c",
            "website_blog_id",
            "website_blog_slug"
        ];
        var queryString = "";
        var hashString = "";
        Object.keys(utmObject).forEach((key)=>{
            if (!hashedParamNames.includes(key)) queryString += `${key}=${utmObject[key]}&`;
            else {
                var renamedKey = "" + key;
                if (key == "fc") var renamedKey = "friend_code";
                hashString += `${renamedKey}=${utmObject[key]}&`;
            }
        });
        if (queryString.slice(-1) == "&") queryString = queryString.slice(0, -1);
        if (hashString.slice(-1) == "&") hashString = hashString.slice(0, -1);
        res = prefix + queryString;
        if (hashString.length > 0) res += "#" + hashString;
        return res;
    } catch (err) {
        res = prefix + "utm_source=" + defaultUTMSource;
        return res;
    }
}
function $12dc7fa94ad8b497$var$getSession() {
    var isNew = false;
    var sID = sessionStorage.getItem("fias_sid");
    if (!sID) {
        isNew = true;
        var sID = crypto.randomUUID();
        sessionStorage.setItem("fias_sid", sID);
    }
    return {
        isNew: isNew,
        id: sID
    };
}
var $12dc7fa94ad8b497$export$2e2bcd8739ae039 = {
    store: $12dc7fa94ad8b497$var$store,
    load: $12dc7fa94ad8b497$var$load,
    getSession: $12dc7fa94ad8b497$var$getSession
};


window.eventBus = {};
eventBus.eventID = 0;
eventBus.events = {};
eventBus.register = (eventName, callBack)=>{
    eventBus.eventID++;
    eventBus.events[eventName] = eventBus.events[eventName] || [];
    var event = {
        id: eventBus.eventID,
        callBack: callBack,
        unregister: ()=>{
            eventBus.unregister(event.id);
        }
    };
    eventBus.events[eventName].push(event);
    return event;
};
eventBus.unregister = (eventID)=>{
    var eventNames = Object.keys(eventBus.events);
    var done = false;
    for(let i = 0; i < eventNames.length; i++){
        var eventName = eventNames[i];
        var events = eventBus.events[eventName];
        for(let j = 0; j < events.length; j++){
            var event = events[j];
            if (event.id == eventID) {
                var newEvents = [];
                for(let k = 0; k < events.length; k++)if (k != j) newEvents.push(events[k]);
                eventBus.events[eventName] = newEvents;
                done = true;
                break;
            }
        }
        if (done) break;
    }
};
eventBus.emit = (eventName, options = {})=>{
    var events = eventBus.events[eventName];
    if (!events) return;
    events.forEach((event)=>{
        event.callBack(options);
    });
};
var $1dad5be70658baa7$export$2e2bcd8739ae039 = eventBus;



function $a86ef8241d5e4abb$var$collect() {
    var res = {};
    res.url = location.href;
    res.ua = navigator.userAgent;
    res.path = location.pathname;
    res.query = location.search;
    res.referrer = document.referrer;
    res.screen = `${screen.width}x${screen.height}`;
    return res;
}
function $a86ef8241d5e4abb$var$send(sessionID) {
    var data = $a86ef8241d5e4abb$var$collect();
    data.sessionID = sessionID;
    var keyNames = {
        "166289319": "sessionID",
        "602384603": "url",
        "1915151226": "ua",
        "2000770061": "path",
        "694532345": "query",
        "1024801784": "referrer",
        "2001789906": "screen"
    };
    var sendData = {};
    Object.keys(keyNames).forEach((fieldID)=>{
        var key = keyNames[fieldID];
        sendData[fieldID] = data[key];
    });
    var body = "";
    Object.keys(sendData).forEach((fieldID)=>{
        var str = `entry.${fieldID}=${encodeURIComponent(sendData[fieldID])}&`;
        body += str;
    });
    body = body.slice(0, -1);
    var url = atob("aHR0cHM6Ly9kb2NzLmdvb2dsZS5jb20vZm9ybXMvZC9lLzFGQUlwUUxTZkFrRDBqZGgwalRHMmExRmxIaVo5OFU5SVNaS0twZEhHTGt2QXhvWHM1anQtemNBL2Zvcm1SZXNwb25zZQ==");
    fetch(url, {
        method: "POST",
        mode: "no-cors",
        body: body,
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    });
}
var $a86ef8241d5e4abb$export$2e2bcd8739ae039 = {
    send: $a86ef8241d5e4abb$var$send
};


(0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).store();
function $d168884506ac480e$var$setConfig() {
    window.config = {
        nextStartDate: null,
        ctaURLS: {
            main: "https://franklin-institute.typeform.com/website-leads" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            pm: "https://franklin-institute.typeform.com/pm-neu" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            sales: "https://franklin-institute.typeform.com/sales-neu" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            kontakt: "https://franklin-institute.typeform.com/to/Bl0H8zlO" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            quiz: "https://franklin-institute.typeform.com/to/E64yV8rs?utm_source=quiz" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            eignungstest: "https://franklin-institute.typeform.com/to/XBvzbkK2" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            eignungstestsales: "https://franklin-institute.typeform.com/to/koweMDcf" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            eignungstestweiterbildungen: "https://franklin-institute.typeform.com/to/ZZaj5y7J" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?"),
            franklinfriends: "https://franklin-institute.typeform.com/to/d6yxruYw" + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?")
        },
        courseData: {
            pm: {
                name: "IT-Berater im Produktmanagement",
                duration: 10,
                minCertCount: 8,
                nextStartDate: "2025-08-28",
                kursnetID: 305415456
            },
            sales: {
                name: "IT-Vertriebsmanager & CRM Spezialist",
                duration: 8,
                minCertCount: 6,
                nextStartDate: "2025-07-14",
                kursnetID: 305415469
            }
        }
    };
}
function $d168884506ac480e$var$setNextGlobalStartDate() {
    var courseSlugs = Object.keys(window.config.courseData);
    var closestDate = null;
    courseSlugs.forEach((slug)=>{
        if (!closestDate) closestDate = window.config.courseData[slug].nextStartDate;
        else if (new Date(window.config.courseData[slug].nextStartDate) < new Date(closestDate)) closestDate = window.config.courseData[slug].nextStartDate;
    });
    window.config.nextStartDate = closestDate;
}
function $d168884506ac480e$var$triggerBeacon() {
    var session = (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).getSession();
    if (session.isNew) (0, $a86ef8241d5e4abb$export$2e2bcd8739ae039).send(session.id);
}
window.getAppConfig = ()=>{
    $d168884506ac480e$var$setNextGlobalStartDate();
    return window.config;
};
window.addEventListener("reset-app-config", $d168884506ac480e$var$setConfig);
$d168884506ac480e$var$setConfig();
$d168884506ac480e$var$setNextGlobalStartDate();
$d168884506ac480e$var$triggerBeacon();


const $467c7a41cb5241d2$var$tagName = "main-menu";
var $467c7a41cb5241d2$var$css = /*css*/ `
${$467c7a41cb5241d2$var$tagName} .nav-bar-cont {
    width: 100%;
    font-size: 18px;
    position: fixed;
    top: 0;
    background: #ffffff;
    z-index: 5;
    transition: 200ms;
    box-shadow: none; /* No shadow initially */
}

/* Shadow class that will be added on scroll */
${$467c7a41cb5241d2$var$tagName} .nav-bar-cont.has-shadow {
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1); /* Shadow added on scroll */
}

    ${$467c7a41cb5241d2$var$tagName} .menu-label {
        font-family: 'inter-medium', 'sans-serif';
        font-size: 14px; 
        text-align: center;
        color: black; 
        margin-right: -1px;
        margin-top: -8px;
    }

    body.has-hover ${$467c7a41cb5241d2$var$tagName} .menu-link.menu-desktop.kurs-dropdown {
        margin-right: 15px; 
    }
    
    ${$467c7a41cb5241d2$var$tagName} .announcement-cont {
        display: none;
        background: var(--light-blue-gradient);
        justify-content: center;
        align-items: center;
        padding: 10px 0px;
        box-sizing: border-box;
        font-family: 'inter-medium';
        font-size: 1.1em;
    }
    @media (max-width: 439px) {
        ${$467c7a41cb5241d2$var$tagName} .announcement-cont {
            font-size: 1em;
        }
    }
    @media (max-width: 369px) {
        ${$467c7a41cb5241d2$var$tagName} .announcement-cont {
            font-size: 0.9em;
        }
    }
    ${$467c7a41cb5241d2$var$tagName} .announcement-cont:before {
        content: '';
        display: flex;
        width: 40px;
        height: 25px;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/assets/images/calendar-gray.svg');
    }
    ${$467c7a41cb5241d2$var$tagName} .announcement-cont[data-visible="true"] {
        display: flex;
    }
    ${$467c7a41cb5241d2$var$tagName} .main-cont {
        display: flex;
        justify-content: space-between;
        height: 100px;
        align-items: center;
        padding: 0px 18px;
        max-width: 1920px;
        margin: 0 auto;
    }
    ${$467c7a41cb5241d2$var$tagName} .button-cont {
        display: flex;
        gap: 40px;
        align-items: center;
        position: relative;
    }
    ${$467c7a41cb5241d2$var$tagName} .main-logo {
        height: 60px;
        aspect-ratio: 255/79;
        background-image: url('/assets/images/fias-logo-new.svg');
    }
    body.has-hover ${$467c7a41cb5241d2$var$tagName} .menu-link {
        transition: 200ms;
        font-family: 'inter-medium', 'sans-serif';
        font-size: 1em;
        cursor: pointer;
        position: relative;
    }
    body.has-hover ${$467c7a41cb5241d2$var$tagName} .menu-link:hover {
        color: var(--blue-brand);
    }
    /* Down arrow only for "Unsere Kurse" */
    body.has-hover ${$467c7a41cb5241d2$var$tagName} .menu-link.menu-desktop.kurs-dropdown::after {
        content: '\u{25BC}';
        font-size: 0.7em;
        position: absolute;
        right: -17px;
        top: 11px;
        transform: translateY(-50%);
        color: var(--gray-brand);
        transition: 200ms;
    }
    body.has-hover ${$467c7a41cb5241d2$var$tagName} .menu-link.menu-desktop.kurs-dropdown:hover::after {
        color: var(--blue-brand);
    }

    /* Dropdown menu styling with smoother corners */
    ${$467c7a41cb5241d2$var$tagName} .dropdown-menu {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        background-color: #ffffff; /* Background white */
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
        z-index: 10;
        flex-direction: column;
        padding: 10px 0;
        min-width: 200px;
        border-radius: 8px; /* Added border-radius for smoother corners */
    }
    ${$467c7a41cb5241d2$var$tagName} .dropdown-menu a {
        padding: 12px 16px;
        text-decoration: none;
        display: block;
        font-size: 0.9em;
        color: black;
        transition: color 200ms;
    }
    ${$467c7a41cb5241d2$var$tagName} .dropdown-menu a:hover {
        background-color: var(--light-blue-gradient);
        color: var(--blue-brand); /* Change text color on hover */
    }
    
    ${$467c7a41cb5241d2$var$tagName} .menu-link.kurs-dropdown:hover .dropdown-menu {
        display: flex;
    }
    
    /* Mobile-specific styles */
    @media (min-width: 1150px) {
        ${$467c7a41cb5241d2$var$tagName} .menu-mobile {
            display: none !important;
        }
    }
    @media (max-width: 1149px) {
        ${$467c7a41cb5241d2$var$tagName} .menu-desktop {
            display: none !important;
        }
    }
    ${$467c7a41cb5241d2$var$tagName} .menu-mobile-btn {
        position: relative;
        display: flex;
        width: 60px;
        height: 50px;
        flex-direction: column;
        cursor: pointer;
        transition: 200ms;
    }
    ${$467c7a41cb5241d2$var$tagName} .mobile-menu-cont {
        position: fixed;
        inset: 0;
        pointer-events: none;
        opacity: 0;
        z-index: 2;
        transition: opacity 0.3s;
        padding-top: var(--nav-menu-height);
        background: var(--gray-brand-gradient);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 1.5em;
        font-family: 'inter-medium';
        color: white;
    }
    ${$467c7a41cb5241d2$var$tagName}[data-mobile-menu-active="true"] .mobile-menu-cont {
        pointer-events: initial;
        opacity: 1;
    }
    ${$467c7a41cb5241d2$var$tagName} .mobile-menu-links {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.75em;
        padding: 0.75em 0.75em;
    }
    ${$467c7a41cb5241d2$var$tagName} .mobile-menu-links a {
        width: fit-content;
        border-bottom: 4px solid var(--blue-brand);
    }

    ${$467c7a41cb5241d2$var$tagName} .mobile-menu-cta {
        background-color: var(--blue-brand); 
        font-family: 'inter-bold', sans-serif;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.75em 2em; 
        text-decoration: none;
        cursor: pointer;
        color: white; 
        border: none;
        border-radius: 25px; /* Adjust this value for more or less rounding */
        text-decoration: underline;
        text-decoration-thickness: 4px;
        text-underline-offset: 5px;
        position: relative;
        top: -20px; 
        margin: 0 auto; 

    }

    ${$467c7a41cb5241d2$var$tagName} .dropdown-icon {
        font-size: 0.8em;
        padding-left: 10px;
        transition: transform 0.3s;
    }

    /* Mobile dropdown for "Unsere Kurse" */
    ${$467c7a41cb5241d2$var$tagName} .kurs-dropdown-mobile {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        width: fit-content;
    }


    ${$467c7a41cb5241d2$var$tagName} .dropdown-menu-mobile a::before {
        content: '\u25B6'; /* Unicode for right arrow */
        display: inline-block;
        margin-right: 10px;
        color: var(--blue-brand); /* Arrow color */
        font-size: 0.8em; /* Adjust font size if needed */
    }
    
    ${$467c7a41cb5241d2$var$tagName} .dropdown-menu-mobile {
        display: none;
        flex-direction: column;
        padding-left: 30px;
        border-bottom: none;
        font-size: 16px;

    }

    ${$467c7a41cb5241d2$var$tagName} .underline {
        border-bottom: 4px solid var(--blue-brand); /* Blue underline */
    }
    
    ${$467c7a41cb5241d2$var$tagName} .dropdown-menu-mobile a {
        padding: 5px 0;
        border-bottom: none;

    }

    ${$467c7a41cb5241d2$var$tagName}[data-mobile-dropdown-open="true"] .dropdown-menu-mobile {
        display: flex;
    }

    ${$467c7a41cb5241d2$var$tagName}[data-mobile-dropdown-open="true"] .dropdown-icon {
        transform: rotate(180deg);
        padding-right: 10px;
    }
    
    ${$467c7a41cb5241d2$var$tagName} .nav-bar-right-mobile-layer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url('/assets/images/burger-menu-icon-layer.svg');
        background-size: 200% 200%;
        background-position: 50% 50%;
        transition: transform 0.2s;
        margin-top: 7px;
    }
    
    ${$467c7a41cb5241d2$var$tagName} .nav-bar-right-mobile-layer#nav-l1 {
        transform: translateY(6px);
    }
    
    ${$467c7a41cb5241d2$var$tagName} .nav-bar-right-mobile-layer#nav-l2 {
        background-image: url('/assets/images/burger-menu-icon-layer-white.svg');
    }
    
    ${$467c7a41cb5241d2$var$tagName} .nav-bar-right-mobile-layer#nav-l3 {
        transform: translateY(-6px);
        background-image: url('/assets/images/burger-menu-icon-layer-blue.svg');
    }

    ${$467c7a41cb5241d2$var$tagName}[data-mobile-menu-active="true"] .menu-label{
        transform: translateY(-8px);

    }

    ${$467c7a41cb5241d2$var$tagName}[data-mobile-menu-active="true"] .nav-bar-right-mobile-layer#nav-l1 {
        transform: translateY(12px);
    }
    
    ${$467c7a41cb5241d2$var$tagName}[data-mobile-menu-active="true"] .nav-bar-right-mobile-layer#nav-l3 {
        transform: translateY(-12px);
    }
`;
const $467c7a41cb5241d2$var$renderTemplate = (announcement)=>{
    return /*html*/ `
        <div class="nav-bar-cont">
            <div class="announcement-cont" data-visible="${announcement ? true : false}">${announcement || ""}</div>
            <div class="main-cont">
                <a internal href="/" class="main-logo bg-img-contain" aria-label="Startseite"></a>
                <div class="button-cont">
                    <div class="menu-link menu-desktop kurs-dropdown">
                        Unsere Kurse
                        <div class="dropdown-menu">
                            <a internal href="/courses/pm">IT-Berater im Produktmanagement</a>
                            <a internal href="/courses/sales">IT-Vertriebsmanager & CRM Spezialist</a>
                        </div>
                    </div>
                    <a class="menu-link menu-desktop" internal href="/about">\xdcber Uns</a>
                    <a class="menu-link menu-desktop" internal href="/blog">Blog</a>
                    <a class="menu-link menu-desktop" internal href="/vermittler">F\xfcr Vermittler</a>
                    <a class="menu-link menu-desktop" internal href="/franklin-friends">Franklin Friends</a>
                    <a class="menu-link menu-desktop" internal href="/#faq">H\xe4ufige Fragen</a>
                    <a cta-prevent-inner-hover target="_blank" href="${config.ctaURLS.main}" class="menu-desktop is-cta">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Jetzt bewerben</span>`)}</a>
                    <div class="menu-mobile-btn menu-mobile">
                    <div class="menu-label">Men\xfc</div>
                        <div class="nav-bar-right-mobile-layer" id="nav-l1"></div>
                        <div class="nav-bar-right-mobile-layer" id="nav-l2"></div>
                        <div class="nav-bar-right-mobile-layer" id="nav-l3"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-menu-cont">
            <div class="mobile-menu-links">
                <div class="menu-link-mobile kurs-dropdown-mobile">
                    <span class="underline">Unsere Kurse</span>
                    <div class="dropdown-icon">\u{25BC}</div>
                </div>
                <div class="dropdown-menu-mobile">
                    <a internal href="/courses/pm">IT-Berater im Produktmanagement</a>
                    <a internal href="/courses/sales">IT-Vertriebsmanager & CRM Spezialist</a>
                </div>
                <a class="menu-link-mobile" internal href="/about"><span class="underline">\xdcber Uns</span></a>
                <a class="menu-link-mobile" internal href="/blog"><span class="underline">Blog</span></a>
                <a class="menu-link-mobile" internal href="/vermittler"><span class="underline">F\xfcr Vermittler</span></a>
                <a class="menu-link-mobile" internal href="/franklin-friends"><span class="underline">Franklin Friends</span></a>
                <a class="menu-link-mobile" internal href="/#faq"><span class="underline">H\xe4ufige Fragen</span></a> 
            </div>
            <a target="_blank" href="${config.ctaURLS.main}" class="mobile-menu-cta is-cta">Jetzt Bewerben</a>
        </div>
        <style>${$467c7a41cb5241d2$var$css}</style>
    `;
};
class $467c7a41cb5241d2$var$MainMenu extends HTMLElement {
    constructor(options){
        super();
        this.isHidden = false;
        this.mobileDropdownOpen = false; // Track the dropdown state
    }
    connectedCallback() {
        try {
            this.options = JSON.parse(atob(this.getAttribute("element-options")));
        } catch (e) {
            this.options = {};
        }
        this.removeAttribute("element-options");
        this.innerHTML = $467c7a41cb5241d2$var$renderTemplate(this.options);
        this.updateCTAs();
        this.updateStartDate();
        this.navBarElem = this.querySelector(".nav-bar-cont");
        this.navBarHeight = this.navBarElem.getBoundingClientRect().height;
        this.navBarElem.setAttribute("data-height", this.navBarHeight);
        document.documentElement.style.setProperty("--nav-menu-height", `${this.navBarHeight}px`);
        var lastScroll = window.scrollY;
        // Add a scroll event listener to toggle the shadow
        window.addEventListener("scroll", ()=>{
            if (window.scrollY > 0) this.navBarElem.classList.add("has-shadow");
            else this.navBarElem.classList.remove("has-shadow");
            if (window.scrollY > lastScroll) this.hide();
            else if (window.scrollY < lastScroll) this.show();
            lastScroll = window.scrollY;
        }, {
            passive: true
        });
        this.mobileMenuBtn = this.querySelector(".menu-mobile-btn");
        this.mobileMenuActive = false;
        this.setAttribute("data-mobile-menu-active", this.mobileMenuActive);
        this.mobileMenuBtn.onclick = ()=>{
            this.handleMobileMenuBtnClick();
        };
        this.initMobileMenuAutoHide();
        this.initMobileDropdownToggle(); // Initialize dropdown toggle
        this.navigationEvent = eventBus.register("navigation", ()=>{
            this.updateCTAs();
            this.updateStartDate();
        // this.setCourseDropDownsVisibility(true);
        });
        this.addEventListener("dynamicCourseType", (e)=>{
            var courseType = e.detail;
            this.updateStartDate(courseType);
            this.updateCTAs(courseType);
        // this.setCourseDropDownsVisibility(false);
        });
        console.warn("NEED TO CHECK THIS @main-menu 418");
        this.addEventListener("update-main-menu", (e)=>{
            this.updateStartDate();
            this.updateCTAs();
        // this.setCourseDropDownsVisibility(false);
        });
    }
    disconnectedCallback() {
        this.navigationEvent.unregister();
    }
    handleMobileMenuBtnClick() {
        this.mobileMenuActive = !this.mobileMenuActive;
        if (this.mobileMenuActive) document.documentElement.classList.add("no-scroll");
        else document.documentElement.classList.remove("no-scroll");
        this.setAttribute("data-mobile-menu-active", this.mobileMenuActive);
    }
    initMobileMenuAutoHide() {
        var linkElems = Array.from(this.querySelectorAll("a"));
        linkElems.forEach((linkElem)=>{
            linkElem.onclick = ()=>{
                this.mobileMenuActive = true;
                this.handleMobileMenuBtnClick();
            };
        });
    }
    initMobileDropdownToggle() {
        const kursDropdown = this.querySelector(".kurs-dropdown-mobile");
        kursDropdown.addEventListener("click", ()=>{
            this.mobileDropdownOpen = !this.mobileDropdownOpen;
            this.setAttribute("data-mobile-dropdown-open", this.mobileDropdownOpen);
        });
    }
    hide() {
        if (this.isHidden || this.mobileMenuActive) return;
        var height = this.navBarElem.getBoundingClientRect().height;
        if (window.scrollY <= height) return;
        this.isHidden = true;
        this.navBarElem.style.transform = `translateY(-${height}px)`;
    }
    show() {
        if (!this.isHidden) return;
        this.isHidden = false;
        this.navBarElem.style.transform = `translateY(0px)`;
    }
    updateCTAs(inputCourseType = null) {
        var overrideCTAPaths = {
            "/courses/pm": "pm",
            "/courses/sales": "sales"
        };
        var loc = location.pathname;
        var overrideHrefKey = overrideCTAPaths[loc];
        if (inputCourseType) overrideHrefKey = inputCourseType;
        if (!overrideHrefKey) overrideHrefKey = "main";
        var ctaHref = config.ctaURLS[overrideHrefKey].split("?")[0] + (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?");
        var CTAs = Array.from(this.querySelectorAll("a.is-cta"));
        CTAs.forEach((cta)=>{
            cta.href = ctaHref;
        });
    }
    setCourseDropDownsVisibility(visible) {
        Array.from(this.querySelectorAll(".kurs-dropdown-mobile,.kurs-dropdown")).forEach((elem)=>{
            if (visible) elem.style.display = "block";
            else elem.style.display = "none";
        });
    }
    updateStartDate(inputCourseType = null) {
        var overrideCTAPaths = {
            "/courses/pm": "pm",
            "/courses/sales": "sales"
        };
        var loc = location.pathname;
        var slug = overrideCTAPaths[loc];
        if (inputCourseType) slug = inputCourseType;
        if (!slug) slug = "main";
        var startDate = "";
        var config1 = window.getAppConfig();
        if (slug == "main") startDate = config1.nextStartDate;
        else startDate = config1.courseData[slug].nextStartDate;
        var startDateFormatted = util.formatDate(startDate);
        this.querySelector(".announcement-cont").innerText = `N\xe4chster Starttermin: ${startDateFormatted}`;
    }
}
customElements.define($467c7a41cb5241d2$var$tagName, $467c7a41cb5241d2$var$MainMenu);
function $467c7a41cb5241d2$var$render(options) {
    return `<${$467c7a41cb5241d2$var$tagName} element-options="${btoa(JSON.stringify(options))}"></${$467c7a41cb5241d2$var$tagName}>`;
}
var $467c7a41cb5241d2$export$2e2bcd8739ae039 = $467c7a41cb5241d2$var$render;


const $5efcc9e2a786d9af$var$tagName = "feature-card";
var $5efcc9e2a786d9af$var$css = /*css*/ `
    ${$5efcc9e2a786d9af$var$tagName} {
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 5px;
        padding: 15px 20px;
        background: rgba(242, 246, 247, 0.8);
        opacity: 1;
        color: rgb(70, 70, 70);
        cursor: grab;
        transition: 0.2s;
    }
    ${$5efcc9e2a786d9af$var$tagName} .feature-title {
        font-size: 24px;
        font-family: 'inter-bold';
        transition: 0.2s;
    }
    ${$5efcc9e2a786d9af$var$tagName} .feature-title:before {
        margin-right: 10px;
        display: inline-flex;
        width: 25px;
        transform: translateY(3px);
        aspect-ratio: 1 / 1;
        background-image: url(/assets/images/blue-arrow-double.svg);
        background-size: contain;
        background-position: 50% 50%;
        transform: rotate(-90deg) translateX(-3px);
        background-repeat: no-repeat;
        content: '';
        transition: 0.2s;
    }
    ${$5efcc9e2a786d9af$var$tagName} .feature-text {
        font-size: 14px;
        font-family: 'inter-light';
        width: 100%;
    }
    ${$5efcc9e2a786d9af$var$tagName}:hover {
        transform: translateY(-3px);
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
    }
    ${$5efcc9e2a786d9af$var$tagName}:hover .feature-title:before {
        margin-right: 15px;
    }
`;
const $5efcc9e2a786d9af$var$renderInnerHTML = (options)=>{
    if (options.html) options.text = options.html;
    return /*html*/ `
        <div class="feature-title">${options.title}</div>
        <div class="feature-text">${options.text}</div>
        <style>${$5efcc9e2a786d9af$var$css}</style>
    `;
};
class $5efcc9e2a786d9af$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $5efcc9e2a786d9af$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    // setTimeout(()=>{
    //     this.setAttribute('delayed-style', true);
    // }, 1);
    }
}
customElements.define($5efcc9e2a786d9af$var$tagName, $5efcc9e2a786d9af$var$CustomElem);
function $5efcc9e2a786d9af$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$5efcc9e2a786d9af$var$tagName} element-options="${e(JSON.stringify(options))}"></${$5efcc9e2a786d9af$var$tagName}>`;
}
var $5efcc9e2a786d9af$export$2e2bcd8739ae039 = $5efcc9e2a786d9af$var$render;


const $c10f68591c353a3e$var$tagName = "double-cta-box";
var $c10f68591c353a3e$var$css = /*css*/ `
    ${$c10f68591c353a3e$var$tagName} {
        display: block;
        background: var(--light-blue-gradient);
        padding: 1em;
        border-radius: 0.7em;
        box-shadow: 0px 1em 2em rgba(0, 0, 0, 0.2);
        max-width: 600px;
        margin: 0 auto;
    }
    ${$c10f68591c353a3e$var$tagName} .flex-col-center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 12px;
    }
    ${$c10f68591c353a3e$var$tagName} .text-1 {
        font-family: 'inter-bold', 'sans-serif';
        font-size: 36px;
    }
    ${$c10f68591c353a3e$var$tagName} .text-2 {
        font-family: 'inter-bold', 'sans-serif';
        font-size: 28px;
    }
    ${$c10f68591c353a3e$var$tagName} .text-3 {
        font-family: 'inter-medium', 'sans-serif';
        font-size: 18px;
    }
    ${$c10f68591c353a3e$var$tagName} .button-cont {
        display: flex;
        gap: 1em;
        margin-top: 0.5em;
        justify-content: center;
        flex-wrap: wrap;
    }
    ${$c10f68591c353a3e$var$tagName} .button {
        width: fit-content;
        padding: 1em 2em;
        color: white;
        background: var(--gray-brand-gradient);
        border-radius: 0.3em;
        cursor: pointer;
        box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
        transition: 200ms;
    }
    body.has-hover ${$c10f68591c353a3e$var$tagName} .button:hover {
        transform: translateY(-2px);
    }
    ${$c10f68591c353a3e$var$tagName} .button span {
        font-size: 1.1em;
        border-bottom: 2px solid var(--blue-brand);
    }
`;
const $c10f68591c353a3e$var$renderButtonContHTML = (options)=>{
    if (options.ctas.length == 1) return /*html*/ `<a class="button" ${options.ctas[0].internal ? "internal" : ""} ${options.ctas[0].newTab ? 'target="_blank"' : ""} href="${options.ctas[0].href}"><span>${options.ctas[0].label}</span></a>`;
    else return /*html*/ `
            <a class="button" ${options.ctas[0].internal ? "internal" : ""} ${options.ctas[0].newTab ? 'target="_blank"' : ""} href="${options.ctas[0].href}"><span>${options.ctas[0].label}</span></a>
            <a class="button" ${options.ctas[1].internal ? "internal" : ""} ${options.ctas[1].newTab ? 'target="_blank"' : ""} href="${options.ctas[1].href}"><span>${options.ctas[1].label}</span></a>
        `;
};
const $c10f68591c353a3e$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="flex-col-center">
            <div class="text-1">
                ${options.texts[0]}
            </div>
            <div class="text-2">
                ${options.texts[1]}
            </div>
            <div class="text-3">
                ${options.texts[2]}
            </div>
            <div class="button-cont">
                ${$c10f68591c353a3e$var$renderButtonContHTML(options)}
            </div>
        </div>
        <style>${$c10f68591c353a3e$var$css}</style>
    `;
};
class $c10f68591c353a3e$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(atob(this.getAttribute("element-options")));
        this.removeAttribute("element-options");
        this.innerHTML = $c10f68591c353a3e$var$renderInnerHTML(this.options);
    // setTimeout(()=>{
    //     this.setAttribute('delayed-style', true);
    // }, 1);
    }
}
customElements.define($c10f68591c353a3e$var$tagName, $c10f68591c353a3e$var$CustomElem);
function $c10f68591c353a3e$var$render(options) {
    return `<${$c10f68591c353a3e$var$tagName} element-options="${btoa(JSON.stringify(options))}"></${$c10f68591c353a3e$var$tagName}>`;
}
var $c10f68591c353a3e$export$2e2bcd8739ae039 = $c10f68591c353a3e$var$render;


const $fe58bfe3bd6680f4$var$tagName = "employer-marquee";
var $fe58bfe3bd6680f4$var$css = /*css*/ `
    ${$fe58bfe3bd6680f4$var$tagName} {
        display: block;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .blue-line {
        height: 0.5rem;
        background: var(--blue-wide-gradient);
    }
    ${$fe58bfe3bd6680f4$var$tagName} .hero-2 {
        font-family: 'inter-bold', sans-serif;
        font-size: 1.6em;
        margin-bottom: 0 !important;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .partner-companies-cont {
        overflow-x: hidden;
        max-width: 1200px;
        margin: 0 auto;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-fade-in-out {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-fade-inner-cont {
        position: relative;
        max-width: 1200px;
        height: 100%;
        margin: 0 auto;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-fade-in {
        width: 200px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-image: linear-gradient(to right, #F2F6F7 0%, transparent 100%);
        z-index: 5;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-fade-out {
        width: 200px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-image: linear-gradient(to left, #F2F6F7 0%, transparent 100%);
        z-index: 5;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .light-blue-bg {
        background: var(--light-blue);
    }
    ${$fe58bfe3bd6680f4$var$tagName} .partner-companies-icon-wrapper {
        width: fit-content;
        position: relative;
        display: flex;
        margin-top: 35px;
        animation: employer-slide 40s linear infinite;
    }
    @keyframes employer-slide {
        0% {
            transform: translateX(0%);
        }
        100% {
            transform: translateX(-25%);
        }
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo {
        height: 40px;
        display: flex;
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 50px;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-1 {
        background-image: url('/assets/employer-logos/employer-logo-bosch.svg');
        aspect-ratio: 732 / 163;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-2 {
        background-image: url('/assets/employer-logos/employer-logo-ey.svg');
        aspect-ratio: 296 / 299;
        height: 50px;
        position: relative;
        bottom: 10px;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-3 {
        background-image: url('/assets/employer-logos/employer-logo-ibm.svg');
        aspect-ratio: 607 / 244;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-4 {
        background-image: url('/assets/employer-logos/employer-logo-lufthansa.svg');
        aspect-ratio: 709 / 122;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-5 {
        background-image: url('/assets/employer-logos/employer-logo-microsoft.svg');
        aspect-ratio: 924 / 198;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-6 {
        background-image: url('/assets/employer-logos/employer-logo-n26.svg');
        aspect-ratio: 454 / 373;
        height: 50px;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-7 {
        background-image: url('/assets/employer-logos/employer-logo-sap.svg');
        aspect-ratio: 455 / 225;
        height: 50px;
    }
    ${$fe58bfe3bd6680f4$var$tagName} .employer-logo-8 {
        background-image: url('/assets/employer-logos/employer-logo-zalando.svg');
        aspect-ratio: 1013 / 186;
    }
    @media(max-width: 899px){
        ${$fe58bfe3bd6680f4$var$tagName} .employer-fade-in-out {
            display: none;
        }
        ${$fe58bfe3bd6680f4$var$tagName} .partner-companies-icon-wrapper {
            animation-duration: 20s;
            margin-top: 25px;
        }
        ${$fe58bfe3bd6680f4$var$tagName} .employer-logo {
            height: 30px !important;
            display: flex;
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 50px;
            bottom: 0px !important;
        }
        ${$fe58bfe3bd6680f4$var$tagName} .employer-padding {
            padding-bottom: 30px !important;
        }
    }
`;
var $fe58bfe3bd6680f4$var$template = /*html*/ `
    <div class="blue-line"></div>
    <div class="light-blue-bg employer-padding" style="padding: 20px 0; padding-bottom: 30px; position: relative;">
        <div class="hero-2" style="text-align: center;">Potentielle Arbeitgeber:</div>
        <div class="partner-companies-cont">
            <div class="partner-companies-icon-wrapper">
                <div class="employer-logo employer-logo-1"></div>
                <div class="employer-logo employer-logo-2"></div>
                <div class="employer-logo employer-logo-3"></div>
                <div class="employer-logo employer-logo-4"></div>
                <div class="employer-logo employer-logo-6"></div>
                <div class="employer-logo employer-logo-7"></div>
                <div class="employer-logo employer-logo-8"></div>
                <div class="employer-logo employer-logo-1"></div>
                <div class="employer-logo employer-logo-2"></div>
                <div class="employer-logo employer-logo-3"></div>
                <div class="employer-logo employer-logo-4"></div>
                <div class="employer-logo employer-logo-6"></div>
                <div class="employer-logo employer-logo-7"></div>
                <div class="employer-logo employer-logo-8"></div>
                <div class="employer-logo employer-logo-1"></div>
                <div class="employer-logo employer-logo-2"></div>
                <div class="employer-logo employer-logo-3"></div>
                <div class="employer-logo employer-logo-4"></div>
                <div class="employer-logo employer-logo-6"></div>
                <div class="employer-logo employer-logo-7"></div>
                <div class="employer-logo employer-logo-8"></div>
                <div class="employer-logo employer-logo-1"></div>
                <div class="employer-logo employer-logo-2"></div>
                <div class="employer-logo employer-logo-3"></div>
                <div class="employer-logo employer-logo-4"></div>
                <div class="employer-logo employer-logo-6"></div>
                <div class="employer-logo employer-logo-7"></div>
                <div class="employer-logo employer-logo-8"></div>
            </div>
        </div>
        <div class="employer-fade-in-out">
            <div class="employer-fade-inner-cont">
                <div class="employer-fade-in"></div>
                <div class="employer-fade-out"></div>
            </div>
        </div>
    </div>
    <div class="blue-line"></div>
    <style>
        ${$fe58bfe3bd6680f4$var$css}
    </style>
`;
class $fe58bfe3bd6680f4$var$CustomElem extends HTMLElement {
    constructor(options){
        super();
    }
    connectedCallback() {
        this.innerHTML = $fe58bfe3bd6680f4$var$template;
    }
}
customElements.define($fe58bfe3bd6680f4$var$tagName, $fe58bfe3bd6680f4$var$CustomElem);
var $fe58bfe3bd6680f4$export$2e2bcd8739ae039 = `<${$fe58bfe3bd6680f4$var$tagName}></${$fe58bfe3bd6680f4$var$tagName}>`;




const $a87dd6ab648eaad6$var$tagName = "course-card";
var $a87dd6ab648eaad6$var$css = /*css*/ `
    ${$a87dd6ab648eaad6$var$tagName} {
        display: flex;
        width: 100%;
        max-width: 450px;
        aspect-ratio: 515 / 740;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 0.8rem;
        position: relative;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        font-size: min(18px, 3.75vw);
        overflow: hidden;
    }
    ${$a87dd6ab648eaad6$var$tagName} .text-cont {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        gap: 1em;
        padding: 1em;
    }
    ${$a87dd6ab648eaad6$var$tagName} .text-title {
        font-size: 35px;
        line-height: 1em;
        letter-spacing: -0.02em;
        font-family: 'inter-bold';
        filter: drop-shadow(0px -30px 30px rgba(255, 255, 255, 1));
    }
    ${$a87dd6ab648eaad6$var$tagName} .button {
        width: fit-content;
        padding: 1em 2em;
        color: white;
        background: var(--gray-brand-gradient);
        border-radius: 0.3em;
        cursor: pointer;
        box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
        transition: 200ms;
    }
    ${$a87dd6ab648eaad6$var$tagName} .button span {
        font-size: 1.1em;
        border-bottom: 2px solid var(--blue-brand);
    }
    ${$a87dd6ab648eaad6$var$tagName} .text-bulletpoints {
        display: flex;
        flex-direction: column;
        gap: 0.4em;
        margin-top: 10px;
        margin-bottom: 15px;        
    }
    ${$a87dd6ab648eaad6$var$tagName} .text-bulletpoint {
        font-family: 'inter-medium';
        letter-spacing: -0.02em;
        display: flex;
        gap: 0.5em;
        transform: translateX(0.3em);
    }
    ${$a87dd6ab648eaad6$var$tagName} .text-bulletpoint:before {
        content: '';
        display: flex;
        width: 1em;
        aspect-ratio: 1/1;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/assets/images/blue-arrow-double.svg');
        transform: rotate(-90deg);
    }
    ${$a87dd6ab648eaad6$var$tagName} .text-cont a {
        margin: 0 auto;
    }
`;
const $a87dd6ab648eaad6$var$renderInnerHTML = (options)=>{
    var bulletPointsHTML = "";
    options.bulletPoints.forEach((bp)=>{
        bulletPointsHTML += /*html*/ `<div class="text-bulletpoint">${bp}</div>`;
    });
    return /*html*/ `
        <div class="text-cont">
            <div class="text-title">${options.title}</div>
            <div class="text-bulletpoints">${bulletPointsHTML}</div>
            <a cta-prevent-inner-hover internal href="${options.ctaURL}">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Mehr erfahren</span>`, {
        noBorder: true,
        shadow: true
    })}</a>
        </div>
        <style>${$a87dd6ab648eaad6$var$css}</style>
    `;
};
class $a87dd6ab648eaad6$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $a87dd6ab648eaad6$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($a87dd6ab648eaad6$var$tagName, $a87dd6ab648eaad6$var$CustomElem);
function $a87dd6ab648eaad6$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$a87dd6ab648eaad6$var$tagName} element-options="${e(JSON.stringify(options))}"></${$a87dd6ab648eaad6$var$tagName}>`;
}
var $a87dd6ab648eaad6$export$2e2bcd8739ae039 = $a87dd6ab648eaad6$var$render;


const $8c93dffafa28d4b6$var$tagName = "checkbox-list";
var $8c93dffafa28d4b6$var$css = /*css*/ `
    ${$8c93dffafa28d4b6$var$tagName} {
        display: flex;
        flex-direction: column;
        font-size: 1em;
        gap: 1.2em;
    }
    ${$8c93dffafa28d4b6$var$tagName} .checkmark-box {

    }
    ${$8c93dffafa28d4b6$var$tagName} .checkmark-title {
        font-family: 'inter-bold';
        font-size: 1.2em;
        margin-bottom: 0.6em;
    }
    ${$8c93dffafa28d4b6$var$tagName} .checkmark-title:before {
        display: inline-block;
        content: '';
        width: 1.2em;
        height: 1.2em;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/assets/images/blue-checkmark.svg');
        transform: translateY(0.2em);
        margin-right: 0.4em;
    }
    ${$8c93dffafa28d4b6$var$tagName} .checkmark-text {
        line-height: 1.5em;
        text-align: justify;
    }
`;
const $8c93dffafa28d4b6$var$renderInnerHTML = (options)=>{
    var boxesHTML = "";
    options.forEach((box)=>{
        boxesHTML += /*html*/ `
            <div class="checkmark-box">
                <div class="checkmark-title">${box.title}</div>
                <div class="checkmark-text">${box.content}</div>
            </div>
        `;
    });
    return /*html*/ `
        ${boxesHTML}
        <style>${$8c93dffafa28d4b6$var$css}</style>
    `;
};
class $8c93dffafa28d4b6$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $8c93dffafa28d4b6$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($8c93dffafa28d4b6$var$tagName, $8c93dffafa28d4b6$var$CustomElem);
function $8c93dffafa28d4b6$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$8c93dffafa28d4b6$var$tagName} element-options="${e(JSON.stringify(options))}"></${$8c93dffafa28d4b6$var$tagName}>`;
}
var $8c93dffafa28d4b6$export$2e2bcd8739ae039 = $8c93dffafa28d4b6$var$render;


const $d86d723d4c921682$var$tagName = "fias-why-section-visual";
var $d86d723d4c921682$var$css = /*css*/ `
    ${$d86d723d4c921682$var$tagName} {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        max-width: 500px;
    }
    ${$d86d723d4c921682$var$tagName} .img {
        background-size: 100% 100%;
        border-radius: 0.7rem;
    }
    ${$d86d723d4c921682$var$tagName} .portrait-cont {
        width: 100%;
        display: flex;
        gap: 8px;
    }
    ${$d86d723d4c921682$var$tagName} .main-visual {
        width: 100%;
        aspect-ratio: 1 / 0.84968;
        background-image: url('/assets/images-webp/why-main-img.webp');
    }
    ${$d86d723d4c921682$var$tagName} .slogan-cont {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        aspect-ratio: 4.598 / 1;
        background: var(--gray-brand-gradient);
        color: white;
        border-radius: 0.7rem;
    }
    ${$d86d723d4c921682$var$tagName} .slogan {
        font-family: 'inter-bold', sans-serif;
        font-size: clamp(1rem, 6vw, 1.9rem);
    }
    ${$d86d723d4c921682$var$tagName} .slogan span {
        color: var(--blue-brand);
    }
    ${$d86d723d4c921682$var$tagName} .portrait {
        flex-grow: 1;
        aspect-ratio: 1 / 1.2971;
    }
    ${$d86d723d4c921682$var$tagName} .portrait-1 {
        background-image: url('/assets/images/portrait-1.jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-2 {
        background-image: url('/assets/images/portrait-2.jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-3 {
        background-image: url('/assets/images/portrait-3.jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-4 {
        background-image: url('/assets/images/portrait-burzin-new.jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-5 {
        background-image: url('/assets/images/portrait-5.jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-6 {
        background-image: url('/assets/images/portrait-6\(new\).jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-7 {
        background-image: url('/assets/images/portrait-7\(new\).jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-8 {
        background-image: url('/assets/images/portrait-8\(new\).jpg');
    }
    ${$d86d723d4c921682$var$tagName} .portrait-9 {
        background-image: url('/assets/images/portrait-9\(new\).jpg');
    }
`;
var $d86d723d4c921682$var$template = /*html*/ `
    <div class="main-visual lazy-load-img-main-visual img img-main-visual appear-element"></div>
    <div class="portrait-cont">
        <div class="portrait lazy-load-portrait-1 img portrait-1 appear-element"></div>
        <div class="portrait lazy-load-portrait-3 img portrait-3 appear-element"></div>
        <div class="portrait lazy-load-portrait-4 img portrait-4 appear-element"></div>
    </div>
    <div class="portrait-cont">
        <div class="portrait lazy-load-portrait-6 img portrait-6 appear-element"></div>
        <div class="portrait lazy-load-portrait-7 img portrait-7 appear-element"></div>
        <div class="portrait lazy-load-portrait-8 img portrait-8 appear-element"></div>
        <div class="portrait lazy-load-portrait-9 img portrait-9 appear-element"></div>
    </div>
    <div class="slogan-cont">
        <div class="slogan">
            Wir leben <span>Karriere.</span>
        </div>
    </div>
    <style>
        ${$d86d723d4c921682$var$css}
    </style>
`;
class $d86d723d4c921682$var$CustomElem extends HTMLElement {
    constructor(options){
        super();
    }
    connectedCallback() {
        this.innerHTML = $d86d723d4c921682$var$template;
    }
}
customElements.define($d86d723d4c921682$var$tagName, $d86d723d4c921682$var$CustomElem);
var $d86d723d4c921682$export$2e2bcd8739ae039 = `<${$d86d723d4c921682$var$tagName}></${$d86d723d4c921682$var$tagName}>`;


const $26e554f22bcc5aa9$var$tagName = "parter-section";
var $26e554f22bcc5aa9$var$css = /*css*/ `
    ${$26e554f22bcc5aa9$var$tagName} {
        display: block;
        padding: 3rem 1rem;
    
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-title {
        font-family: 'inter-bold';
        font-size: 30px !important;
        font-size: 2rem;
        text-align: center;
        margin-bottom: 1em;
        margin-top: -20px;
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper {
        display: grid;
        gap: 20px;
        justify-content: space-evenly;
        grid-template-columns: repeat(6, 1fr);
        margin-left: auto;
        margin-right: auto;
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo {
        width: 140px;
        height: 40px;
        background-size: contain;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        margin: auto auto;
        transition: 200ms;
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo:hover {
        transform: translateY(-3px);
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo.partner-pp {
        background-image: url('/assets/images/product-people-logo.png');
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo.partner-ixdf {
        background-image: url('/assets/images/ixdf-logo-black-medium.png');
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo.partner-miro {
        background-image: url('/assets/images/miro-logo.svg');
        background-size: 100%;
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo.partner-webflow {
        background-image: url('/assets/images/webflow-logo.svg');
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo.partner-uizard {
        background-image: url('/assets/images/uizard_logo_yellow.svg');
    }
    ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper .partner-logo.partner-ihk-muc {
        background-image: url('/assets/images/ihk-akademie-muenchen-oberbayern.svg');
    }
    @media(max-width: 1100px){
        ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper {
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
            max-width: 800px;
        }
    }
    @media(max-width: 572px){
        ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper {
            grid-template-columns: repeat(2, 1fr);
            gap: 40px;
        }
    }
    @media(max-width: 399px){
        ${$26e554f22bcc5aa9$var$tagName} .partner-wrapper {
            grid-template-columns: repeat(1, 1fr);
            gap: 40px;
        }
    }
`;
var $26e554f22bcc5aa9$var$template = /*html*/ `
    <div class="partner-title">Unsere Partner</div>
    <div class="partner-wrapper">
        <a href="https://www.getproductpeople.com" target="_blank" class="partner-logo partner-pp"></a>
        <a href="https://www.interaction-design.org/" target="_blank" class="partner-logo partner-ixdf"></a>
        <a href="https://miro.com/" target="_blank" class="partner-logo partner-miro"></a>
        <a href="https://webflow.com/" target="_blank" class="partner-logo partner-webflow"></a>
        <a href="https://uizard.io/" target="_blank" class="partner-logo partner-uizard"></a>
        <a href="https://www.ihk-akademie-muenchen.de/" target="_blank" class="partner-logo partner-ihk-muc"></a>
    </div>
    <style>
        ${$26e554f22bcc5aa9$var$css}
    </style>
`;
class $26e554f22bcc5aa9$var$CustomElem extends HTMLElement {
    constructor(options){
        super();
    }
    connectedCallback() {
        this.innerHTML = $26e554f22bcc5aa9$var$template;
    }
}
customElements.define($26e554f22bcc5aa9$var$tagName, $26e554f22bcc5aa9$var$CustomElem);
var $26e554f22bcc5aa9$export$2e2bcd8739ae039 = `<${$26e554f22bcc5aa9$var$tagName}></${$26e554f22bcc5aa9$var$tagName}>`;




const $6891603719d52046$var$tagName = "home-hero-section";
var $6891603719d52046$var$css = /*css*/ `
    ${$6891603719d52046$var$tagName} {
        display: flex;
        gap: 0;
        max-width: 990px;
        margin: 0 auto;
        padding-top: 4rem;
        overflow: visible;
        font-size: 1.2rem;
        padding-right: 1rem;
    }
    ${$6891603719d52046$var$tagName} .hero-img-cont {
        // background: rgba(255, 0, 0, 0.1);
        flex: 2.5;
        align-self: stretch;
        position: relative;
        min-width: 380px;
    }
    ${$6891603719d52046$var$tagName} .hero-img-inner-cont {
        width: 100%;
        aspect-ratio: 402 / 557;
        position: absolute;
        bottom: 0;
    }
    ${$6891603719d52046$var$tagName} .hero-img {
        position: relative;
        width: 100%;
        height: 100%;
        background-image: url('/assets/images-webp/fias-hero-img-transparent-new.webp');
        background-size: 105%;
        background-repeat: no-repeat;
        background-position: 150% 100%;
    }
    ${$6891603719d52046$var$tagName} .hero-img-desktop-bg-img {
        position: absolute;
        width: 150%;
        aspect-ratio: 573 / 378;
        background-image: url('/assets/images/hero-desktop-bg.svg');
        background-size: contain;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        transform: scaleX(-1) translateX(-40%) translateY(-10%);
        z-index: 0;
    }
    ${$6891603719d52046$var$tagName} .hero-content {
        // background: red;
        flex: 4;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding-bottom: 2rem;
        z-index: 1;
    }
    ${$6891603719d52046$var$tagName} .hero-content > a {
        display: block;
    }
    ${$6891603719d52046$var$tagName} .hero-title {
        font-family: 'inter-bold';
        font-size: 3rem;
    }
    ${$6891603719d52046$var$tagName} .hero-text {
        font-size: 0.9em;
        font-family: 'inter-light';
    }
    ${$6891603719d52046$var$tagName} .hero-text b {
        font-family: 'inter-bold';
    }
    ${$6891603719d52046$var$tagName} .hero-partner-cont {
        display: flex;
        gap: 0.5em;
    }
    ${$6891603719d52046$var$tagName} .hero-partner {
        font-size: 0.55em;
        border: 1px solid var(--gray-brand);
        border-radius: 6px;
        padding: 4px 8px;
        transition: 200ms;
    }
    ${$6891603719d52046$var$tagName} .hero-partner:hover {
        transform: translateY(-2px);
    }
    ${$6891603719d52046$var$tagName} .hero-partner span {
        margin-bottom: 0.3em;
        display: block;
        text-align: center;
    }
    ${$6891603719d52046$var$tagName} .hero-partner-logo {
        display: flex;
        width: 100%;
        aspect-ratio: 541 / 151;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }
    ${$6891603719d52046$var$tagName} .hero-partner-logo-ihk {
        background-image: url('/assets/images/ihk-akademie-muenchen-oberbayern.svg');
    }
    ${$6891603719d52046$var$tagName} .hero-partner-logo-product-people {
        background-image: url('/assets/images/product-people-logo.png');
    }
    ${$6891603719d52046$var$tagName} .hero-partner-logo-ixdf {
        background-image: url('/assets/images/ixdf-logo-black-medium.png');
    }
    ${$6891603719d52046$var$tagName} .google-review-cont {
        display: flex;
        gap: 1em;
        // max-width: 200px;
        align-items: center;
    }
    ${$6891603719d52046$var$tagName} .google-review-cont > div {
        // flex: 1;
        height: fit-content;
    }
    ${$6891603719d52046$var$tagName} .google-review-img-left {
        width: 12em;
        max-width: 180px;
        aspect-ratio: 192 / 43;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 50% 50%;
        background-image: url('/assets/images-webp/google-review-img-new.webp');
    }
    ${$6891603719d52046$var$tagName} .google-review-right-side {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 0.8em;
    }
    ${$6891603719d52046$var$tagName} .google-review-right-top {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }
    ${$6891603719d52046$var$tagName} .google-review-stars {
        display: flex;
        gap: 4px;
    }
    ${$6891603719d52046$var$tagName} .google-review-star {
        width: 22px;
        aspect-ratio: 1/1;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 50% 50%;
        background-image: url('/assets/images/star-icon.svg');
    }
    ${$6891603719d52046$var$tagName} .google-review-rating {
        font-family: 'inter-bold';
    }
    ${$6891603719d52046$var$tagName} .google-review-right-bottom {
        font-family: 'inter-light';
    }
    @media(max-width: 880px){
        ${$6891603719d52046$var$tagName} {
            // padding-right: 0rem;
            padding-top: 1rem;
        }
        ${$6891603719d52046$var$tagName} .hero-img-cont {
            min-width: 320px;
        }
        ${$6891603719d52046$var$tagName} .hero-img-inner-cont {
            aspect-ratio: 352 / 557;
        }
    }
    @media(max-width: 820px){
        ${$6891603719d52046$var$tagName} {
            // padding-right: 0rem;
            flex-direction: column-reverse;
            max-width: 520px;
            margin: 0 2rem;
            padding-top: 2rem;
        }
        ${$6891603719d52046$var$tagName} .hero-content {
            padding-bottom: 1rem;
            gap: 1.2rem;
        }
        ${$6891603719d52046$var$tagName} .hero-img-cont {
            min-width: initial;
            width: 300px;
            aspect-ratio: 452 / 557;
            display: block;
            flex: initial;
            align-self: initial;
        }
        ${$6891603719d52046$var$tagName} .hero-img-cont {
            // aspect-ratio: 352 / 557;
            display: none;
        }
        ${$6891603719d52046$var$tagName} .hero-title {
            line-height: 1em;
            margin-bottom: 0.3em;
        }
        ${$6891603719d52046$var$tagName} .hero-title span {
            border-bottom: 0.15em solid var(--blue-brand);
        }
    }
    @media(max-width: 460px){
        ${$6891603719d52046$var$tagName} {
            padding-right: 0;
            margin: 0;
        }
        ${$6891603719d52046$var$tagName} .hero-img-cont {
            // aspect-ratio: 352 / 557;
            display: block;
            margin: 0 auto;
        }
        ${$6891603719d52046$var$tagName} .hero-img-desktop-bg-img {
            // aspect-ratio: 352 / 557;
            display: none;
        }
    }
`;
function $6891603719d52046$var$template() {
    return /*html*/ `
    <div class="hero-img-cont">
        <div class="hero-img-inner-cont">
            <div class="hero-img-desktop-bg-img"></div>
            <div class="hero-img"></div>
        </div>
    </div>
    <div class="hero-content">
        <div class="hero-title">Wir leben <span>Karriere</span>.</div>
        <div class="hero-text">Mit unseren <b>zertifizierten Weiterbildungen</b> und <b>internen Bewerbungscoachings</b> bringen wir dich deinem Traumjob den entscheidenden Schritt n\xe4her. Das Fundament unserer Weiterbildungen bilden dabei unsere <b>qualifizierten Teacher</b>, die <b>echtes und relevantes Wissen aus der Praxis</b> vermitteln. So sorgen wir f\xfcr eine <b>unvergleichliche digitale Lernatmosph\xe4re</b>.<br><br><b>Starte jetzt mit uns durch</b> und <b>informiere dich zu unseren Weiterbildungen</b>.</div>
        <div class="hero-partner-cont">
            <a href="https://www.ihk-akademie-muenchen.de/" target="_blank" class="hero-partner">
                <span>Offizieller Partner von</span>
                <div class="hero-partner-logo hero-partner-logo-ihk"></div>
            </a>
            <a href="https://www.getproductpeople.com/" target="_blank" class="hero-partner">
                <span>Offizieller Partner von</span>
                <div class="hero-partner-logo hero-partner-logo-product-people"></div>
            </a>
            <a href="https://www.interaction-design.org/courses" target="_blank" class="hero-partner">
                <span>Offizieller Partner von</span>
                <div class="hero-partner-logo hero-partner-logo-ixdf"></div>
            </a>
        </div>
        <div class="google-review-cont">
            <div class="google-review-img-left"></div>
            <div class="google-review-right-side">
                <div class="google-review-right-top">
                    <div class="google-review-stars">
                        <div class="google-review-star"></div>
                        <div class="google-review-star"></div>
                        <div class="google-review-star"></div>
                        <div class="google-review-star"></div>
                        <div class="google-review-star"></div>
                    </div>
                    <div class="google-review-rating">5.0</div>
                </div>
                <div class="google-review-right-bottom">315+ Bewertungen</div>
            </div>
        </div>
        <a cta-prevent-inner-hover target="_blank" href="${getAppConfig().ctaURLS.main}">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `Jetzt bewerben und <span>durchstarten</span>.`)}</a>
    </div>
    <style>
        ${$6891603719d52046$var$css}
    </style>
    `;
}
class $6891603719d52046$var$CustomElem extends HTMLElement {
    constructor(options){
        super();
    }
    connectedCallback() {
        this.innerHTML = $6891603719d52046$var$template();
    }
}
customElements.define($6891603719d52046$var$tagName, $6891603719d52046$var$CustomElem);
var $6891603719d52046$export$2e2bcd8739ae039 = `<${$6891603719d52046$var$tagName}></${$6891603719d52046$var$tagName}>`;


const $726e3f6128d4ba4e$var$tagName = "faq-box";
var $726e3f6128d4ba4e$var$css = /*css*/ `
    ${$726e3f6128d4ba4e$var$tagName} {
        display: flex;
        flex-direction: column;
        gap: 1em;
        color: white;
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-dropdown {
        cursor: pointer;
        background: var(--gray-brand-gradient);
        border-radius: 0.5em;
        box-shadow: 0px 10px 20px rgb(0 0 0 / 50%);
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-question {
        font-family: 'inter-medium';
        font-size: 1.3rem;
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-dropdown-inner {
        display: flex;
        gap: 20px;
        justify-content: space-between;
        align-items: center;
        padding: 1.5em 1.2em;
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-dropdown-inner .faq-question {
        transition: color 0.5s;
    }

    body.has-hover ${$726e3f6128d4ba4e$var$tagName} .faq-dropdown-inner:hover {
        color: var(--blue-brand);
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-arrow {
        display: flex;
        color: white;
        min-width: 30px;
        min-height: 30px;
        padding: 0;
        margin: 0;
        background-image: url('/assets/images/blue-arrow-single.svg');
        background-size: 100% 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        transition: 0.2s;
        -webkit-transition: 0.2s;
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-arrow-active {
        transform: rotate(180deg);
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-answer-wrapper {
        height: 0;
        overflow: hidden;
    }

    ${$726e3f6128d4ba4e$var$tagName} .faq-answer {
        cursor: initial;
        line-height: 1.5em;
        padding: 1em 1.2em;
        padding-top: 0;
        font-family: 'inter-medium';
        font-size: 1.1em;
    }
`;
function $726e3f6128d4ba4e$var$renderSingleFAQ(qa) {
    return /*html*/ `
        <div class="faq-dropdown">
            <div class="faq-dropdown-inner">
                <div class="faq-question">${qa.q}</div>
                <div class="faq-arrow"></div>
            </div>
            <div class="faq-answer-wrapper">
                <div class="faq-answer">${qa.a}</div>
            </div>
        </div>
    `;
}
const $726e3f6128d4ba4e$var$renderInnerHTML = (options)=>{
    var faqHTML = "";
    options.forEach((qa)=>{
        faqHTML += $726e3f6128d4ba4e$var$renderSingleFAQ(qa);
    });
    return /*html*/ `
        ${faqHTML}
        <style>${$726e3f6128d4ba4e$var$css}</style>
    `;
};
var $726e3f6128d4ba4e$var$faqSpeed = 200;
class $726e3f6128d4ba4e$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $726e3f6128d4ba4e$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
        this.hydrate();
    }
    hydrate() {
        var parent = this;
        this.QAs = Array.from(this.querySelectorAll(".faq-dropdown"));
        this.QAs.forEach((QA)=>{
            QA.expandBtn = QA.querySelector(".faq-arrow");
            QA.top = QA.querySelector(".faq-dropdown-inner");
            QA.expanded = false;
            QA.answer = QA.querySelector(".faq-answer-wrapper");
            QA.answer.style.height = "0px";
            QA.answer.style.opacity = "0";
            QA.expand = function() {
                parent.QAs.forEach(function(QA) {
                    QA.contract();
                });
                QA.expanded = true;
                QA.expandBtn.classList.add("faq-arrow-active");
                QA.answer.animate({
                    height: QA.answer.scrollHeight + "px",
                    opacity: "1"
                }, {
                    duration: $726e3f6128d4ba4e$var$faqSpeed,
                    fill: "forwards"
                });
            };
            QA.contract = function() {
                QA.expanded = false;
                QA.expandBtn.classList.remove("faq-arrow-active");
                QA.answer.animate({
                    height: "0px",
                    opacity: "0"
                }, {
                    duration: $726e3f6128d4ba4e$var$faqSpeed,
                    fill: "forwards"
                });
            };
            QA.handleClick = function() {
                if (!QA.expanded) QA.expand();
                else QA.contract();
            };
            QA.top.onclick = QA.handleClick;
        });
    }
}
customElements.define($726e3f6128d4ba4e$var$tagName, $726e3f6128d4ba4e$var$CustomElem);
function $726e3f6128d4ba4e$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$726e3f6128d4ba4e$var$tagName} element-options="${e(JSON.stringify(options))}"></${$726e3f6128d4ba4e$var$tagName}>`;
}
var $726e3f6128d4ba4e$export$2e2bcd8739ae039 = $726e3f6128d4ba4e$var$render;



window.util = {};
util.formatDate = function(dateStr) {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};
util.formatDateWritten = function(dateStr) {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}. ${month} ${year}`;
};
util.setPageTitle = function(title) {
    document.title = title;
};
util.setPageDescription = function(description) {
    document.querySelector('meta[name="description"]').setAttribute("content", description);
};
function $1bda09d2dd26bd7c$export$c383cdd2a518017a(title = "") {
    return title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[\s\+]+/g, "-").replace(/[?!:,;]+/g, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
}


const $3cd78c7a486265a3$var$tagName = "feedback-box-component";
var $3cd78c7a486265a3$var$feedbackCss = /*css*/ `
    ${$3cd78c7a486265a3$var$tagName} {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: white;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        padding: 15px;
        left: 12px;
        width: 410px;
        height: 200px;
        margin: 10px;
        position: relative;
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-star {
        display: flex;
        gap: 2px;
        top: -10px;
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-star img {
        width: 20px;
        height: 20px;
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-google-logo {
        position: absolute;
        top: 17px;
        right: 15px;
        width: 20px;
        height: 20px;
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-text {
        margin-top: 10px;
        font-size: 14px;
        line-height: 1.4;
        color: #333;
        max-height: 98px; /* Set the maximum height for the text area */
        overflow-y: hidden;  /* Hide overflow initially */
        position: relative;
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-text.overflowing {
        overflow-y: auto;  /* Enable vertical scrolling if content exceeds max height */
        padding-right: 10px;
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-ellipsis {
        position: absolute;
        font-weight: bold;
        bottom: 46px;
        left: 15px;
        background: linear-gradient(to top, white, transparent);
    }

    ${$3cd78c7a486265a3$var$tagName} .feedback-user-name {
        font-weight: bold;
        font-size: 14px;
        margin-top: 20px;
    }

    @media (max-width: 1244px) {
        ${$3cd78c7a486265a3$var$tagName} { 
        width: 290px;
        left: 0px;
        }
    }

    @media (max-width: 390px) {
        ${$3cd78c7a486265a3$var$tagName} { 
        width: 290px;
        justify-content: center;
        box-sizing: border-box;
        left: 0px;
        }
    }
`;
const $3cd78c7a486265a3$var$renderFeedbackBox = (options)=>{
    return /*html*/ `
        <div class="feedback-box">
            <div class="feedback-star">
                ${[
        ...Array(5)
    ].map((_)=>'<img src="/assets/images/star-icon.svg" alt="star">').join("")}
            </div>
            <img src="/assets/images/google_logo.png" class="feedback-google-logo" alt="Google Logo">
            <div class="feedback-text">${options.text}</div>
            <div class="feedback-user-name">${options.userName}</div>
            <div class="feedback-ellipsis">...</div>
            <style>${$3cd78c7a486265a3$var$feedbackCss}</style>
        </div>
    `;
};
class $3cd78c7a486265a3$var$FeedbackBoxComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        this.innerHTML = $3cd78c7a486265a3$var$renderFeedbackBox(this.options);
        // Check if the text overflows and needs scrolling
        const feedbackText = this.querySelector(".feedback-text");
        const feedbackEllipsis = this.querySelector(".feedback-ellipsis");
        if (feedbackText.scrollHeight > feedbackText.clientHeight) {
            feedbackText.classList.add("overflowing");
            feedbackEllipsis.style.display = "block";
            feedbackText.addEventListener("scroll", ()=>{
                if (feedbackText.scrollTop > 0) feedbackEllipsis.style.display = "none";
                else feedbackEllipsis.style.display = "block";
            });
        } else feedbackEllipsis.style.display = "none";
    }
}
customElements.define($3cd78c7a486265a3$var$tagName, $3cd78c7a486265a3$var$FeedbackBoxComponent);
function $3cd78c7a486265a3$var$renderFeedback(options) {
    return `<${$3cd78c7a486265a3$var$tagName} element-options='${JSON.stringify(options)}'></${$3cd78c7a486265a3$var$tagName}>`;
}
var $3cd78c7a486265a3$export$2e2bcd8739ae039 = $3cd78c7a486265a3$var$renderFeedback;


const $741eb4901885d7cb$var$tagName = "feedback-section";
var $741eb4901885d7cb$var$feedbackSectionCss = /*css*/ `
    ${$741eb4901885d7cb$var$tagName} {
        display: block;
        position: relative;
        background: #f2f6f7;
        padding: 20px 0;
        overflow: hidden;
    }

    ${$741eb4901885d7cb$var$tagName} .blue-line {
        height: 0.5rem;
        background: var(--blue-wide-gradient);
        position: absolute;
        left: 0;
        right: 0;
    }

    ${$741eb4901885d7cb$var$tagName} .blue-line.top {
        top: 0px;
    }

    ${$741eb4901885d7cb$var$tagName} .blue-line.bottom {
        bottom: 0px;
    }

    ${$741eb4901885d7cb$var$tagName} .hero-2 {
        font-family: 'inter-bold', sans-serif;
        font-size: 30px;
        margin-bottom: 20px !important;
        margin-top: 10px;
        text-align: center;
    }

    ${$741eb4901885d7cb$var$tagName} .feedback-container {
        max-width: 80%;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-direction: column; /* Stack elements vertically */
        align-items: center;
        justify-content: center; /* Center vertically */
    }

    ${$741eb4901885d7cb$var$tagName} .feedback-wrapper {
        display: flex;
        overflow: hidden;
        width: 100%;
        scroll-behavior: smooth;
    }

    ${$741eb4901885d7cb$var$tagName} .feedback-item {
        flex: 0 0 25%; /* Show 4 items at a time */
        box-sizing: border-box;
        padding: 10px;
    }


    ${$741eb4901885d7cb$var$tagName} .nav-button {
        background: none;
        border: none;
        color: var(--blue-brand);
        font-size: 2rem;
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
    }

    ${$741eb4901885d7cb$var$tagName} .nav-button.left {
        left: -40px;
    }

    ${$741eb4901885d7cb$var$tagName} .nav-button.right {
        right: -40px;
    }

    ${$741eb4901885d7cb$var$tagName} .feedback-fade {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 30px;
        z-index: 1;
    }

    ${$741eb4901885d7cb$var$tagName} .feedback-fade.left {
        left: 0;
        background: linear-gradient(to right, #f2f6f7, transparent);
    }

    ${$741eb4901885d7cb$var$tagName} .feedback-fade.right {
        right: 0;
        background: linear-gradient(to left, #f2f6f7, transparent);
    }

    @media (max-width: 390px) {
        ${$741eb4901885d7cb$var$tagName} .feedback-fade { 
            display: none;
        }

        ${$741eb4901885d7cb$var$tagName} .feedback-item {
            justify-content: center; /* Center content */
            align-items: center; /* Center content vertically */
            padding: 0px;
        }

        ${$741eb4901885d7cb$var$tagName} .nav-button.left {
            left: -30px;
        }
    
        ${$741eb4901885d7cb$var$tagName} .nav-button.right {
            right: -30px;
        }
        
    }
    
`;
const $741eb4901885d7cb$var$renderFeedbackSection = (feedbackList)=>{
    const feedbackItems = feedbackList.map((feedback)=>`
        <div class="feedback-item">
            ${(0, $3cd78c7a486265a3$export$2e2bcd8739ae039)(feedback)}
        </div>
    `).join("");
    return /*html*/ `
    <div class="blue-line top"></div>
    <div class="hero-2">Das sagen unsere Kunden:</div>
        <div class="feedback-container">
            <button class="nav-button left">&#9664;</button>
            <div class="feedback-wrapper">
                ${feedbackItems}
            </div>
            <button class="nav-button right">&#9654;</button>
            <div class="feedback-fade left"></div>
            <div class="feedback-fade right"></div>
        </div>
    <div class="blue-line bottom"></div>
    <style>${$741eb4901885d7cb$var$feedbackSectionCss}</style>
    `;
};
class $741eb4901885d7cb$var$FeedbackSection extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const feedbackList = [
            {
                text: "Ich bin jetzt seit \xfcber 2 Monaten in der Weiterbildung zum IT-Produktmanager beim FI und muss sagen von Anmeldung bis jetzt hat <mark>alle meine Erwartungen \xfcbertroffen</mark>. Wenn man Anliegen oder Fragen hat, werden diese innerhalb von k\xfcrzester Zeit beantwortet und/oder gekl\xe4rt. Der Unterricht ist meiner Meinung <mark>sehr modern gestaltet</mark> und durch die <mark>Abwechslung von Theorie und Praxis</mark> kann man alles perfekt festigen! Im Gro\xdfen und Ganzen kann ich in der kurzen Zeit sagen, <mark>ich f\xfchle mich bestens betreut und geleert!</mark>",
                userName: "Janosch M."
            },
            {
                text: "Top! Die Dozenten sind nicht nur <mark>mega kompetent</mark>, sondern auch super sympathisch. Man merkt einfach, dass hier <mark>jeden Tag mit Herz gearbeitet wird</mark>. Das Konzept ist durchdacht, und man lernt jeden Tag Neues dazu. Davor war ich bei einem anderen Anbieter und der Unterschied ist wie Tag & Nacht (Schulungen k\xf6nnen tats\xe4chlich auch Spa\xdf machen!). Wer also \xfcberlegt, hier eine Weiterbildung zu starten, dem kann ich nur sagen: Macht es! :-)",
                userName: "Emily D."
            },
            {
                text: 'Do it, the Franklin Way! Ich mach eine Umschulung zum Softwareberater/ produktmanager. <mark>Ich lerne jeden Tag etwas und habe Spa\xdf bei der Arbeit!</mark> :D Am besten finde ich die offenen Dialoge die wir in der Gruppe f\xfchren. Der Unterricht wird in Theorie & Praxis unterteilt. Morgens bis zum Mittag haben wir Theorie und am Nachmittag wird dieses wissen dann meist mit passenden Praxisaufgaben erg\xe4nzt bzw. gefestigt. Das "on-Boarding" lief auch super entspannt ab. Unterlagen wurden mir alle vollst\xe4ndig zugeschickt, bei den "Amt-G\xe4ngen wurde" ich super beraten und vorbereitet und stehe seitdem im engen Kontakt mit meinem Buddy.',
                userName: "Tim L."
            },
            {
                text: "Das Franklin Institute ist <mark>super organisiert und vor allem digitalisiert.</mark> Die pers\xf6nliche Betreuung ist einwandfrei, mit einer <mark>guten Erreichbarkeit seines Kursbetreuers.</mark> Die Kurse sind gut strukturiert, organisiert und es gibt interaktive praktische Aufgaben. <mark>Es wird nicht langweilig.</mark> Ich kann das Franklin Institute jedem empfehlen, wenn man dar\xfcber nachdenkt sich weiterzubilden bzw. umzuschulen.",
                userName: "Aleksandar S."
            },
            {
                text: '<mark>Eine v\xf6llig neue Art zu lernen, dennoch sehr effektiv,</mark> da es mich in meine nat\xfcrliche neugierde - die Dinge zu erkunden - zur\xfcckbringt. <mark>Dozenten sind erste Sahne, nat\xfcrlich, herzlich, kompetent, auf Augenh\xf6he und sehr verst\xe4ndnisvoll.</mark> Bin jetzt einen Monat dabei und freue mich jeden einzelnen Tag auf den Kurs und auf meine Kommilitonen. Empfehle den Kurs gerade f\xfcr Menschen, welche sich mit Theorie schwertun, da ein gro\xdfer Teil des Unterrichts aus Praxis besteht. Ich habe bereits jetzt schon so <mark>unfassbar viel dazugelernt,</mark> was gerade durch das "selbst ausprobieren" gef\xf6rdert wurde und der Austausch mit den Kommilitonen soviel Mehrwert bietet. <mark>Absolute Empfehlung zu 100%.</mark>',
                userName: "Pamela L."
            },
            {
                text: "<mark>Sehr professionelles und seri\xf6ses Institut!</mark> Ich wurde nicht nur ausf\xfchrlich beraten, sondern auch intensiv bei dem Prozess f\xfcr einen Bildungsgutschein mit der Agentur f\xfcr Arbeit begleitet. Meine Beraterin Frau Lederer m\xf6chte ich hier besonders positiv hervor heben! Mit ihrer aufgeschlossenen, <mark>sehr sympathischen und emphatischen Art</mark> hat sie mir meine \xc4ngste und Zweifel bez\xfcglich einer Weiterbildung und dem Termin bei der Agentur f\xfcr Arbeit genommen. Den Bildungsgutschein h\xe4tte ich ohne ihre Unterst\xfctzung nur schwer erhalten. Vielen Dank f\xfcr die wunderbare Beratung!",
                userName: "Sinem Y."
            },
            {
                text: "Die Beratung, die ich f\xfcr meine Weiterbildung im Bereich IT-Beratung erhalten habe, <mark>war absolut erstklassig.</mark> Das Beraterteam war \xe4u\xdferst kenntnisreich und professionell. Sie nahmen sich die Zeit, um meine aktuellen F\xe4higkeiten und meine Karriereziele zu verstehen, und lieferten dann <mark>ma\xdfgeschneiderte Empfehlungen f\xfcr Kurse und Zertifizierungen,</mark> die meinen Bed\xfcrfnissen entsprachen. Die Berater hatten ein tiefes Verst\xe4ndnis f\xfcr die IT-Branche und waren in der Lage, mir klare Einblicke in die aktuellen Trends und Anforderungen zu geben. Sie erkl\xe4rten ausf\xfchrlich, wie die verschiedenen Weiterbildungsoptionen meine berufliche Entwicklung beeinflussen k\xf6nnten, und beantworteten geduldig all meine Fragen. Die Kommunikation verlief reibungslos, und ich f\xfchlte mich wirklich unterst\xfctzt und ermutigt, diese wichtige Entscheidung f\xfcr meine Karriere voranzutreiben. Ich kann die <mark>IT-Weiterbildungsberatung uneingeschr\xe4nkt empfehlen und danke dem Team herzlich f\xfcr die herausragende Unterst\xfctzung!</mark>",
                userName: "Umair M."
            },
            {
                text: "Unfassbar guter Kurs. <mark>Hoch qualifizierte Dozenten, viele Praxisaufgaben, die auch als alleinerziehender Vater machbar sind.</mark> War erst skeptisch, weil ich keine Vorerfahrung in dem Bereich habe, aber hat sich sehr schnell in Luft aufgel\xf6st. Man wird dort abgeholt, wo man aktuell steht. Klar, es ist nicht super einfach, aber wenn man motiviert am Ball bleibt, dann ist das Kein Thema. Die Ansprechpartner stehen immer zur Verf\xfcgung, man macht hier wirklich einen Neustart und wird als Quereinsteiger top auf die neue Branche vorbereitet. <mark>F\xfchle mich sehr gut aufgehoben.</mark> Danke an Johannes und das Team!",
                userName: "Eric L."
            },
            {
                text: 'F\xfcr mich als Unternehmensberater und experte aus der Industrie, ist diese Consulting und IT-Expert Weiterbildung zum "Product Owner" optimal, um sich einer immer werdenden digitalen Arbeitswelt mit neuen Qualifikationen anzupassen. Jedes Modul wird durch <mark>renommierte Zertifizierer wie der \u201EStanford University\u201C, dem \u201ET\xdcV S\xfcd\u201C</mark> oder der renommierten Produktmanagement-Beratung \u201EProduct People\u201C durchgef\xfchrt. Auch kann nur seri\xf6s das fachliche Wissen vermittelt werden, wenn man sich auch \xfcber diesen Mindestzeitraum von 10-12 Monate mit diesem sehr speziellen Themen Vollzeit besch\xe4ftigt. Nach fundierter Pr\xfcfung verschiedenster Institute am digitalen Bildungsmarkt habe ich diese Kombination wirklich nirgendwo so vorgefunden. Aus diesem Grund bin ich von dieser Weiterbildungsma\xdfnahme \xfcberzeugt und freue mich morgen meinen "Fernstudium" zum "Product Owner" beim Franklin Institute of Applied Science starten zu k\xf6nnen.',
                userName: "Mario H."
            },
            {
                text: "Ich bin komplett <mark>positiv \xfcberrascht von der Professionalit\xe4t dieser Weiterbildung.</mark> Man lernt, mit den auf dem Markt g\xe4ngigen Cloudprogrammen umzugehen. Es finden monatliche Feedbackgespr\xe4che per Einzel und Gruppensession statt, die auch bei Sinnhaftigkeit umgesetzt werden. Das Team ist super innovativ und die Lehrer von der Praxis. <mark>Ich bin froh, diesen Bildungstr\xe4ger gew\xe4hlt zu haben</mark> und w\xfcrde ihn meinen Freunden und Familie zu 100% weiterempfehlen!",
                userName: "Chelsea E."
            },
            {
                text: "Ich kann den Kurs und das Franklin Institute of Applied Sciences insgesamt <mark>uneingeschr\xe4nkt empfehlen.</mark> Die Kombination aus erstklassigen Kursinhalten, motivierten Teilnehmern, innovativen Lernmethoden, exzellenter Betreuung, abwechslungsreichen Aktivit\xe4ten und angemessenem Zeitaufwand hat meine Erwartungen \xfcbertroffen. Wenn Sie nach einer Bildungseinrichtung suchen, die Ihnen eine <mark>hochwertige und bereichernde Lernerfahrung</mark> bietet, an der sie als Person individuell ihre St\xe4rken mit in den Lernprozess einbringen k\xf6nnen und NICHT \u201Cvon oben herab druckbetankt\u201D werden wollen, dann ist das Franklin Institute of Applied Sciences die richtige Wahl!",
                userName: "Ulf O."
            }
        ];
        this.innerHTML = $741eb4901885d7cb$var$renderFeedbackSection(feedbackList);
        const container = this.querySelector(".feedback-wrapper");
        const leftButton = this.querySelector(".nav-button.left");
        const rightButton = this.querySelector(".nav-button.right");
        leftButton.addEventListener("click", ()=>{
            const itemWidth = container.querySelector(".feedback-item").clientWidth; // Get the width of one item
            container.scrollBy({
                left: -itemWidth,
                behavior: "smooth"
            });
        });
        rightButton.addEventListener("click", ()=>{
            const itemWidth = container.querySelector(".feedback-item").clientWidth; // Get the width of one item
            container.scrollBy({
                left: itemWidth,
                behavior: "smooth"
            });
        });
    }
}
customElements.define($741eb4901885d7cb$var$tagName, $741eb4901885d7cb$var$FeedbackSection);
var $741eb4901885d7cb$export$2e2bcd8739ae039 = `<${$741eb4901885d7cb$var$tagName}></${$741eb4901885d7cb$var$tagName}>`;


const $8901f5b516489ece$var$tagName = "quiz-component";
var $8901f5b516489ece$var$css = /*css*/ `
    ${$8901f5b516489ece$var$tagName} {
        display: block;
        background: var(--gray-brand-gradient); /* White background */
        padding: 1em;
        border-radius: 1em; /* Rounded corners */
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        max-width: 850px;
        margin: 1em auto;
        margin-bottom: 70px;
        box-shadow: 0 0.7em 1em rgba(0, 0, 0, 0.2);
        transition: 200ms;
    }
    ${$8901f5b516489ece$var$tagName} .flex-col-center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 12px;
    }
    ${$8901f5b516489ece$var$tagName} .text-1 {
        font-family: 'inter-bold', 'sans-serif';
        font-size: 36px;
        color: white;
    }
    ${$8901f5b516489ece$var$tagName} .text-2 {
        font-family: 'inter-bold', 'sans-serif';
        font-size: 28px;
        color: white;
    }
    ${$8901f5b516489ece$var$tagName} .button-cont {
        display: flex;
        gap: 1em;
        margin-top: 0.5em;
        justify-content: center;
        flex-wrap: wrap;
    }
    ${$8901f5b516489ece$var$tagName} .button {
        width: fit-content;
        padding: 1em 2em;
        color: black;
        background: var(--light-blue-gradient);
        border-radius: 0.3em;
        cursor: pointer;
        box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
        transition: 200ms;
        font-weight: 500;
    }
    body.has-hover ${$8901f5b516489ece$var$tagName} .button:hover {
        transform: translateY(-2px);
    }
    ${$8901f5b516489ece$var$tagName} .button span {
        font-size: 1.1em;
        font-weight: 800px;
    }

    @media (max-width: 634px) {

        ${$8901f5b516489ece$var$tagName} {
            max-width: 500px;
        }

    }

    @media (max-width: 400px) {

        ${$8901f5b516489ece$var$tagName} {
            max-width: 330px;
            margin-top: 40px;
        }

        ${$8901f5b516489ece$var$tagName} .text-1 {
            font-size: 34px;

        }

    }
`;
const $8901f5b516489ece$var$renderButtonContHTML = (options)=>{
    return /*html*/ `
        <a class="button" ${options.ctas[0].internal ? "internal" : ""} 
            ${options.ctas[0].newTab ? 'target="_blank"' : ""} 
            href="${options.ctas[0].href}">
            <span>${options.ctas[0].label}</span>
        </a>
    `;
};
const $8901f5b516489ece$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="flex-col-center">
            <div class="text-1">
                ${options.texts[0]}
            </div>
            <div class="text-2">
                ${options.texts[1]}
            </div>
            <div class="button-cont">
                ${$8901f5b516489ece$var$renderButtonContHTML(options)}
            </div>
        </div>
        <style>${$8901f5b516489ece$var$css}</style>
    `;
};
class $8901f5b516489ece$var$QuizComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(atob(this.getAttribute("element-options")));
        this.removeAttribute("element-options");
        this.innerHTML = $8901f5b516489ece$var$renderInnerHTML(this.options);
    }
}
customElements.define($8901f5b516489ece$var$tagName, $8901f5b516489ece$var$QuizComponent);
function $8901f5b516489ece$var$render(options) {
    return `<${$8901f5b516489ece$var$tagName} element-options="${btoa(JSON.stringify(options))}"></${$8901f5b516489ece$var$tagName}>`;
}
var $8901f5b516489ece$export$2e2bcd8739ae039 = $8901f5b516489ece$var$render;


const $b463acade1f18979$var$tagName = "azav-verifiziert-section";
var $b463acade1f18979$var$css = /*css*/ `
${$b463acade1f18979$var$tagName} {
    display: block;
    font-family: 'inter-medium';
}
${$b463acade1f18979$var$tagName} .grid-outer-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 20px; 
    padding-top: 90px;
    padding-bottom: 20px;
}

${$b463acade1f18979$var$tagName} .section-grid {
    max-width: 900px; /* Adjusted to match the width of the boxes above */
    display: grid;
    gap: 40px;
    grid-template-columns: 2fr 1fr;
}
${$b463acade1f18979$var$tagName} .text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.6em;
}
${$b463acade1f18979$var$tagName} .section-title {
    font-family: 'inter-bold';
    font-size: 1.5rem;
    margin-bottom: 1em;
}
${$b463acade1f18979$var$tagName} .section-text {
    font-size: 1rem;
    margin-bottom: 1.5em;
}
${$b463acade1f18979$var$tagName} .info-img {
    background-image: url('/assets/images/azav-logo.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
}

/* Responsive adjustments */

@media (max-width: 956px) {

    ${$b463acade1f18979$var$tagName} .grid-outer-cont {
        padding: 40px 40px; /* Further reduce padding on smaller screens */
        padding-top: 90px;
        padding-bottom: 20px;
    }

    ${$b463acade1f18979$var$tagName} .section-grid {
        max-width: 700px;
    }


}
@media(max-width: 899px){
    ${$b463acade1f18979$var$tagName} .section-grid {
        grid-template-columns: 1fr;
    }
    ${$b463acade1f18979$var$tagName} .info-img {
        height: 200px;
    }
}

@media (max-width: 500px) {
    ${$b463acade1f18979$var$tagName} .grid-outer-cont {
        padding: 40px 40px; /* Further reduce padding on smaller screens */
        padding-bottom: 20px;
    }

    ${$b463acade1f18979$var$tagName} .info-img {
        padding-left: 40px;
}
}

`;
const $b463acade1f18979$var$renderInnerHTML = ()=>{
    return /*html*/ `
    <div class="grid-outer-cont">
        <div class="section-grid">
            <div class="text-content">
                <div class="section-title">AZAV verifiziert</div>
                <div class="section-text">Franklin Institute of Applied Sciences ist ein AZAV-zertifiziertes Institut, das sich auf die Ausbildung in technischen Berufen spezialisiert hat. Wir arbeiten seit vielen Jahren mit dem Jobcenter und der Agentur f\xfcr Arbeit zusammen, um Ihren Klient*innen durch den Bildungsgutschein oder AVGS optimalen Zugang zu unseren praxisnahen Weiterbildungen zu verschaffen.</div>
            </div>
            <div class="info-img"></div>
        </div>
    </div>
    <style>${$b463acade1f18979$var$css}</style>
    `;
};
class $b463acade1f18979$var$AzavVerifiziertSection extends HTMLElement {
    connectedCallback() {
        this.innerHTML = $b463acade1f18979$var$renderInnerHTML();
    }
}
customElements.define("azav-verifiziert-section", $b463acade1f18979$var$AzavVerifiziertSection);
function $b463acade1f18979$var$render() {
    return `<${$b463acade1f18979$var$tagName}></${$b463acade1f18979$var$tagName}>`;
}
var $b463acade1f18979$export$2e2bcd8739ae039 = $b463acade1f18979$var$render;


const $a219e08290095784$var$tagName = "fcc-6-schritte-component";
// CSS to be applied globally
var $a219e08290095784$var$fccComponentCss = /*css*/ `
.fcc-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px; /* Reduced padding for compactness */
    background-color: transparent;
}

.fcc-svg-container {
    width: 100%;
    max-width: 800px; /* Increased max width for SVG container */
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 800px; /* This prevents layout shifts */
}

svg {
    width: 100%;
    height: auto;
    max-width: 100%; /* Ensures SVG scales within its container */
    overflow: visible;
}

/* Hover effects for desktop SVG elements */
#desktop-01,
#desktop-02,
#desktop-03,
#desktop-04,
#desktop-05,
#desktop-06 {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.15));
    transition: transform 0.3s ease;
    transform-origin: center;
}

#desktop-01 {
    position: relative;
    transition: transform 0.3s ease;
}

#desktop-01:hover {
    position: absolute;
    transform: translateX(5px) !important;
    top: 0 !important;
}

#desktop-02:hover {
    transform: translateX(5px);
}

#desktop-03:hover {
    transform: translateY(5px) !important;
}

#desktop-04:hover,
#desktop-06:hover,
#desktop-05:hover {
    transform: translateX(-5px);
}

/* Title and text styles */
.centered-text {
    text-align: center;
    margin-bottom: 0.1em;
    font-family: 'inter-bold';
    font-size: clamp(28px, 6.18vw, 45px);
    padding-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
}

.light-blue-text {
    color: var(--blue-brand);
}

/* Mobile adjustments */
@media (max-width: 630px) {
    .fcc-svg-container {
        display: none;
    }

    .centered-text {
        padding-top: 0px;
    }

    .fcc-container {
        display: none;
    }

    .fcc-svg-container-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 350px; /* Slightly larger max width for mobile view */
        margin: 0 auto;
        padding-top: 10px;
        padding-bottom: 10px;
        min-height: 900px; /* This prevents layout shifts */
    }

    svg {
        width: 100%;
        height: auto;
    }
}

/* Hide mobile SVG on larger screens */
@media (min-width: 631px) {
    .fcc-svg-container-mobile {
        display: none;
    }
}
`;
// HTML template for the component
var $a219e08290095784$var$fccComponentTemplate = /*html*/ `
<div class="section-message centered-text">
    <span style="font-size: clamp(28px, 6.18vw, 45px); font-family: 'inter-bold';">
        Franklin Career Center <br>
    </span>
    <span class="section-message centered-text" style="font-size: clamp(28px, 6.18vw, 45px); font-family: 'inter-bold';">
        Unsere
        <span class="light-blue-text" style="font-size: clamp(28px, 6.18vw, 45px); font-family: 'inter-bold';">
            6 Schritte zum Traumjob
        </span>
    </span>
</div>

<!-- Desktop SVG container -->
<section class="fcc-container">
    <div class="fcc-svg-container" id="desktop-svg-container"></div>
</section>

<!-- Mobile SVG container -->
<section class="fcc-container-mobile">
    <div class="fcc-svg-container-mobile" id="mobile-svg-container"></div>
</section>
`;
// Function to load the external SVG files
function $a219e08290095784$var$loadSVG(svgUrl, containerElement) {
    fetch(svgUrl).then((response)=>response.text()).then((svgData)=>{
        containerElement.innerHTML = svgData;
        const svgElement = containerElement.querySelector("svg");
        if (svgElement) {
            svgElement.style.width = "100%";
            svgElement.style.height = "auto";
            svgElement.style.maxWidth = "800px";
        }
    }).catch((error)=>console.error("Error loading SVG:", error));
}
// Define the custom element without using Shadow DOM
class $a219e08290095784$var$FCC6SchritteComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // Append the template content
        this.innerHTML = $a219e08290095784$var$fccComponentTemplate;
        // Append the CSS styles directly to the document if not already added
        if (!document.getElementById("fcc-6-schritte-styles")) {
            const style = document.createElement("style");
            style.id = "fcc-6-schritte-styles";
            style.textContent = $a219e08290095784$var$fccComponentCss;
            document.head.appendChild(style);
        }
        // Load the desktop and mobile SVGs
        const desktopSvgContainer = this.querySelector("#desktop-svg-container");
        const mobileSvgContainer = this.querySelector("#mobile-svg-container");
        $a219e08290095784$var$loadSVG("/assets/images/FCC 6 Schritte.svg", desktopSvgContainer);
        $a219e08290095784$var$loadSVG("/assets/images/FCC 6 Schritte Mobile.svg", mobileSvgContainer);
    }
}
customElements.define($a219e08290095784$var$tagName, $a219e08290095784$var$FCC6SchritteComponent);
var $a219e08290095784$export$2e2bcd8739ae039 = $a219e08290095784$var$FCC6SchritteComponent;


const $df492b283b41f7dd$var$tagName = "video-section";
var $df492b283b41f7dd$var$css = /*css*/ `
    ${$df492b283b41f7dd$var$tagName} {
        display: block;
        text-align: center;
        margin-top: 1rem;
        padding: 20px;
    }
    ${$df492b283b41f7dd$var$tagName} iframe {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        aspect-ratio: 16 / 9;
        border-radius: 20px;
        overflow: hidden;
        border: none;
        box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    }
`;
class $df492b283b41f7dd$var$VideoSection extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const videoURL = this.getAttribute("data-video-url");
        this.innerHTML = `
            <iframe src="${videoURL}" allow="autoplay; fullscreen" allowfullscreen></iframe>
            <style>${$df492b283b41f7dd$var$css}</style>
        `;
    }
}
customElements.define($df492b283b41f7dd$var$tagName, $df492b283b41f7dd$var$VideoSection);
function $df492b283b41f7dd$export$2e2bcd8739ae039(videoURL) {
    return `<${$df492b283b41f7dd$var$tagName} data-video-url="${videoURL}"></${$df492b283b41f7dd$var$tagName}>`;
}


const $92733ef4b7d17708$var$tagName = "home-page";
var $92733ef4b7d17708$var$pageTitle = "Home | Franklin Institute of Applied Sciences";
var $92733ef4b7d17708$var$pageDescription = "Das Franklin Institute bietet zu 100% staatliche gef\xf6rderte IT-Weiterbildungen und Karriereunterst\xfctzung f\xfcr Arbeitssuchende. Entdecke deine M\xf6glichkeiten in der IT-Branche mit unserem umfassenden Kursangebot, erfahrenen Dozenten und individueller Beratung. Starte jetzt deine erfolgreiche IT-Karriere mit uns.";
var $92733ef4b7d17708$var$videoURL = "https://fast.wistia.com/embed/medias/yc67ol9ioj";
const $92733ef4b7d17708$var$j = JSON.stringify;
var $92733ef4b7d17708$var$css = /*css*/ `
    ${$92733ef4b7d17708$var$tagName} {
        font-size: clamp(16px, 1.8vw, 18px);
    }

    ${$92733ef4b7d17708$var$tagName} .blue-underline-big {
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
        text-decoration-thickness: 3px;
        text-underline-offset: 4px;
    }

    ${$92733ef4b7d17708$var$tagName} .blue-underline-small {
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
        text-decoration-thickness: 2px;
        text-underline-offset: 4px;
    }

    ${$92733ef4b7d17708$var$tagName} triplecolumn {
        display: flex;
        background: red;
    }
    ${$92733ef4b7d17708$var$tagName} .flex-col-center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    ${$92733ef4b7d17708$var$tagName} .two-col-wrapper {
        margin-bottom: 3em;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    ${$92733ef4b7d17708$var$tagName} .blue-line {
        height: 0.5em;
        background: var(--blue-wide-gradient);
    }
    ${$92733ef4b7d17708$var$tagName} .hero-1 {
        font-family: 'inter-bold', sans-serif;
        font-size: 2em;
        margin-bottom: 0.5em;
    }
    ${$92733ef4b7d17708$var$tagName} .hero-2 {
        font-family: 'inter-bold', sans-serif;
        font-size: 1.6em;
        margin-bottom: 0.5em;
    }
    ${$92733ef4b7d17708$var$tagName} .grow-font-2 {
        font-size: clamp(32px, 4.18vw, 46px) !important;
    }
    ${$92733ef4b7d17708$var$tagName} .section-dream-career .two-col-wrapper {
        margin-top: 3em;
        margin-bottom: 2em;
        gap: 4em;
    }
    @media (min-width: 700px) {
        ${$92733ef4b7d17708$var$tagName} .section-dream-career .two-col-wrapper {
            flex-direction: column;
        }
    }
    @media (min-width: 900px) {
        ${$92733ef4b7d17708$var$tagName} .section-dream-career .two-col-wrapper {
            flex-direction: row;
        }
    }
    ${$92733ef4b7d17708$var$tagName} .dream-career-img {
        display: block;
        width: 320px;
        aspect-ratio: 633/948;
        background-image: url('/assets/images-webp/dream-career-img.webp');
        border-radius: 0.7em;
    }
    ${$92733ef4b7d17708$var$tagName} .hero-3 {
        font-family: 'inter-medium', sans-serif;
        font-size: 1.2em;
        margin-bottom: 0.5em;
    }
    ${$92733ef4b7d17708$var$tagName} .section-dream-career .hero-3 {
        font-family: 'inter-bold', sans-serif;
    }
    ${$92733ef4b7d17708$var$tagName} .section-dream-career .paragraph {
        margin-bottom: 0;
    }
    ${$92733ef4b7d17708$var$tagName} .paragraph {
        margin-bottom: 2em;
        line-height: 1.6em;
        font-family: 'inter-medium', sans-serif;
    }
    ${$92733ef4b7d17708$var$tagName} .numbered-list-item {
        display: flex;
    }
    ${$92733ef4b7d17708$var$tagName} .section-dream-career .two-col-cont b {
        font-family: 'inter-bold', sans-serif;
    }
    ${$92733ef4b7d17708$var$tagName} .numbered-list-item-number {
        font-size: 45px;
        margin-right: 45px;
        margin-left: 35px;
        position: relative;
        z-index: 1;
        font-family: 'inter-medium', sans-serif;
    }
    ${$92733ef4b7d17708$var$tagName} .numbered-list-item-number:before {
        position: absolute;
        left: -40px;
        top: -10px;
        content: '';
        width: 90px;
        height: 90px;
        z-index: -1;
        background-image: url('/assets/images/number-background.svg');
        background-size: 100% 100%;
    }
    ${$92733ef4b7d17708$var$tagName} .limit-max-width {
        max-width: 85%;
        margin-left: auto;
        margin-right: auto;
    }
    @media (max-width: 1100px) {
        ${$92733ef4b7d17708$var$tagName} .limit-max-width {
            max-width: 95%;
        }
    }
    @media (max-width: 459px) {
        ${$92733ef4b7d17708$var$tagName} .numbered-list-item-number {
            display: none;
        }
        ${$92733ef4b7d17708$var$tagName} .numbered-list-item .hero-3:before {
            content: attr(data-num);
            margin-right: 0.3em;
        }
    }
    ${$92733ef4b7d17708$var$tagName} .course-card-cont {
        display: flex;
        gap: 2em;
        margin: 0 auto;
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;
    }
    ${$92733ef4b7d17708$var$tagName} .course-card-cont course-card {
        width: 450px;
    }
    @media (max-width: 490px) {
        ${$92733ef4b7d17708$var$tagName} .course-card-cont {
            gap: 1em;
        }
    }
    ${$92733ef4b7d17708$var$tagName} .course-card-title {
        font-family: 'inter-bold';
        font-size: clamp(1.5rem, 9.375vw, 30px);
        text-align: center;
        margin-bottom: 0.8em;
    }

    ${$92733ef4b7d17708$var$tagName} azav-verifiziert-section {
        margin-top: -20px; 
        padding-top: 0;
    }

    @media (max-width: 490px) {
        ${$92733ef4b7d17708$var$tagName} azav-verifiziert-section {
            margin-top: 10px;
        }
    }
    
`;
function $92733ef4b7d17708$var$template() {
    return /*html*/ `
    <div class="wrapper">
        ${0, $6891603719d52046$export$2e2bcd8739ae039}
    </div>
    ${0, $fe58bfe3bd6680f4$export$2e2bcd8739ae039}
    <div style="width: 100%; height: 70px;"></div>
    <div class="wrapper">
        <div class="course-card-title" id="courses">Unsere Weiterbildungen</div>
        <div class="course-card-cont">
            ${(0, $a87dd6ab648eaad6$export$2e2bcd8739ae039)({
        title: "IT-Berater im Produktmanagement",
        bulletPoints: [
            "Inkl. Karrierecoaching",
            "100% finanziert durch die Agentur f\xfcr Arbeit",
            "Inkl. MacBook",
            //`${config.courseData.pm.duration} Monate Dauer`,
            `${config.courseData.pm.minCertCount} anerkannte Zertifikate + IHK Zertifikat`
        ],
        imageURL: "/assets/images-webp/course-banner-img-pm.webp",
        ctaURL: "/courses/pm"
    })}
            ${(0, $a87dd6ab648eaad6$export$2e2bcd8739ae039)({
        title: "IT-Vertriebsmanager & CRM Spezialist",
        bulletPoints: [
            "Inkl. Karrierecoaching",
            "100% finanziert durch die Agentur f\xfcr Arbeit",
            "Inkl. MacBook",
            //`${config.courseData.sales.duration} Monate Dauer`,
            `${config.courseData.sales.minCertCount} anerkannte Zertifikate + IHK Zertifikat`
        ],
        imageURL: "/assets/images-webp/course-banner-img-sales.webp",
        ctaURL: "/courses/sales"
    })}
        </div>
    </div>
    <div style="width: 100%; height: 70px;"></div>

    ${(0, $8901f5b516489ece$export$2e2bcd8739ae039)({
        texts: [
            'Welche Weiterbildung passt <span class="blue-underline-big">am besten</span> zu dir?',
            'Finde es <span class="blue-underline-big">jetzt heraus</span> und mache den Test!'
        ],
        ctas: [
            {
                label: "Jetzt Test starten!",
                href: config.ctaURLS.quiz,
                internal: false,
                newTab: true
            }
        ]
    })}

    <div class="section section-dream-career">
        <div class="wrapper">
            <div class="flex-col-center">
                <div class="hero-1 grow-font-2"> Und so funktionierts</div>
                <div class="hero-2" style="color: var(--blue-brand);">In vier einfachen Schritten zur Traumkarriere</div>
            </div>
            <div class="two-col-wrapper limit-max-width">
                <div class="two-col-cont" style="flex: 0; display: flex; justify-content: center; align-items: center;">
                    <div style="display: flex;">
                        <div class="dream-career-img bg-img-cover"></div>
                    </div>
                </div>
                <div class="two-col-cont list-col" style="flex: 1;">
                    <div style="display: flex; flex-direction: column; gap: 2rem;">
                        <div class="numbered-list-item" data-num="1">
                            <div class="numbered-list-item-number">
                                1
                            </div>
                            <div class="numbered-list-item-text">
                                <div class="hero-3" data-num="1.">F\xfclle unsere Kurzbewerbung aus.</div>
                                <div class="paragraph">
                                    \xdcber den Button gelangst Du zu unserem Bewerbungsformular. Nachdem du dieses ausgef\xfcllt hast setzen wir uns mit dir in Verbindung und sprechen mit dir \xfcber deine Bewerbung.
                                </div>
                            </div>
                        </div>
                        <div class="numbered-list-item" data-num="2">
                            <div class="numbered-list-item-number">
                                2
                            </div>
                            <div class="numbered-list-item-text">
                                <div class="hero-3" data-num="2.">Bildungsgutschein sichern</div>
                                <div class="paragraph">
                                    Wir helfen dir dabei einen <b>Bildungsgutschein</b> bei der Agentur f\xfcr Arbeit oder beim Jobcenter zu beantragen. So ist deine Weiterbildung bei uns zu <b>100% kostenlos.</b> 
                                </div>
                            </div>
                        </div>
                        <div class="numbered-list-item" data-num="3">
                            <div class="numbered-list-item-number">
                                3
                            </div>
                            <div class="numbered-list-item-text">
                                <div class="hero-3" data-num="3.">Gemeinsam lernen - Profi werden</div>
                                <div class="paragraph">
                                    <b>Du erh\xe4ltst einen Laptop</b> von uns und dein Weg in eine <b>erfolgreiche IT-Karriere</b> kann beginnen! 
                                </div>
                            </div>
                        </div>
                        <div class="numbered-list-item" data-num="4">
                            <div class="numbered-list-item-number">
                                4
                            </div>
                            <div class="numbered-list-item-text">
                                <div class="hero-3" data-num="4.">Der Einstieg in deine Karriere</div>
                                <div class="paragraph">
                                    Mit unserem <b>Bewerbungs- und Karriere Coaching</b> helfen wir dir kostenlos dabei deinen <b>Traumjob</b> zu finden! 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section" style="background: var(--gray-brand);">
        <div class="blue-line"></div>
        <div class="wrapper" style="padding: 2rem 0;">
            <div class="flex-col-center">
                <div class="hero-1" style="margin-bottom: 1em; color: white; text-align: center;">Finde jetzt heraus, ob Du zu uns passt!</div>
                <a cta-prevent-inner-hover target="_blank" href="${config.ctaURLS.main}" class="menu-desktop">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Jetzt bewerben</span>`)}</a>
            </div>
        </div>
        <div class="blue-line"></div>
    </div>
    <style>
        ${$92733ef4b7d17708$var$tagName} .section-why {
            display: flex;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
            margin-top: 3rem;
        }
        ${$92733ef4b7d17708$var$tagName} .section-why .two-col-wrapper {
            display: flex;
            justify-content: center;
        }
        ${$92733ef4b7d17708$var$tagName} checkbox-list {
            flex: 1.2;
        }
        ${$92733ef4b7d17708$var$tagName} fias-why-section-visual {
            flex: 1;
        }
        ${$92733ef4b7d17708$var$tagName} .section-why-main-cont {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 3em;
            margin-top: 2.5em;
            padding: 0 3em;
        }
        @media(max-width: 1100px){
            ${$92733ef4b7d17708$var$tagName} .section-why-main-cont {
                gap: 2em;
                padding: 0 1em;
            }
            ${$92733ef4b7d17708$var$tagName} checkbox-list {
                flex: 1.3;
            }
            ${$92733ef4b7d17708$var$tagName} fias-why-section-visual {
                flex: 1;
            }
        }
        @media(max-width: 899px){
            ${$92733ef4b7d17708$var$tagName} .section-why-main-cont {
                flex-direction: column-reverse;
                max-width: 500px;
                margin-top: 1.5em;
            }
            ${$92733ef4b7d17708$var$tagName} .section-why {
                max-width: 500px;
            }
            ${$92733ef4b7d17708$var$tagName} checkbox-list {
                flex: initial;
            }
            ${$92733ef4b7d17708$var$tagName} fias-why-section-visual {
                flex: initial;
            }
        }
        @media(max-width: 400px){
            ${$92733ef4b7d17708$var$tagName} .section-why-main-cont {
                gap: 2em;
                padding: 0 0em;
            }
        }
    </style>
    <div class="section section-why">
        <div class="wrapper">
            <div class="flex-col-center">
                <div class="hero-1 grow-font-2">Warum das Franklin Institute?</div>
                <div class="hero-2" style="color: var(--blue-brand);">Profitiere von unserem einzigartigen Weiterbildungs-System</div>
            </div>
            <div class="section-why-main-cont">
                ${0, $d86d723d4c921682$export$2e2bcd8739ae039}
                ${(0, $8c93dffafa28d4b6$export$2e2bcd8739ae039)([
        {
            title: "Zeitaufwand auf das mindeste reduziert!",
            content: "Unsere Weiterbildung soll <b>in Dein Leben passen</b> und so schnell wie m\xf6glich dabei helfen, dass Du Deinen Weg in <b>Deine Traumkarriere</b> findest."
        },
        {
            title: "100% Kostenlos - mit Bildungsgutschein",
            content: "Bildung sollte bezahlbar, oder noch besser, <b>kostenlos</b> sein. Unsere Weiterbildung kannst Du <b>mit dem Bildungsgutschein komplett kostenlos absolvieren</b>. Bewerbe Dich einfach bei uns, <b>wir helfen Dir</b>, den Bildungsgutschein zu erhalten."
        },
        {
            title: "Individuelle Betreuung - lernen in kleinen Gruppen",
            content: "Damit Du in unserem einj\xe4hrigen Karriereprogramm optimal auf Deinen neuen Job vorbereitet wirst, setzen wir auf <b>kleine, homogene</b> Lerngruppen."
        },
        {
            title: "Unschlagbares Karriere-Programm f\xfcr deinen Traumjob",
            content: "Aufgrund der langen Erfahrung und der verschiedenen Karrierewege unseres Gr\xfcnderteams verf\xfcgen wir \xfcber einen <b>unbezahlbaren Wissensschatz aus \xfcber 50 Jahren erfolgreicher Karrieren</b> in verschiedensten Bereichen. <b>Dieses Wissen wollen wir mit dir teilen, ohne Aufpreis, ohne Verpflichtungen.</b> Deshalb haben wir unser <b>Karriere- und Bewerbungscoaching</b> entwickelt um dir am Ende deiner Ausbildung das n\xf6tige Wissen f\xfcr einen <b>Raketenstart in deine eigene erfolgreiche Karriere</b> zu geben! Freu dich darauf, das ist der <b>wohl wichtigste Teil deiner Weiterbildung beim Franklin Institute.</b>"
        }
    ])}
            </div>
        </div>
    </div>

    <azav-verifiziert-section></azav-verifiziert-section>
 
    <div class="fcc-section-wrapper" style="padding-top: 25px;">
    <fcc-6-schritte-component></fcc-6-schritte-component>
    <!-- Title Section -->
    <div class="video-title" style="text-align: center; color: var(--gray-brand); font-family: 'inter-bold', sans-serif; font-size: clamp(28px, 6.18vw, 45px); margin: 20px 0;">
    Unsere Arbeit im <span style="color: var(--blue-brand);">FCC</span> f\xfcr <br> einen
    <span style="color: var(--blue-brand);"> Start in deinem Traumjob</span>
    </div>

    <!-- Video Section -->
    ${(0, $df492b283b41f7dd$export$2e2bcd8739ae039)($92733ef4b7d17708$var$videoURL)}
    </div>


    <div class="section" style="margin-top: 1rem;">
        <div class="wrapper">
            ${0, $26e554f22bcc5aa9$export$2e2bcd8739ae039}
        </div>
       ${0, $741eb4901885d7cb$export$2e2bcd8739ae039} <!-- FeedbackSection -->

    </div>
    <div class="section" style="margin: 1rem 0;">
        <div class="wrapper">
            <div class="hero-1" style="text-align: center; margin-bottom: 3rem; margin-top: 2rem;" id="faq">H\xe4ufig gestellte Fragen:</div>
            ${(0, $726e3f6128d4ba4e$export$2e2bcd8739ae039)([
        {
            q: "Was bringt mir eine Weiterbildung beim Franklin Institute?",
            a: "Wir leben Karriere. Das ist unser Motto - Unsere Weiterbildungen sollen Dir genau das erm\xf6glichen - Karriere. Wir bilden Dich \xfcber mehrere Monate in einem relevanten Beruf in der IT-Branche aus und unterst\xfctzen Dich dann beim Einstieg in deine Traumkarriere. Mit uns an Deiner Seite formen wir Deine Karriere und geben Dir alles an die Hand, was Du brauchst um beruflich erfolgreich zu sein."
        },
        {
            q: "Welche Voraussetzungen muss ich erf\xfcllen?",
            a: "Um an der Weiterbildung & am Career Success Programm teilnehmen zu k\xf6nnen, musst Du lediglich (bald) bei der Agentur f\xfcr Arbeit oder beim Jobcenter arbeitslos gemeldet sein. Solltest Du dies nicht sein, ist die Teilnahme leider nicht m\xf6glich. Du wirst in absehbarer Zeit arbeitslos? Dann bewerbe Dich gerne \xfcber unser kurzes Formular bei uns."
        },
        {
            q: "Fallen f\xfcr die Weiterbildung Kosten an?",
            a: "Wenn Du arbeitslos gemeldet bist, hast Du die M\xf6glichkeit einen Bildungsgutschein vom Staat zu erhalten. Dieser Bildungsgutschein finanziert Dir die komplette Weiterbildung und unser Career Success Programm - somit ist unser gesamtes Angebot kostenlos f\xfcr Dich. Bewerbe Dich gerne \xfcber unser kurzes Formular und wir helfen Dir dabei einen Bildungsgutschein zu erhalten."
        },
        {
            q: "Kann ich die Weiterbildung von Zuhause aus absolvieren?",
            a: "Ja - die komplette Weiterbildung inkl. Career Success Programm findet Remote statt. Somit hast Du die M\xf6glichkeit von \xfcberall aus teilzunehmen. Du erh\xe4ltst auch einen Laptop von uns."
        },
        {
            q: "Erhalte ich nach meiner Weiterbildung ein anerkanntes Zertifikat?",
            a: "Ja, da wir AZAV zertifiziert sind, erh\xe4ltst du nach deiner Weiterbildung ein offizielles Abschluss-Zertifikat von uns. Zus\xe4tzlich erh\xe4ltst du w\xe4hrend unseren Weiterbildungen einige, in der IT-Branche sehr angesehene, Zertifikate von namhaften Anbietern. So stellen wir sicher, dass du am Ende neben deiner Praxiserfahrung auch die n\xf6tigen Dokumente f\xfcr einen erfolgreichen Einstieg in die IT-Branche vorlegen kannst."
        }
    ])}
        </div>
    </div>
    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
        ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Bewerbungsformular oder rufen Sie uns direkt an."
        ],
        ctas: [
            {
                label: "Jetzt bewerben.",
                href: config.ctaURLS.main,
                internal: false,
                newTab: true
            },
            {
                label: "+49 89 62826149",
                href: "tel:+498962826149"
            }
        ]
    })}
    </div>
    <style>${$92733ef4b7d17708$var$css}</style>
    `;
}
//<feature-card element-options='${j({title: "MacBook inklusive", html: '<img src="https://franklin-institute.de/images-webp/hero-img.webp"/>Hallo'})}'/></feature-card>
class $92733ef4b7d17708$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($92733ef4b7d17708$var$pageTitle);
        util.setPageDescription($92733ef4b7d17708$var$pageDescription);
        this.innerHTML = $92733ef4b7d17708$var$template();
    }
}
customElements.define($92733ef4b7d17708$var$tagName, $92733ef4b7d17708$var$Page);
var $92733ef4b7d17708$export$2e2bcd8739ae039 = `<${$92733ef4b7d17708$var$tagName}></${$92733ef4b7d17708$var$tagName}>`;




const $0e731ffcb5fe0c97$var$tagName = "notfound-page";
var $0e731ffcb5fe0c97$var$pageTitle = "404 | Franklin Institute of Applied Sciences";
var $0e731ffcb5fe0c97$var$pageDescription = "Das Franklin Institute bietet zu 100% staatliche gef\xf6rderte IT-Weiterbildungen und Karriereunterst\xfctzung f\xfcr Arbeitssuchende. Entdecke deine M\xf6glichkeiten in der IT-Branche mit unserem umfassenden Kursangebot, erfahrenen Dozenten und individueller Beratung. Starte jetzt deine erfolgreiche IT-Karriere mit uns.";
var $0e731ffcb5fe0c97$var$css = /*css*/ `
    ${$0e731ffcb5fe0c97$var$tagName} {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 3rem;
    }
    ${$0e731ffcb5fe0c97$var$tagName} .section-title {
        font-size: 6rem;
        font-family: 'inter-bold';
        text-align: center;
    }
    ${$0e731ffcb5fe0c97$var$tagName} .section-text {
        font-size: 1rem;
        font-family: 'inter-bold';
        text-align: center;
    }
    ${$0e731ffcb5fe0c97$var$tagName} .section-btns {
        display: flex;
        gap: 1em;
        margin-top: 2rem;
    }
`;
var $0e731ffcb5fe0c97$var$template = /*html*/ `
    <div class="section-title">404</div>
    <div class="section-text">Diese Seite konnte nicht gefunden werden.</div>
    <div class="section-btns">
        <a cta-prevent-inner-hover onclick="history.back()" style="cursor: pointer;">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Zur\xfcck</span>`, {
    noBorder: true,
    shadow: true
})}</a>
        <a cta-prevent-inner-hover internal href="/">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Zur Startseite</span>`, {
    noBorder: true,
    shadow: true
})}</a>
    </div>
    <style>${$0e731ffcb5fe0c97$var$css}</style>
`;
class $0e731ffcb5fe0c97$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($0e731ffcb5fe0c97$var$pageTitle);
        util.setPageDescription($0e731ffcb5fe0c97$var$pageDescription);
        this.innerHTML = $0e731ffcb5fe0c97$var$template;
    }
}
customElements.define($0e731ffcb5fe0c97$var$tagName, $0e731ffcb5fe0c97$var$Page);
var $0e731ffcb5fe0c97$export$2e2bcd8739ae039 = `<${$0e731ffcb5fe0c97$var$tagName}></${$0e731ffcb5fe0c97$var$tagName}>`;




const $1ac07ed33ac075eb$var$tagName = "notfound-page-course";
var $1ac07ed33ac075eb$var$pageTitle = "404 | Franklin Institute of Applied Sciences";
var $1ac07ed33ac075eb$var$pageDescription = "Das Franklin Institute bietet praxisnahe IT-Weiterbildungen und gezielte Karriereunterst\xfctzung f\xfcr deinen Einstieg in die IT-Branche. Entdecke deine M\xf6glichkeiten mit unserem vielf\xe4ltigen Kursangebot, erfahrenen Dozenten und individueller Beratung. Starte jetzt deine erfolgreiche IT-Karriere mit uns.";
var $1ac07ed33ac075eb$var$css = /*css*/ `
    ${$1ac07ed33ac075eb$var$tagName} {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 3rem;
    }
    ${$1ac07ed33ac075eb$var$tagName} .section-title {
        font-size: 6rem;
        font-family: 'inter-bold';
        text-align: center;
    }
    ${$1ac07ed33ac075eb$var$tagName} .section-text {
        font-size: 1rem;
        font-family: 'inter-bold';
        text-align: center;
    }
    ${$1ac07ed33ac075eb$var$tagName} .section-btns {
        display: flex;
        gap: 1em;
        margin-top: 2rem;
    }
`;
var $1ac07ed33ac075eb$var$template = /*html*/ `
    <div class="section-title">404</div>
    <div class="section-text">Dieser Kurs konnte nicht gefunden werden. M\xf6glicherweise ist er bereits abgelaufen oder nicht mehr verf\xfcgbar.</div>
    <div class="section-btns">
        <a cta-prevent-inner-hover onclick="history.back()" style="cursor: pointer;">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Zur\xfcck</span>`, {
    noBorder: true,
    shadow: true
})}</a>
        <a cta-prevent-inner-hover internal href="/">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Zur Startseite</span>`, {
    noBorder: true,
    shadow: true
})}</a>
    </div>
    <style>${$1ac07ed33ac075eb$var$css}</style>
`;
class $1ac07ed33ac075eb$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($1ac07ed33ac075eb$var$pageTitle);
        util.setPageDescription($1ac07ed33ac075eb$var$pageDescription);
        this.innerHTML = $1ac07ed33ac075eb$var$template;
    }
}
customElements.define($1ac07ed33ac075eb$var$tagName, $1ac07ed33ac075eb$var$Page);
var $1ac07ed33ac075eb$export$2e2bcd8739ae039 = `<${$1ac07ed33ac075eb$var$tagName}></${$1ac07ed33ac075eb$var$tagName}>`;





const $7eab43868532f832$var$tagName = "about-page";
var $7eab43868532f832$var$pageTitle = "\xdcber das Franklin Institute of Applied Sciences";
var $7eab43868532f832$var$pageDescription = "Das Franklin Institute bietet zu 100% staatliche gef\xf6rderte IT-Weiterbildungen und Karriereunterst\xfctzung f\xfcr Arbeitssuchende. Entdecke deine M\xf6glichkeiten in der IT-Branche mit unserem umfassenden Kursangebot, erfahrenen Dozenten und individueller Beratung. Starte jetzt deine erfolgreiche IT-Karriere mit uns.";
var $7eab43868532f832$var$css = /*css*/ `

`;
function $7eab43868532f832$var$template() {
    return /*html*/ `
    <iframe id="test-frame" src="/legacy-website/frames/about_frame.html" frameborder="0" width="100%" scrolling="no" height="2000px" title="${$7eab43868532f832$var$pageTitle}"></iframe>
    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
        ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Bewerbungsformular oder rufen Sie uns direkt an."
        ],
        ctas: [
            {
                label: "Jetzt bewerben.",
                href: config.ctaURLS.main,
                internal: false,
                newTab: true
            },
            {
                label: "+49 89 62826149",
                href: "tel:+498962826149"
            }
        ]
    })}
    </div>
    <a cta-emulator href="${config.ctaURLS.main}" target="_blank" style="display: none;"></a>
    <style>${$7eab43868532f832$var$css}</style>
    `;
}
class $7eab43868532f832$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($7eab43868532f832$var$pageTitle);
        util.setPageDescription($7eab43868532f832$var$pageDescription);
        this.innerHTML = $7eab43868532f832$var$template();
        this.iframeElem = this.querySelector("iframe");
        this.messageEvent = eventBus.register("message", (options)=>{
            this.handleIframeMessage(options);
        });
    }
    disconnectedCallback() {
        this.messageEvent.unregister();
    }
    handleIframeMessage(message) {
        try {
            var msg = JSON.parse(message);
            if (msg.type == "height") {
                var setHeight = Math.floor(msg.data) + 5 + "px";
                this.iframeElem.height = setHeight;
            }
            if (msg.type == "cta") this.querySelector("a[cta-emulator]").click();
        } catch  {}
    }
}
customElements.define($7eab43868532f832$var$tagName, $7eab43868532f832$var$Page);
var $7eab43868532f832$export$2e2bcd8739ae039 = `<${$7eab43868532f832$var$tagName}></${$7eab43868532f832$var$tagName}>`;



const $eb90d02e1cd2e134$var$tagName = "career-page";
var $eb90d02e1cd2e134$var$pageTitle = "Karriere beim Franklin Institute | Traumjob finden und durchstarten";
var $eb90d02e1cd2e134$var$pageDescription = "Entdecke spannende Karrierem\xf6glichkeiten beim Franklin Institute of Applied Sciences. Werde Teil unseres dynamischen Teams, nutze vielseitige Entwicklungschancen und arbeite mit inspirierenden Kollegen. Jetzt bewerben und deine berufliche Zukunft gestalten!";
var $eb90d02e1cd2e134$var$css = /*css*/ `

`;
var $eb90d02e1cd2e134$var$template = /*html*/ `
    <iframe id="test-frame" src="/legacy-website/frames/karriere_frame.html" frameborder="0" width="100%" scrolling="no" height="2000px" title="${$eb90d02e1cd2e134$var$pageTitle}"></iframe>
    <style>${$eb90d02e1cd2e134$var$css}</style>
`;
class $eb90d02e1cd2e134$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($eb90d02e1cd2e134$var$pageTitle);
        util.setPageDescription($eb90d02e1cd2e134$var$pageDescription);
        this.innerHTML = $eb90d02e1cd2e134$var$template;
        this.iframeElem = this.querySelector("iframe");
        this.messageEvent = eventBus.register("message", (options)=>{
            this.handleIframeMessage(options);
        });
    }
    disconnectedCallback() {
        this.messageEvent.unregister();
    }
    handleIframeMessage(message) {
        try {
            var msg = JSON.parse(message);
            if (msg.type == "height") {
                var setHeight = Math.floor(msg.data) + 5 + "px";
                this.iframeElem.height = setHeight;
            }
            if (msg.type == "cta") this.querySelector("a[cta-emulator]").click();
        } catch  {}
    }
}
customElements.define($eb90d02e1cd2e134$var$tagName, $eb90d02e1cd2e134$var$Page);
var $eb90d02e1cd2e134$export$2e2bcd8739ae039 = `<${$eb90d02e1cd2e134$var$tagName}></${$eb90d02e1cd2e134$var$tagName}>`;





const $b52b4475956ac080$var$tagName = "partner-page";
var $b52b4475956ac080$var$pageTitle = "F\xfcr Unternehmen | Franklin Institute of Applied Sciences";
var $b52b4475956ac080$var$pageDescription = "Sichern Sie sich qualifizierte IT-Fachkr\xe4fte f\xfcr Ihr Unternehmen mit dem Partnerprogramm des Franklin Institute of Applied Sciences. Wir bieten ma\xdfgeschneiderte L\xf6sungen f\xfcr die planbare Gewinnung und das Upskilling von IT-Talenten. Finden Sie in unserem Talentpool die passenden Kandidaten und sparen Sie Zeit und Geld. Profitieren Sie von schnelleren Onboarding-Prozessen und einem exklusiven Zugang zu unseren Absolventen. Vereinbaren Sie jetzt einen Termin mit unserem Partner Management und starten Sie durch. Jetzt Partner werden!";
var $b52b4475956ac080$var$css = /*css*/ `
    // ${$b52b4475956ac080$var$tagName} {
    //     display: block;
    //     margin: 0;
    //     padding: 0;
    //     border: none;
    //     outline: none;
    //     background: var(--gray-brand);
    // }
    // ${$b52b4475956ac080$var$tagName} iframe {
    //     background: var(--gray-brand);
    // }
`;
var $b52b4475956ac080$var$template = /*html*/ `
    <iframe id="test-frame" src="/legacy-website/frames/partner_frame.html" frameborder="0" width="100%" scrolling="no" height="2000px" title="${$b52b4475956ac080$var$pageTitle}"></iframe>
    <style>${$b52b4475956ac080$var$css}</style>
`;
class $b52b4475956ac080$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($b52b4475956ac080$var$pageTitle);
        util.setPageDescription($b52b4475956ac080$var$pageDescription);
        this.innerHTML = $b52b4475956ac080$var$template;
        this.iframeElem = this.querySelector("iframe");
        this.messageEvent = eventBus.register("message", (options)=>{
            this.handleIframeMessage(options);
        });
    }
    disconnectedCallback() {
        this.messageEvent.unregister();
    }
    handleIframeMessage(message) {
        try {
            var msg = JSON.parse(message);
            if (msg.type == "height") {
                var setHeight = Math.floor(msg.data) + 5 + "px";
                this.iframeElem.height = setHeight;
            }
            if (msg.type == "cta") this.querySelector("a[cta-emulator]").click();
        } catch  {}
    }
}
customElements.define($b52b4475956ac080$var$tagName, $b52b4475956ac080$var$Page);
var $b52b4475956ac080$export$2e2bcd8739ae039 = `<${$b52b4475956ac080$var$tagName}></${$b52b4475956ac080$var$tagName}>`;





// File: /components/scarcity-progress-bar.js

const $0ed16f62426208ce$var$tagName = "scarcity-progress-bar";
const $0ed16f62426208ce$var$css = /*css*/ `
  ${$0ed16f62426208ce$var$tagName} {
    display: block;
    margin-top: 0px;
    margin-bottom: 20px;
  }

  /* Outer container with gradient border */
  .progress-container {
    width: 91%;
    height: 28px; 
    background: var(--light-blue-gradient, linear-gradient(90deg, #0a84ff, #3aa0ff));
    border-radius: 9999px; 
    padding: 2px;         
    box-sizing: border-box;
    position: relative;
  }

  /* White interior area */
  .inner {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 9999px;
    position: relative;
    overflow: hidden;
  }

  /* Gradient fill with white border */
  .progress-fill {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0%;
    border: 2px solid #fff;
    border-radius: 9999px;
    background: var(--light-blue-gradient, linear-gradient(90deg, #0a84ff, #3aa0ff));
    transition: width 0.4s ease;
    z-index: 1;
  }

  /* Text displayed underneath the progress bar */
  .progress-text {
    width: 91%;
    text-align: center;
    font-family: 'inter-bold', sans-serif;
    font-size: 12px;
    color: #333;
    margin-top: 8px;
  }

  @media (max-width: 768px) {
    .progress-container,
    .progress-text {
      width: 100%;
    }
  }
`;
function $0ed16f62426208ce$var$renderInnerHTML(progressValue) {
    return /*html*/ `
    <div class="progress-container">
      <div class="inner">
        <div class="progress-fill" style="width: ${progressValue}%;"></div>
      </div>
    </div>
    <div class="progress-text">${progressValue}% der Pl\xe4tze sind vergeben, melden Sie sich jetzt!</div>
    <style>${$0ed16f62426208ce$var$css}</style>
  `;
}
class $0ed16f62426208ce$var$ScarcityProgressBar extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // Get relevant attributes or default them
        this.courseSlug = this.getAttribute("courseSlug") || "pm";
        this.thresholdDays = parseInt(this.getAttribute("threshold") || "14", 10);
        // Calculate the final progress and set the HTML
        const progressValue = this.calculateProgress();
        this.innerHTML = $0ed16f62426208ce$var$renderInnerHTML(progressValue);
    }
    /**
   * Calculates a number between 70% and 95% based on how close today's date
   * is to the course's nextStartDate in window.config.courseData.
   */ calculateProgress() {
        const courseData = window.config.courseData[this.courseSlug];
        if (!courseData) {
            console.warn(`No course data found for slug: ${this.courseSlug}`);
            return 72;
        }
        const nextStartDate = new Date(courseData.nextStartDate);
        const today = new Date();
        // If start date is today or in the past, clamp to 89%.
        if (today >= nextStartDate) return 89;
        // Compute days remaining
        const msPerDay = 86400000;
        const daysRemaining = Math.ceil((nextStartDate - today) / msPerDay);
        // If more than thresholdDays remain, show 72%.
        if (daysRemaining > this.thresholdDays) return 72;
        // Otherwise, linearly interpolate from 72% -> 89% over the last thresholdDays
        const daysPassedWithinThreshold = this.thresholdDays - daysRemaining;
        const fraction = daysPassedWithinThreshold / this.thresholdDays;
        const progress = 72 + fraction * 25; // 72 -> 89 range
        return Math.min(89, Math.round(progress));
    }
}
customElements.define($0ed16f62426208ce$var$tagName, $0ed16f62426208ce$var$ScarcityProgressBar);
var $0ed16f62426208ce$export$2e2bcd8739ae039 = $0ed16f62426208ce$var$ScarcityProgressBar;


const $1bf35103779040b3$var$tagName = "product-hero-section";
const $1bf35103779040b3$var$heroData = {
    pm: {
        text: /*html*/ `IT-Berater im<br>Produktmanagement`,
        img: "/assets/images-webp/product-hero-img-pm.webp"
    },
    sales: {
        text: /*html*/ `IT-Vertriebsmanager <br>& CRM Spezialist`,
        img: "/assets/images-webp/product-hero-img-sales.webp"
    }
};
var $1bf35103779040b3$var$topSectionCSS = /*css*/ `
    ${$1bf35103779040b3$var$tagName} .product-hero-main-cont {
        display: flex;
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-content-title {
        font-size: clamp(1.5em, 7.1vw, 2.4em);
        font-family: 'inter-bold';
        letter-spacing: -0.01em;
        line-height: 1.1em;
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-content-title span {
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-content-cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1.3em;
        flex: 1;
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-visual-cont {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-img {
        aspect-ratio: 2/3;
        width: 100%;
        max-width: 340px;
        margin: auto;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 11px;
        position: relative;
        overflow: hidden;
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner-cont {
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        padding: 0.8em;
        gap: 0.8em;
        box-sizing: border-box;
        background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.5));
        background-size: 100% 100%;
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner {
        background: white;
        border-radius: 7px;
        flex: 1;
        padding: 8px 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        transition: transform 200ms;
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner:hover {
        transform: translateY(-3px);
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner span {
        font-size: 0.6rem;
        text-align: center;
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner-logo {
        display: flex;
        width: 100%;
        aspect-ratio: 55 / 18;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner-logo-ihk {
        background-image: url('/assets/images/ihk-akademie-muenchen-oberbayern.svg');
    }
    ${$1bf35103779040b3$var$tagName} .hero-img-partner-logo-ixdf {
        background-image: url('/assets/images/ixdf-logo-black-medium.png');
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-content-bulletpoints {
        display: flex;
        flex-direction: column;
        gap: 0.2em;
    }
    ${$1bf35103779040b3$var$tagName} .product-hero-content-bulletpoint:before {
        content: '';
        display: inline-block;
        width: 1em;
        height: 1em;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/assets/images/blue-arrow-double.svg');
        transform: rotate(-90deg) translateX(-0.15em);
        margin-right: 0.5em;
    }
    ${$1bf35103779040b3$var$tagName} .section-kursnet-link {
        transition: 200ms;
    }
    ${$1bf35103779040b3$var$tagName} .section-kursnet-link:hover{
        color: var(--blue-brand);
    }
    ${$1bf35103779040b3$var$tagName} .section-kursnet-link:before{
        content: "";
        display: inline-flex;
        width: 30px;
        aspect-ratio: 1 / 1;
        background-image: url('/assets/images/afa-logo.svg');
        background-size: contain;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        margin-right: 10px;
        transform: translateY(9px);
    }
    @media(max-width: 970px){
        ${$1bf35103779040b3$var$tagName} .product-hero-main-cont {
            gap: 3em;
        }
        ${$1bf35103779040b3$var$tagName} .product-hero-content-cont {
            flex: 1.5;
        }
        ${$1bf35103779040b3$var$tagName} .product-hero-visual-cont {
            flex: 1;
        }
    }
    @media(max-width: 840px){
        ${$1bf35103779040b3$var$tagName} {
            padding-top: 1rem;
        }
        ${$1bf35103779040b3$var$tagName} .product-hero-main-cont {
            flex-direction: column;
            max-width: 550px;
            margin: auto;
        }
        ${$1bf35103779040b3$var$tagName} .product-hero-content-title {
            text-align: center;
            margin-bottom: 0.5em;
        }
        ${$1bf35103779040b3$var$tagName} .product-hero-content-cont {
            flex: 1.5;
        }
        ${$1bf35103779040b3$var$tagName} .product-hero-visual-cont {
            flex: 1;
        }
    }
    @media(max-width: 470px){
        ${$1bf35103779040b3$var$tagName} .product-hero-content-bulletpoints {
            gap: 0.5em;
        }
    }
    @media(max-width: 360px){
        ${$1bf35103779040b3$var$tagName} .product-hero-main-cont {
            gap: 1.2em;
        }
    }
`;
var $1bf35103779040b3$var$featureCardCSS = /*css*/ `
    ${$1bf35103779040b3$var$tagName} .feature-card-cont {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        margin-top: 45px;
        gap: 45px;
    }
    @media (max-width: 999px) {
        ${$1bf35103779040b3$var$tagName} .feature-card-cont {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
        }
        ${$1bf35103779040b3$var$tagName} .feature-card-cont>*:nth-child(2){
            grid-column: 1 / 3;
        }
    
        ${$1bf35103779040b3$var$tagName} .feature-card-cont>*:nth-child(1){
            grid-row: 2;
        }
    }
    @media(max-width: 599px){
        ${$1bf35103779040b3$var$tagName} .feature-card-cont {
            grid-template-columns: 1fr;
            grid-template-rows: 1fr 1fr 1fr;
            gap: 20px;
        }
    
        ${$1bf35103779040b3$var$tagName} .feature-card-cont>*:nth-child(2){
            grid-column: initial;
        }
    
        ${$1bf35103779040b3$var$tagName} .feature-card-cont>*:nth-child(1){
            grid-row: initial;
        }
    }
    @media(max-width: 360px){
        ${$1bf35103779040b3$var$tagName} .feature-card-cont {
            margin-top: 20px;
        }
    }
`;
var $1bf35103779040b3$var$css = /*css*/ `
    ${$1bf35103779040b3$var$tagName} {
        display: block;
        padding-top: 2em;
        padding-bottom: 2rem;
        font-family: 'inter-medium';
    }
    ${$1bf35103779040b3$var$topSectionCSS}
    ${$1bf35103779040b3$var$featureCardCSS}

    @media(max-width: 430px) and (max-height: 932px){
        ${$1bf35103779040b3$var$tagName} .product-hero-content-bulletpoint {
            font-size: 13px;
            font-family: "inter-medium";
        }
    }

    @media(min-width: 971px) {
        ${$1bf35103779040b3$var$tagName} .product-hero-main-cont {
            justify-content: center; 
            padding-left: 80px; 
        }
    }

/* General title section styling */
${$1bf35103779040b3$var$tagName} .product-hero-content-title {
    margin-bottom: 0;
    padding-bottom: 0; 
}

/* Smaller title styling */
${$1bf35103779040b3$var$tagName} .product-hero-content-title .smaller-title {
    font-size: 20px;
    font-family: 'inter-bold';
    text-decoration: none;
    line-height: 1.2em; 
    margin-bottom: 0; 
    padding-bottom: 0; 
}

/* Large title (IT-Berater im Produktmanagement) styling */
${$1bf35103779040b3$var$tagName} .product-hero-content-title span {
    display: block;
    margin: 0; 
    padding: 0; 
}

/* Specific adjustment for the main title to bring it up */
${$1bf35103779040b3$var$tagName} .product-hero-content-title span:last-child {
    margin-top: -1em; 
    line-height: 1.1em; 
}

${$1bf35103779040b3$var$tagName} .google-review-cont {
    display: flex;
    gap: 1em;
    // max-width: 200px;
    align-items: center;
    margin-left: -5px;
}
${$1bf35103779040b3$var$tagName} .google-review-cont > div {
    // flex: 1;
    height: fit-content;
}
${$1bf35103779040b3$var$tagName} .google-review-img-left {
    width: 12em;
    max-width: 180px;
    aspect-ratio: 192 / 43;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50% 50%;
    background-image: url('/assets/images-webp/google-review-img-new.webp');
}
${$1bf35103779040b3$var$tagName} .google-review-right-side {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.8em;
}
${$1bf35103779040b3$var$tagName} .google-review-right-top {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}
${$1bf35103779040b3$var$tagName} .google-review-stars {
    display: flex;
    gap: 4px;
}
${$1bf35103779040b3$var$tagName} .google-review-star {
    width: 22px;
    aspect-ratio: 1/1;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50% 50%;
    background-image: url('/assets/images/star-icon.svg');
}
${$1bf35103779040b3$var$tagName} .google-review-rating {
    font-family: 'inter-bold';
}
${$1bf35103779040b3$var$tagName} .google-review-right-bottom {
    font-family: 'inter-light';
}

@media (max-width: 430px) {
    ${$1bf35103779040b3$var$tagName} .product-hero-content-title span:last-child {
        font-size: 35px; 
        line-height: 1.2em; 
        margin-top:-28px;

    }

    ${$1bf35103779040b3$var$tagName} .product-hero-content-text{
        font-size: 16px;
        text-align: center;
        font-family: "inter-medium";

    }
}
`;
const $1bf35103779040b3$var$renderInnerHTML = (options)=>{
    var slug = options.courseSlug;
    var useSlugText = $1bf35103779040b3$var$heroData[slug].text;
    var useSlugDuration = getAppConfig().courseData[slug].duration;
    var hideZertifikateInfo = false;
    var hideKostenlosInfo = false;
    var hideKursnetLink = false;
    var zumString = " zum";
    if (options.dynamicCourse) {
        zumString = "";
        var course = options.dynamicCourse;
        useSlugText = course.title_readability_optimized;
        useSlugDuration = course.duration;
        hideZertifikateInfo = true;
        hideKursnetLink = true;
        hideKostenlosInfo = true;
    }
    return /*html*/ `
        <div class="product-hero-main-cont">
            <div class="product-hero-content-cont">
                <div class="product-hero-content-title">
                    <span class="smaller-title">Sichere Dir Jetzt Deine <br> Online-Weiterbildung${zumString}</span><br>
                    <span>${useSlugText}</span>
                </div>
                <div class="product-hero-content-text">
                    <b>In ${useSlugDuration} Monaten aus der Arbeitslosigkeit zum Traumjob.</b>
                </div>
                <div class="product-hero-content-bulletpoints">
                    <div class="product-hero-content-bulletpoint"${hideKostenlosInfo ? ' style="display: none;"' : ""}><strong>Kostenlose </strong> Weiterbildung f\xfcr Arbeitssuchende \u{2705}</div>
                    <div class="product-hero-content-bulletpoint">Kostenloses <strong>MacBook</strong> inklusive \u{1F4BB}</div>
                    <div class="product-hero-content-bulletpoint">Bequem von <strong>zu Hause aus</strong> lernen \u{1F3E0}</div>
                    <div class="product-hero-content-bulletpoint"${hideZertifikateInfo ? ' style="display: none;"' : ""}>\xdcber <strong> ${getAppConfig().courseData[slug].minCertCount}</strong> angesehene <strong>Zertifikate</strong> + <strong>IHK Zertifikat</strong> \u{1F393}</div>
                    <div class="product-hero-content-bulletpoint">Optimal f\xfcr <strong>Quereinsteiger</strong> geeignet \u{1F4C8}</div>
                </div>
                <a class="section-kursnet-link product-hero-content-text" 
                target="_blank" href="https://web.arbeitsagentur.de/weiterbildungssuche/angebot/${getAppConfig().courseData[slug].kursnetID}"${hideKursnetLink ? ' style="display: none;"' : ""}>
                Unsere Ma\xdfnahme in Kursnet
                </a>
                         <!-- Hero Button -->
                <a cta-prevent-inner-hover target="_blank" href="${getAppConfig().ctaURLS[slug]}">
                ${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(slug === "pm" ? /*html*/ `Kostenlose Beratung vereinbaren und <span>durchstarten.</span>` : /*html*/ `Sicher dir deinen Platz - <span>Jetzt anmelden!</span>`)}
                </a>
              
                <!-- Scarcity Progress Bar Underneath Hero Button -->
                <scarcity-progress-bar courseSlug="${slug}" threshold="14"></scarcity-progress-bar>
              
                <!-- Google Review Section -->
                <div class="google-review-cont" style="text-align: center; max-width: 800px;">
                    <div class="google-review-img-left"></div>
                    <div class="google-review-right-side">
                        <div class="google-review-right-top">
                            <div class="google-review-stars">
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                            </div>
                            <div class="google-review-rating">5.0</div>
                        </div>
                        <div class="google-review-right-bottom">315+ Bewertungen</div>
                    </div>
                </div>
                <!-- End of Google Review Section -->
            </div>
            <div class="product-hero-visual-cont">
                <div class="product-hero-img-cont">
                    <div class="product-hero-img" style="background-image: url('${$1bf35103779040b3$var$heroData[slug].img}')">
                        <div class="hero-img-partner-cont">
                            <a target="_blank" href="https://www.ihk-akademie-muenchen.de/" class="hero-img-partner">
                                <span>Offizieller Partner von</span>
                                <div class="hero-img-partner-logo hero-img-partner-logo-ihk"></div>
                            </a>
                            <a target="_blank" href="https://www.interaction-design.org/courses" class="hero-img-partner">
                                <span>Offizieller Partner von</span>
                                <div class="hero-img-partner-logo hero-img-partner-logo-ixdf"></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="feature-card-cont">
            ${(0, $5efcc9e2a786d9af$export$2e2bcd8739ae039)(options.featureCards[0])}
            ${(0, $5efcc9e2a786d9af$export$2e2bcd8739ae039)(options.featureCards[1])}
            ${(0, $5efcc9e2a786d9af$export$2e2bcd8739ae039)(options.featureCards[2])}
        </div>
        <style>${$1bf35103779040b3$var$css}</style>
    `;
};
class $1bf35103779040b3$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $1bf35103779040b3$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($1bf35103779040b3$var$tagName, $1bf35103779040b3$var$CustomElem);
function $1bf35103779040b3$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$1bf35103779040b3$var$tagName} element-options="${e(JSON.stringify(options))}"></${$1bf35103779040b3$var$tagName}>`;
}
var $1bf35103779040b3$export$2e2bcd8739ae039 = $1bf35103779040b3$var$render;



const $2c2e1177fa389bbb$var$tagName = "yt-video-section";
var $2c2e1177fa389bbb$var$videoURL = "https://www.youtube-nocookie.com/embed/5q3nu1sOFwE?autoplay=1&rel=0&modestbranding=1&showinfo=0";
var $2c2e1177fa389bbb$var$css = /*css*/ `
    ${$2c2e1177fa389bbb$var$tagName} {
        display: block;
        margin-top: 1rem;
    }
    ${$2c2e1177fa389bbb$var$tagName} .video-thumbnail {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        margin-top: 2rem;
        margin-bottom: 6rem;
        aspect-ratio: 16 / 9;
        background-image: url('/assets/images-webp/hero-video-thumbnail-bg.webp');
        background-position: 50% 50%;
        background-size: cover;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    }
    ${$2c2e1177fa389bbb$var$tagName} .video-btn {
        width: 90px;
        aspect-ratio: 1 / 1;
        border-radius: 50%;
        background: #252629;
        transition: 0.2s;
        background-image: url("data:image/svg+xml,%3Csvg width='619' height='619' viewBox='0 0 619 619' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_1627_949' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='619' height='619'%3E%3Ccircle cx='309.5' cy='309.5' r='309.5' fill='%23252629'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_1627_949)'%3E%3Cpath d='M461.5 298.242C470.167 303.245 470.167 315.755 461.5 320.758L243.25 446.765C234.583 451.769 223.75 445.514 223.75 435.507V183.493C223.75 173.486 234.583 167.231 243.25 172.235L461.5 298.242Z' fill='%2300D5EA'/%3E%3C/g%3E%3C/svg%3E%0A");
        background-position: 50% 50%;
        background-size: 90px;
        background-repeat: no-repeat;
        animation: 1500ms btn-pulse infinite;
    }
    ${$2c2e1177fa389bbb$var$tagName} .video-thumbnail:hover .video-btn {
        background: white;
        background-image: url("data:image/svg+xml,%3Csvg width='619' height='619' viewBox='0 0 619 619' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_1627_949' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='619' height='619'%3E%3Ccircle cx='309.5' cy='309.5' r='309.5' fill='%23252629'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_1627_949)'%3E%3Cpath d='M461.5 298.242C470.167 303.245 470.167 315.755 461.5 320.758L243.25 446.765C234.583 451.769 223.75 445.514 223.75 435.507V183.493C223.75 173.486 234.583 167.231 243.25 172.235L461.5 298.242Z' fill='%2300D5EA'/%3E%3C/g%3E%3C/svg%3E%0A");
        background-position: 50% 50%;
        background-size: 120px;
        background-repeat: no-repeat;
    }
    @keyframes btn-pulse {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    ${$2c2e1177fa389bbb$var$tagName} .video-thumbnail>div>iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        overflow: hidden;
    }
`;
const $2c2e1177fa389bbb$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="section-message page-hero-medium centered font-scale-down" style="margin-bottom: 0.3em;">Was ist Produktmanagement \xfcberhaupt?</div>
        <div class="section-message centered" style="font-size: 1.3em;">Klicke auf das Video um mehr \xfcber deine Karrierechancen im Produktmanagement zu erfahren.</div>
        <div class="video-thumbnail" id="video">
            <div class="video-btn"></div>
        </div>
        <style>${$2c2e1177fa389bbb$var$css}</style>
    `;
};
class $2c2e1177fa389bbb$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $2c2e1177fa389bbb$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
        this.initVideo();
    }
    initVideo() {
        var btn = this.querySelector(".video-thumbnail");
        if (location.href.includes("#video")) window.scrollTo(0, btn.offsetTop - 200);
        function insertYT() {
            var iframeHTML = `<iframe width="560" height="315" src="${$2c2e1177fa389bbb$var$videoURL}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
            var iframeCont = document.createElement("div");
            iframeCont.innerHTML = iframeHTML;
            btn.appendChild(iframeCont);
            btn.onclick = "";
        }
        btn.onclick = insertYT;
    }
}
customElements.define($2c2e1177fa389bbb$var$tagName, $2c2e1177fa389bbb$var$CustomElem);
function $2c2e1177fa389bbb$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$2c2e1177fa389bbb$var$tagName} element-options="${e(JSON.stringify(options))}"></${$2c2e1177fa389bbb$var$tagName}>`;
}
var $2c2e1177fa389bbb$export$2e2bcd8739ae039 = $2c2e1177fa389bbb$var$render;






const $89f654207e7613e6$var$tagName = "wide-cta-section";
var $89f654207e7613e6$var$css = /*css*/ `
    ${$89f654207e7613e6$var$tagName} {
        display: block;
        background: var(--gray-brand);
        color: white;
    }
    ${$89f654207e7613e6$var$tagName} .wrapper {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        padding: 2em 0;
    }
    ${$89f654207e7613e6$var$tagName} .section-message span {
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
        text-decoration-thickness: 0.2em;
    }
`;
const $89f654207e7613e6$var$renderInnerHTML = (options)=>{
    var slug = options.courseSlug;
    return /*html*/ `
        <div class="blue-line"></div>
        <div class="wrapper">
            <div class="section-message page-hero-medium centered">${options.title}</div>
            <a cta-prevent-inner-hover target="_blank" href="${config.ctaURLS[slug]}">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(options.btnText)}</a>
        </div>
        <div class="blue-line"></div>
        <style>${$89f654207e7613e6$var$css}</style>
    `;
};
class $89f654207e7613e6$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $89f654207e7613e6$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($89f654207e7613e6$var$tagName, $89f654207e7613e6$var$CustomElem);
function $89f654207e7613e6$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$89f654207e7613e6$var$tagName} element-options="${e(JSON.stringify(options))}"></${$89f654207e7613e6$var$tagName}>`;
}
var $89f654207e7613e6$export$2e2bcd8739ae039 = $89f654207e7613e6$var$render;


const $26bb59f23615df1a$var$tagName = "teacher-section";
const $26bb59f23615df1a$var$teacherData = {
    js: {
        img: "dozenten-portrait-1(new).jpg",
        name: "Jan-Henrik Stocker",
        title: "Principal Product Manager",
        text: "Motivierter Teamleiter und Produktmanager f\xfcr digitale Produkte mit einer starken Leidenschaft f\xfcr Strategie. \xdcber 8 Jahre Erfahrung im Produktmanagement, als Gr\xfcnder und Angel Investor. Liebt es, tief in die Kernbed\xfcrfnisse der Kunden, Unternehmensabl\xe4ufe und Marktentwicklungen einzutauchen, um daraus eine \xfcberzeugende Unternehmensstrategie abzuleiten."
    },
    br: {
        img: "dozenten-portrait-3(new).jpg",
        name: "Beate Radics",
        title: "Lead PM Coach",
        text: "Leidenschaftliche Product Managerin und Product Owner f\xfcr digitale und IoT-Produkte mit Fokus auf den Kunden in der Zusammenarbeit mit DEV, Design & Analytics. \xdcber 10 Jahre Erfahrung in Product Ownership & Teamleitung. Liebt die Kooperation mit allen Bereichen der Produktentwicklung, um f\xfcr den User das beste Produkt zu entwickeln."
    },
    md: {
        img: "dozenten-portrait-4(new).jpg",
        name: "Minja Derviskadic",
        title: "Senior Career Coach",
        text: "\xdcber 10 Jahre F\xfchrungserfahrung mit bis zu 80 Mitarbeitern als Regionalleiterin und Projektleiterin. \xdcber 4 Jahre Jahre Erfahrung als (agile / Job) Coach und Teamcoach. Leidenschaft f\xfcr systemisches Coaching, agiles Management und die Digitalisierung von Produkten & Vertriebsprozessen. Zertifizierte Systemische Trainerin & SCRUM Master. Gr\xfcnderin des Startup MY H&B Clinic GmbH."
    },
    uoc: {
        img: "portrait-ulf.jpg",
        name: "Ulf Oliveros-Calvo",
        title: "IT Sales Coach",
        text: "Product Owner, Scrum Master, Sales Experte & Coach... \xdcber 12 Jahre Sales-, F\xfchrungs-, Projekt- und Coachingerfahrung in der IT sowie im Bereich Klimaschutz Leidenschaftlicher Agile Enthusiast, DJ und Podcast Host.\vMacht seit 30 Jahren Musik, \u201Cgoes the extra mile. every time\u201D, auch f\xfcr seine Kursteilnehmer."
    },
    sp: {
        img: "portrait-steven.jpg",
        name: "Steven Parker",
        title: "IT Sales Coach",
        text: "Sales Manager f\xfcr digitale Produkte, Digital Marketing Manager, SEO BVDW Fachkraft, Vertical Farming Sales Manager, zertifizierter systemischer Coach. Knapp 20 Jahre Erfahrung im B2B Sales und Marketing mit dem Fokus auf ehrlicher und ergebnisorientierter Beratung, mit dem Anspruch seinen Kunden und Kursteilnehmern immer eine helfende Hand zu reichen. Liebt es Menschen bei Ihrer beruflichen und pers\xf6nlichen Entwicklung zu unterst\xfctzen."
    },
    tr: {
        img: "Tobi_Riede.jpg",
        name: "Tobias Riede",
        title: "PM Coach",
        text: "Erfahrener Teamleiter und Produktmanagement-Coach mit Fokus auf den Aufbau erfolgreicher Produktorganisationen. Spezialisiert auf agile Methoden im Mittelstand und Konzern, um Teams kundenorientiert und effizient zu gestalten. Umfangreiche Erfahrung als Projektleiter f\xfcr digitale L\xf6sungen im sechsstelligen Bereich, mit der F\xe4higkeit, Produktstrategien gezielt mit wirtschaftlichen Zielen zu verbinden. T\xe4tigkeit in f\xfchrenden Digitalagenturen wie TEAM23, flytech, LUMIUM und Agile Heroes sowie als Coach und Dozent am Franklin Institute."
    }
};
const $26bb59f23615df1a$var$courseTeachers = {
    pm: [
        "js",
        "br",
        "md",
        "tr"
    ],
    sales: [
        "js",
        "md",
        "sp",
        "uoc"
    ]
};
var $26bb59f23615df1a$var$css = /*css*/ `
    ${$26bb59f23615df1a$var$tagName} {
        display: block;
        font-size: 1em;
        padding: 3em 0;
        padding-bottom: 2em;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-cont {
        display: flex;
        flex-direction: column;
        gap: 4.3em;
        margin-top: 4.3em;
        max-width: 1000px;
        margin: 0 auto;
        margin-top: 3em;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-box {
        display: flex;
        gap: 2.5em;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-portrait-box-outer {
        display: block;
        min-width: 216px;
        min-height: 216px;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-portrait-box-inner {
        position: relative;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-portrait-box-inner div {
        display: block;
        width: 200px;
        aspect-ratio: 1 / 1;
        position: absolute;
        border-radius: 4px;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-portrait-box-inner div:nth-child(1) {
        background: var(--blue-brand);
        top: 16px;
        left: 16px;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-portrait-box-inner div:nth-child(2) {
        background: var(--gray-brand);
        top: 8px;
        left: 8px;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-portrait-box-inner div:nth-child(3) {
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-text {
        font-family: 'inter-medium';
        text-align: justify;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-name {
        margin-bottom: 0.3em !important;
    }
    ${$26bb59f23615df1a$var$tagName} .teacher-title {
        margin-bottom: 0.5em !important;
    }
    @media(max-width: 739px){
        ${$26bb59f23615df1a$var$tagName} .teacher-box {
            flex-direction: column;
            gap: 2rem;
            align-items: center;
            max-width: 450px;
            margin: auto;
        }
        ${$26bb59f23615df1a$var$tagName} .teacher-text-box {
            max-width: 90%;
            margin: auto;
        }
    }
    @media(max-width: 420px){
        ${$26bb59f23615df1a$var$tagName} .teacher-text {
            text-align: left;
        }
        ${$26bb59f23615df1a$var$tagName} .teacher-box {
            gap: 1.2rem;
        }
        ${$26bb59f23615df1a$var$tagName} .teacher-cont {
            gap: 3rem;
        }
    }
    @media(max-width: 339px){
        ${$26bb59f23615df1a$var$tagName} .teacher-text-box {
            max-width: initial;
            margin: initial;
        }
    }
`;
const $26bb59f23615df1a$var$renderTeacherElements = function(slug) {
    var res = "";
    var teachers = $26bb59f23615df1a$var$courseTeachers[slug];
    teachers.forEach((teacher)=>{
        var teacherHTML = /*html*/ `
            <div class="teacher-box">
                <div class="teacher-portrait-box-outer">
                    <div class="teacher-portrait-box-inner">
                        <div></div>
                        <div></div>
                        <div style="background-image: url('/assets/images/${$26bb59f23615df1a$var$teacherData[teacher].img}');"></div>
                    </div>
                </div>
                <div class="teacher-text-box">
                    <div class="teacher-name section-message page-hero-medium font-scale-down">${$26bb59f23615df1a$var$teacherData[teacher].name}</div>
                    <div class="teacher-title section-message page-hero-small">${$26bb59f23615df1a$var$teacherData[teacher].title}</div>
                    <div class="teacher-text">${$26bb59f23615df1a$var$teacherData[teacher].text}</div>
                </div>
            </div>
        `;
        res += teacherHTML;
    });
    return res;
};
const $26bb59f23615df1a$var$renderInnerHTML = (options)=>{
    var slug = options.courseSlug;
    return /*html*/ `
        <div class="section-message page-hero-medium centered font-scale-down" style="margin-bottom: 0.3em;">Unsere leitenden Dozenten</div>
        <div class="section-message centered" style="font-size: 1.3em;">Lerne das Management unseres Dozententeams kennen</div>
        <div class="teacher-cont">
            ${$26bb59f23615df1a$var$renderTeacherElements(slug)}
        </div>
        <style>${$26bb59f23615df1a$var$css}</style>
    `;
};
class $26bb59f23615df1a$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $26bb59f23615df1a$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($26bb59f23615df1a$var$tagName, $26bb59f23615df1a$var$CustomElem);
function $26bb59f23615df1a$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$26bb59f23615df1a$var$tagName} element-options="${e(JSON.stringify(options))}"></${$26bb59f23615df1a$var$tagName}>`;
}
var $26bb59f23615df1a$export$2e2bcd8739ae039 = $26bb59f23615df1a$var$render;


const $26ea0bccf6b5e721$var$tagName = "product-info-section";
var $26ea0bccf6b5e721$var$productDescriptionHTML = {
    pm: /*html*/ `
        Als ${config.courseData.pm.name} unterst\xfctzt du Unternehmen dabei, ihre <b>IT-Systeme und Gesch\xe4ftsprozesse</b> durch die <b>Entwicklung und Implementierung von neuen Softwarel\xf6sungen</b> und die <b>Beratung bei der Auswahl von geeigneten Technologien</b> zu optimieren. Mit der Spezialisierung auf <b>Produktmanagement</b> bist du der <b>Experte</b> f\xfcr die Entwicklung neuer <b>Softwareprodukte</b> und f\xfcr die Verbesserung / Weiterentwicklung der bestehenden <b>Softwarel\xf6sungen.</b>
    `,
    sales: /*html*/ `
        Als ${config.courseData.sales.name} \xf6ffnen sich <b>viele Vertriebsm\xf6glichkeiten in verschiedenen Branchen</b> - auch au\xdferhalb des IT-Bereichs. Neben dem Verkauf von Softwareprodukten erm\xf6glicht die Weiterbildung, sich auf die <b>Gestaltung, Implementierung und Optimierung interner Vertriebsprozesse</b> sowie die Integration passender Tools zu konzentrieren. Mit entsprechender Erfahrung kann man als Teamleiter Verantwortung f\xfcr die Leistungs\xfcberwachung und Kennzahlenanalyse \xfcbernehmen. Die Qualifikation als ${config.courseData.sales.name} er\xf6ffnet Absolventen <b>vielf\xe4ltige Karrierewege.</b>
    `
};
var $26ea0bccf6b5e721$var$css = /*css*/ `
    ${$26ea0bccf6b5e721$var$tagName} {
        display: block;
        font-family: 'inter-medium';
    }
    ${$26ea0bccf6b5e721$var$tagName} .grid-outer-cont {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-grid {
        max-width: 1000px;
        display: grid;
        gap: 40px;
        grid-template-columns: 1fr 1fr 1fr;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box {
        padding: 20px 25px;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(1) {
        padding: 0;
        grid-column: 1;
        grid-row: 1;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(2) {
        grid-column: 2 / 4;
        grid-row: 1;
        background: var(--light-gray);
        background: #EBEBEB;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(3) {
        color: white;
        grid-column: 1 / 3;
        grid-row: 2;
        background: var(--gray-brand-gradient-light);
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(4) {
        grid-column: 3;
        grid-row: 2;
        padding: 0;
    }
    ${$26ea0bccf6b5e721$var$tagName} .info-img-1 {
        background-image: url('/assets/images-webp/product-manager-img.webp');
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
    }
    ${$26ea0bccf6b5e721$var$tagName} .info-img-2 {
        background-image: url('/assets/images-webp/philosophie-img-2.webp');
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
    }
    @media(max-width: 899px){
        ${$26ea0bccf6b5e721$var$tagName} .section-grid {
            grid-template-columns: 1fr 1fr;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(1) {
            grid-column: 1;
            grid-row: 2;
            aspect-ratio: 1 / 1.5;
            display: none;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(2) {
            grid-column: 1/3;
            grid-row: 1;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(3) {
            grid-column: 1/3;
            grid-row: 3;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(4) {
            grid-column: 1/3;
            grid-row: 2;
            aspect-ratio: 1.5 / 1;
        }
    }
    @media(max-width: 499px){
        ${$26ea0bccf6b5e721$var$tagName} .section-grid {
            grid-template-columns: 1fr;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(1) {
            grid-column: 1;
            grid-row: 2;
            aspect-ratio: 1 / 1.3;
            display: initial;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(2) {
            grid-column: 1;
            grid-row: 1;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(3) {
            grid-column: 1;
            grid-row: 3;
        }
        ${$26ea0bccf6b5e721$var$tagName} .section-grid .section-grid-box:nth-child(4) {
            grid-column: 1;
            grid-row: 4;
            aspect-ratio: 1.3 / 1;
        }
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-bulletpoints {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-bulletpoint b {
        font-family: 'inter-bold', sans-serif;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-bulletpoint:before {
        margin: 0 !important;
        margin-right: 0.5em !important;
        display: inline-flex;
        content: '';
        min-width: 12px;
        min-height: 12px;
        background-image: url('/assets/images/blue-arrow-double.svg');
        background-size: 100% 100%;
        transform: rotate(-90deg);
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-text {
        margin-bottom: 2em;
        line-height: 1.6em;
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-text b {
        font-family: 'inter-bold';
    }
    ${$26ea0bccf6b5e721$var$tagName} .section-title {
        margin-bottom: 1em;
        font-family: 'inter-bold';
        font-size: 1.2rem;
    }
`;
const $26ea0bccf6b5e721$var$renderInnerHTML = (options)=>{
    var slug = options.courseSlug;
    return /*html*/ `
        <div class="grid-outer-cont">
            <div class="section-grid">
                <div class="section-grid-box">
                    <div class="info-img-1"></div>
                </div>
                <div class="section-grid-box">
                    <div class="section-title">Was macht ein ${config.courseData[slug].name}?</div>
                    <div class="section-text">${$26ea0bccf6b5e721$var$productDescriptionHTML[slug]}</div>
                    <div class="section-title">Mit unserer Weiterbildung erwarten dich:</div>
                    <div class="section-bulletpoints">
                        <div class="section-bulletpoint"><b>Attraktive Geh\xe4lter</b> und <b>Aufstiegsm\xf6glichkeiten</b></div>
                        <div class="section-bulletpoint">M\xf6glichkeiten f\xfcr <b>Remote-Jobs</b></div>
                        <div class="section-bulletpoint"><b>Herausforderungen</b> und <b>Entwicklungspotential</b></div>
                        <div class="section-bulletpoint">Die Chance <b>positiven & wichtigen Einfluss</b> zu haben</div>
                        <div class="section-bulletpoint">M\xf6glichkeit in <b>F\xfchrungsposition</b> zu arbeiten</div>
                    </div>
                </div>
                <div class="section-grid-box section-bulletpoints">
                    <div class="section-bulletpoint">Weiterbildung findet komplett <b>remote</b> statt.</div>
                    <div class="section-bulletpoint">F\xfcr den optimalen Start erh\xe4ltst du ein <b>MacBook</b> von uns!</div>
                    <div class="section-bulletpoint"><b>Finanzierung durch die AfA</b> - durch den <b>Bildungsgutschein!</b></div>
                    <div class="section-bulletpoint">Inkl. <b>IHK Zertifikat</b> - perfekt f\xfcr deinen Lebenslauf.</div>
                    <div class="section-bulletpoint"><b>Karrierecoaching</b> - unser Career-Success Team hilft dir <b>durchzustarten.</b></div>
                    <div class="section-bulletpoint">Wir helfen dir dabei, den <b>perfekten Job f\xfcr dich</b> zu finden.</div>
                </div>
                <div class="section-grid-box">
                    <div class="info-img-2"></div>
                </div>
            </div>
        </div>
        <style>${$26ea0bccf6b5e721$var$css}</style>
    `;
};
class $26ea0bccf6b5e721$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $26ea0bccf6b5e721$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($26ea0bccf6b5e721$var$tagName, $26ea0bccf6b5e721$var$CustomElem);
function $26ea0bccf6b5e721$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$26ea0bccf6b5e721$var$tagName} element-options="${e(JSON.stringify(options))}"></${$26ea0bccf6b5e721$var$tagName}>`;
}
var $26ea0bccf6b5e721$export$2e2bcd8739ae039 = $26ea0bccf6b5e721$var$render;




const $68392dbefd4434c1$var$tagName = "start-date-cta-section";
var $68392dbefd4434c1$var$css = /*css*/ `
    ${$68392dbefd4434c1$var$tagName} {
        display: block;
    }
    ${$68392dbefd4434c1$var$tagName} {
        font-size: clamp(0.8rem, 4.3vw, 1rem) !important;
    }
    ${$68392dbefd4434c1$var$tagName} .main-cont {
        display: block;
        background: var(--gray-brand);
        color: white;
    }
    ${$68392dbefd4434c1$var$tagName} .wrapper {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        padding: 2em 0;
    }
    ${$68392dbefd4434c1$var$tagName} .section-message {
        max-width: 800px;
    }
    ${$68392dbefd4434c1$var$tagName} .section-message span {
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
        text-decoration-thickness: 0.2em;
    }
    ${$68392dbefd4434c1$var$tagName} .section-inner-box {
        box-sizing: border-box;
        margin: 0;
        margin-bottom: 2rem;
        margin-left: auto;
        margin-right: auto;
        padding: 1.5em 1em;
        border-radius: 0.7em;
        box-shadow: 0px 1em 2em rgba(0, 0, 0, 0.2);
        background: var(--light-blue-gradient);
        color: var(--gray-brand);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        max-width: 600px;
    }
    ${$68392dbefd4434c1$var$tagName} .section-box-title {
        word-break: break-word;
        font-family: 'inter-bold', sans-serif;
        font-size: 2.5em;
        margin-bottom: 0.5em;
    }
    ${$68392dbefd4434c1$var$tagName} .section-date-cont {
        margin-bottom: 1.5rem;
        font-family: 'inter-bold', sans-serif;
        font-size: 1.6em;
    }
    ${$68392dbefd4434c1$var$tagName} .section-date-cont:before {
        content: '';
        display: inline-block;
        width: 1.2em;
        height: 1.2em;
        background-image: url('/assets/images/calendar-gray.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        transform: translateY(0.2em) translateX(-0.5em);
    }
    ${$68392dbefd4434c1$var$tagName} .above-cont {
        display: flex;
        justify-content: center;
        gap: 2em;
        align-items: center;
        margin-top: 3.5em;
        margin-bottom: 1.2em;
    }
    ${$68392dbefd4434c1$var$tagName} .above-cont-text {
        text-transform: uppercase;
        text-align: center;
        font-family: 'inter-bold', sans-serif;
        font-size: 1.6em;
    }
    ${$68392dbefd4434c1$var$tagName} .above-cont-text span {
        color: var(--blue-brand);
    }
    ${$68392dbefd4434c1$var$tagName} .double-arrow-down {
        width: 2.5em;
        height: 2.5em;
        background-image: url('/assets/images/blue-arrow-double.svg');
        background-size: 100% 100%;
    }
    ${$68392dbefd4434c1$var$tagName} .font-scale-down {
        font-size: clamp(1.5rem, 9.5vw, 2.2rem) !important;
    }
`;
const $68392dbefd4434c1$var$renderInnerHTML = (options)=>{
    var slug = options.courseSlug;
    var isBGInfoHidden = false;
    var dateWritten = "";
    if (slug == "main") dateWritten = util.formatDateWritten(getAppConfig().nextStardDate);
    else dateWritten = util.formatDateWritten(getAppConfig().courseData[slug].nextStartDate);
    if (location.href.includes("/course/")) isBGInfoHidden = true;
    return /*html*/ `
        <div class="above-cont">
            <div class="double-arrow-down"></div>
            <div class="above-cont-text">Jetzt<br><span>Bewerben</span></div>
            <div class="double-arrow-down"></div>
        </div>
        <div class="main-cont">
            <div class="blue-line"></div>
            <div class="wrapper">
                <div class="section-inner-box">
                    <div class="section-box-title">N\xe4chster Starttermin:</div>
                    <div class="section-date-cont">${dateWritten}</div>
                    <a cta-prevent-inner-hover target="_blank" href="${getAppConfig().ctaURLS[slug]}">${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Jetzt bewerben</span>`, {
        noBorder: true,
        shadow: true
    })}</a>
                </div>
                <div class="section-message page-hero-medium centered font-scale-down" style="margin-bottom: 0;${isBGInfoHidden ? "display: none;" : ""}">
                    <span>100%ige Kosten\xfcbernahme</span> durch die Agentur f\xfcr Arbeit - mit dem Bildungsgutschein.
                </div>
            </div>
            <div class="blue-line"></div>
        </div>
        <style>${$68392dbefd4434c1$var$css}</style>
    `;
};
class $68392dbefd4434c1$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $68392dbefd4434c1$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($68392dbefd4434c1$var$tagName, $68392dbefd4434c1$var$CustomElem);
function $68392dbefd4434c1$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$68392dbefd4434c1$var$tagName} element-options="${e(JSON.stringify(options))}"></${$68392dbefd4434c1$var$tagName}>`;
}
var $68392dbefd4434c1$export$2e2bcd8739ae039 = $68392dbefd4434c1$var$render;




const $e45512b181b7d7ee$var$tagName = "certificate-component";
var $e45512b181b7d7ee$var$css = /*css*/ `
    ${$e45512b181b7d7ee$var$tagName} {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
    }

    .zertifikate-box {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(3, 1fr) !important; /* Default: three columns */
        grid-template-rows: auto !important; /* Adjust row height based on content */

        grid-gap: 20px; /* Space between grid items */
        justify-items: center;
    }
  

    .zertifikate-box-point {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: white;
        background-image: linear-gradient(137.51deg, #FFFFFF -8.85%, #959595 152.17%);
        color: var(--gray-brand);
        padding: 8px 8px;
        border-radius: 4px;
        gap: 10px;
        width: 220px;
        height: 120px;
        position: relative;
        overflow: hidden;
        transition: transform 0.2s;
        cursor: grab;
        user-select: none;
    }

    body.has-hover .zertifikate-box-point:hover {
        transform: translateY(-5px);
    }

    .certificate-title {
        font-family: 'inter-medium';
        font-size: 18px;
    }

    .certificate-title-product-school {
        font-family: 'inter-medium';
        font-size: 17px;
    }

    .zertifikat-badge {
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        background: rgba(255, 216, 77, 0.7);
        padding: 3px 7px;
        border-radius: 4px;
    }
    
    .zertifikat-badge-blue {
        background: #99EEF7;
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        padding: 3px 7px;
        border-radius: 4px;
    }
    
    .zertifikat-badge-green {
        background: rgba(178, 255, 205, 0.7);
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        padding: 3px 7px;
        border-radius: 4px;
    }

    .zertifikate-box-point * {
        z-index: 2;
    }

    .zertifikate-box-point:before {
        content: '';
        display: block;
        position: absolute;
        background-image: linear-gradient(-65deg, transparent 26%, rgba(255, 255, 255, 0.2) 27%, rgba(255, 255, 255, 0.2) 29%, transparent 30%, transparent 39%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 255, 255, 0.4) 50%, transparent 51%, transparent 55%, rgba(255, 255, 255, 0.2) 56%, rgba(255, 255, 255, 0.2) 64%, transparent 65%, transparent 69%, rgba(255, 255, 255, 0.2) 70%, rgba(255, 255, 255, 0.2) 71%, transparent 72%);
        width: 100%;
        height: 100%;
        top: 0;
        left: -100%;
        z-index: 1;
        animation: 2s shine infinite linear;
        animation-delay: inherit;
        mix-blend-mode: luminosity;
    }

    .zertifikat-logo {
        position: absolute;
        top: 10px;
        right: 8px;
        width: auto;
        height: auto;
        max-width: 90px;
        max-height: 90px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* Specific logo styles */
    .zertifikat-logo-ihk {
        width: 70px;
        aspect-ratio: 2/1;
        background-image: url('/assets/images/ihk-logo.svg');
    }

    .zertifikat-logo-tuev {
        right: 8px;
        bottom: unset;
        top: 8px;
        width: 40px;
        aspect-ratio: 1/1;
        background-image: url('/assets/images/tuev-sued-logo.svg');
    }

    .zertifikat-logo-ixdf {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/ixdf-logo-black-small.png');
    }

    .zertifikat-logo-pp {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/product-people-logo.png');
    }

    .zertifikat-logo-fias {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/fias-logo-new.svg');
    }

    .zertifikat-logo-fias-white {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/fias-logo-new-white.svg');
    }

    .zertifikat-logo-stanford {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/stanford-university-logo-medium.png');
    }

    .zertifikat-logo-metagile {
        right: 8px;
        bottom: unset;
        width: 55px;
        aspect-ratio: 1.9/1;
        background-image: url('/assets/images/metagile-logo.png');
    }

    .zertifikat-logo-scrum-alliance {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/scrum-alliance-logo.svg');
    }

    .zertifikat-logo-scrum {
        right: -20px;
        bottom: unset;
        width: 120px;
        top: 3px;
        aspect-ratio: 4/2;
        background-image: url('/assets/images/scrum-logo.png');
    }

    .zertifikat-logo-product-school {
        right: -3px;
        bottom: unset;
        width: 90px;
        aspect-ratio: 4/1;
        background-image: url('/assets/images/product-school-logo.png');
    }
    

    @keyframes shine {
        0% {
            left: -100%;
        }
        25% {
            left: 100%;
        }
        100% {
            left: 100%;
        }
    }

    @media (max-width: 1119px) {
        .zertifikate-box {
            grid-template-columns: 1fr 1fr !important; /* Two columns for screens narrower than 1119px */
        }
    }
    
    @media (max-width: 599px) {
        .zertifikate-box {
            grid-template-columns: 1fr !important; /* One column on very small screens */
        }
    }
`;
const $e45512b181b7d7ee$var$renderInnerHTML = (options)=>{
    // Determine the logo class based on the logoURL or another property
    let logoClass = "";
    if (options.logoURL.includes("ihk-logo.svg")) logoClass = "zertifikat-logo-ihk";
    else if (options.logoURL.includes("tuev-sued-logo.svg")) logoClass = "zertifikat-logo-tuev";
    else if (options.logoURL.includes("ixdf-logo-black-small.png")) logoClass = "zertifikat-logo-ixdf";
    else if (options.logoURL.includes("product-people-logo.png")) logoClass = "zertifikat-logo-pp";
    else if (options.logoURL.includes("fias-logo-new.svg")) logoClass = "zertifikat-logo-fias";
    else if (options.logoURL.includes("fias-logo-new-white.svg")) logoClass = "zertifikat-logo-fias-white";
    else if (options.logoURL.includes("stanford-university-logo-medium.png")) logoClass = "zertifikat-logo-stanford";
    else if (options.logoURL.includes("metagile-logo.png")) logoClass = "zertifikat-logo-metagile";
    else if (options.logoURL.includes("scrum-alliance-logo.svg")) logoClass = "zertifikat-logo-scrum-alliance";
    else if (options.logoURL.includes("product-school-logo.png")) logoClass = "zertifikat-logo-product-school";
    else if (options.logoURL.includes("scrum-logo.png")) logoClass = "zertifikat-logo-scrum";
    // Determine the badge class based on the badgeText content
    let badgeClass = "";
    if (options.badgeText.includes("+ Zertifikat")) badgeClass = "zertifikat-badge";
    else if (options.badgeText.includes("+ Coaching")) badgeClass = "zertifikat-badge-green";
    else if (options.badgeText.includes("+ Report")) badgeClass = "zertifikat-badge-blue";
    // Determine the title class based on the title content
    let titleClass = "certificate-title";
    if (options.title.includes("User Research Zertifikat der Interaction Design Foundation")) titleClass = "certificate-title-product-school";
    return /*html*/ `
        <div class="zertifikate-box-point">
            <div class="${badgeClass}">${options.badgeText}</div>
            <div class="${titleClass}">${options.title}</div>
            <div class="zertifikat-logo ${logoClass}"></div>
            <style>${$e45512b181b7d7ee$var$css}</style>
        </div>
    `;
};
class $e45512b181b7d7ee$var$CertificateComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Received data:', this.options);  // Log the data
        this.innerHTML = $e45512b181b7d7ee$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($e45512b181b7d7ee$var$tagName, $e45512b181b7d7ee$var$CertificateComponent);
function $e45512b181b7d7ee$var$render(options) {
    return `<${$e45512b181b7d7ee$var$tagName} element-options='${JSON.stringify(options)}'></${$e45512b181b7d7ee$var$tagName}>`;
}
var $e45512b181b7d7ee$export$2e2bcd8739ae039 = $e45512b181b7d7ee$var$render;


const $6a0ea2a0e3d8d15a$var$tagName = "module-box-component-pm";
var $6a0ea2a0e3d8d15a$var$css = /*css*/ `
${$6a0ea2a0e3d8d15a$var$tagName} .module-zertifikate-grid {
    margin-top: 40px;
    display: grid;
    grid-template-columns: 1fr 3fr; /* One column for numbers, three for the content */
    gap: 40px;
    align-items: start; /* Align items at the top of the grid */
}

${$6a0ea2a0e3d8d15a$var$tagName} .modul-number {
    font-size: 110px;
    color: black;
    text-align: right;
    position: relative;
    align-self: start; /* Align number to the top of the grid cell */
    z-index: 1;
    top: 10px;
    background-image: url('/assets/images/number-background.svg');
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 200px; /* Adjust width to fit the background */
    height: 200px; /* Adjust height to fit the background */
    padding-right: 50px; /* Adjust padding to align the text inside the background */
    box-sizing: border-box; /* Ensure padding doesn't affect the overall size */
}

${$6a0ea2a0e3d8d15a$var$tagName} .modul-box {
    position: relative; /* Ensure the title stays within the box */
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 25px 30px;
    padding-top: 45px;
    border-radius: 14px;
    background: var(--gray-brand-gradient);
    color: white;
}

${$6a0ea2a0e3d8d15a$var$tagName} .modul-box-title {
    position: absolute;
    top: -15px;
    left: -25px;
    background: var(--light-blue-gradient);
    color: var(--gray-brand);
    padding: 0.6em 1em;
    border-radius: 6px;
    z-index: 1; /* Ensure the title stays above other elements */
    font-family: 'inter-bold';
}

${$6a0ea2a0e3d8d15a$var$tagName} .bulletpoint {
    font-size: 1rem;
    margin-bottom: 10px;
    font-family: 'inter-bold';
}

${$6a0ea2a0e3d8d15a$var$tagName} .bulletpoint:before {
    margin: 0 !important;
    margin-right: 0.5em !important;
    display: inline-flex;
    content: '';
    min-width: 12px;
    min-height: 12px;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
    transform: rotate(-90deg);
}

/* Responsive adjustments */

@media (max-width: 857px) {

    ${$6a0ea2a0e3d8d15a$var$tagName} .modul-number {
        font-size: 70px; /* Reduce the font size */
        padding-top: 17px;
        padding-right: 50px;
        width: 170px; /* Adjust the width */
        height: 170px; /* Adjust the height */
        background-size: 80%; /* Adjust background size */
        background-position: center; /* Center the background */
    }
}

@media (max-width: 809px) {
    ${$6a0ea2a0e3d8d15a$var$tagName} .modul-number {
        display: none; /* Hide the number */
    }

    ${$6a0ea2a0e3d8d15a$var$tagName} .module-zertifikate-grid {
        grid-template-columns: 1fr; /* Make the module box take the full width */
    }
}
`;
const $6a0ea2a0e3d8d15a$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="module-zertifikate-grid">
            <div class="modul-number">${options.number}</div>
            <div class="modul-box">
                <div class="modul-box-title">${options.title}</div>
                <div class="bulletpoints">
                    ${options.bulletpoints.map((point)=>`<div class="bulletpoint">${point}</div>`).join("")}
                </div>
                <div class="zertifikate-box">
                    ${options.certificates.map((cert)=>(0, $e45512b181b7d7ee$export$2e2bcd8739ae039)(cert)).join("")}
                </div>
            </div>
        </div>
        <style>${$6a0ea2a0e3d8d15a$var$css}</style>
    `;
};
class $6a0ea2a0e3d8d15a$var$ModuleBoxComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Module Box Options:', this.options);
        this.innerHTML = $6a0ea2a0e3d8d15a$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($6a0ea2a0e3d8d15a$var$tagName, $6a0ea2a0e3d8d15a$var$ModuleBoxComponent);
function $6a0ea2a0e3d8d15a$var$render(options) {
    return `<${$6a0ea2a0e3d8d15a$var$tagName} element-options='${JSON.stringify(options)}'></${$6a0ea2a0e3d8d15a$var$tagName}>`;
}
var $6a0ea2a0e3d8d15a$export$2e2bcd8739ae039 = $6a0ea2a0e3d8d15a$var$render;


const $eadebe06eac8faeb$var$tagName = "black-certificate-component";
var $eadebe06eac8faeb$var$css = /*css*/ `
    ${$eadebe06eac8faeb$var$tagName} {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikate-box {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(3, 1fr) !important; /* Default: three columns */
        grid-template-rows: auto !important; /* Adjust row height based on content */

        grid-gap: 20px; /* Space between grid items */
        justify-items: center;
    }
  

    ${$eadebe06eac8faeb$var$tagName} .zertifikate-box-point {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: var(--gray-brand-gradient);
	    color: white;
        padding: 8px 8px;
        border-radius: 4px;
        gap: 10px;
        width: 220px;
        height: 120px;
        position: relative;
        overflow: hidden;
        transition: transform 0.2s;
        cursor: grab;
        user-select: none;
    }

    ${$eadebe06eac8faeb$var$tagName} body.has-hover .zertifikate-box-point:hover {
        transform: translateY(-5px);
    }

    ${$eadebe06eac8faeb$var$tagName} .certificate-title {
        font-family: 'inter-medium';
        font-size: 18px;
    }

    ${$eadebe06eac8faeb$var$tagName} .certificate-title-product-school {
        font-family: 'inter-medium';
        font-size: 17px;
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-badge {
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        background: rgba(255, 216, 77, 0.7);
        padding: 3px 7px;
        border-radius: 4px;
    }
    
    ${$eadebe06eac8faeb$var$tagName} .zertifikat-badge-blue {
        background: #99EEF7;
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        padding: 3px 7px;
        border-radius: 4px;
    }
    
    ${$eadebe06eac8faeb$var$tagName} .zertifikat-badge-green {
        background: rgba(178, 255, 205, 0.7);
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        padding: 3px 7px;
        border-radius: 4px;
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikate-box-point * {
        z-index: 1;
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikate-box-point:before {
        content: '';
        display: block;
        position: absolute;
        background-image: linear-gradient(-65deg, transparent 26%, rgba(255, 255, 255, 0.2) 27%, rgba(255, 255, 255, 0.2) 29%, transparent 30%, transparent 39%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 255, 255, 0.4) 50%, transparent 51%, transparent 55%, rgba(255, 255, 255, 0.2) 56%, rgba(255, 255, 255, 0.2) 64%, transparent 65%, transparent 69%, rgba(255, 255, 255, 0.2) 70%, rgba(255, 255, 255, 0.2) 71%, transparent 72%);
        width: 100%;
        height: 100%;
        top: 0;
        left: -100%;
        z-index: 10;
        animation: 2s shine infinite linear;
        animation-delay: inherit;
        mix-blend-mode: luminosity;
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo {
        position: absolute;
        top: 10px;
        right: 8px;
        width: auto;
        height: auto;
        max-width: 90px;
        max-height: 90px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* Specific logo styles */
    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-ihk {
        width: 50px;
        aspect-ratio: 2/1;
        background-image: url('/assets/images/ihk-logo.svg');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-tuev {
        right: 8px;
        bottom: unset;
        top: 8px;
        width: 40px;
        aspect-ratio: 1/1;
        background-image: url('/assets/images/tuev-sued-logo.svg');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-ixdf {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/ixdf-logo-black-small.png');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-pp {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/product-people-logo.png');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-fias {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/fias-logo-new.svg');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-fias-white {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/fias-logo-new-white.svg');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-stanford {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/stanford-university-logo-medium.png');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-metagile {
        right: 8px;
        bottom: unset;
        width: 55px;
        aspect-ratio: 1.9/1;
        background-image: url('/assets/images/metagile-logo.png');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-scrum-alliance {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/scrum-alliance-logo.svg');
    }

    ${$eadebe06eac8faeb$var$tagName} .zertifikat-logo-product-school {
        right: 8px;
        bottom: unset;
        width: 90px;
        aspect-ratio: 4/1;
        background-image: url('/assets/images/product-school-logo.svg');
    }

    @keyframes shine {
        0% {
            left: -100%;
        }
        25% {
            left: 100%;
        }
        100% {
            left: 100%;
        }
    }

    @media (max-width: 1119px) {
        ${$eadebe06eac8faeb$var$tagName} .zertifikate-box {
            grid-template-columns: 1fr 1fr !important; /* Two columns for screens narrower than 1119px */
        }
    }
    
    @media (max-width: 599px) {
        ${$eadebe06eac8faeb$var$tagName} .zertifikate-box {
            grid-template-columns: 1fr !important; /* One column on very small screens */
        }
    }
`;
const $eadebe06eac8faeb$var$renderInnerHTML = (options)=>{
    // Determine the logo class based on the logoURL or another property
    let logoClass = "";
    if (options.logoURL.includes("ihk-logo.svg")) logoClass = "zertifikat-logo-ihk";
    else if (options.logoURL.includes("tuev-sued-logo.svg")) logoClass = "zertifikat-logo-tuev";
    else if (options.logoURL.includes("ixdf-logo-black-small.png")) logoClass = "zertifikat-logo-ixdf";
    else if (options.logoURL.includes("product-people-logo.png")) logoClass = "zertifikat-logo-pp";
    else if (options.logoURL.includes("fias-logo-new.svg")) logoClass = "zertifikat-logo-fias";
    else if (options.logoURL.includes("fias-logo-new-white.svg")) logoClass = "zertifikat-logo-fias-white";
    else if (options.logoURL.includes("stanford-university-logo-medium.png")) logoClass = "zertifikat-logo-stanford";
    else if (options.logoURL.includes("metagile-logo.png")) logoClass = "zertifikat-logo-metagile";
    else if (options.logoURL.includes("scrum-alliance-logo.svg")) logoClass = "zertifikat-logo-scrum-alliance";
    else if (options.logoURL.includes("product-school-logo.svg")) logoClass = "zertifikat-logo-product-school";
    // Determine the badge class based on the badgeText content
    let badgeClass = "";
    if (options.badgeText.includes("+ Zertifikat")) badgeClass = "zertifikat-badge";
    else if (options.badgeText.includes("+ Coaching")) badgeClass = "zertifikat-badge-green";
    else if (options.badgeText.includes("+ Report")) badgeClass = "zertifikat-badge-blue";
    // Determine the title class based on the title content
    let titleClass = "certificate-title";
    if (options.title.includes("User Research Zertifikat der Interaction Design Foundation")) titleClass = "certificate-title-product-school";
    return /*html*/ `
        <div class="zertifikate-box-point">
            <div class="${badgeClass}">${options.badgeText}</div>
            <div class="${titleClass}">${options.title}</div>
            <div class="zertifikat-logo ${logoClass}"></div>
            <style>${$eadebe06eac8faeb$var$css}</style>
        </div>
    `;
};
class $eadebe06eac8faeb$var$CertificateComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Received data:', this.options);  // Log the data
        this.innerHTML = $eadebe06eac8faeb$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($eadebe06eac8faeb$var$tagName, $eadebe06eac8faeb$var$CertificateComponent);
function $eadebe06eac8faeb$var$render(options) {
    return `<${$eadebe06eac8faeb$var$tagName} element-options='${JSON.stringify(options)}'></${$eadebe06eac8faeb$var$tagName}>`;
}
var $eadebe06eac8faeb$export$2e2bcd8739ae039 = $eadebe06eac8faeb$var$render;


const $6054afff3f5b6e30$var$tagName = "inverted-module-box-component-pm";
var $6054afff3f5b6e30$var$css = /*css*/ `
${$6054afff3f5b6e30$var$tagName} .module-zertifikate-grid-inverted {
    margin-top: 40px;
    display: grid;
    grid-template-columns: 1fr 3fr; /* One column for numbers, three for the content */
    gap: 40px;
    align-items: start; /* Align items at the top of the grid */
}

${$6054afff3f5b6e30$var$tagName} .modul-number-inverted {
    font-size: 110px;
    color: black;
    text-align: right;
    position: relative;
    align-self: start; /* Align number to the top of the grid cell */
    z-index: 2;
    top: 10px;
    background-image: url('/assets/images/number-background.svg');
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 200px; /* Adjust width to fit the background */
    height: 200px; /* Adjust height to fit the background */
    padding-right: 50px; /* Adjust padding to align the text inside the background */
    box-sizing: border-box; /* Ensure padding doesn't affect the overall size */
}

${$6054afff3f5b6e30$var$tagName} .modul-box-inverted {
    position: relative; /* Ensure the title stays within the box */
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 25px 30px;
    padding-top: 45px;
    border-radius: 14px;
    background: white;  /* Background is white */
    color: var(--gray-brand);
    border: 6px solid #5AE3F0;
}

${$6054afff3f5b6e30$var$tagName} .modul-box-title-inverted {
    position: absolute;
    top: -22px;
    left: -25px;
    padding: 0.6em 1em;
    border-radius: 6px;
    background: var(--gray-brand-gradient);
    color: white;
    z-index: 2;
    grid-column: 2; /* Place the title in the second column */
    font-family: 'inter-bold';
}

${$6054afff3f5b6e30$var$tagName} .bulletpoint {
    font-size: 1rem;
    margin-bottom: 10px;
    font-family: 'inter-bold';
}

${$6054afff3f5b6e30$var$tagName} .bulletpoint:before {
    margin: 0 !important;
    margin-right: 0.5em !important;
    display: inline-flex;
    content: '';
    min-width: 12px;
    min-height: 12px;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
    transform: rotate(-90deg);
}

/* Responsive adjustments */

@media (max-width: 857px) {

    ${$6054afff3f5b6e30$var$tagName} .modul-number-inverted {
        font-size: 70px; /* Reduce the font size */
        padding-top: 17px;
        padding-right: 50px;
        width: 170px; /* Adjust the width */
        height: 170px; /* Adjust the height */
        background-size: 80%; /* Adjust background size */
        background-position: center; /* Center the background */
    }
}

@media (max-width: 809px) {
    ${$6054afff3f5b6e30$var$tagName} .modul-number-inverted {
        display: none; /* Hide the number */
    }

    ${$6054afff3f5b6e30$var$tagName} .module-zertifikate-grid-inverted {
        grid-template-columns: 1fr; /* Make the module box take the full width */
    }
}
`;
const $6054afff3f5b6e30$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="module-zertifikate-grid-inverted">
            <div class="modul-number-inverted">${options.number}</div>
            <div class="modul-box-inverted">
                <div class="modul-box-title-inverted">${options.title}</div>
                <div class="bulletpoints">
                    ${options.bulletpoints.map((point)=>`<div class="bulletpoint">${point}</div>`).join("")}
                </div>
                <div class="zertifikate-box">
                    ${options.certificates.map((cert)=>(0, $eadebe06eac8faeb$export$2e2bcd8739ae039)(cert)).join("")}
                </div>
            </div>
        </div>
        <style>${$6054afff3f5b6e30$var$css}</style>
    `;
};
class $6054afff3f5b6e30$var$ModuleBoxComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Module Box Options:', this.options);
        this.innerHTML = $6054afff3f5b6e30$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($6054afff3f5b6e30$var$tagName, $6054afff3f5b6e30$var$ModuleBoxComponent);
function $6054afff3f5b6e30$var$render(options) {
    return `<${$6054afff3f5b6e30$var$tagName} element-options='${JSON.stringify(options)}'></${$6054afff3f5b6e30$var$tagName}>`;
}
var $6054afff3f5b6e30$export$2e2bcd8739ae039 = $6054afff3f5b6e30$var$render;


const $c1cc64f038d6da05$var$tagName = "certificate-section";
var $c1cc64f038d6da05$var$css = /*css*/ `
    ${$c1cc64f038d6da05$var$tagName} {
        padding: 2rem;
        background: var(--light-gray);
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    ${$c1cc64f038d6da05$var$tagName} .centered-text {
        text-align: center;
        margin-bottom: 0.1em;
        font-family: 'inter-bold';
        font-size: clamp(28px, 6.18vw, 60px);
    }

    ${$c1cc64f038d6da05$var$tagName} .subheading-text {
        font-size: 1.3em;
        font-family: 'inter-medium';
    }

    ${$c1cc64f038d6da05$var$tagName} .light-blue-text {
        color: var(--blue-brand);
    }
`;
const $c1cc64f038d6da05$var$renderInnerHTML = (options)=>{
    const normalModuleBoxesHTML = options.moduleBoxes.map((moduleBox)=>{
        return (0, $6a0ea2a0e3d8d15a$export$2e2bcd8739ae039)(moduleBox);
    }).join("");
    const invertedModuleBoxHTML = (0, $6054afff3f5b6e30$export$2e2bcd8739ae039)(options.invertedModuleBox);
    return /*html*/ `
        <div class="section-message centered-text">
            <span style="font-size: clamp(28px, 6.18vw, 60px); font-family: 'inter-bold';">
                Der effektivste Start <br> in 
            </span>
            <span class="light-blue-text" style="font-size: clamp(28px, 6.18vw, 60px); font-family: 'inter-bold';">
                deine neue Karriere
            </span>
        </div>
        <div class="section-message centered subheading-text">Unser Kursaufbau und Karrierecoaching (Kurzfassung)</div>
        <div class="module-boxes-container">
            ${normalModuleBoxesHTML}
            ${invertedModuleBoxHTML}  
        </div>
        <style>${$c1cc64f038d6da05$var$css}</style>
    `;
};
class $c1cc64f038d6da05$var$CertificateSection extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Certificate Section Options:', this.options);
        this.innerHTML = $c1cc64f038d6da05$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($c1cc64f038d6da05$var$tagName, $c1cc64f038d6da05$var$CertificateSection);
function $c1cc64f038d6da05$var$render(options) {
    return `<${$c1cc64f038d6da05$var$tagName} element-options='${JSON.stringify(options)}'></${$c1cc64f038d6da05$var$tagName}>`;
}
var $c1cc64f038d6da05$export$2e2bcd8739ae039 = $c1cc64f038d6da05$var$render;


const $fcea271cab5c7f45$var$tagName = "blue-certificate-component";
var $fcea271cab5c7f45$var$css = /*css*/ `
    ${$fcea271cab5c7f45$var$tagName} {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 10px;
    }

    ${$fcea271cab5c7f45$var$tagName} .bonus-modul-wrapper {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-left: 320px; /* Adjust this value to control the space between the left edge and the certificate */
    }

    ${$fcea271cab5c7f45$var$tagName} .bonus-modul-plus-icon {
        width: 40px;
        height: 40px;
        background-image: url('/assets/images/plus-icon.png');
        background-size: contain;
        background-repeat: no-repeat;
    }

    ${$fcea271cab5c7f45$var$tagName} .zertifikate-box-point {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        background: var(--light-blue-gradient);
        color: black;
        padding: 8px 8px;
        border-radius: 4px;
        gap: 10px;
        width: 220px;
        height: 120px;
        overflow: hidden;
        transition: transform 0.2s;
        cursor: grab;
        user-select: none;
    }

    ${$fcea271cab5c7f45$var$tagName} body.has-hover .zertifikate-box-point:hover {
        transform: translateY(-5px);
    }

    ${$fcea271cab5c7f45$var$tagName} .certificate-title {
        font-family: 'inter-medium';
        font-size: 18px;
    }

    ${$fcea271cab5c7f45$var$tagName} .certificate-title-product-school {
        font-family: 'inter-medium';
        font-size: 17px;
    }

    ${$fcea271cab5c7f45$var$tagName} .zertifikat-badge-ihk {
        background-image: linear-gradient(137.51deg, #FFFFFF -8.85%, #959595 152.17%);
        background: linear-gradient(137.51deg, #fbf5b7 -8.85%, #b38728 152.17%);
        border: 1px solid #bf953f;
        padding: 3px 7px;
        border-radius: 4px;
        color: rgba(0, 0, 0, 0.7);
    }

    ${$fcea271cab5c7f45$var$tagName} .zertifikate-box-point * {
        z-index: 1;
    }

    ${$fcea271cab5c7f45$var$tagName} .zertifikat-logo {
        position: absolute;
        top: 10px;
        right: 8px;
        width: auto;
        height: auto;
        max-width: 90px;
        max-height: 90px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* Specific logo styles */
    ${$fcea271cab5c7f45$var$tagName} .zertifikat-logo-ihk {
        width: 70px;
        aspect-ratio: 2/1;
        background-image: url('/assets/images/ihk-logo.svg');
        top: 75px;
    }

    .bonus-modul-disclaimer {
        max-width: 800px;
        text-align: center;
        font-family: 'inter-light';
        margin: 0 auto;
        margin-top: 30px;
        font-size: 18px;
        margin-bottom: 20px;
    }

    @keyframes shine {
        0% {
            left: -100%;
        }
        25% {
            left: 100%;
        }
        100% {
            left: 100%;
        }
    }

    @media (max-width: 1119px) {
        ${$fcea271cab5c7f45$var$tagName} .zertifikate-box {
            grid-template-columns: 1fr 1fr !important; /* Two columns for screens narrower than 1119px */
        }
    }

    @media (max-width: 599px) {
        ${$fcea271cab5c7f45$var$tagName} .zertifikate-box {
            grid-template-columns: 1fr !important; /* One column on very small screens */
        }
    }

    @media (max-width: 809px) {
        ${$fcea271cab5c7f45$var$tagName} .bonus-modul-wrapper {
            margin-left: 40px; /* Adjust this value to control the space between the left edge and the certificate */
        }
    }
`;
const $fcea271cab5c7f45$var$renderInnerHTML = (options)=>{
    // Determine the logo class based on the logoURL or another property
    let logoClass = "";
    if (options.logoURL.includes("ihk-logo.svg")) logoClass = "zertifikat-logo-ihk";
    // Determine the badge class based on the badgeText content
    let badgeClass = "";
    if (options.badgeText.includes("+ IHK-Zertifikat")) badgeClass = "zertifikat-badge-ihk";
    else if (options.badgeText.includes("+ Coaching")) badgeClass = "zertifikat-badge-green";
    // Determine the title class based on the title content
    let titleClass = "certificate-title";
    if (options.title.includes("User Research Zertifikat der Interaction Design Foundation")) titleClass = "certificate-title-product-school";
    return /*html*/ `
        <div class="bonus-modul-wrapper">
            <div class="bonus-modul-plus-icon"></div>
            <div class="zertifikate-box-point">
                <div class="${badgeClass}">${options.badgeText}</div>
                <div class="${titleClass}">${options.title}</div>
                <div class="zertifikat-logo ${logoClass}"></div>
            </div>
        </div>
        <div class="bonus-modul-disclaimer">* Teilnehmer, die die entsprechenden, vorausgesetzten Qualifikationen mitbringen, d\xfcrfen an der Pr\xfcfung der IHK teilnehmen.</div>
        <style>${$fcea271cab5c7f45$var$css}</style>
    `;
};
class $fcea271cab5c7f45$var$BlueCertificateComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Received data:', this.options);  // Log the data
        this.innerHTML = $fcea271cab5c7f45$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($fcea271cab5c7f45$var$tagName, $fcea271cab5c7f45$var$BlueCertificateComponent);
function $fcea271cab5c7f45$var$render(options) {
    return `<${$fcea271cab5c7f45$var$tagName} element-options='${JSON.stringify(options)}'></${$fcea271cab5c7f45$var$tagName}>`;
}
var $fcea271cab5c7f45$export$2e2bcd8739ae039 = $fcea271cab5c7f45$var$render;






const $3f499fec838245db$var$tagName = "pm-course-page";
const $3f499fec838245db$var$courseSlug = "pm";
var $3f499fec838245db$var$pageTitle = "Werde IT-Berater im Produktmanagement | Franklin Institute of Applied Sciences";
var $3f499fec838245db$var$pageDescription = `Starte deine Karriere mit der kostenlosen Weiterbildung des Franklin Institute zum ${config.courseData[$3f499fec838245db$var$courseSlug].name}. In nur ${config.courseData[$3f499fec838245db$var$courseSlug].duration} Monaten von der Arbeitslosigkeit zum Traumjob, inklusive MacBook und IHK-Zertifikat. Perfekt f\xfcr Quereinsteiger und 100% kostenfrei dank Bildungsgutschein. Sichere dir jetzt deinen Platz und nutze unsere umfassende Karriereberatung f\xfcr einen erfolgreichen Einstieg in die IT-Branche.`;
var $3f499fec838245db$var$videoURL = "https://fast.wistia.com/embed/medias/yc67ol9ioj";
var $3f499fec838245db$var$css = /*css*/ `

.feedback-section-wrapper {
        margin-bottom: -10px; 
    }
.partner-section-wrapper {
    margin-top: 10px;
    margin-bottom: 0px; 
}

${$3f499fec838245db$var$tagName} azav-verifiziert-section {
    margin-top: -20px; 
    padding-top: 0;
}

@media (max-width: 490px) {
    ${$3f499fec838245db$var$tagName} azav-verifiziert-section {
        margin-top: 10px;
    }
}
    
`;
const $3f499fec838245db$var$certificateSectionData = {
    moduleBoxes: [
        {
            number: "1",
            title: "Grundlagen",
            bulletpoints: [
                "Einf\xfchrung und digitaler Wandel",
                "K\xfcnstliche Intelligenz f\xfcr PMs",
                "Designmanagement und Design Thinking",
                "Nutzer- und Aufgabenanalyse sowie Produktanalyse und Marktbeobachtung"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Design Thinking Zertifikat der Franklin IAS",
                    logoURL: "/assets/images/fias-logo-new.svg"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Professional Scrum Master PSM I",
                    logoURL: "/assets/images/scrum-logo.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Professional Scrum Product Owner PSPO I",
                    logoURL: "/assets/images/scrum-logo.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Product Analystics Micro-Certification",
                    logoURL: "/assets/images/product-school-logo.png"
                }
            ]
        },
        {
            number: "2",
            title: "DeepDive 1.0",
            bulletpoints: [
                "Requirement-Engineering",
                "Agile Methoden",
                "User Experience und Praxis-Teil",
                "Business Models und Finanzplanung"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Agile Leadership Zertifikat von Metagile",
                    logoURL: "/assets/images/metagile-logo.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Business Models Zertifikat der Stanford University",
                    logoURL: "/assets/images/stanford-university-logo-medium.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Applied IT-Consulting Zertifikat von Product People",
                    logoURL: "/assets/images/product-people-logo.png"
                }
            ]
        },
        {
            number: "3",
            title: "DeepDive 2.0",
            bulletpoints: [
                "Produktstrategie und Roadmap / Portfolio-Analysen",
                "F\xfchrung und Controlling f\xfcr IT- und Software-Berater",
                "Pers\xf6nliches Benchmarking und Effektivit\xe4tssteigerung",
                "Projektauswahl und Zielsetzung (PRAXIS MODUL)",
                "Umsetzungsphase (PRAXIS MODUL)",
                "Evaluation und Diskussion (PRAXIS MODUL)"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Service Design: How to Design Integrated Service Experiences",
                    logoURL: "/assets/images/ixdf-logo-black-small.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "AI for Designers",
                    logoURL: "/assets/images/ixdf-logo-black-small.png"
                }
            ]
        }
    ],
    invertedModuleBox: {
        number: "4",
        title: "Franklin Career Center",
        bulletpoints: [
            "Karriere-Coaching & Pers\xf6nlichkeitsanalyse",
            "Intensives Bewerber Coaching",
            "Arbeitsvermittlung an Partner Unternehmen",
            "Bewerbungsphase mit Individueller Betreuung"
        ],
        certificates: [
            {
                badgeText: "+ Report",
                title: "Ausf\xfchrlicher Coaching Report",
                logoURL: "/assets/images/fias-logo-new-white.svg"
            },
            {
                badgeText: "+ Coaching",
                title: "Karriere-und Bewerbungscoaching",
                logoURL: "/assets/images/fias-logo-new-white.svg"
            },
            {
                badgeText: "+ Zertifikat",
                title: "IHK-Zertifikat \u201CDigital Transformation Manager\u201D",
                logoURL: "/assets/images/ihk-logo.svg"
            }
        ]
    }
};
console.log("Certificate Section Data:", $3f499fec838245db$var$certificateSectionData);
function $3f499fec838245db$var$template() {
    return /*html*/ `
    <div class="wrapper">
        ${(0, $1bf35103779040b3$export$2e2bcd8739ae039)({
        courseSlug: $3f499fec838245db$var$courseSlug,
        featureCards: [
            {
                title: "67.056 \u20AC",
                text: "Durchschnittliches Gehalt (J\xe4hrlich, Brutto - Quelle: Bundesagentur f\xfcr Arbeit)"
            },
            {
                title: "MacBook inklusive",
                text: "Um optimale Bedingungen f\xfcr deine Teilnahme an unserer Weiterbildung zu schaffen, stellen wir dir ein MacBook zur Verf\xfcgung"
            },
            {
                title: "Karrierechancen",
                html: /*html*/ `
                        <div style="display: flex; flex-direction: column; align-items: start; gap: 10px; margin-top: 5px;">
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div class="five-stars-icon-cont" style="display: flex; gap: 5px;">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>Sehr gut
                            </div>
                            <div style="font-size: 17px; font-family: inter-bold;">Vermittlungsquote: 78,3%</div>
                        </div>
                        <style>
                            ${$3f499fec838245db$var$tagName} .five-stars-icon-cont > div {
                                display: block;
                                width: 28px;
                                aspect-ratio: 1/1;
                                background-position: 50% 50%;
                                background-repeat: no-repeat;
                                background-size: contain;
                                background-image: url('/assets/images/star-icon.svg');
                            }
                        </style>
                    `
            }
        ]
    })}
    </div>
    ${0, $fe58bfe3bd6680f4$export$2e2bcd8739ae039}
    <div class="wrapper" style="padding-top: 2rem;">
        ${(0, $2c2e1177fa389bbb$export$2e2bcd8739ae039)({
        courseSlug: $3f499fec838245db$var$courseSlug
    })}
        ${(0, $26ea0bccf6b5e721$export$2e2bcd8739ae039)({
        courseSlug: $3f499fec838245db$var$courseSlug
    })}
    </div>

    <azav-verifiziert-section></azav-verifiziert-section>

    ${(0, $68392dbefd4434c1$export$2e2bcd8739ae039)({
        courseSlug: $3f499fec838245db$var$courseSlug
    })}

    <div class="wrapper">
    ${(0, $c1cc64f038d6da05$export$2e2bcd8739ae039)($3f499fec838245db$var$certificateSectionData)}
        <!--
        <div class="blue-certificate">
            ${/ÜrenderBlueCertificate(certificateSectionData.invertedModuleBox.blueCertificate)*/}
        </div>
        -->
    </div>

    <div class="fcc-section-wrapper" style="padding-top: 25px;">
    <fcc-6-schritte-component></fcc-6-schritte-component>
    <!-- Title Section -->
    <div class="video-title" style="text-align: center; color: var(--gray-brand); font-family: 'inter-bold', sans-serif; font-size: clamp(28px, 6.18vw, 45px); margin: 20px 0;">
    Unsere Arbeit im <span style="color: var(--blue-brand);">FCC</span> f\xfcr <br> einen
    <span style="color: var(--blue-brand);"> Start in deinem Traumjob</span>
    </div>

    <!-- Video Section -->
    ${(0, $df492b283b41f7dd$export$2e2bcd8739ae039)($3f499fec838245db$var$videoURL)}
    </div>

        <div class="wrapper">
        <div class="partner-section-wrapper"> ${0, $26e554f22bcc5aa9$export$2e2bcd8739ae039} </div>
    
        </div>

    <div class="feedback-section-wrapper">
        ${0, $741eb4901885d7cb$export$2e2bcd8739ae039} 
    </div>

    <div class="wrapper">
    ${(0, $26bb59f23615df1a$export$2e2bcd8739ae039)({
        courseSlug: $3f499fec838245db$var$courseSlug
    })}
    </div>

        
    ${(0, $89f654207e7613e6$export$2e2bcd8739ae039)({
        courseSlug: $3f499fec838245db$var$courseSlug,
        title: /*html*/ `<div class="line">Starte jetzt mit der Weiterbildung zum</div> <div class="line"><span>${config.courseData[$3f499fec838245db$var$courseSlug].name}</span></div>`,
        btnText: /*html*/ `<span>Jetzt kostenlose Beratung vereinbaren</span>`
    })}
    <div class="section" style="margin: 1rem 0;">
        <div class="wrapper">
            <div class="page-hero-medium font-scale-down centered" style="text-align: center; margin-bottom: 3rem; margin-top: 4rem;" id="faq">H\xe4ufig gestellte Fragen:</div>
            ${(0, $726e3f6128d4ba4e$export$2e2bcd8739ae039)([
        {
            q: "Was bringt mir eine Weiterbildung beim Franklin Institute?",
            a: "Wir leben Karriere. Das ist unser Motto - Unsere Weiterbildungen sollen Dir genau das erm\xf6glichen - Karriere. Wir bilden Dich \xfcber mehrere Monate in einem relevanten Beruf in der IT-Branche aus und unterst\xfctzen Dich dann beim Einstieg in deine Traumkarriere. Mit uns an Deiner Seite formen wir Deine Karriere und geben Dir alles an die Hand, was Du brauchst um beruflich erfolgreich zu sein."
        },
        {
            q: "Welche Voraussetzungen muss ich erf\xfcllen?",
            a: "Um an der Weiterbildung & am Career Success Programm teilnehmen zu k\xf6nnen, musst Du lediglich (bald) bei der Agentur f\xfcr Arbeit oder beim Jobcenter arbeitslos gemeldet sein. Solltest Du dies nicht sein, ist die Teilnahme leider nicht m\xf6glich. Du wirst in absehbarer Zeit arbeitslos? Dann bewerbe Dich gerne \xfcber unser kurzes Formular bei uns."
        },
        {
            q: "Fallen f\xfcr die Weiterbildung Kosten an?",
            a: "Wenn Du arbeitslos gemeldet bist, hast Du die M\xf6glichkeit einen Bildungsgutschein vom Staat zu erhalten. Dieser Bildungsgutschein finanziert Dir die komplette Weiterbildung und unser Career Success Programm - somit ist unser gesamtes Angebot kostenlos f\xfcr Dich. Bewerbe Dich gerne \xfcber unser kurzes Formular und wir helfen Dir dabei einen Bildungsgutschein zu erhalten."
        },
        {
            q: "Kann ich die Weiterbildung von Zuhause aus absolvieren?",
            a: "Ja - die komplette Weiterbildung inkl. Career Success Programm findet Remote statt. Somit hast Du die M\xf6glichkeit von \xfcberall aus teilzunehmen. Du erh\xe4ltst auch einen Laptop von uns."
        },
        {
            q: "Erhalte ich nach meiner Weiterbildung ein anerkanntes Zertifikat?",
            a: "Ja, da wir AZAV zertifiziert sind, erh\xe4ltst du nach deiner Weiterbildung ein offizielles Abschluss-Zertifikat von uns. Zus\xe4tzlich erh\xe4ltst du w\xe4hrend unseren Weiterbildungen einige, in der IT-Branche sehr angesehene, Zertifikate von namhaften Anbietern. So stellen wir sicher, dass du am Ende neben deiner Praxiserfahrung auch die n\xf6tigen Dokumente f\xfcr einen erfolgreichen Einstieg in die IT-Branche vorlegen kannst."
        }
    ])}
        </div>
    </div>
    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
        ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Bewerbungsformular."
        ],
        ctas: [
            {
                label: "Jetzt bewerben.",
                href: config.ctaURLS[$3f499fec838245db$var$courseSlug],
                internal: false,
                newTab: true
            }
        ]
    })}
    </div>
    <style>${$3f499fec838245db$var$css}</style>
    `;
}
class $3f499fec838245db$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($3f499fec838245db$var$pageTitle);
        util.setPageDescription($3f499fec838245db$var$pageDescription);
        this.innerHTML = $3f499fec838245db$var$template();
        document.body.classList.add("pm-course-page");
    }
}
customElements.define($3f499fec838245db$var$tagName, $3f499fec838245db$var$Page);
var $3f499fec838245db$export$2e2bcd8739ae039 = `<${$3f499fec838245db$var$tagName}></${$3f499fec838245db$var$tagName}>`;















const $045bef32e36755fc$var$tagName = "certificate-component-sales";
var $045bef32e36755fc$var$css = /*css*/ `
    ${$045bef32e36755fc$var$tagName} {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
    }

    .zertifikate-box {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(3, 1fr) !important; /* Default: three columns */
        grid-template-rows: auto !important; /* Adjust row height based on content */

        grid-gap: 20px; /* Space between grid items */
        justify-items: center;
    }
  

    .zertifikate-box-point {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: white;
        background-image: linear-gradient(137.51deg, #FFFFFF -8.85%, #959595 152.17%);
        color: var(--gray-brand);
        padding: 8px 8px;
        border-radius: 4px;
        gap: 10px;
        width: 220px;
        height: 120px;
        position: relative;
        overflow: hidden;
        transition: transform 0.2s;
        cursor: grab;
        user-select: none;
    }

    body.has-hover .zertifikate-box-point:hover {
        transform: translateY(-5px);
    }

    .certificate-title {
        font-family: 'inter-medium';
        font-size: 18px;
    }

    .certificate-title-product-school {
        font-family: 'inter-medium';
        font-size: 17px;
    }

    .zertifikat-badge {
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        background: rgba(255, 216, 77, 0.7);
        padding: 3px 7px;
        border-radius: 4px;
    }
    
    .zertifikat-badge-blue {
        background: #99EEF7;
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        padding: 3px 7px;
        border-radius: 4px;
    }
    
    .zertifikat-badge-green {
        background: rgba(178, 255, 205, 0.7);
        color: rgba(0, 0, 0, 0.7);
        font-size: 12px;
        padding: 3px 7px;
        border-radius: 4px;
    }

    .zertifikate-box-point * {
        z-index: 2;
    }

    .zertifikate-box-point:before {
        content: '';
        display: block;
        position: absolute;
        background-image: linear-gradient(-65deg, transparent 26%, rgba(255, 255, 255, 0.2) 27%, rgba(255, 255, 255, 0.2) 29%, transparent 30%, transparent 39%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 255, 255, 0.4) 50%, transparent 51%, transparent 55%, rgba(255, 255, 255, 0.2) 56%, rgba(255, 255, 255, 0.2) 64%, transparent 65%, transparent 69%, rgba(255, 255, 255, 0.2) 70%, rgba(255, 255, 255, 0.2) 71%, transparent 72%);
        width: 100%;
        height: 100%;
        top: 0;
        left: -100%;
        z-index: 1;
        animation: 2s shine infinite linear;
        animation-delay: inherit;
        mix-blend-mode: luminosity;
    }

    .zertifikat-logo {
        position: absolute;
        top: 10px;
        right: 8px;
        width: auto;
        height: auto;
        max-width: 90px;
        max-height: 90px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* Specific logo styles */
    .zertifikat-logo-hubspot {
        width: 70px;
        aspect-ratio: 2/1;
        top: -1px;
        background-image: url('/assets/images/hubspot-logo.png');
    }

    .zertifikat-logo-dvnlp {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 2/1;
        top: -1px;
        background-image: url('/assets/images/dvnlp-logo.png');
    }

    .zertifikat-logo-salesforce {
        right: -17px;
        bottom: unset;
        width: 90px;
        aspect-ratio: 2/1;
        top: 0px;
        background-image: url('/assets/images/salesforce-logo.webp');
    }

    .zertifikat-logo-fias {
        right: 8px;
        bottom: unset;
        width: 75px;
        aspect-ratio: 3/1;
        top: 7px;
        background-image: url('/assets/images/fias-logo-new.svg');
    }

    .zertifikat-logo-fias-white {
        right: 8px;
        bottom: unset;
        width: 70px;
        aspect-ratio: 3/1;
        background-image: url('/assets/images/fias-logo-new-white.svg');
    }

    @keyframes shine {
        0% {
            left: -100%;
        }
        25% {
            left: 100%;
        }
        100% {
            left: 100%;
        }
    }

    @media (max-width: 1119px) {
        .zertifikate-box {
            grid-template-columns: 1fr 1fr !important; /* Two columns for screens narrower than 1119px */
        }
    }
    
    @media (max-width: 599px) {
        .zertifikate-box {
            grid-template-columns: 1fr !important; /* One column on very small screens */
        }
    }
`;
const $045bef32e36755fc$var$renderInnerHTML = (options)=>{
    // Determine the logo class based on the logoURL or another property
    let logoClass = "";
    if (options.logoURL.includes("hubspot-logo.png")) logoClass = "zertifikat-logo-hubspot";
    else if (options.logoURL.includes("dvnlp-logo.png")) logoClass = "zertifikat-logo-dvnlp";
    else if (options.logoURL.includes("salesforce-logo.webp")) logoClass = "zertifikat-logo-salesforce";
    else if (options.logoURL.includes("fias-logo-new.svg")) logoClass = "zertifikat-logo-fias";
    else if (options.logoURL.includes("fias-logo-new-white.svg")) logoClass = "zertifikat-logo-fias-white";
    // Determine the badge class based on the badgeText content
    let badgeClass = "";
    if (options.badgeText.includes("+ Zertifikat")) badgeClass = "zertifikat-badge";
    else if (options.badgeText.includes("+ Praxis Portfolio")) badgeClass = "zertifikat-badge-green";
    else if (options.badgeText.includes("+ Report")) badgeClass = "zertifikat-badge-blue";
    // Determine the title class based on the title content
    let titleClass = "certificate-title";
    if (options.title.includes("User Research Zertifikat der Interaction Design Foundation")) titleClass = "certificate-title-product-school";
    return /*html*/ `
        <div class="zertifikate-box-point">
            <div class="${badgeClass}">${options.badgeText}</div>
            <div class="${titleClass}">${options.title}</div>
            <div class="zertifikat-logo ${logoClass}"></div>
            <style>${$045bef32e36755fc$var$css}</style>
        </div>
    `;
};
class $045bef32e36755fc$var$CertificateComponentSales extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Received data:', this.options);  // Log the data
        this.innerHTML = $045bef32e36755fc$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($045bef32e36755fc$var$tagName, $045bef32e36755fc$var$CertificateComponentSales);
function $045bef32e36755fc$var$render(options) {
    return `<${$045bef32e36755fc$var$tagName} element-options='${JSON.stringify(options)}'></${$045bef32e36755fc$var$tagName}>`;
}
var $045bef32e36755fc$export$2e2bcd8739ae039 = $045bef32e36755fc$var$render;


const $902e967d9eac56bb$var$tagName = "module-box-component";
var $902e967d9eac56bb$var$css = /*css*/ `
${$902e967d9eac56bb$var$tagName} .module-zertifikate-grid {
    margin-top: 40px;
    display: grid;
    grid-template-columns: 1fr 3fr; /* One column for numbers, three for the content */
    gap: 40px;
    align-items: start; /* Align items at the top of the grid */
}

${$902e967d9eac56bb$var$tagName} .modul-number {
    font-size: 110px;
    color: black;
    text-align: right;
    position: relative;
    align-self: start; /* Align number to the top of the grid cell */
    z-index: 1;
    top: 10px;
    background-image: url('/assets/images/number-background.svg');
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 200px; /* Adjust width to fit the background */
    height: 200px; /* Adjust height to fit the background */
    padding-right: 50px; /* Adjust padding to align the text inside the background */
    box-sizing: border-box; /* Ensure padding doesn't affect the overall size */
}

${$902e967d9eac56bb$var$tagName} .modul-box {
    position: relative; /* Ensure the title stays within the box */
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 25px 30px;
    padding-top: 45px;
    border-radius: 14px;
    background: var(--gray-brand-gradient);
    color: white;
}

${$902e967d9eac56bb$var$tagName} .modul-box-title {
    position: absolute;
    top: -15px;
    left: -25px;
    background: var(--light-blue-gradient);
    color: var(--gray-brand);
    padding: 0.6em 1em;
    border-radius: 6px;
    z-index: 1; /* Ensure the title stays above other elements */
    font-family: 'inter-bold';
}

${$902e967d9eac56bb$var$tagName} .bulletpoint {
    font-size: 1rem;
    margin-bottom: 10px;
    font-family: 'inter-bold';
}

${$902e967d9eac56bb$var$tagName} .bulletpoint:before {
    margin: 0 !important;
    margin-right: 0.5em !important;
    display: inline-flex;
    content: '';
    min-width: 12px;
    min-height: 12px;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
    transform: rotate(-90deg);
}

/* Responsive adjustments */

@media (max-width: 857px) {

    ${$902e967d9eac56bb$var$tagName} .modul-number {
        font-size: 70px; /* Reduce the font size */
padding-top: 17px;
padding-right: 50px;
        width: 170px; /* Adjust the width */
        height: 170px; /* Adjust the height */
        background-size: 80%; /* Adjust background size */
        background-position: center; /* Center the background */
    }
}

@media (max-width: 809px) {
    ${$902e967d9eac56bb$var$tagName} .modul-number {
        display: none; /* Hide the number */
    }

    ${$902e967d9eac56bb$var$tagName} .module-zertifikate-grid {
        grid-template-columns: 1fr; /* Make the module box take the full width */
    }
}
`;
const $902e967d9eac56bb$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="module-zertifikate-grid">
            <div class="modul-number">${options.number}</div>
            <div class="modul-box">
                <div class="modul-box-title">${options.title}</div>
                <div class="bulletpoints">
                    ${options.bulletpoints.map((point)=>`<div class="bulletpoint">${point}</div>`).join("")}
                </div>
                <div class="zertifikate-box">
                    ${options.certificates.map((cert)=>(0, $045bef32e36755fc$export$2e2bcd8739ae039)(cert)).join("")}
                </div>
            </div>
        </div>
        <style>${$902e967d9eac56bb$var$css}</style>
    `;
};
class $902e967d9eac56bb$var$ModuleBoxComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Module Box Options:', this.options);
        this.innerHTML = $902e967d9eac56bb$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($902e967d9eac56bb$var$tagName, $902e967d9eac56bb$var$ModuleBoxComponent);
function $902e967d9eac56bb$var$render(options) {
    return `<${$902e967d9eac56bb$var$tagName} element-options='${JSON.stringify(options)}'></${$902e967d9eac56bb$var$tagName}>`;
}
var $902e967d9eac56bb$export$2e2bcd8739ae039 = $902e967d9eac56bb$var$render;



const $20188c3001b694c4$var$tagName = "inverted-module-box-component";
var $20188c3001b694c4$var$css = /*css*/ `
${$20188c3001b694c4$var$tagName} .module-zertifikate-grid-inverted {
    margin-top: 40px;
    display: grid;
    grid-template-columns: 1fr 3fr; /* One column for numbers, three for the content */
    gap: 40px;
    align-items: start; /* Align items at the top of the grid */
}

${$20188c3001b694c4$var$tagName} .modul-number-inverted {
    font-size: 110px;
    color: black;
    text-align: right;
    position: relative;
    align-self: start; /* Align number to the top of the grid cell */
    z-index: 2;
    top: 10px;
    background-image: url('/assets/images/number-background.svg');
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 200px; /* Adjust width to fit the background */
    height: 200px; /* Adjust height to fit the background */
    padding-right: 50px; /* Adjust padding to align the text inside the background */
    box-sizing: border-box; /* Ensure padding doesn't affect the overall size */
}

${$20188c3001b694c4$var$tagName} .modul-box-inverted {
    position: relative; /* Ensure the title stays within the box */
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 25px 30px;
    padding-top: 45px;
    border-radius: 14px;
    background: white;  /* Background is white */
    color: var(--gray-brand);
    border: 6px solid #5AE3F0;
}

${$20188c3001b694c4$var$tagName} .modul-box-title-inverted {
    position: absolute;
    top: -22px;
    left: -25px;
    padding: 0.6em 1em;
    border-radius: 6px;
    background: var(--gray-brand-gradient);
    color: white;
    z-index: 2;
    grid-column: 2; /* Place the title in the second column */
    font-family: 'inter-bold';
}

${$20188c3001b694c4$var$tagName} .bulletpoint {
    font-size: 1rem;
    margin-bottom: 10px;
    font-family: 'inter-bold';
}

${$20188c3001b694c4$var$tagName} .bulletpoint:before {
    margin: 0 !important;
    margin-right: 0.5em !important;
    display: inline-flex;
    content: '';
    min-width: 12px;
    min-height: 12px;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
    transform: rotate(-90deg);
}

/* Responsive adjustments */

@media (max-width: 857px) {

    ${$20188c3001b694c4$var$tagName} .modul-number-inverted {
        font-size: 70px; /* Reduce the font size */
padding-top: 17px;
padding-right: 50px;
        width: 170px; /* Adjust the width */
        height: 170px; /* Adjust the height */
        background-size: 80%; /* Adjust background size */
        background-position: center; /* Center the background */
    }
}

@media (max-width: 809px) {
    ${$20188c3001b694c4$var$tagName} .modul-number-inverted {
        display: none; /* Hide the number */
    }

    ${$20188c3001b694c4$var$tagName} .module-zertifikate-grid-inverted {
        grid-template-columns: 1fr; /* Make the module box take the full width */
    }
}
`;
const $20188c3001b694c4$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="module-zertifikate-grid-inverted">
            <div class="modul-number-inverted">${options.number}</div>
            <div class="modul-box-inverted">
                <div class="modul-box-title-inverted">${options.title}</div>
                <div class="bulletpoints">
                    ${options.bulletpoints.map((point)=>`<div class="bulletpoint">${point}</div>`).join("")}
                </div>
                <div class="zertifikate-box">
                    ${options.certificates.map((cert)=>(0, $eadebe06eac8faeb$export$2e2bcd8739ae039)(cert)).join("")}
                </div>
            </div>
        </div>
        <style>${$20188c3001b694c4$var$css}</style>
    `;
};
class $20188c3001b694c4$var$ModuleBoxComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Module Box Options:', this.options);
        this.innerHTML = $20188c3001b694c4$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($20188c3001b694c4$var$tagName, $20188c3001b694c4$var$ModuleBoxComponent);
function $20188c3001b694c4$var$render(options) {
    return `<${$20188c3001b694c4$var$tagName} element-options='${JSON.stringify(options)}'></${$20188c3001b694c4$var$tagName}>`;
}
var $20188c3001b694c4$export$2e2bcd8739ae039 = $20188c3001b694c4$var$render;


const $7ce037480fc99cce$var$tagName = "certificate-section-sales";
var $7ce037480fc99cce$var$css = /*css*/ `
    ${$7ce037480fc99cce$var$tagName} {
        padding: 2rem;
        background: var(--light-gray);
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .centered-text {
        text-align: center;
        margin-bottom: 0.1em;
        font-family: 'inter-bold';
        font-size: clamp(28px, 6.18vw, 60px);
    }

    .subheading-text {
        font-size: 1.3em;
        font-family: 'inter-medium';
    }

    .light-blue-text {
        color: var(--blue-brand);
    }
`;
const $7ce037480fc99cce$var$renderInnerHTML = (options)=>{
    const normalModuleBoxesHTML = options.moduleBoxes.map((moduleBox)=>{
        return (0, $902e967d9eac56bb$export$2e2bcd8739ae039)(moduleBox);
    }).join("");
    const invertedModuleBoxHTML = (0, $20188c3001b694c4$export$2e2bcd8739ae039)(options.invertedModuleBox);
    return /*html*/ `
        <div class="section-message centered-text">
            <span style="font-size: clamp(28px, 6.18vw, 60px); font-family: 'inter-bold';">
                Der effektivste Start <br> in 
            </span>
            <span class="light-blue-text" style="font-size: clamp(28px, 6.18vw, 60px); font-family: 'inter-bold';">
                deine neue Karriere
            </span>
        </div>
        <div class="section-message centered subheading-text">Unser Kursaufbau und Karrierecoaching (Kurzfassung)</div>
        <div class="module-boxes-container">
            ${normalModuleBoxesHTML}
            ${invertedModuleBoxHTML}  
        </div>
        <style>${$7ce037480fc99cce$var$css}</style>
    `;
};
class $7ce037480fc99cce$var$CertificateSectionSales extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        console.log("Certificate Section Options:", this.options);
        this.innerHTML = $7ce037480fc99cce$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($7ce037480fc99cce$var$tagName, $7ce037480fc99cce$var$CertificateSectionSales);
function $7ce037480fc99cce$var$render(options) {
    return `<${$7ce037480fc99cce$var$tagName} element-options='${JSON.stringify(options)}'></${$7ce037480fc99cce$var$tagName}>`;
}
var $7ce037480fc99cce$export$2e2bcd8739ae039 = $7ce037480fc99cce$var$render;


const $c228935c53780454$var$tagName = "blue-certificate-component-sales";
var $c228935c53780454$var$css = /*css*/ `
    ${$c228935c53780454$var$tagName} {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 10px;
    }

    ${$c228935c53780454$var$tagName} .bonus-modul-wrapper {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-left: 320px; /* Adjust this value to control the space between the left edge and the certificate */
    }

    ${$c228935c53780454$var$tagName} .bonus-modul-plus-icon {
        width: 40px;
        height: 40px;
        background-image: url('/assets/images/plus-icon.png');
        background-size: contain;
        background-repeat: no-repeat;
    }

    ${$c228935c53780454$var$tagName} .zertifikate-box-point {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        background: var(--light-blue-gradient);
        color: black;
        padding: 8px 8px;
        border-radius: 4px;
        gap: 10px;
        width: 220px;
        height: 120px;
        overflow: hidden;
        transition: transform 0.2s;
        cursor: grab;
        user-select: none;
    }

    ${$c228935c53780454$var$tagName} body.has-hover .zertifikate-box-point:hover {
        transform: translateY(-5px);
    }

    ${$c228935c53780454$var$tagName} .certificate-title {
        font-family: 'inter-medium';
        font-size: 18px;
    }

    ${$c228935c53780454$var$tagName} .certificate-title-product-school {
        font-family: 'inter-medium';
        font-size: 17px;
    }

    ${$c228935c53780454$var$tagName} .zertifikat-badge-ihk {
        background-image: linear-gradient(137.51deg, #FFFFFF -8.85%, #959595 152.17%);
        background: linear-gradient(137.51deg, #fbf5b7 -8.85%, #b38728 152.17%);
        border: 1px solid #bf953f;
        padding: 3px 7px;
        border-radius: 4px;
        color: rgba(0, 0, 0, 0.7);
    }

    ${$c228935c53780454$var$tagName} .zertifikate-box-point * {
        z-index: 1;
    }

    ${$c228935c53780454$var$tagName} .zertifikat-logo {
        position: absolute;
        top: 10px;
        right: 8px;
        width: auto;
        height: auto;
        max-width: 90px;
        max-height: 90px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* Specific logo styles */
    ${$c228935c53780454$var$tagName} .zertifikat-logo-ihk {
        width: 70px;
        aspect-ratio: 2/1;
        background-image: url('/assets/images/ihk-logo.svg');
        top: 75px;
    }

    .bonus-modul-disclaimer {
        max-width: 800px;
        text-align: center;
        font-family: 'inter-light';
        margin: 0 auto;
        margin-top: 30px;
        font-size: 18px;
        margin-bottom: 20px;
    }

    @keyframes shine {
        0% {
            left: -100%;
        }
        25% {
            left: 100%;
        }
        100% {
            left: 100%;
        }
    }

    @media (max-width: 1119px) {
        ${$c228935c53780454$var$tagName} .zertifikate-box {
            grid-template-columns: 1fr 1fr !important; /* Two columns for screens narrower than 1119px */
        }
    }

    @media (max-width: 599px) {
        ${$c228935c53780454$var$tagName} .zertifikate-box {
            grid-template-columns: 1fr !important; /* One column on very small screens */
        }
    }

    @media (max-width: 809px) {
        ${$c228935c53780454$var$tagName} .bonus-modul-wrapper {
            margin-left: 40px; /* Adjust this value to control the space between the left edge and the certificate */
        }
    }
`;
const $c228935c53780454$var$renderInnerHTML = (options)=>{
    // Determine the logo class based on the logoURL or another property
    let logoClass = "";
    if (options.logoURL.includes("ihk-logo.svg")) logoClass = "zertifikat-logo-ihk";
    // Determine the badge class based on the badgeText content
    let badgeClass = "";
    if (options.badgeText.includes("+ IHK-Zertifikat")) badgeClass = "zertifikat-badge-ihk";
    // Determine the title class based on the title content
    let titleClass = "certificate-title";
    if (options.title.includes("User Research Zertifikat der Interaction Design Foundation")) titleClass = "certificate-title-product-school";
    return /*html*/ `
        <div class="bonus-modul-wrapper">
            <div class="bonus-modul-plus-icon"></div>
            <div class="zertifikate-box-point">
                <div class="${badgeClass}">${options.badgeText}</div>
                <div class="${titleClass}">${options.title}</div>
                <div class="zertifikat-logo ${logoClass}"></div>
            </div>
        </div>
        <style>${$c228935c53780454$var$css}</style>
    `;
};
class $c228935c53780454$var$BlueCertificateComponentSales extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(this.getAttribute("element-options"));
        // console.log('Received data:', this.options);  // Log the data
        this.innerHTML = $c228935c53780454$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
    }
}
customElements.define($c228935c53780454$var$tagName, $c228935c53780454$var$BlueCertificateComponentSales);
function $c228935c53780454$var$render(options) {
    return `<${$c228935c53780454$var$tagName} element-options='${JSON.stringify(options)}'></${$c228935c53780454$var$tagName}>`;
}
var $c228935c53780454$export$2e2bcd8739ae039 = $c228935c53780454$var$render;





const $93ee16d3c36079c1$var$tagName = "sales-course-page";
const $93ee16d3c36079c1$var$courseSlug = "sales";
var $93ee16d3c36079c1$var$pageTitle = "Werde IT-Vertriebsmanager | Franklin Institute of Applied Sciences";
var $93ee16d3c36079c1$var$pageDescription = `Starte deine Karriere mit der kostenlosen Weiterbildung des Franklin Institute zum ${config.courseData[$93ee16d3c36079c1$var$courseSlug].name}. In nur ${config.courseData[$93ee16d3c36079c1$var$courseSlug].duration} Monaten von der Arbeitslosigkeit zum Traumjob, inklusive MacBook und IHK-Zertifikat. Perfekt f\xfcr Quereinsteiger und 100% kostenfrei dank Bildungsgutschein. Sichere dir jetzt deinen Platz und nutze unsere umfassende Karriereberatung f\xfcr einen erfolgreichen Einstieg in die IT-Branche.`;
var $93ee16d3c36079c1$var$videoURL = "https://fast.wistia.com/embed/medias/yc67ol9ioj";
var $93ee16d3c36079c1$var$css = /*css*/ `

.feedback-section-wrapper {
        margin-top: -10px; 
    }

    ${$93ee16d3c36079c1$var$tagName} azav-verifiziert-section {
        margin-top: -20px; 
        padding-top: 0;
    }
    
    @media (max-width: 490px) {
        ${$93ee16d3c36079c1$var$tagName} azav-verifiziert-section {
            margin-top: 10px;
        }
    }
`;
const $93ee16d3c36079c1$var$certificateSectionData = {
    moduleBoxes: [
        {
            number: "1",
            title: "Grundlagen",
            bulletpoints: [
                "Grundlagen des IT-Vertriebs",
                "Technische Grundlagen von Softwareprodukten"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Inbound Sales der Hubspot Academy",
                    logoURL: "/assets/images/hubspot-logo.png"
                }
            ]
        },
        {
            number: "2",
            title: "DeepDive 1.0",
            bulletpoints: [
                "Markt- und Kundenanalyse",
                "Customer Relationship Management Deepdive",
                "Kommunikation im Vertrieb & Angebote verhandeln + erstellen"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Hubspot Sales Hub Software der Hubspot Academy",
                    logoURL: "/assets/images/hubspot-logo.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "NLP Basics von DVNLP",
                    logoURL: "/assets/images/dvnlp-logo.png"
                }
            ]
        },
        {
            number: "3",
            title: "DeepDive 2.0",
            bulletpoints: [
                "Prozessanalyse im Vertrieb & SaaS Leadakquise",
                "Sales Automation",
                "Agiles Projekt- & Anforderungsmanagement",
                "Leadership im Vertrieb",
                "Abschlussprojekt"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Design Thinking Franklin IAS",
                    logoURL: "/assets/images/fias-logo-new.svg"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Salesforce Certified Associate (Trailhead)",
                    logoURL: "/assets/images/salesforce-logo.webp"
                }
            ]
        }
    ],
    invertedModuleBox: {
        number: "4",
        title: "Franklin Career Center",
        bulletpoints: [
            "Karriere-Coaching & Pers\xf6nlichkeitsanalyse",
            "Intensives Bewerber Coaching",
            "Arbeitsvermittlung an Partner Unternehmen",
            "Bewerbungsphase mit Individueller Betreuung"
        ],
        certificates: [
            {
                badgeText: "+ Report",
                title: "Ausf\xfchrlicher Coaching Report",
                logoURL: "/assets/images/fias-logo-new-white.svg"
            }
        ],
        blueCertificate: {
            badgeText: "+ IHK-Zertifikat",
            title: "IHK-Zertifikat",
            logoURL: "/assets/images/ihk-logo.svg"
        }
    }
};
// console.log('Certificate Section Data:', certificateSectionData);
function $93ee16d3c36079c1$var$template() {
    return /*html*/ `
    <div class="wrapper">
        ${(0, $1bf35103779040b3$export$2e2bcd8739ae039)({
        courseSlug: $93ee16d3c36079c1$var$courseSlug,
        featureCards: [
            {
                title: "55.049 \u20AC + Bonus",
                text: "Durchschnittliches Gehalt (J\xe4hrlich, Brutto - Quelle: Bundesagentur f\xfcr Arbeit)"
            },
            {
                title: "MacBook inklusive",
                text: "Um optimale Bedingungen f\xfcr deine Teilnahme an unserer Weiterbildung zu schaffen, stellen wir dir ein MacBook zur Verf\xfcgung"
            },
            {
                title: "Karrierechancen",
                html: /*html*/ `
                        <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
                            <div class="five-stars-icon-cont" style="display: flex; gap: 5px;">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>Sehr gut
                        </div>
                        <style>
                            ${$93ee16d3c36079c1$var$tagName} .five-stars-icon-cont > div {
                                display: block;
                                width: 28px;
                                aspect-ratio: 1/1;
                                background-position: 50% 50%;
                                background-repeat: no-repeat;
                                background-size: contain;
                                background-image: url('/assets/images/star-icon.svg');
                            }
                        </style>
                    `
            }
        ]
    })}
    </div>
    ${0, $fe58bfe3bd6680f4$export$2e2bcd8739ae039}
    <div class="wrapper" style="padding-top: 2rem;">
        ${""}
        ${(0, $26ea0bccf6b5e721$export$2e2bcd8739ae039)({
        courseSlug: $93ee16d3c36079c1$var$courseSlug
    })}
    </div>

    <azav-verifiziert-section></azav-verifiziert-section>

    ${(0, $68392dbefd4434c1$export$2e2bcd8739ae039)({
        courseSlug: $93ee16d3c36079c1$var$courseSlug
    })}
    <div class="wrapper">

    ${(0, $7ce037480fc99cce$export$2e2bcd8739ae039)($93ee16d3c36079c1$var$certificateSectionData)}
    <div class="blue-certificate">
        ${(0, $c228935c53780454$export$2e2bcd8739ae039)($93ee16d3c36079c1$var$certificateSectionData.invertedModuleBox.blueCertificate)}
    </div>
</div>

    <div class="fcc-section-wrapper" style="padding-top: 25px;">
    <fcc-6-schritte-component></fcc-6-schritte-component>
    <!-- Title Section -->
    <div class="video-title" style="text-align: center; color: var(--gray-brand); font-family: 'inter-bold', sans-serif; font-size: clamp(28px, 6.18vw, 45px); margin: 20px 0;">
    Unsere Arbeit im <span style="color: var(--blue-brand);">FCC</span> f\xfcr <br> einen
    <span style="color: var(--blue-brand);"> Start in deinem Traumjob</span>
    </div>

    <!-- Video Section -->
    ${(0, $df492b283b41f7dd$export$2e2bcd8739ae039)($93ee16d3c36079c1$var$videoURL)}
    </div>

<div class="wrapper">
<div class="partner-section-wrapper" style="padding-top: 20px;"> ${0, $26e554f22bcc5aa9$export$2e2bcd8739ae039} 
</div>
</div>
        <div style="padding-top: 10px;">
        ${0, $741eb4901885d7cb$export$2e2bcd8739ae039}
        </div> 

        ${(0, $26bb59f23615df1a$export$2e2bcd8739ae039)({
        courseSlug: $93ee16d3c36079c1$var$courseSlug
    })}
    </div>
    ${(0, $89f654207e7613e6$export$2e2bcd8739ae039)({
        courseSlug: $93ee16d3c36079c1$var$courseSlug,
        title: /*html*/ `<div class="line">Starte jetzt mit der Weiterbildung zum</div> <div class="line"><span>${config.courseData[$93ee16d3c36079c1$var$courseSlug].name}</span></div>`,
        btnText: /*html*/ `<span>Jetzt kostenlose Beratung vereinbaren</span>`
    })}
    <div class="section" style="margin: 1rem 0;">
        <div class="wrapper">
        <div class="page-hero-medium font-scale-down centered" style="text-align: center; margin-bottom: 3rem; margin-top: 4rem;" id="faq">H\xe4ufig gestellte Fragen:</div>
            ${(0, $726e3f6128d4ba4e$export$2e2bcd8739ae039)([
        {
            q: "Was bringt mir eine Weiterbildung beim Franklin Institute?",
            a: "Wir leben Karriere. Das ist unser Motto - Unsere Weiterbildungen sollen Dir genau das erm\xf6glichen - Karriere. Wir bilden Dich \xfcber mehrere Monate in einem relevanten Beruf in der IT-Branche aus und unterst\xfctzen Dich dann beim Einstieg in deine Traumkarriere. Mit uns an Deiner Seite formen wir Deine Karriere und geben Dir alles an die Hand, was Du brauchst um beruflich erfolgreich zu sein."
        },
        {
            q: "Welche Voraussetzungen muss ich erf\xfcllen?",
            a: "Um an der Weiterbildung & am Career Success Programm teilnehmen zu k\xf6nnen, musst Du lediglich (bald) bei der Agentur f\xfcr Arbeit oder beim Jobcenter arbeitslos gemeldet sein. Solltest Du dies nicht sein, ist die Teilnahme leider nicht m\xf6glich. Du wirst in absehbarer Zeit arbeitslos? Dann bewerbe Dich gerne \xfcber unser kurzes Formular bei uns."
        },
        {
            q: "Fallen f\xfcr die Weiterbildung Kosten an?",
            a: "Wenn Du arbeitslos gemeldet bist, hast Du die M\xf6glichkeit einen Bildungsgutschein vom Staat zu erhalten. Dieser Bildungsgutschein finanziert Dir die komplette Weiterbildung und unser Career Success Programm - somit ist unser gesamtes Angebot kostenlos f\xfcr Dich. Bewerbe Dich gerne \xfcber unser kurzes Formular und wir helfen Dir dabei einen Bildungsgutschein zu erhalten."
        },
        {
            q: "Kann ich die Weiterbildung von Zuhause aus absolvieren?",
            a: "Ja - die komplette Weiterbildung inkl. Career Success Programm findet Remote statt. Somit hast Du die M\xf6glichkeit von \xfcberall aus teilzunehmen. Du erh\xe4ltst auch einen Laptop von uns."
        },
        {
            q: "Erhalte ich nach meiner Weiterbildung ein anerkanntes Zertifikat?",
            a: "Ja, da wir AZAV zertifiziert sind, erh\xe4ltst du nach deiner Weiterbildung ein offizielles Abschluss-Zertifikat von uns. Zus\xe4tzlich erh\xe4ltst du w\xe4hrend unseren Weiterbildungen einige, in der IT-Branche sehr angesehene, Zertifikate von namhaften Anbietern. So stellen wir sicher, dass du am Ende neben deiner Praxiserfahrung auch die n\xf6tigen Dokumente f\xfcr einen erfolgreichen Einstieg in die IT-Branche vorlegen kannst."
        }
    ])}
        </div>
    </div>
    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
        ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Bewerbungsformular."
        ],
        ctas: [
            {
                label: "Jetzt bewerben.",
                href: config.ctaURLS[$93ee16d3c36079c1$var$courseSlug],
                internal: false,
                newTab: true
            }
        ]
    })}
    </div>
    <style>${$93ee16d3c36079c1$var$css}</style>
    `;
}
class $93ee16d3c36079c1$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($93ee16d3c36079c1$var$pageTitle);
        util.setPageDescription($93ee16d3c36079c1$var$pageDescription);
        this.innerHTML = $93ee16d3c36079c1$var$template();
        document.body.classList.add("sales-course-page");
    }
}
customElements.define($93ee16d3c36079c1$var$tagName, $93ee16d3c36079c1$var$Page);
var $93ee16d3c36079c1$export$2e2bcd8739ae039 = `<${$93ee16d3c36079c1$var$tagName}></${$93ee16d3c36079c1$var$tagName}>`;



const $d5fc890d86b7e181$var$tagName = "impressum-page";
var $d5fc890d86b7e181$var$pageTitle = "Impressum | Franklin Institute of Applied Sciences";
var $d5fc890d86b7e181$var$pageDescription = "Das Franklin Institute bietet zu 100% staatliche gef\xf6rderte IT-Weiterbildungen und Karriereunterst\xfctzung f\xfcr Arbeitssuchende. Entdecke deine M\xf6glichkeiten in der IT-Branche mit unserem umfassenden Kursangebot, erfahrenen Dozenten und individueller Beratung. Starte jetzt deine erfolgreiche IT-Karriere mit uns.";
var $d5fc890d86b7e181$var$css = /*css*/ `
 ${$d5fc890d86b7e181$var$tagName} h3 {
    line-height: 1.2em;
 }
`;
var $d5fc890d86b7e181$var$template = /*html*/ `
    <div class="wrapper">
        <h1>Impressum</h1>
        <h3>
            Pioneer People GmbH<br>
            Arnulfstra\xdfe 61<br>
            80636 M\xfcnchen<br><br>
            beratung@franklin-institute.de<br>
            +49 89 62826149<br><br>
            Gesch\xe4ftsf\xfchrer: Johannes Burzin, Lorenz Franz<br>
            Ust-ID: DE355563609<br><br>
            Registergericht: Amtsgericht M\xfcnchen, HRB 287714<br><br>
            Inhaltlich verantwortlich gem. \xa7 55 RStV:<br>Johannes Burzin (Anschrift s.o.)
        </h3>
    </div>
    <style>${$d5fc890d86b7e181$var$css}</style>
`;
class $d5fc890d86b7e181$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($d5fc890d86b7e181$var$pageTitle);
        util.setPageDescription($d5fc890d86b7e181$var$pageDescription);
        this.innerHTML = $d5fc890d86b7e181$var$template;
    }
}
customElements.define($d5fc890d86b7e181$var$tagName, $d5fc890d86b7e181$var$Page);
var $d5fc890d86b7e181$export$2e2bcd8739ae039 = `<${$d5fc890d86b7e181$var$tagName}></${$d5fc890d86b7e181$var$tagName}>`;



const $cc5b2fa8db4fe3c5$var$tagName = "datenschutz-page";
var $cc5b2fa8db4fe3c5$var$pageTitle = "Datenschutz | Franklin Institute of Applied Sciences";
var $cc5b2fa8db4fe3c5$var$pageDescription = "Datenschutzerkl\xe4rung des Franklin Institute of Applied Sciences";
var $cc5b2fa8db4fe3c5$var$css = /*css*/ `
    // ${$cc5b2fa8db4fe3c5$var$tagName} h3 {
    //     line-height: 1.2em;
    // }
`;
var $cc5b2fa8db4fe3c5$var$template = /*html*/ `
    <div class="wrapper" id="datenschutz-cont">
        <div style="height: 1000px;"></div>
    </div>
    <style>${$cc5b2fa8db4fe3c5$var$css}</style>
`;
class $cc5b2fa8db4fe3c5$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($cc5b2fa8db4fe3c5$var$pageTitle);
        util.setPageDescription($cc5b2fa8db4fe3c5$var$pageDescription);
        this.innerHTML = $cc5b2fa8db4fe3c5$var$template;
        this.innerCont = this.querySelector("#datenschutz-cont");
        this.render();
    }
    async render() {
        var response = await fetch("/assets/text/fias-datenschutz.html");
        var responseText = await response.text();
        this.innerCont.innerHTML = responseText;
        var internalLinks = Array.from(this.querySelectorAll("a.index-link"));
        internalLinks.forEach((link)=>{
            link.setAttribute("internal", "");
            var preHref = link.getAttribute("href");
            link.setAttribute("href", location.pathname + preHref);
        });
    }
}
customElements.define($cc5b2fa8db4fe3c5$var$tagName, $cc5b2fa8db4fe3c5$var$Page);
var $cc5b2fa8db4fe3c5$export$2e2bcd8739ae039 = `<${$cc5b2fa8db4fe3c5$var$tagName}></${$cc5b2fa8db4fe3c5$var$tagName}>`;


const $8c3323cebf5b63fd$var$tagName = "vermittler-hero-component";
var $8c3323cebf5b63fd$var$vermittlerHeroComponentCss = /*css*/ `
    :host {
        display: block;
        position: relative;
        width: 100%;
        background-color: transparent;
    }
    
    .blue-line {
        height: 0.5rem;
        background: var(--blue-wide-gradient);
        position: absolute;
        left: 0;
        right: 0;
    }

    .blue-line.top {
        top: 0px;
    }

    .blue-line.bottom {
        bottom: 0px;
        z-index: 2;
    }

    .vermittler-hero-mobile-img {
        background-image: url('/assets/images/vermittler-hero-img-desktop-new.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 200px;
        position: relative;
        background-color: transparent;
        padding: 0;
        margin: 0;
    }

    .vermittler-hero-img-mobile-cont {
        display: none;
        padding: 0;
        margin: 0;
        background-color: transparent;
        overflow: visible;
    }

    .vermittler-hero-desktop-cont {
        position: relative;
        display: block;
        overflow: visible;
    }

    .vermittler-hero-desktop-img {
        background-image: url('/assets/images/vermittler-hero-img-desktop-new.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 400px;
        position: relative;
    }

    .vermittler-hero-mobile-text {
        position: absolute;
        bottom: 50%;
        left: 35%;  
        transform: translate(-50%, 50%); 
        color: white;
        font-family: 'inter-light', sans-serif;
        font-size: clamp(25px, 2vw, 30px); /* Use clamp for responsiveness */
        max-width: 36vw;
    }

    .vermittler-hero-mobile-text span {
        font-family: 'inter-bold', sans-serif;
        font-size: clamp(14px, 1.8vw, 22px); /* Ensure responsive font for span */
    }

    .vermittler-hero-desktop-fade {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0) 60%);
    }    

    .vermittler-hero-desktop-text {
        position: absolute;
        bottom: 50%; 
        left: 35%;   
        transform: translate(-50%, 50%); 
        color: white;
        font-family: 'inter-light', sans-serif;
        font-size: clamp(25px, 2vw, 30px); /* Use clamp for responsiveness */
        max-width: 36vw;
    }

    .vermittler-hero-desktop-text span {
        font-family: 'inter-bold', sans-serif;
        font-size: clamp(14px, 1.8vw, 22px); /* Ensure responsive font for span */
    }

    @media (max-width: 710px) {
        .vermittler-hero-img-mobile-cont {
            display: block;
        }

        .vermittler-hero-img-mobile {
            width: 100%;
            height: auto;
            background-size: cover;
        }

        .vermittler-hero-desktop-img {
            display: none;
        }

        .vermittler-hero-mobile-text {
            bottom: 50%; 
            left: 33%;   
            transform: translate(-50%, 50%); /* Adjust positioning to truly center */
            font-size: clamp(6px, 3.4vw, 18px); /* Responsive font size with min/max */
            width: 45%; 
            max-width: 90vw;
        }

        .vermittler-hero-mobile-text span {
            font-family: 'inter-bold', sans-serif;
            font-size: clamp(8px, 2.5vw, 16px); /* Ensure responsive font for span */
        }

        .vermittler-hero-desktop-text {
            display: none;
        }
    }
`;
// Create a new CSSStyleSheet
const $8c3323cebf5b63fd$var$styleSheet = new CSSStyleSheet();
$8c3323cebf5b63fd$var$styleSheet.replaceSync($8c3323cebf5b63fd$var$vermittlerHeroComponentCss);
const $8c3323cebf5b63fd$var$getTemplate = ()=>/*html*/ `
    <div class="vermittler-hero-img-mobile-cont">
        <div class="vermittler-hero-mobile-img">
            <div class="vermittler-hero-desktop-fade"></div>
        </div>
        <div class="vermittler-hero-mobile-text">
            "Unser Anspruch ist es, mindestens 90% unserer Teilnehmer erfolgreich in einen zukunftssicheren Job in der IT-Branche zu vermitteln."<br><br>
            <span>Dr. Emil Kendziorra<br>Bildungsbeauftragter Franklin IAS</span>
        </div>
        <div class="blue-line bottom"></div> 
    </div>
    <div class="vermittler-hero-desktop-cont">
        <div class="vermittler-hero-desktop-img">
            <div class="vermittler-hero-desktop-fade"></div>
        </div>
        <div class="vermittler-hero-desktop-text">
            "Unser Anspruch ist es, mindestens 90% unserer Teilnehmer erfolgreich in einen zukunftssicheren Job in der IT-Branche zu vermitteln."<br><br>
            <span>Dr. Emil Kendziorra<br>Bildungsbeauftragter Franklin IAS</span>
        </div>
        <div class="blue-line bottom"></div> 
    </div>
`;
class $8c3323cebf5b63fd$var$HeroComponent extends HTMLElement {
    constructor(){
        super();
        // Attach shadow DOM
        const shadow = this.attachShadow({
            mode: "open"
        });
        // Use adoptedStyleSheets to apply the styles
        shadow.adoptedStyleSheets = [
            $8c3323cebf5b63fd$var$styleSheet
        ];
        // Create and append the template
        const container = document.createElement("div");
        container.innerHTML = $8c3323cebf5b63fd$var$getTemplate();
        shadow.appendChild(container);
    }
}
// Register the custom element
customElements.define($8c3323cebf5b63fd$var$tagName, $8c3323cebf5b63fd$var$HeroComponent);
var $8c3323cebf5b63fd$export$2e2bcd8739ae039 = $8c3323cebf5b63fd$var$HeroComponent;


// Define the component tag name
const $9f52cafc713acde8$var$tagName = "warum-fias-grid-component";
// Define the CSS for the component
// Define the CSS for the component
var $9f52cafc713acde8$var$css = /*css*/ `
:host {
    display: block;
    padding: 20px;
    background-color: #ffffff;
    width: 100%;
    box-sizing: border-box;
}

.hero-3 {
    font-size: 44px;
    color: var(--blue-brand);
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
    padding-top: 30px;
    padding-bottom: 20px; 
}

/* Flexbox layout for two boxes in one row */
.four-field-grid-cont {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
    padding-left: 330px;
    padding-right: 330px;


}

.box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background: linear-gradient(135deg, #f0f0f0, #d9d9d9); /* Light gradient background */
    border-radius: 12px;
    padding: 20px;
    flex: 1;
    box-sizing: border-box;
    max-width: 48%; /* Two boxes per row */
    flex: 0 0 48%; /* Ensures each box takes 48% of the row width */
    max-height: 250px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Box shadow for depth */
    margin-bottom: 20px; /* Space between rows */
}

/* Flexbox to align icon and title side by side */
.icon-title-container {
    display: flex;
    align-items: center; /* Align icon and title vertically */
}

.partner-benefit-icon {
    width: 60px;
    height: 60px;
    background-color: var(--gray-brand); /* Set background to --gray-brand */
    border-radius: 100%; /* Circular icon background */
    background-size: 55%;
    background-position: center;
    margin-right: 15px;
    background-repeat: no-repeat;
}

.vermittler-icon-1 {
    background-image: url('/assets/images/icons/vermittler-icon-test.svg');
}

.vermittler-icon-2 {
    background-image: url('/assets/images/icons/vermittler-icon-group.svg');
}

.vermittler-icon-3 {
    background-image: url('/assets/images/icons/vermittler-icon-dozenten.svg');
}

.vermittler-icon-4 {
    background-image: url('/assets/images/icons/vermittler-icon-programm.svg');
}

.partner-benefit-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    line-height: 1.2;
}

.partner-benefit-text {
    font-size: 14px;
    font-family: 'inter-medium';
    line-height: 1.5;
    margin-top: 10px;
}


@media (max-width: 1605px) {
    .four-field-grid-cont {
        padding-left: 180px;
        padding-right: 180px;
    }

    @media (max-width: 990px) {
        .hero-3 {
            font-size: 26px;
        }
        .four-field-grid-cont {
            padding-left: 170px;
            padding-right: 170px;
        }
    
        .box {
            max-width: 100%; /* One box per row on smaller screens */
            flex: 0 0 100%; /* Ensure the box takes the full width */
            margin-bottom: 20px;
        }
    }

    @media (max-width: 835px) {
        .four-field-grid-cont {
            padding-left: 110px;
            padding-right: 110px;
        }

    }

@media (max-width: 617px) {
    .hero-3 {
        font-size: 26px;
    }
    .four-field-grid-cont {
        padding: 0 20px; /* Adjust padding for smaller screens */
    }

    .box {
        max-width: 100%; /* One box per row on smaller screens */
        flex: 0 0 100%; /* Ensure the box takes the full width */
        margin-bottom: 20px;
    }
}
`;
// Define the HTML structure for the component
var $9f52cafc713acde8$var$template = /*html*/ `
<div class="hero-3 blue-font centered">Warum das Franklin IAS?</div>
<div class="four-field-grid-cont">
    <!-- Box 1 -->
    <div class="box">
        <div class="icon-title-container">
            <div class="partner-benefit-icon vermittler-icon-1"></div>
            <div class="partner-benefit-title">Sorgf\xe4ltige <br> Eignungs-Pr\xfcfung</div>
        </div>
        <div class="partner-benefit-text">
            Alle Interessenten werden durch einen fundierten, schriftlichen Eignungstest, sowie pers\xf6nliche Gespr\xe4che auf Eignung f\xfcr unsere Weiterbildungen gepr\xfcft.
        </div>
    </div>

    <!-- Box 2 -->
    <div class="box">
        <div class="icon-title-container">
            <div class="partner-benefit-icon vermittler-icon-2"></div>
            <div class="partner-benefit-title">Kleine Lerngruppen</div>
        </div>
        <div class="partner-benefit-text">
            Wir setzen auf kleine, homogene Lerngruppen. So stellen wir sicher, dass sie den maximalen Lernerfolg erlangen und individuell von unseren Dozenten betreut werden k\xf6nnen.
        </div>
    </div>

    <!-- Box 3 -->
    <div class="box">
        <div class="icon-title-container">
            <div class="partner-benefit-icon vermittler-icon-3"></div>
            <div class="partner-benefit-title">Qualifizierte Dozenten</div>
        </div>
        <div class="partner-benefit-text">
            Unsere Dozenten kommen direkt aus der Praxis. Unternehmensberater, IT-Spezialisten und Doktoranten - bei uns lehren Experten aus den wichtigsten Bereichen.
        </div>
    </div>

    <!-- Box 4 -->
    <div class="box">
        <div class="icon-title-container">
            <div class="partner-benefit-icon vermittler-icon-4"></div>
            <div class="partner-benefit-title">Karriere-Programm</div>
        </div>
        <div class="partner-benefit-text">
            Wir vermitteln unseren Teilnehmern nicht nur das n\xf6tige Fachwissen, sondern vermitteln diese auch in einen passenden, zukunftssicheren Job - mit unserem Karriereprogramm.
        </div>
    </div>
</div>
`;
// Define the WarumFiasComponent class
class $9f52cafc713acde8$var$WarumFiasComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // Attach Shadow DOM to isolate component styles and markup
        const shadow = this.attachShadow({
            mode: "open"
        });
        // Create a container to hold the template and styles
        const container = document.createElement("div");
        container.innerHTML = $9f52cafc713acde8$var$template;
        const style = document.createElement("style");
        style.textContent = $9f52cafc713acde8$var$css;
        shadow.appendChild(style);
        shadow.appendChild(container);
    }
}
// Register the custom element
customElements.define($9f52cafc713acde8$var$tagName, $9f52cafc713acde8$var$WarumFiasComponent);
var $9f52cafc713acde8$export$2e2bcd8739ae039 = $9f52cafc713acde8$var$WarumFiasComponent;


const $a24d1a4667450860$var$tagName = "counter-widget-component";
var $a24d1a4667450860$var$counterCss = /*css*/ `
.counter-section {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 60px;  /* Spacing between the boxes */
    padding: 40px 350px;
    background-color: #ffffff;
    grid-auto-rows: 1fr;  /* Make sure all rows have the same height */
}

.counter-box {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    transition: transform 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;  /* Ensures the box takes the full width of its grid cell */
    height: 230px;  /* Ensures a fixed height for all boxes */
    cursor: pointer;
    justify-self: center;

}

.counter-box.middle-box {
    background-color: var(--blue-brand);
}

.counter-box.middle-box .counter {
    color: white;  /* White counter for the middle box */
}

.counter-box.middle-box p {
    color: white;  /* White text for the middle box */
}

.counter-box:hover {
    transform: translateY(-5px);
}

/* Individual icon classes */
.icon-teilnehmer {
    width: 80px;  /* Size for first icon */
    height: auto;
    margin-bottom: 10px;
}

.icon-vermittlung {
    width: 80px;  /* Size for second icon */
    height: auto;
    margin-bottom: 10px;
}

.icon-bewertungen {
    width: 190px;  /* Size for third icon */
    height: auto;
    margin-bottom: 8px;
    margin-top: 9px;
}

.counter {
    font-size: 36px;
    color: var(--blue-brand);  /* Default color for the counter */
    margin: 10px 0;
    font-family: inter-bold;
}

p {
    font-size: 20px;
    color: #333;
    font-family: inter-medium;
}

/* Responsive adjustments */

@media (max-width: 953px) {
    .counter-section {
        grid-template-columns: 1fr;  /* Stack boxes vertically on smaller screens */
        padding: 20px 10px;  /* Reduce padding between the boxes and screen walls */
    }

    .counter-box {
        max-width: 100%;
    }
}

@media (max-width: 1192px) {
    .counter-section {
        grid-template-columns: 1fr;  /* Stack boxes vertically on smaller screens */
        padding: 40px;
    }

    .counter-box {
        max-width: 100%;
    }
}


@media (max-width: 1605px) {
    .counter-section {
        grid-template-columns: repeat(2, 1fr);  /* Two equal columns */
        grid-template-rows: auto;
        gap: 30px;
        padding: 40px 200px;
    }

    .counter-box:nth-child(2) {
        grid-column: 1 / 3;  /* Span across both columns */
        grid-row: 2;  /* Place the middle box on the second row */
        justify-self: center;
    }
}

@media (max-width: 835px) {
    .counter-section {
        grid-template-columns: 1fr;  /* Stack all boxes vertically */
        grid-template-rows: auto;    /* Automatically adjust rows */
        width: 80%;
        length: auto;
        justify-self: center;
        padding: 75px;
    }

    /* Ensure the second box (middle blue box) stays in the middle */
    .counter-box:nth-child(2) {
        grid-column: auto;  /* Reset column span */
        grid-row: auto;     /* Reset row placement */
    }

    .counter-box {
        width: 80%;  /* Ensure the boxes take full width */
        justify-self: center;
        

    }
}

@media (max-width: 835px) {
    .counter-section {
        padding: 60px;
    }
}

@media (max-width: 460px) {
    .counter-section {
        padding: 40px;
    }
}


`;
var $a24d1a4667450860$var$counterTemplate = /*html*/ `
    <section class="counter-section">
        <div class="counter-box">
            <img src="/assets/images/icons/Teilnehmer-Icon.png" class="icon icon-teilnehmer" alt="Teilnehmer Icon">
            <div class="counter" data-target="200" data-suffix="+">0</div>
            <p>zufriedene Teilnehmer</p>
        </div>
        <div class="counter-box middle-box">
            <img src="/assets/images/icons/Vermittlung-Icon.png" class="icon icon-vermittlung" alt="Vermittlungsquote Icon">
            <div class="counter" data-target="78.3" data-suffix="%">0%</div>
            <p>Vermittlungsquote</p>
        </div>
        <div class="counter-box">
            <img src="/assets/images/icons/5-Sterne-Icon.png" class="icon icon-bewertungen" alt="Bewertungen Icon">
            <div class="counter" data-target="315" data-suffix="+">0</div>
            <p>5 Sterne Bewertungen</p>
        </div>
    </section>
`;
class $a24d1a4667450860$var$CounterWidget extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // Attach Shadow DOM to isolate component styles and markup
        const shadow = this.attachShadow({
            mode: "open"
        });
        // Create a container to hold the template and styles
        const container = document.createElement("div");
        container.innerHTML = $a24d1a4667450860$var$counterTemplate;
        const style = document.createElement("style");
        style.textContent = $a24d1a4667450860$var$counterCss;
        shadow.appendChild(style);
        shadow.appendChild(container);
        // Initialize counter animation
        this.initCounters(shadow);
    }
    initCounters(shadow) {
        const counters = shadow.querySelectorAll(".counter");
        const speed = 50; // Animation speed
        const runCounter = ()=>{
            counters.forEach((counter)=>{
                const target = +counter.getAttribute("data-target");
                const suffix = counter.getAttribute("data-suffix") || ""; // Get suffix
                const updateCount = ()=>{
                    let currentValue = +counter.innerText.replace(suffix, ""); // Remove suffix to get numeric value
                    const increment = target / speed;
                    if (currentValue < target) {
                        currentValue = Math.ceil(currentValue + increment);
                        counter.innerText = `${currentValue}${suffix}`;
                        setTimeout(updateCount, 20);
                    } else counter.innerText = `${target}${suffix}`; // Final value with suffix
                };
                updateCount();
            });
        };
        // Observe when the component is in view to start animation
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    runCounter();
                    observer.disconnect(); // Stop observing after animation
                }
            });
        }, {
            threshold: 0.5
        });
        observer.observe(shadow.querySelector(".counter-section"));
    }
}
customElements.define($a24d1a4667450860$var$tagName, $a24d1a4667450860$var$CounterWidget);
var $a24d1a4667450860$export$2e2bcd8739ae039 = $a24d1a4667450860$var$CounterWidget;



const $3f0b18165d08a7ee$var$tagName = "warum-pm-section";
var $3f0b18165d08a7ee$var$css = /*css*/ `
    ${$3f0b18165d08a7ee$var$tagName} {
        display: block;
        font-family: 'inter-medium';
    }
    ${$3f0b18165d08a7ee$var$tagName} .grid-outer-cont {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 40px;
        padding-right: 40px;
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-grid {
        max-width: 1100px;
        display: grid;
        gap: 40px;
        grid-template-columns: 1fr 1fr 1fr;
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box {
        padding: 20px 25px;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(1) {
        padding: 0;
        grid-column: 1;
        grid-row: 1;
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(2) {
        grid-column: 2 / 4;
        grid-row: 1;
        background: var(--light-gray);
        background: #EBEBEB;
    }
    ${$3f0b18165d08a7ee$var$tagName} .info-img-1 {
        background-image: url('/assets/images/vermittler-why.jpg');
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
    }

    ${$3f0b18165d08a7ee$var$tagName} .section-bulletpoints {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
        line-height: 1.6em;
        margin-bottom: 1.2em;
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-bulletpoint b {
        font-family: 'inter-bold', 'inter';
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
        text-decoration-thickness: 2px;
        text-underline-offset: 2px;
    }
    
    ${$3f0b18165d08a7ee$var$tagName} .section-bulletpoint:before {
        margin: 0 !important;
        margin-right: 0.5em !important;
        display: inline-flex;
        content: '';
        min-width: 12px;
        min-height: 12px;
        background-image: url('/assets/images/blue-arrow-double.svg');
        background-size: 100% 100%;
        transform: rotate(-90deg);
    }

    ${$3f0b18165d08a7ee$var$tagName} .section-text {
        margin-bottom: 1.2em;
        line-height: 1.6em;
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-text b {
        font-family: 'inter-bold';
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
        text-decoration-thickness: 2px;
        text-underline-offset: 2px;
    }
    ${$3f0b18165d08a7ee$var$tagName} .section-title {
        margin-bottom: 1em;
        font-family: 'inter-bold';
        font-size: 1.2rem;
    }

    .hero-3 {
        font-size: 44px;
        color: var(--blue-brand);
        text-align: center;
        font-weight: bold;
        margin-bottom: 20px;
        padding-bottom: 20px; 
    }

    @media(max-width: 899px){
        ${$3f0b18165d08a7ee$var$tagName} .section-grid {
            grid-template-columns: 1fr 1fr;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(1) {
            grid-column: 1;
            grid-row: 2;
            aspect-ratio: 1 / 1.5;
            display: none;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(2) {
            grid-column: 1/3;
            grid-row: 1;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(3) {
            grid-column: 1/3;
            grid-row: 3;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(4) {
            grid-column: 1/3;
            grid-row: 2;
            aspect-ratio: 1.5 / 1;
        }
    }
    @media(max-width: 499px){
        ${$3f0b18165d08a7ee$var$tagName} .hero-3 {
            font-size: 28px;
            padding-bottom: 10px;
            padding-left:20px !important;
            padding-right:20px !important;
        }

        ${$3f0b18165d08a7ee$var$tagName} .grid-outer-cont {
            padding-left:20px !important;
            padding-right:20px !important;
        }

        ${$3f0b18165d08a7ee$var$tagName} .section-grid {
            grid-template-columns: 1fr;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(1) {
            grid-column: 1;
            grid-row: 2;
            aspect-ratio: 1 / 1.3;
            display: initial;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(2) {
            grid-column: 1;
            grid-row: 1;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(3) {
            grid-column: 1;
            grid-row: 3;
        }
        ${$3f0b18165d08a7ee$var$tagName} .section-grid .section-grid-box:nth-child(4) {
            grid-column: 1;
            grid-row: 4;
            aspect-ratio: 1.3 / 1;
        }
    }
`;
const $3f0b18165d08a7ee$var$renderInnerHTML = (options)=>{
    return /*html*/ `
    <div class="hero-3 blue-font centered">Warum eine Karriere im IT-Bereich?</div>
        <div class="grid-outer-cont">
            <div class="section-grid">
                <div class="section-grid-box">
                    <div class="info-img-1"></div>
                </div>
                <div class="section-grid-box">
                    <div class="section-text">IT-Fachkr\xe4fte unterst\xfctzen Unternehmen bei der <b>Optimierung ihrer digitalen Prozesse</b> und sind in vielen Bereichen gefragt. Es gibt zahlreiche Gr\xfcnde, warum sich eine Karriere in diesem Bereich lohnt:</div>
                    <div class="section-bulletpoints">
                        <div class="section-bulletpoint"> <b>Zukunftssicherheit:</b> Die fortschreitende Digitalisierung pr\xe4gt alle Branchen und wird auch in Zukunft von zentraler Bedeutung sein. Entwicklungen wie die <b>k\xfcnstliche Intelligenz</b> verdeutlichen den <b>langfristigen Bedarf</b> an IT-Expertise.</div>
                        <div class="section-bulletpoint"><b>Vielf\xe4ltige Einsatzm\xf6glichkeiten:</b> IT-Fachkr\xe4fte werden in fast allen Branchen ben\xf6tigt, von gro\xdfen Unternehmen bis hin zu Start-ups. Es gibt zudem zahlreiche Remote-Positionen, was <b>Flexibilit\xe4t</b> und vielf\xe4ltige <b>Entwicklungsm\xf6glichkeiten</b> bietet. Derzeit gibt es laut Indeed in Deutschland etwa <b>26.000 offene Stellen</b> in diesem Bereich.</div>
                        <div class="section-bulletpoint"><b>Hohes Potential f\xfcr Karriere und finanzielle Entwicklung:</b> Die hohe Nachfrage sorgt f\xfcr gute Karrierechancen und ein attraktives Einkommenspotenzial.</div>
                        <div class="section-bulletpoint"><b>Einstiegsm\xf6glichkeiten f\xfcr Quereinsteiger:</b> Auch Personen aus anderen Berufsfeldern k\xf6nnen durch passende Weiterbildung und Schulungen die <b>erforderlichen Kompetenzen</b> f\xfcr eine Karriere im IT-Bereich erwerben.</div>
                    </div>
                    <div class="section-text">Insgesamt bietet eine Karriere im IT-Bereich, ob als Berater oder im Vertrieb, <b>zukunftssichere</b>, <b>vielseitige</b> und <b>attraktive M\xf6glichkeiten</b>.</div>

                </div>
                    <div class="info-img-2"></div>
                </div>
            </div>
        </div>
        <style>${$3f0b18165d08a7ee$var$css}</style>
    `;
};
class $3f0b18165d08a7ee$var$CustomElem extends HTMLElement {
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $3f0b18165d08a7ee$var$renderInnerHTML(this.options);
    }
}
customElements.define($3f0b18165d08a7ee$var$tagName, $3f0b18165d08a7ee$var$CustomElem);
function $3f0b18165d08a7ee$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$3f0b18165d08a7ee$var$tagName} element-options="${e(JSON.stringify(options))}"></${$3f0b18165d08a7ee$var$tagName}>`;
}
var $3f0b18165d08a7ee$export$2e2bcd8739ae039 = $3f0b18165d08a7ee$var$render;


const $d9f3bfc1df5f6a19$var$tagName = "voraussetzungen-component";
// CSS to be applied globally
var $d9f3bfc1df5f6a19$var$VoraussetzungenCss = /*css*/ `
${$d9f3bfc1df5f6a19$var$tagName} .fcc-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px; /* Adjusted padding */
    background-color: transparent;
}

${$d9f3bfc1df5f6a19$var$tagName} .fcc-svg-container {
    width: 100%;
    max-width: 1100px; 
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

${$d9f3bfc1df5f6a19$var$tagName} svg {
    width: 100%;
    height: auto;
    max-width: 100%; /* Ensures SVG scales within its container */
    overflow: visible;
}

/* Desktop hover effects */
${$d9f3bfc1df5f6a19$var$tagName} #desktop-01,
#desktop-02,
#desktop-03,
#desktop-04,
#desktop-05,
#desktop-06 {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.15));
    transition: transform 0.3s ease;
    transform-origin: center;
}

${$d9f3bfc1df5f6a19$var$tagName} #desktop-01:hover {
    transform: translateY(-5px) !important;
}

${$d9f3bfc1df5f6a19$var$tagName} #desktop-02:hover {
    transform: translateX(5px);
}

${$d9f3bfc1df5f6a19$var$tagName} #desktop-03:hover {
    transform: translateX(-5px) !important;
}

${$d9f3bfc1df5f6a19$var$tagName} #desktop-04:hover {
    transform: translateX(-5px);
}

${$d9f3bfc1df5f6a19$var$tagName} #desktop-05:hover {
    transform: translateX(5px);
}


/* Title and text styles */
${$d9f3bfc1df5f6a19$var$tagName} .centered-text {
    text-align: center;
    margin-bottom: 0.1em;
    font-family: 'inter-bold';
    font-size: clamp(28px, 6.18vw, 45px);
    padding-top: 50px;
}

/* Mobile adjustments */
@media (max-width: 630px) {
    ${$d9f3bfc1df5f6a19$var$tagName} .fcc-svg-container {
        display: none;
    }

    ${$d9f3bfc1df5f6a19$var$tagName} .centered-text {
        padding-top: 30px;
    }

    ${$d9f3bfc1df5f6a19$var$tagName} .fcc-container {
        display: none;
    }

    ${$d9f3bfc1df5f6a19$var$tagName} .fcc-svg-container-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 350px; /* Smaller max width for mobile view */
        margin: 0 auto;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    ${$d9f3bfc1df5f6a19$var$tagName} svg {
        width: 100%;
        height: auto;
    }
}

/* Hide mobile SVG on larger screens */
@media (min-width: 631px) {
    ${$d9f3bfc1df5f6a19$var$tagName} .fcc-svg-container-mobile {
        display: none;
    }
}
`;
// HTML template for desktop and mobile SVG containers
var $d9f3bfc1df5f6a19$var$VoraussetzungenTemplate = /*html*/ `
<head>
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap" rel="stylesheet">
</head>
<div class="section-message centered-text">
    <span style="font-size: clamp(28px, 6.18vw, 45px); font-family: 'inter-bold';">
        Voraussetzungen der Teilnehmer
    </span>
</div>

<!-- Desktop SVG container -->
<section class="fcc-container">
    <div class="fcc-svg-container" id="desktop-svg-container"></div>
</section>

<!-- Mobile SVG container -->
<section class="fcc-container-mobile">
    <div class="fcc-svg-container-mobile" id="mobile-svg-container"></div>
</section>
`;
// Function to load the external SVG files
function $d9f3bfc1df5f6a19$var$loadSVG(svgUrl, containerElement) {
    fetch(svgUrl).then((response)=>response.text()).then((svgData)=>{
        containerElement.innerHTML = svgData;
        const svgElement = containerElement.querySelector("svg");
        if (svgElement) {
            svgElement.style.width = "100%";
            svgElement.style.height = "auto";
        }
    }).catch((error)=>console.error("Error loading SVG:", error));
}
// Define the custom element without using Shadow DOM
class $d9f3bfc1df5f6a19$var$Voraussetzungen extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // Append the template content
        this.innerHTML = $d9f3bfc1df5f6a19$var$VoraussetzungenTemplate;
        // Append the CSS styles directly to the document if not already added
        if (!document.getElementById("voraussetzungen-styles")) {
            const style = document.createElement("style");
            style.id = "voraussetzungen-styles";
            style.textContent = $d9f3bfc1df5f6a19$var$VoraussetzungenCss;
            document.head.appendChild(style);
        }
        // Load the desktop and mobile SVGs
        const desktopSvgContainer = this.querySelector("#desktop-svg-container");
        const mobileSvgContainer = this.querySelector("#mobile-svg-container");
        $d9f3bfc1df5f6a19$var$loadSVG("/assets/images/Voraussetzungen.svg", desktopSvgContainer);
        $d9f3bfc1df5f6a19$var$loadSVG("/assets/images/Voraussetzungen_mobile.svg", mobileSvgContainer);
    }
}
customElements.define($d9f3bfc1df5f6a19$var$tagName, $d9f3bfc1df5f6a19$var$Voraussetzungen);
var $d9f3bfc1df5f6a19$export$2e2bcd8739ae039 = $d9f3bfc1df5f6a19$var$Voraussetzungen;



const $f47a2815d6db1851$var$tagName = "course-card-vermittler";
var $f47a2815d6db1851$var$css = /*css*/ `
    ${$f47a2815d6db1851$var$tagName} {
        display: flex;
        width: 100%;
        max-width: 450px;
        aspect-ratio: 515 / 660;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        // border: 10px solid yellow;
        border-radius: 0.8rem;
        position: relative;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        // border: 1.5px solid rgba(0, 0, 0, 0.2);
        box-sizing: border-box;
        font-size: min(18px, 3.75vw);
        overflow: hidden;
    }
    ${$f47a2815d6db1851$var$tagName} .text-cont {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        // background: rgba(255, 255, 0, 0.1);
        display: flex;
        flex-direction: column;
        gap: 1em;
        padding: 1em;
    }
    ${$f47a2815d6db1851$var$tagName} .text-title {
        font-size: 2.2em;
        line-height: 1em;
        letter-spacing: -0.02em;
        font-family: 'inter-bold';
        filter: drop-shadow(0px -30px 30px rgba(255, 255, 255, 1));
    }
    ${$f47a2815d6db1851$var$tagName} .button {
        width: fit-content;
        padding: 1em 2em;
        color: white;
        background: var(--gray-brand-gradient);
        border-radius: 0.3em;
        cursor: pointer;
        box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
        transition: 200ms;
    }
    ${$f47a2815d6db1851$var$tagName} .button span {
        font-size: 1.1em;
        border-bottom: 2px solid var(--blue-brand);
    }
    ${$f47a2815d6db1851$var$tagName} .text-bulletpoints {
        display: flex;
        flex-direction: column;
        gap: 0.4em;
        margin-top: 10px;
        margin-bottom: 15px;

    }
    ${$f47a2815d6db1851$var$tagName} .text-bulletpoint {
        font-family: 'inter-medium';
        letter-spacing: -0.02em;
        display: flex;
        gap: 0.5em;
        transform: translateX(0.3em);
    }
    ${$f47a2815d6db1851$var$tagName} .text-bulletpoint:before {
        content: '';
        display: flex;
        width: 1em;
        aspect-ratio: 1/1;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/assets/images/blue-arrow-double.svg');
        transform: rotate(-90deg);
    }
    ${$f47a2815d6db1851$var$tagName} .text-cont a {
        margin: 0 auto;
    }
`;
const $f47a2815d6db1851$var$renderInnerHTML = (options)=>{
    var bulletPointsHTML = "";
    options.bulletPoints.forEach((bp)=>{
        bulletPointsHTML += /*html*/ `<div class="text-bulletpoint">${bp}</div>`;
    });
    return /*html*/ `
        <div class="text-cont">
            <div class="text-title">${options.title}</div>
            <div class="text-bulletpoints">${bulletPointsHTML}</div>
            <div style="display: flex; justify-content: center;">
                <button class="button" style="background: none; border: none; padding: 0; cursor: pointer;" onclick="window.open('${options.ctaURL}', '_blank')">
                    ${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(/*html*/ `<span>Infomaterial</span>`, {
        noBorder: true,
        shadow: true
    })}
                </button>
            </div>
        </div>
        <style>${$f47a2815d6db1851$var$css}</style>
    `;
};
class $f47a2815d6db1851$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $f47a2815d6db1851$var$renderInnerHTML(this.options);
        this.style.backgroundImage = `url('${this.options.imageURL}')`;
        this.removeAttribute("element-options");
    }
}
customElements.define($f47a2815d6db1851$var$tagName, $f47a2815d6db1851$var$CustomElem);
function $f47a2815d6db1851$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$f47a2815d6db1851$var$tagName} element-options="${e(JSON.stringify(options))}"></${$f47a2815d6db1851$var$tagName}>`;
}
var $f47a2815d6db1851$export$2e2bcd8739ae039 = $f47a2815d6db1851$var$render;



const $131ad46bce8c8335$var$tagName = "white-cta-box";
var $131ad46bce8c8335$var$css = /*css*/ `
    ${$131ad46bce8c8335$var$tagName} {
        display: block;
        background: var(--gray-brand-gradient); /* White background */
        padding: 1em;
        border-radius: 1em; /* Rounded corners */
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
        max-width: 600px;
        margin: 5em auto;
        margin-bottom: 70px;
        box-shadow: 0 0.7em 1em rgba(0, 0, 0, 0.2);
        transition: 200ms;
        max-width: 600px;
    }
    ${$131ad46bce8c8335$var$tagName} .flex-col-center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 12px;
    }
    ${$131ad46bce8c8335$var$tagName} .text-1 {
        font-family: 'inter-bold', 'sans-serif';
        font-size: 36px;
        color: white;
    }
    ${$131ad46bce8c8335$var$tagName} .text-2 {
        font-family: 'inter-bold', 'sans-serif';
        font-size: 28px;
        color: white;
    }
    ${$131ad46bce8c8335$var$tagName} .text-3 {
        font-family: 'inter-medium', 'sans-serif';
        font-size: 18px;
        color: white;
    }
    ${$131ad46bce8c8335$var$tagName} .button-cont {
        display: flex;
        gap: 1em;
        margin-top: 0.5em;
        justify-content: center;
        flex-wrap: wrap;
    }
    ${$131ad46bce8c8335$var$tagName} .button {
        width: fit-content;
        padding: 1em 2em;
        color: black;
        background: var(--light-blue-gradient);
        border-radius: 0.3em;
        cursor: pointer;
        box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
        transition: 200ms;
    }
    body.has-hover ${$131ad46bce8c8335$var$tagName} .button:hover {
        transform: translateY(-2px);
    }
    ${$131ad46bce8c8335$var$tagName} .button span {
        font-size: 1.1em;
        font-weight: 800px;
    }

    @media (max-width: 634px) {

        ${$131ad46bce8c8335$var$tagName} {
            max-width: 500px;
        }

    }

    @media (max-width: 400px) {

        ${$131ad46bce8c8335$var$tagName} {
            max-width: 330px;
            margin-top: 40px;
        }

        ${$131ad46bce8c8335$var$tagName} .text-1 {
            font-size: 34px;

        }

    }
`;
const $131ad46bce8c8335$var$renderButtonContHTML = (options)=>{
    if (options.ctas.length == 1) return /*html*/ `<a class="button" ${options.ctas[0].internal ? "internal" : ""} ${options.ctas[0].newTab ? 'target="_blank"' : ""} href="${options.ctas[0].href}"><span>${options.ctas[0].label}</span></a>`;
    else return /*html*/ `
            <a class="button" ${options.ctas[0].internal ? "internal" : ""} ${options.ctas[0].newTab ? 'target="_blank"' : ""} href="${options.ctas[0].href}"><span>${options.ctas[0].label}</span></a>
            <a class="button" ${options.ctas[1].internal ? "internal" : ""} ${options.ctas[1].newTab ? 'target="_blank"' : ""} href="${options.ctas[1].href}"><span>${options.ctas[1].label}</span></a>
        `;
};
const $131ad46bce8c8335$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="flex-col-center">
            <div class="text-1">
                ${options.texts[0]}
            </div>
            <div class="text-2">
                ${options.texts[1]}
            </div>
            <div class="text-3">
                ${options.texts[2]}
            </div>
            <div class="button-cont">
                ${$131ad46bce8c8335$var$renderButtonContHTML(options)}
            </div>
        </div>
        <style>${$131ad46bce8c8335$var$css}</style>
    `;
};
class $131ad46bce8c8335$var$WhiteCtaBox extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.options = JSON.parse(atob(this.getAttribute("element-options")));
        this.removeAttribute("element-options");
        this.innerHTML = $131ad46bce8c8335$var$renderInnerHTML(this.options);
    }
}
customElements.define($131ad46bce8c8335$var$tagName, $131ad46bce8c8335$var$WhiteCtaBox);
function $131ad46bce8c8335$var$render(options) {
    return `<${$131ad46bce8c8335$var$tagName} element-options="${btoa(JSON.stringify(options))}"></${$131ad46bce8c8335$var$tagName}>`;
}
var $131ad46bce8c8335$export$2e2bcd8739ae039 = $131ad46bce8c8335$var$render;




const $9c894f0eb67aadc7$var$tagName = "vermittler-new-page";
var $9c894f0eb67aadc7$var$pageTitle = "F\xfcr Arbeitsvermittler | Franklin Institute of Applied Sciences";
var $9c894f0eb67aadc7$var$pageDescription = "Wir geben durch Weiterbildungen und Arbeitsvermittlung Talenten mit unterschiedlichsten beruflichen Hintergr\xfcnden die M\xf6glichkeit, ihr volles Potenzial in der IT-Branche auszusch\xf6pfen.";
var $9c894f0eb67aadc7$var$videoURL = "https://fast.wistia.com/embed/medias/yc67ol9ioj";
var $9c894f0eb67aadc7$var$css = /*css*/ `

.blue-line {
    height: 0.5rem;
    background: var(--blue-wide-gradient);
    left: 0;
    right: 0;  
    position: relative;

}

.blue-line.top {
    top: 0px;
}

.blue-line.bottom {
    bottom: 0px;
    z-index: 2;
}

${$9c894f0eb67aadc7$var$tagName} .full-width-image {
    width: 110%;
    display: flex;
    justify-content: center;
    margin: 0;
    margin-left: -60px;
  }
  
  ${$9c894f0eb67aadc7$var$tagName} .full-width-image img {
    width: 120%; /* Adjusted to 100% for proper scaling */
    height: auto;
    display: block;
    margin: 0 auto; /* Center the image */
    object-fit: cover; /* Ensures the image proportionally covers the container */
  }
   

${$9c894f0eb67aadc7$var$tagName} .course-card-cont {
  display: flex;
  gap: 2em;
  margin: 0 auto;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
}

${$9c894f0eb67aadc7$var$tagName} .course-card-cont course-card {
  width: 450px;
}

@media (max-width: 490px) {
  ${$9c894f0eb67aadc7$var$tagName} .course-card-cont {
      gap: 1em;
  }
}

${$9c894f0eb67aadc7$var$tagName} .course-card-title {
  font-family: 'inter-bold';
  font-size: clamp(28px, 6.18vw, 45px);
  text-align: center;
  margin-bottom: 0.8em;
  padding-top: 30px;
}
`;
function $9c894f0eb67aadc7$var$template() {
    return /*html*/ `
  <vermittler-hero-component></vermittler-hero-component>
  <warum-fias-grid-component></warum-fias-grid-component>
  <counter-widget-component></counter-widget-component>
    <div class="wrapper">
        <div class="course-card-title" id="courses">Unsere Weiterbildungen</div>
        <div class="course-card-cont">
            ${(0, $f47a2815d6db1851$export$2e2bcd8739ae039)({
        title: "IT-Berater im Produktmanagement",
        bulletPoints: [
            "Inkl. Karrierecoaching",
            "Inkl. MacBook",
            `${config.courseData.pm.minCertCount} anerkannte Zertifikate + IHK Zertifikat`
        ],
        imageURL: "/assets/images-webp/course-banner-img-pm.webp",
        ctaURL: "/redirect?to=infomaterial-av"
    })}
            ${(0, $f47a2815d6db1851$export$2e2bcd8739ae039)({
        title: "IT-Vertriebsmanager & CRM Spezialist",
        bulletPoints: [
            "Inkl. Karrierecoaching",
            "Inkl. MacBook",
            `${config.courseData.sales.minCertCount} anerkannte Zertifikate + IHK Zertifikat`
        ],
        imageURL: "/assets/images-webp/course-banner-img-sales.webp",
        ctaURL: "/redirect?to=infomaterial-sales"
    })}
        </div>
    </div>
    <azav-verifiziert-section></azav-verifiziert-section>
    ${(0, $131ad46bce8c8335$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Kontaktformular oder rufen Sie uns jederzeit direkt an."
        ],
        ctas: [
            {
                label: "Jetzt Kontakt aufnehmen",
                href: config.ctaURLS.kontakt,
                internal: false,
                newTab: true
            },
            {
                label: "+49 89 62826149",
                href: "tel:+498962826149"
            }
        ]
    })}
</div>

    <warum-pm-section></warum-pm-section>

    <div class="fcc-section-wrapper" style="padding-top: 25px;">
    <fcc-6-schritte-component></fcc-6-schritte-component>
    <!-- Title Section -->
    <div class="video-title" style="text-align: center; color: var(--gray-brand); font-family: 'inter-bold', sans-serif; font-size: clamp(28px, 6.18vw, 45px); margin: 20px 0;">
    Unsere Arbeit im <span style="color: var(--blue-brand);">FCC</span> f\xfcr <br> einen
    <span style="color: var(--blue-brand);"> Start in deinem Traumjob</span>
    </div>

    <!-- Video Section -->
    ${(0, $df492b283b41f7dd$export$2e2bcd8739ae039)($9c894f0eb67aadc7$var$videoURL)}
    </div>
    

    <div class="full-width-image">
    <img src="/assets/images/team-people-img-desktop.png" alt="Team Image">
    </div>
    <div class="blue-line bottom"></div>


    <voraussetzungen-component></voraussetzungen-component>

    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
        ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Kontaktformular oder rufen Sie uns jederzeit direkt an."
        ],
        ctas: [
            {
                label: "Jetzt Kontakt aufnehmen",
                href: config.ctaURLS.kontakt,
                internal: false,
                newTab: true
            },
            {
                label: "+49 89 62826149",
                href: "tel:+498962826149"
            }
        ]
    })}
    </div>

    <style>${$9c894f0eb67aadc7$var$css}</style>
        
    `;
}
// Define the main page component
class $9c894f0eb67aadc7$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($9c894f0eb67aadc7$var$pageTitle);
        util.setPageDescription($9c894f0eb67aadc7$var$pageDescription);
        this.innerHTML = $9c894f0eb67aadc7$var$template();
    }
}
// Register the main page component
customElements.define($9c894f0eb67aadc7$var$tagName, $9c894f0eb67aadc7$var$Page);
var // Export the main component if needed
$9c894f0eb67aadc7$export$2e2bcd8739ae039 = `<${$9c894f0eb67aadc7$var$tagName}></${$9c894f0eb67aadc7$var$tagName}>`;


const $c83fb2851bca9f67$var$tagName = "danke-4-schritte-component";
// CSS to be applied globally
var $c83fb2851bca9f67$var$fccComponentCss = /*css*/ `
.danke-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px; /* Reduced padding for compactness */
    background-color: transparent;
}

.danke-svg-container {
    width: 100%;
    max-width: 1000px; /* Increased max width for SVG container */
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}


svg {
    width: 100%;
    height: auto;
    max-width: 100%; /* Ensures SVG scales within its container */
    overflow: visible;
}

/* Hover effects for desktop SVG elements */
#desktop-01,
#desktop-02,
#desktop-03,
#desktop-04 {
    transition: transform 0.3s ease;
    transform-origin: center;
}

#desktop-01:hover,
#desktop-02:hover,
#desktop-03:hover,
#desktop-04:hover {
    transform: translateY(-5px);
}

/* Mobile adjustments */
@media (max-width: 630px) {
    .danke-svg-container {
        display: none;
    }

    .danke-container {
        display: none;
    }

    .danke-svg-container-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 350px; /* Slightly larger max width for mobile view */
        margin: 0 auto;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    svg {
        width: 100%;
        height: auto;
    }

    .danke-svg-container-mobile text {
          font-family: 'Inter', sans-serif !important;
    }
      
}

/* Hide mobile SVG on larger screens */
@media (min-width: 631px) {
    .danke-svg-container-mobile {
        display: none;
    }
}
`;
// HTML template for the component
var $c83fb2851bca9f67$var$fccComponentTemplate = /*html*/ `
<!-- Desktop SVG container -->
<section class="danke-container">
    <div class="danke-svg-container" id="desktop-svg-container"></div>
</section>

<!-- Mobile SVG container -->
<section class="danke-container-mobile">
    <div class="danke-svg-container-mobile" id="mobile-svg-container"></div>
</section>
`;
// Function to load the external SVG files
function $c83fb2851bca9f67$var$loadSVG(svgUrl, containerElement) {
    fetch(svgUrl).then((response)=>response.text()).then((svgData)=>{
        containerElement.innerHTML = svgData;
        const svgElement = containerElement.querySelector("svg");
        if (svgElement) {
            svgElement.style.width = "100%";
            svgElement.style.height = "auto";
            svgElement.style.maxWidth = "1000px"; // Ensures SVG stays within a larger range on desktop
        }
    }).catch((error)=>console.error("Error loading SVG:", error));
}
// Define the custom element without using Shadow DOM
class $c83fb2851bca9f67$var$Danke4SchritteComponent extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // Append the template content
        this.innerHTML = $c83fb2851bca9f67$var$fccComponentTemplate;
        // Append the CSS styles directly to the document if not already added
        if (!document.getElementById("danke-4-schritte-styles")) {
            const style = document.createElement("style");
            style.id = "danke-4-schritte-styles";
            style.textContent = $c83fb2851bca9f67$var$fccComponentCss;
            document.head.appendChild(style);
        }
        // Load the desktop and mobile SVGs
        const desktopSvgContainer = this.querySelector("#desktop-svg-container");
        const mobileSvgContainer = this.querySelector("#mobile-svg-container");
        $c83fb2851bca9f67$var$loadSVG("/assets/images/danke-4-schritte.svg", desktopSvgContainer);
        $c83fb2851bca9f67$var$loadSVG("/assets/images/danke-4-schritte-mobile.svg", mobileSvgContainer);
    }
}
customElements.define($c83fb2851bca9f67$var$tagName, $c83fb2851bca9f67$var$Danke4SchritteComponent);
var $c83fb2851bca9f67$export$2e2bcd8739ae039 = $c83fb2851bca9f67$var$Danke4SchritteComponent;


const $4c9bbb82bfe43c0c$var$tagName = "danke-video-section";
var $4c9bbb82bfe43c0c$var$css = /*css*/ `
    ${$4c9bbb82bfe43c0c$var$tagName} {
        display: block;
        text-align: center;
        margin-top: 1rem;
        padding: 20px;
    }
    ${$4c9bbb82bfe43c0c$var$tagName} iframe {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        aspect-ratio: 16 / 9;
        border-radius: 20px;
        overflow: hidden;
        border: none;
        box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    }
    .section-message {
        font-family: 'inter-bold';
        margin-bottom: 1rem;
    }
    .light-blue-text {
        color: var(--blue-brand);
        font-size: clamp(28px, 6.18vw, 45px);
    }
    .centered-text {
        font-size: clamp(28px, 6.18vw, 45px);
        padding-bottom: 20px;
    }
`;
class $4c9bbb82bfe43c0c$var$DankeVideoSection extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const videoURL = this.getAttribute("data-video-url");
        this.innerHTML = `
            <div class="section-message centered-text">
                <span class="light-blue-text">Vielen Dank! <br></span>
                <span>Das hat funktioniert.</span>
            </div>
            <iframe src="${videoURL}" allow="autoplay; fullscreen" allowfullscreen></iframe>
            <style>${$4c9bbb82bfe43c0c$var$css}</style>
        `;
    }
}
customElements.define($4c9bbb82bfe43c0c$var$tagName, $4c9bbb82bfe43c0c$var$DankeVideoSection);
function $4c9bbb82bfe43c0c$export$2e2bcd8739ae039(videoURL) {
    return `<${$4c9bbb82bfe43c0c$var$tagName} data-video-url="${videoURL}"></${$4c9bbb82bfe43c0c$var$tagName}>`;
}



const $86a1ebfadbce19ce$var$tagName = "danke-page";
var $86a1ebfadbce19ce$var$pageTitle = "Weiterbildung beim Franklin Institute | Dein Weg zum zukunftssicheren Traumjob";
var $86a1ebfadbce19ce$var$pageDescription = "Entdecke spannende Weiterbildungen beim Franklin Institute of Applied Sciences. Wir freuen uns auf den Kontakt mir dir";
var $86a1ebfadbce19ce$var$videoURL = "https://fast.wistia.net/embed/iframe/plllk2a66t";
var $86a1ebfadbce19ce$var$options = {
    ctas: [
        {
            label: "Jetzt starten!",
            href: config.ctaURLS.eignungstest,
            internal: false,
            newTab: true
        }
    ]
};
var $86a1ebfadbce19ce$var$css = /*css*/ `
/* Styling */
.above-cont {
    display: flex;
    justify-content: center;
    gap: 2em;
    align-items: center;
    margin-top: 3em;
    margin-bottom: 1.2em;
}

.above-cont-text {
    text-transform: uppercase;
    text-align: center;
    font-family: 'inter-bold', sans-serif;
    font-size: 1.6em;
}

.above-cont-text span {
    color: var(--blue-brand);
}

.double-arrow-down {
    width: 2.5em;
    height: 2.5em;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
}

/* Centering the button */
.hero-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    padding-bottom: 60px;
}

.hero-button a {
    padding: 0.6em 3em; /* Increased padding for larger button size */
    font-size: 1.7em; /* Increased font size */
    font-family: 'inter-bold', sans-serif;
    background-color: var(--blue-brand); /* Brand blue background */
    color: white; /* White text */
    border: 3px solid var(--blue-brand); /* Slightly thicker border */
    border-radius: 30px; /* More rounded corners */
    text-decoration: none;
    transition: all 0.3s ease-in-out; /* Smooth transition for hover effects */
}

.hero-button a:hover {
    background-color: white; /* Invert colors on hover */
    color: var(--blue-brand); /* Blue text */
    transform: scale(0.9); /* Slightly enlarge on hover */
}
`;
var $86a1ebfadbce19ce$var$template = /*html*/ `
    <style>${$86a1ebfadbce19ce$var$css}</style>

    <!-- Video Section -->
    ${(0, $4c9bbb82bfe43c0c$export$2e2bcd8739ae039)($86a1ebfadbce19ce$var$videoURL)}

    <!-- 4-Schritte Section -->
    <danke-4-schritte-component></danke-4-schritte-component>

    <!-- Above-Cont Section -->
    <div class="above-cont">
        <div class="double-arrow-down"></div>
        <div class="above-cont-text">Zum<br><span>Eignungstest</span></div>
        <div class="double-arrow-down"></div>
    </div>

    <!-- Button Section -->
    <div class="hero-button">
        <a 
            class="button" 
            ${$86a1ebfadbce19ce$var$options.ctas[0].internal ? "internal" : ""} 
            ${$86a1ebfadbce19ce$var$options.ctas[0].newTab ? 'target="_blank"' : ""} 
            href="${$86a1ebfadbce19ce$var$options.ctas[0].href}">
            <span>${$86a1ebfadbce19ce$var$options.ctas[0].label}</span>
        </a>
    </div>

    <!-- Feedback Section -->
    <div class="feedback-section-wrapper">
        ${(0, $741eb4901885d7cb$export$2e2bcd8739ae039)}
    </div>
`;
class $86a1ebfadbce19ce$var$DankePage extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $86a1ebfadbce19ce$var$template;
    }
}
customElements.define($86a1ebfadbce19ce$var$tagName, $86a1ebfadbce19ce$var$DankePage);
var $86a1ebfadbce19ce$export$2e2bcd8739ae039 = `<${$86a1ebfadbce19ce$var$tagName}></${$86a1ebfadbce19ce$var$tagName}>`;





const $1e855b9d5d20f2d8$var$tagName = "danke-sales-page";
var $1e855b9d5d20f2d8$var$pageTitle = "Weiterbildung beim Franklin Institute | Dein Weg zum zukunftssicheren Traumjob";
var $1e855b9d5d20f2d8$var$pageDescription = "Entdecke spannende Weiterbildungen beim Franklin Institute of Applied Sciences. Wir freuen uns auf den Kontakt mit dir";
// Define the options object globally
var $1e855b9d5d20f2d8$var$options = {
    ctas: [
        {
            label: "Jetzt starten!",
            href: config.ctaURLS.eignungstestsales,
            internal: false,
            newTab: true
        }
    ]
};
// Define the video URL for the sales page
var $1e855b9d5d20f2d8$var$videoURL = "https://fast.wistia.net/embed/iframe/9fj2q7fwdj";
var $1e855b9d5d20f2d8$var$css = /*css*/ `
/* Styling */
.above-cont {
    display: flex;
    justify-content: center;
    gap: 2em;
    align-items: center;
    margin-top: 3em;
    margin-bottom: 1.2em;
}

.above-cont-text {
    text-transform: uppercase;
    text-align: center;
    font-family: 'inter-bold', sans-serif;
    font-size: 1.6em;
}

.above-cont-text span {
    color: var(--blue-brand);
}

.double-arrow-down {
    width: 2.5em;
    height: 2.5em;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
}

/* Centering the button */
.hero-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    padding-bottom: 60px;
}

.hero-button a {
    padding: 0.6em 3em; /* Increased padding for larger button size */
    font-size: 1.7em; /* Increased font size */
    font-family: 'inter-bold', sans-serif;
    background-color: var(--blue-brand); /* Brand blue background */
    color: white; /* White text */
    border: 3px solid var(--blue-brand); /* Slightly thicker border */
    border-radius: 30px; /* More rounded corners */
    text-decoration: none;
    transition: all 0.3s ease-in-out; /* Smooth transition for hover effects */
}

.hero-button a:hover {
    background-color: white; /* Invert colors on hover */
    color: var(--blue-brand); /* Blue text */
    transform: scale(0.9); /* Slightly enlarge on hover */
}
`;
var $1e855b9d5d20f2d8$var$template = /*html*/ `
    <style>${$1e855b9d5d20f2d8$var$css}</style>

    <!-- Video Section -->
    ${(0, $4c9bbb82bfe43c0c$export$2e2bcd8739ae039)($1e855b9d5d20f2d8$var$videoURL)} <!-- Pass the video URL -->

    <!-- 4-Schritte Section -->
    <danke-4-schritte-component></danke-4-schritte-component>

    <!-- Above-Cont Section -->
    <div class="above-cont">
        <div class="double-arrow-down"></div>
        <div class="above-cont-text">Zum<br><span>Eignungstest</span></div>
        <div class="double-arrow-down"></div>
    </div>

    <!-- Button Section -->
    <div class="hero-button">
        <a 
            class="button" 
            ${$1e855b9d5d20f2d8$var$options.ctas[0].internal ? "internal" : ""} 
            ${$1e855b9d5d20f2d8$var$options.ctas[0].newTab ? 'target="_blank"' : ""} 
            href="${$1e855b9d5d20f2d8$var$options.ctas[0].href}">
            <span>${$1e855b9d5d20f2d8$var$options.ctas[0].label}</span>
        </a>
    </div>

    <!-- Feedback Section -->
    <div class="feedback-section-wrapper">
        ${(0, $741eb4901885d7cb$export$2e2bcd8739ae039)}
    </div>
`;
class $1e855b9d5d20f2d8$var$DankeSalesPage extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $1e855b9d5d20f2d8$var$template;
    }
}
customElements.define($1e855b9d5d20f2d8$var$tagName, $1e855b9d5d20f2d8$var$DankeSalesPage);
var $1e855b9d5d20f2d8$export$2e2bcd8739ae039 = `<${$1e855b9d5d20f2d8$var$tagName}></${$1e855b9d5d20f2d8$var$tagName}>`;





const $f03f935329ab79c2$var$tagName = "danke-weiterbildungen-page";
var $f03f935329ab79c2$var$pageTitle = "Weiterbildung beim Franklin Institute | Dein Weg zum zukunftssicheren Traumjob";
var $f03f935329ab79c2$var$pageDescription = "Entdecke spannende Weiterbildungen beim Franklin Institute of Applied Sciences. Wir freuen uns auf den Kontakt mir dir";
// Define the options object globally
var $f03f935329ab79c2$var$options = {
    ctas: [
        {
            label: "Jetzt starten!",
            href: config.ctaURLS.eignungstestweiterbildungen,
            internal: false,
            newTab: true
        }
    ]
};
var $f03f935329ab79c2$var$videoURL = "https://fast.wistia.net/embed/iframe/9fj2q7fwdj";
var $f03f935329ab79c2$var$css = /*css*/ `
/* Styling */
.above-cont {
    display: flex;
    justify-content: center;
    gap: 2em;
    align-items: center;
    margin-top: 3em;
    margin-bottom: 1.2em;
}

.above-cont-text {
    text-transform: uppercase;
    text-align: center;
    font-family: 'inter-bold', sans-serif;
    font-size: 1.6em;
}

.above-cont-text span {
    color: var(--blue-brand);
}

.double-arrow-down {
    width: 2.5em;
    height: 2.5em;
    background-image: url('/assets/images/blue-arrow-double.svg');
    background-size: 100% 100%;
}

/* Centering the button */
.hero-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    padding-bottom: 60px;
}

.hero-button a {
    padding: 0.6em 3em; /* Increased padding for larger button size */
    font-size: 1.7em; /* Increased font size */
    font-family: 'inter-bold', sans-serif;
    background-color: var(--blue-brand); /* Brand blue background */
    color: white; /* White text */
    border: 3px solid var(--blue-brand); /* Slightly thicker border */
    border-radius: 30px; /* More rounded corners */
    text-decoration: none;
    transition: all 0.3s ease-in-out; /* Smooth transition for hover effects */
}

.hero-button a:hover {
    background-color: white; /* Invert colors on hover */
    color: var(--blue-brand); /* Blue text */
    transform: scale(0.9); /* Slightly enlarge on hover */
}
`;
var $f03f935329ab79c2$var$template = /*html*/ `
    <style>${$f03f935329ab79c2$var$css}</style>

    <!-- Video Section -->
    ${(0, $4c9bbb82bfe43c0c$export$2e2bcd8739ae039)($f03f935329ab79c2$var$videoURL)}

    <!-- 4-Schritte Section -->
    <danke-4-schritte-component></danke-4-schritte-component>

    <!-- Above-Cont Section -->
    <div class="above-cont">
        <div class="double-arrow-down"></div>
        <div class="above-cont-text">Zum<br><span>Eignungstest</span></div>
        <div class="double-arrow-down"></div>
    </div>

    <!-- Button Section -->
    <div class="hero-button">
        <a 
            class="button" 
            ${$f03f935329ab79c2$var$options.ctas[0].internal ? "internal" : ""} 
            ${$f03f935329ab79c2$var$options.ctas[0].newTab ? 'target="_blank"' : ""} 
            href="${$f03f935329ab79c2$var$options.ctas[0].href}">
            <span>${$f03f935329ab79c2$var$options.ctas[0].label}</span>
        </a>
    </div>

    <!-- Feedback Section -->
    <div class="feedback-section-wrapper">
        ${(0, $741eb4901885d7cb$export$2e2bcd8739ae039)}
    </div>
`;
class $f03f935329ab79c2$var$DankeWeiterbildungenPage extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $f03f935329ab79c2$var$template;
    }
}
customElements.define($f03f935329ab79c2$var$tagName, $f03f935329ab79c2$var$DankeWeiterbildungenPage);
var $f03f935329ab79c2$export$2e2bcd8739ae039 = `<${$f03f935329ab79c2$var$tagName}></${$f03f935329ab79c2$var$tagName}>`;


const $c0c990b893a195a8$var$tagName = "danke-page-genaumeinkurs";
var $c0c990b893a195a8$var$pageTitle = "Weiterbildung beim Franklin Institute | Dein Weg zum zukunftssicheren Traumjob";
var $c0c990b893a195a8$var$pageDescription = "Entdecke spannende Weiterbildungen beim Franklin Institute of Applied Sciences. Wir freuen uns auf den Kontakt mit dir";
var $c0c990b893a195a8$var$css = /*css*/ `
    ${$c0c990b893a195a8$var$tagName} {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        margin-top: 1rem;
        padding: 20px;
    }
    ${$c0c990b893a195a8$var$tagName} .section-message {
        font-family: 'inter-bold';
        margin-bottom: 2rem; /* Increased padding after the title */
    }
    ${$c0c990b893a195a8$var$tagName} .light-blue-text {
        color: var(--blue-brand);
        font-size: clamp(28px, 6.18vw, 45px);
    }
    ${$c0c990b893a195a8$var$tagName} .black-text {
        color: black;
        font-size: clamp(28px, 6.18vw, 45px); /* Same size as light-blue-text */
        font-family: 'inter-bold'; /* Same font as light-blue-text */
    }
    ${$c0c990b893a195a8$var$tagName} .sub-message {
        font-size: 20px;
        font-weight: 550;
        color: var(--gray-text);
        margin-top: 10px;
        padding-bottom: 20px;
        line-height: 1.8; /* Increased line spacing */
    }
`;
const $c0c990b893a195a8$var$renderInnerHTML = ()=>{
    return /*html*/ `
        <div class="section-message">
            <span class="light-blue-text">Vielen Dank </span>
            <span class="black-text">f\xfcr dein Interesse!</span>
        </div>
        <div class="sub-message">
            Wir haben Deine Anfrage an GenauMeinKurs weitergegeben.<br>
            Du erh\xe4ltst von Ihnen innerhalb von 24 Stunden bis zu 5 passende Weiterbildungsvorschl\xe4ge via Mail.
        </div>
        <style>${$c0c990b893a195a8$var$css}</style>
    `;
};
class $c0c990b893a195a8$var$DankeGenauMeinKursPage extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $c0c990b893a195a8$var$renderInnerHTML();
    }
}
customElements.define($c0c990b893a195a8$var$tagName, $c0c990b893a195a8$var$DankeGenauMeinKursPage);
var $c0c990b893a195a8$export$2e2bcd8739ae039 = `<${$c0c990b893a195a8$var$tagName}></${$c0c990b893a195a8$var$tagName}>`;






const $d9f4ec2d3f79a82c$var$tagName = "product-hero-section-skeleton";
const $d9f4ec2d3f79a82c$var$heroData = {
    pm: {
        text: /*html*/ `IT-Berater im<br>Produktmanagement`,
        img: "/assets/images-webp/product-hero-img-pm.webp"
    },
    sales: {
        text: /*html*/ `IT-Vertriebsmanager <br>& CRM Spezialist`,
        img: "/assets/images-webp/product-hero-img-sales.webp"
    }
};
var $d9f4ec2d3f79a82c$var$topSectionCSS = /*css*/ `
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-main-cont {
        display: flex;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title {
        font-size: clamp(1.5em, 7.1vw, 2.4em);
        font-family: 'inter-bold';
        letter-spacing: -0.01em;
        line-height: 1.1em;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title span {
        text-decoration: underline;
        text-decoration-color: var(--blue-brand);
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1.3em;
        flex: 1;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-visual-cont {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-img {
        aspect-ratio: 2/3;
        width: 100%;
        max-width: 340px;
        margin: auto;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 11px;
        position: relative;
        overflow: hidden;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner-cont {
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        padding: 0.8em;
        gap: 0.8em;
        box-sizing: border-box;
        background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.5));
        background-size: 100% 100%;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner {
        background: white;
        border-radius: 7px;
        flex: 1;
        padding: 8px 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        transition: transform 200ms;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner:hover {
        transform: translateY(-3px);
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner span {
        font-size: 0.6rem;
        text-align: center;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner-logo {
        display: flex;
        width: 100%;
        aspect-ratio: 55 / 18;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner-logo-ihk {
        background-image: url('/assets/images/ihk-akademie-muenchen-oberbayern.svg');
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner-logo-ixdf {
        background-image: url('/assets/images/ixdf-logo-black-medium.png');
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-bulletpoints {
        display: flex;
        flex-direction: column;
        gap: 0.2em;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-bulletpoint:before {
        content: '';
        display: inline-block;
        width: 1em;
        height: 1em;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/assets/images/blue-arrow-double.svg');
        transform: rotate(-90deg) translateX(-0.15em);
        margin-right: 0.5em;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .section-kursnet-link {
        transition: 200ms;
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .section-kursnet-link:hover{
        color: var(--blue-brand);
    }
    ${$d9f4ec2d3f79a82c$var$tagName} .section-kursnet-link:before{
        content: "";
        display: inline-flex;
        width: 30px;
        aspect-ratio: 1 / 1;
        background-image: url('/assets/images/afa-logo.svg');
        background-size: contain;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        margin-right: 10px;
        transform: translateY(9px);
    }
    @media(max-width: 970px){
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-main-cont {
            gap: 3em;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-cont {
            flex: 1.5;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-visual-cont {
            flex: 1;
        }
    }
    @media(max-width: 840px){
        ${$d9f4ec2d3f79a82c$var$tagName} {
            padding-top: 1rem;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-main-cont {
            flex-direction: column;
            max-width: 550px;
            margin: auto;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title {
            text-align: center;
            margin-bottom: 0.5em;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-cont {
            flex: 1.5;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-visual-cont {
            flex: 1;
        }
    }
    @media(max-width: 470px){
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-bulletpoints {
            gap: 0.5em;
        }
    }
    @media(max-width: 360px){
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-main-cont {
            gap: 1.2em;
        }
    }
`;
var $d9f4ec2d3f79a82c$var$featureCardCSS = /*css*/ `
    ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        margin-top: 45px;
        gap: 45px;
    }
    @media (max-width: 999px) {
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
        }
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont>*:nth-child(2){
            grid-column: 1 / 3;
        }
    
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont>*:nth-child(1){
            grid-row: 2;
        }
    }
    @media(max-width: 599px){
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont {
            grid-template-columns: 1fr;
            grid-template-rows: 1fr 1fr 1fr;
            gap: 20px;
        }
    
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont>*:nth-child(2){
            grid-column: initial;
        }
    
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont>*:nth-child(1){
            grid-row: initial;
        }
    }
    @media(max-width: 360px){
        ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-cont {
            margin-top: 20px;
        }
    }
`;
var $d9f4ec2d3f79a82c$var$css = /*css*/ `
    ${$d9f4ec2d3f79a82c$var$tagName} {
        display: block;
        padding-top: 2em;
        padding-bottom: 2rem;
        font-family: 'inter-medium';
        padding-bottom: 200px;
    }
    ${$d9f4ec2d3f79a82c$var$topSectionCSS}
    ${$d9f4ec2d3f79a82c$var$featureCardCSS}

    @media(max-width: 430px) and (max-height: 932px){
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-bulletpoint {
            font-size: 13px;
            font-family: "inter-medium";
        }
    }

    @media(min-width: 971px) {
        ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-main-cont {
            justify-content: center; 
            padding-left: 80px; 
        }
    }

/* General title section styling */
${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title {
    margin-bottom: 0;
    padding-bottom: 0; 
}

/* Smaller title styling */
${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title .smaller-title {
    font-size: 20px;
    font-family: 'inter-bold';
    text-decoration: none;
    line-height: 1.2em; 
    margin-bottom: 0; 
    padding-bottom: 0; 
}

/* Large title (IT-Berater im Produktmanagement) styling */
${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title span {
    display: block;
    margin: 0; 
    padding: 0; 
}

/* Specific adjustment for the main title to bring it up */
${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title span:last-child {
    margin-top: -1em; 
    line-height: 1.1em; 
}

${$d9f4ec2d3f79a82c$var$tagName} .google-review-cont {
    display: flex;
    gap: 1em;
    // max-width: 200px;
    align-items: center;
    margin-left: -5px;
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-cont > div {
    // flex: 1;
    height: fit-content;
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-img-left {
    width: 12em;
    max-width: 180px;
    aspect-ratio: 192 / 43;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50% 50%;
    background-image: url('/assets/images-webp/google-review-img-new.webp');
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-right-side {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 0.8em;
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-right-top {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-stars {
    display: flex;
    gap: 4px;
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-star {
    width: 22px;
    aspect-ratio: 1/1;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50% 50%;
    background-image: url('/assets/images/star-icon.svg');
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-rating {
    font-family: 'inter-bold';
}
${$d9f4ec2d3f79a82c$var$tagName} .google-review-right-bottom {
    font-family: 'inter-light';
}

@media (max-width: 430px) {
    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-title span:last-child {
        font-size: 35px; 
        line-height: 1.2em; 
        margin-top:-28px;

    }

    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-content-text{
        font-size: 16px;
        text-align: center;
        font-family: "inter-medium";

    }
}
`;
const $d9f4ec2d3f79a82c$var$renderInnerHTML = (options)=>{
    return /*html*/ `
        <div class="product-hero-main-cont">
            <div class="product-hero-content-cont">
                <div class="product-hero-content-title">
                <span class="skeleton-box"><span class="smaller-title">Sichere Dir Jetzt Deine <br> Online-Weiterbildung zum</span></span><br>
                    <span class="skeleton-box"><span>Internet Mensch</span></span>
                </div>
                <span class="skeleton-box">
                <div class="product-hero-content-text">
                    <b>In X Monaten aus der Arbeitslosigkeit zum Traumjob.</b>
                </div>
                </span>
                <div class="product-hero-content-bulletpoints">
                    <span class="skeleton-box"><div class="product-hero-content-bulletpoint"><strong>Kostenlose </strong> Weiterbildung f\xfcr Arbeitssuchende \u{2705}</div></span>
                    <span class="skeleton-box"><div class="product-hero-content-bulletpoint">Kostenloses <strong>MacBook</strong> inklusive \u{1F4BB}</div></span>
                    <span class="skeleton-box"><div class="product-hero-content-bulletpoint">Bequem von <strong>zu Hause aus</strong> lernen \u{1F3E0}</div></span>
                    <span class="skeleton-box"><div class="product-hero-content-bulletpoint">Optimal f\xfcr <strong>Quereinsteiger</strong> geeignet \u{1F4C8}</div></span>
                </div>
                <span class="skeleton-box"><a cta-prevent-inner-hover target="_blank" href="/">
                ${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)("Kostenlose Beratung vereinbaren und <span>durchstarten.</span>")}
            </a></span>
            
                <!-- Google Review Section -->
                <div class="google-review-cont" style="text-align: center; max-width: 800px;" skeleton-fade-in>
                    <div class="google-review-img-left"></div>
                    <div class="google-review-right-side">
                        <div class="google-review-right-top">
                            <div class="google-review-stars">
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                                <div class="google-review-star"></div>
                            </div>
                            <div class="google-review-rating">5.0</div>
                        </div>
                        <div class="google-review-right-bottom">181+ Bewertungen</div>
                    </div>
                </div>
                <!-- End of Google Review Section -->
            </div>
            <div class="product-hero-visual-cont">
                <div class="product-hero-img-cont">
                    <div class="product-hero-img" skeleton-fade-in>
                        <div class="hero-img-partner-cont">
                            <a class="hero-img-partner">
                                <span></span>
                                <div class="hero-img-partner-logo"></div>
                            </a>
                            <a class="hero-img-partner">
                                <span></span>
                                <div class="hero-img-partner-logo"></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="feature-card-cont">
            <div class="feature-card-skeleton" skeleton-fade-in></div>
            <div class="feature-card-skeleton" skeleton-fade-in></div>
            <div class="feature-card-skeleton" skeleton-fade-in></div>
        </div>
        <style>
            ${$d9f4ec2d3f79a82c$var$tagName} {
                --skeleton-bg-color: #E4E4E4;
            }
            ${$d9f4ec2d3f79a82c$var$tagName} .feature-card-skeleton {
                    width: 336px;
                    height: 132px;
                    background: var(--skeleton-bg-color);
                    border-radius: 20px;
                }
                ${$d9f4ec2d3f79a82c$var$tagName} {
                    position: relative;
                }
                ${$d9f4ec2d3f79a82c$var$tagName}:before {
                    position: absolute;
        content: '';
        display: block;
        width: 300%;
        height: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(to left, transparent 0%, transparent 34%, rgba(255, 255, 255, 0.5) 50%, transparent 66%, transparent 100%);
        animation: infinite product-hero-skeleton-slide 1200ms;
        z-index: 1;
                }
                ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-img {
                            background: var(--skeleton-bg-color);
                        }
                        ${$d9f4ec2d3f79a82c$var$tagName} .hero-img-partner-cont {
                            display: none !important;
                            background: transparent !important;
                        }
                        ${$d9f4ec2d3f79a82c$var$tagName} .google-review-img-left, .google-review-right-side {
                            background: var(--skeleton-bg-color) !important;
                            border-radius: 10px;
                        }
                        ${$d9f4ec2d3f79a82c$var$tagName} .google-review-right-side > * {
                            visibility: hidden;
                        }
                        ${$d9f4ec2d3f79a82c$var$tagName} .skeleton-box {
                        background: var(--skeleton-bg-color);
                        width: fit-content;
                        height: fit-content;
                        border-radius: 10px;
                    }
                    ${$d9f4ec2d3f79a82c$var$tagName} .skeleton-box > * {
                        visibility: hidden;
                    }
                    @keyframes product-hero-skeleton-slide {
                        0% {
                            transform: translateX(-67%);
                        }
                        100% {
                            transform: translateX(0%);
                        }
                        100% {
                            transform: translateX(0%);
                        }
                    }
                    ${$d9f4ec2d3f79a82c$var$tagName} .product-hero-skeleton-fade-in {
                        opacity: 0;
                        animation: 250ms product-hero-skeleton-fade-in linear forwards;
                    }
                    @keyframes product-hero-skeleton-fade-in {
                        0% {
                            opacity: 0;
                        }
                        100% {
                            opacity: 1;
                        }
                    }
        </style>
        <style>${$d9f4ec2d3f79a82c$var$css}</style>
    `;
};
class $d9f4ec2d3f79a82c$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        // var d = window.decodeURIComponent;
        // this.options = JSON.parse(d(this.getAttribute('element-options')));
        this.innerHTML = $d9f4ec2d3f79a82c$var$renderInnerHTML();
        this.removeAttribute("element-options");
    // this.setFadeIn();
    }
    setFadeIn() {
        var fadeInElements = Array.from(this.querySelectorAll(".skeleton-box, [skeleton-fade-in]"));
        var delayStep = 25;
        var delay = 0;
        fadeInElements.forEach((elem)=>{
            elem.classList.add("product-hero-skeleton-fade-in");
            elem.style.animationDelay = `${delay}ms`;
            delay += delayStep;
        });
    }
}
customElements.define($d9f4ec2d3f79a82c$var$tagName, $d9f4ec2d3f79a82c$var$CustomElem);
function $d9f4ec2d3f79a82c$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$d9f4ec2d3f79a82c$var$tagName} element-options="${e(JSON.stringify(options))}"></${$d9f4ec2d3f79a82c$var$tagName}>`;
}
var $d9f4ec2d3f79a82c$export$2e2bcd8739ae039 = $d9f4ec2d3f79a82c$var$render;


















const $41d22ebf4234c6e6$var$tagName = "dynamic-course-content";
var $41d22ebf4234c6e6$var$css = /*css*/ `
    ${$41d22ebf4234c6e6$var$tagName}.module-box-appear .course-module-cont {
        animation: module-box-appear 500ms forwards linear;
    }
    @keyframes module-box-appear {
        0%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }
    ${$41d22ebf4234c6e6$var$tagName} .modules-cont {
        display: grid;
        grid-template-columns: 1fr 1fr;
        // flex-direction: column;
        gap: 16px;
        font-size: 16px;
        max-width: 800px;
        margin: 0 auto;
    }
    ${$41d22ebf4234c6e6$var$tagName} .course-module-cont {
        padding: 12px 20px;
        border-radius: 10px;
        // background-image: linear-gradient(170deg, #FAFAFA 0%, #EEE 100%);
        background: rgba(242, 246, 247, 0.8);
        opacity: 0;
        transition: opacity 200ms;
        // border: 1px solid #EEE;
    }
    ${$41d22ebf4234c6e6$var$tagName} .course-module-title {
        font-family: 'inter-bold';
        line-height: 2em;
    }
    ${$41d22ebf4234c6e6$var$tagName} .course-module-content-cont {
        padding-left: 20px;
        line-height: 1.6em;
    }
    ${$41d22ebf4234c6e6$var$tagName} .course-content-title {
        font-size: clamp(28px, 6vw, 42px);
        font-family: 'inter-bold';
        text-align: center;
        letter-spacing: -0.02em;
        line-height: 1.1em;
        padding: 0.3em 0px;
        margin-top: 0.7em;
    }
    ${$41d22ebf4234c6e6$var$tagName} .course-content-title span {
        color: var(--blue-brand);
    }
    ${$41d22ebf4234c6e6$var$tagName} .course-content-subtitle {
        text-align: center;
        font-size: 18px;
        font-family: 'inter-bold';
        margin-bottom: 1.5em;
    }
    @media(max-width: 699px){
        ${$41d22ebf4234c6e6$var$tagName} .modules-cont {
            grid-template-columns: 1fr;
        }
    }
`;
function $41d22ebf4234c6e6$var$renderModule(module, moduleCount) {
    var contentHTML = "";
    var subModuleCount = 0;
    module.module_content.forEach((content)=>{
        subModuleCount++;
        contentHTML += /*html*/ `
            <div class="course-module-content">${moduleCount}.${subModuleCount} ${content}</div>
        `.trim();
    });
    var html = /*html*/ `
        <div class="course-module-cont" style="animation-delay: ${moduleCount * 70}ms">
            <div class="course-module-title">${moduleCount}. ${module.module_title}</div>
            <div class="course-module-content-cont">${contentHTML}</div>
        </div>
    `.trim();
    return html;
}
const $41d22ebf4234c6e6$var$renderInnerHTML = (options)=>{
    var modules = options.modules;
    var modulesHTML = "";
    var moduleCount = 0;
    modules.forEach((module)=>{
        moduleCount++;
        modulesHTML += $41d22ebf4234c6e6$var$renderModule(module, moduleCount);
    });
    var html = /*html*/ `
        <div class="course-content-title">Der effektivste Start<br>in <span>deine neue Karriere</span></div>
        <div class="course-content-subtitle">So ist deine Weiterbildung aufgebaut</div>
        <div class="modules-cont">${modulesHTML}</div>
        <style>${$41d22ebf4234c6e6$var$css}</style>
    `.trim();
    html += /*html*/ `<style>${$41d22ebf4234c6e6$var$css}</style>`;
    return html;
};
class $41d22ebf4234c6e6$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options")));
        this.innerHTML = $41d22ebf4234c6e6$var$renderInnerHTML(this.options);
        this.removeAttribute("element-options");
        this.hydrate();
    }
    hydrate() {
        var observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    this.classList.add("module-box-appear");
                    observer.unobserve(this);
                }
            });
        }, {
            rootMargin: "0px 0px -400px 0px",
            threshold: 0
        });
        observer.observe(this);
        var moduleBoxes, moduleBox, observer1, entries, entry;
        return;
    }
}
customElements.define($41d22ebf4234c6e6$var$tagName, $41d22ebf4234c6e6$var$CustomElem);
function $41d22ebf4234c6e6$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$41d22ebf4234c6e6$var$tagName} element-options="${e(JSON.stringify(options))}"></${$41d22ebf4234c6e6$var$tagName}>`;
}
var $41d22ebf4234c6e6$export$2e2bcd8739ae039 = $41d22ebf4234c6e6$var$render;



const $c24c39c61b4168b8$var$tagName = "dynamic-course-page";
const $c24c39c61b4168b8$var$courseSlug = "pm";
var $c24c39c61b4168b8$var$getPageTitle = (course)=>{
    return `${course.title_readability_optimized} | Franklin Institute of Applied Sciences`;
};
var $c24c39c61b4168b8$var$getPageDescription = (course)=>{
    return `Starte deine Karriere mit der Weiterbildung ${course.title_readability_optimized}. In nur ${course.duration} Monaten von der Arbeitslosigkeit zum Traumjob, inklusive MacBook und IHK-Zertifikat. Perfekt f\xfcr Quereinsteiger. Sichere dir jetzt deinen Platz und nutze unsere umfassende Karriereberatung f\xfcr einen erfolgreichen Einstieg in die IT-Branche.`;
};
var $c24c39c61b4168b8$var$css = /*css*/ `

${$c24c39c61b4168b8$var$tagName} .feedback-section-wrapper {
        margin-bottom: -10px; 
    }
${$c24c39c61b4168b8$var$tagName} .partner-section-wrapper {
    margin-top: 30px;
    margin-bottom: 10px; 
}
${$c24c39c61b4168b8$var$tagName} .hero-1 {
    font-family: 'inter-bold', sans-serif;
    font-size: 2em;
    margin-bottom: 0.5em;
}
${$c24c39c61b4168b8$var$tagName} .hero-2 {
    font-family: 'inter-bold', sans-serif;
    font-size: 1.6em;
    margin-bottom: 0.5em;
}
${$c24c39c61b4168b8$var$tagName} .grow-font-2 {
    font-size: clamp(32px, 4.18vw, 46px) !important;
}
${$c24c39c61b4168b8$var$tagName} .flex-col-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
`;
const $c24c39c61b4168b8$var$certificateSectionData = {
    moduleBoxes: [
        {
            number: "1",
            title: "Grundlagen",
            bulletpoints: [
                "Einf\xfchrung und digitaler Wandel",
                "Agile Methoden",
                "Nutzer- und Aufgabenanalyse sowie Produktanalyse und Marktbeobachtung"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Product Analytics Zertifikat der Product School",
                    logoURL: "/assets/images/product-school-logo.svg"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Scrum Master Zertifikat der Scrum Alliance",
                    logoURL: "/assets/images/scrum-alliance-logo.svg"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "User Research Zertifikat der Interaction Design Foundation",
                    logoURL: "/assets/images/ixdf-logo-black-small.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Projektmanagement Zertifikat von Product People",
                    logoURL: "/assets/images/product-people-logo.png"
                }
            ]
        },
        {
            number: "2",
            title: "DeepDive 1.0",
            bulletpoints: [
                "Requirement-Engineering",
                "Designmanagement und Design Thinking",
                "User Experience und Praxis-Teil"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Product Owner Zertifikat des T\xdcV S\xfcd",
                    logoURL: "/assets/images/tuev-sued-logo.svg"
                }
            ]
        },
        {
            number: "3",
            title: "DeepDive 2.0",
            bulletpoints: [
                "Produktstrategie und Roadmap / Portfolio-Analysen",
                "F\xfchrung und Controlling f\xfcr IT- und Software-Berater",
                "Pers\xf6nliches Benchmarking und Effektivit\xe4tssteigerung",
                "Projektauswahl und Zielsetzung (PRAXIS MODUL)",
                "Umsetzungsphase (PRAXIS MODUL)",
                "Evaluation und Diskussion (PRAXIS MODUL)"
            ],
            certificates: [
                {
                    badgeText: "+ Zertifikat",
                    title: "Business Models Zertifikat der Stanford University",
                    logoURL: "/assets/images/stanford-university-logo-medium.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Agile Leadership Zertifikat von Metagile",
                    logoURL: "/assets/images/metagile-logo.png"
                },
                {
                    badgeText: "+ Zertifikat",
                    title: "Applied IT-Consulting Zertifikat von Product People",
                    logoURL: "/assets/images/product-people-logo.png"
                },
                {
                    badgeText: "+ Praxis Portfolio",
                    title: "Praxis-Projekt-Portfolio",
                    logoURL: "/assets/images/fias-logo-new.svg"
                }
            ]
        }
    ],
    invertedModuleBox: {
        number: "4",
        title: "Franklin Career Center",
        bulletpoints: [
            "Karriere-Coaching & Pers\xf6nlichkeitsanalyse",
            "Intensives Bewerber Coaching",
            "Arbeitsvermittlung an Partner Unternehmen",
            "Bewerbungsphase mit Individueller Betreuung"
        ],
        certificates: [
            {
                badgeText: "+ Report",
                title: "Ausf\xfchrlicher Coaching Report",
                logoURL: "/assets/images/fias-logo-new-white.svg"
            }
        ],
        blueCertificate: {
            badgeText: "+ IHK-Zertifikat",
            title: "IHK-Abschluss*",
            logoURL: "/assets/images/ihk-logo.svg"
        }
    }
};
var $c24c39c61b4168b8$var$salaryData = {
    "pm": {
        salaryString: "67.056 \u20AC",
        jobTitle: "IT-Berater im Produktmanagement"
    },
    "sales": {
        salaryString: "55.049 \u20AC + Bonus",
        jobTitle: "IT-Sales Manager"
    },
    "cyber": {
        salaryString: "69.698 \u20AC",
        jobTitle: "IT-Security Specialist"
    }
};
function $c24c39c61b4168b8$var$generateHTML(course) {
    var courseSlug = course.vertical.toLowerCase();
    if (courseSlug == "its") courseSlug = "sales";
    return /*html*/ `
    <div class="wrapper">
        ${(0, $1bf35103779040b3$export$2e2bcd8739ae039)({
        dynamicCourse: course,
        courseSlug: function() {
            if (courseSlug == "cyber") return "pm";
            else return courseSlug;
        }(),
        featureCards: [
            {
                title: `${$c24c39c61b4168b8$var$salaryData[courseSlug].salaryString}`,
                text: `Durchschnittliches Gehalt als ${$c24c39c61b4168b8$var$salaryData[courseSlug].jobTitle} (J\xe4hrlich, Brutto)`
            },
            {
                title: "MacBook inklusive",
                text: "Um optimale Bedingungen f\xfcr deine Teilnahme an unserer Weiterbildung zu schaffen, stellen wir dir ein MacBook zur Verf\xfcgung"
            },
            {
                title: "Karrierechancen",
                html: /*html*/ `
                        <div style="display: flex; flex-direction: column; align-items: start; gap: 10px; margin-top: 5px;">
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div class="five-stars-icon-cont" style="display: flex; gap: 5px;">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>Sehr gut
                            </div>
                            <div style="font-size: 17px; font-family: inter-bold;">Vermittlungsquote: 93,7%</div>
                        </div>
                        <style>
                            ${$c24c39c61b4168b8$var$tagName} .five-stars-icon-cont > div {
                                display: block;
                                width: 28px;
                                aspect-ratio: 1/1;
                                background-position: 50% 50%;
                                background-repeat: no-repeat;
                                background-size: contain;
                                background-image: url('/assets/images/star-icon.svg');
                            }
                        </style>
                    `
            }
        ]
    })}
    </div>
    ${0, $fe58bfe3bd6680f4$export$2e2bcd8739ae039}
    <div class="wrapper">${(0, $41d22ebf4234c6e6$export$2e2bcd8739ae039)({
        modules: course.modules
    })}</div>
    <div class="wrapper" style="padding-top: 2rem; display: none;">
        ${""}
        <div>
        ${(0, $26ea0bccf6b5e721$export$2e2bcd8739ae039)({
        courseSlug: function() {
            if (courseSlug == "cyber") return "pm";
            else return courseSlug;
        }()
    })}
        </div>
    </div>
    ${(0, $68392dbefd4434c1$export$2e2bcd8739ae039)({
        courseSlug: function() {
            if (courseSlug == "cyber") return "pm";
            else return courseSlug;
        }()
    })}
    <style>
        ${$c24c39c61b4168b8$var$tagName} .section-why {
            display: flex;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
            margin-top: 3rem;
        }
        ${$c24c39c61b4168b8$var$tagName} .section-why .two-col-wrapper {
            display: flex;
            justify-content: center;
        }
        ${$c24c39c61b4168b8$var$tagName} checkbox-list {
            flex: 1.2;
        }
        ${$c24c39c61b4168b8$var$tagName} fias-why-section-visual {
            flex: 1;
        }
        ${$c24c39c61b4168b8$var$tagName} .section-why-main-cont {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 3em;
            margin-top: 2.5em;
            padding: 0 3em;
        }
        @media(max-width: 1100px){
            ${$c24c39c61b4168b8$var$tagName} .section-why-main-cont {
                gap: 2em;
                padding: 0 1em;
            }
            ${$c24c39c61b4168b8$var$tagName} checkbox-list {
                flex: 1.3;
            }
            ${$c24c39c61b4168b8$var$tagName} fias-why-section-visual {
                flex: 1;
            }
        }
        @media(max-width: 899px){
            ${$c24c39c61b4168b8$var$tagName} .section-why-main-cont {
                flex-direction: column-reverse;
                max-width: 500px;
                margin-top: 1.5em;
            }
            ${$c24c39c61b4168b8$var$tagName} .section-why {
                max-width: 500px;
            }
            ${$c24c39c61b4168b8$var$tagName} checkbox-list {
                flex: initial;
            }
            ${$c24c39c61b4168b8$var$tagName} fias-why-section-visual {
                flex: initial;
            }
        }
        @media(max-width: 400px){
            ${$c24c39c61b4168b8$var$tagName} .section-why-main-cont {
                gap: 2em;
                padding: 0 0em;
            }
        }
    </style>
    <div class="section section-why">
        <div class="wrapper">
            <div class="flex-col-center">
                <div class="hero-1 grow-font-2">Warum das Franklin Institute?</div>
                <div class="hero-2" style="color: var(--blue-brand);">Profitiere von unserem einzigartigen Weiterbildungs-System</div>
            </div>
            <div class="section-why-main-cont">
                ${0, $d86d723d4c921682$export$2e2bcd8739ae039}
                ${(0, $8c93dffafa28d4b6$export$2e2bcd8739ae039)([
        {
            title: "Zeitaufwand auf das mindeste reduziert!",
            content: "Unsere Weiterbildung soll <b>in Dein Leben passen</b> und so schnell wie m\xf6glich dabei helfen, dass Du Deinen Weg in <b>Deine Traumkarriere</b> findest."
        },
        // {
        //     title: "Lass dich kostenlos beraten",
        //     content: "Bildung sollte bezahlbar, oder noch besser, <b>kostenlos</b> sein. Bewerbe Dich einfach bei uns, um herauszufinden, welche Fördermöglichkeiten für dich bestehen."
        // },
        {
            title: "Individuelle Betreuung - lernen in kleinen Gruppen",
            content: "Damit Du in unserem einj\xe4hrigen Karriereprogramm optimal auf Deinen neuen Job vorbereitet wirst, setzen wir auf <b>kleine, homogene</b> Lerngruppen."
        },
        {
            title: "Unschlagbares Karriere-Programm f\xfcr deinen Traumjob",
            content: "Aufgrund der langen Erfahrung und der verschiedenen Karrierewege unseres Gr\xfcnderteams verf\xfcgen wir \xfcber einen <b>unbezahlbaren Wissensschatz aus \xfcber 50 Jahren erfolgreicher Karrieren</b> in verschiedensten Bereichen. <b>Dieses Wissen wollen wir mit dir teilen, ohne Aufpreis, ohne Verpflichtungen.</b> Deshalb haben wir unser <b>Karriere- und Bewerbungscoaching</b> entwickelt um dir am Ende deiner Ausbildung das n\xf6tige Wissen f\xfcr einen <b>Raketenstart in deine eigene erfolgreiche Karriere</b> zu geben! Freu dich darauf, das ist der <b>wohl wichtigste Teil deiner Weiterbildung beim Franklin Institute.</b>"
        }
    ])}
            </div>
        </div>
    </div>
    <div class="wrapper" style="display: none;">
    ${(0, $c1cc64f038d6da05$export$2e2bcd8739ae039)($c24c39c61b4168b8$var$certificateSectionData)}
        <div class="blue-certificate">
            ${(0, $fcea271cab5c7f45$export$2e2bcd8739ae039)($c24c39c61b4168b8$var$certificateSectionData.invertedModuleBox.blueCertificate)}
        </div>
    </div>

    <div class="wrapper">
        <div class="partner-section-wrapper"> ${0, $26e554f22bcc5aa9$export$2e2bcd8739ae039} </div>
    </div>

    <div class="feedback-section-wrapper">
        ${0, $741eb4901885d7cb$export$2e2bcd8739ae039} 
    </div>

    <div class="wrapper">
    ${(0, $26bb59f23615df1a$export$2e2bcd8739ae039)({
        courseSlug: function() {
            if (courseSlug == "cyber") return "pm";
            else return courseSlug;
        }()
    })}
    </div>

        
    ${(0, $89f654207e7613e6$export$2e2bcd8739ae039)({
        dynamicCourse: course,
        courseSlug: courseSlug,
        title: /*html*/ `<div class="line">Starte jetzt mit der Weiterbildung</div> <div class="line"><span>${course.title_readability_optimized}</span></div>`,
        btnText: /*html*/ `<span>Jetzt kostenlose Beratung vereinbaren</span>`
    })}
    <div class="section" style="margin: 1rem 0;">
        <div class="wrapper">
            <div class="page-hero-medium font-scale-down centered" style="text-align: center; margin-bottom: 3rem; margin-top: 4rem;" id="faq">H\xe4ufig gestellte Fragen:</div>
            ${(0, $726e3f6128d4ba4e$export$2e2bcd8739ae039)([
        {
            q: "Was bringt mir eine Weiterbildung beim Franklin Institute?",
            a: "Wir leben Karriere. Das ist unser Motto - Unsere Weiterbildungen sollen Dir genau das erm\xf6glichen - Karriere. Wir bilden Dich \xfcber mehrere Monate in einem relevanten Beruf in der IT-Branche aus und unterst\xfctzen Dich dann beim Einstieg in deine Traumkarriere. Mit uns an Deiner Seite formen wir Deine Karriere und geben Dir alles an die Hand, was Du brauchst um beruflich erfolgreich zu sein."
        },
        // {
        //     q: "Welche Voraussetzungen muss ich erfüllen?",
        //     a: "Um an der Weiterbildung & am Career Success Programm teilnehmen zu können, musst Du lediglich (bald) bei der Agentur für Arbeit oder beim Jobcenter arbeitslos gemeldet sein. Solltest Du dies nicht sein, ist die Teilnahme leider nicht möglich. Du wirst in absehbarer Zeit arbeitslos? Dann bewerbe Dich gerne über unser kurzes Formular bei uns."
        // },
        // {
        //     q: "Fallen für die Weiterbildung Kosten an?",
        //     a: "Wenn Du arbeitslos gemeldet bist, hast Du die Möglichkeit einen Bildungsgutschein vom Staat zu erhalten. Dieser Bildungsgutschein finanziert Dir die komplette Weiterbildung und unser Career Success Programm - somit ist unser gesamtes Angebot kostenlos für Dich. Bewerbe Dich gerne über unser kurzes Formular und wir helfen Dir dabei einen Bildungsgutschein zu erhalten."
        // },
        {
            q: "Kann ich die Weiterbildung von Zuhause aus absolvieren?",
            a: "Ja - die komplette Weiterbildung inkl. Career Success Programm findet Remote statt. Somit hast Du die M\xf6glichkeit von \xfcberall aus teilzunehmen. Du erh\xe4ltst auch einen Laptop von uns."
        },
        {
            q: "Erhalte ich nach meiner Weiterbildung ein anerkanntes Zertifikat?",
            a: "Ja, du erh\xe4ltst w\xe4hrend unseren Weiterbildungen einige, in der IT-Branche sehr angesehene, Zertifikate von namhaften Anbietern. So stellen wir sicher, dass du am Ende neben deiner Praxiserfahrung auch die n\xf6tigen Dokumente f\xfcr einen erfolgreichen Einstieg in die IT-Branche vorlegen kannst."
        }
    ])}
        </div>
    </div>
    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
        ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Haben Sie Fragen?",
            "Wir beraten Sie gerne pers\xf6nlich.",
            "Nutzen Sie hierf\xfcr einfach unser Bewerbungsformular."
        ],
        ctas: [
            {
                label: "Jetzt bewerben.",
                href: config.ctaURLS[courseSlug],
                internal: false,
                newTab: true
            }
        ]
    })}
    </div>
    <style>${$c24c39c61b4168b8$var$css}</style>
`;
}
function $c24c39c61b4168b8$var$generateLoadingHTML() {
    return /*html*/ `<div class="wrapper">${(0, $d9f4ec2d3f79a82c$export$2e2bcd8739ae039)()}</div>`;
}
function $c24c39c61b4168b8$var$parseCourseID() {
    return location.pathname.split("/course/")[1].split("_")[0];
}
async function $c24c39c61b4168b8$var$getCourseData(courseID) {
    try {
        var xAK = atob("SkpTSEZFc2RmYmRqp1pSKEZaL0hKaUZkZmFzZGYzcQ==");
        var url = "https://app.franklin-institute.de/api-external/course-listings/getCourse?id=" + courseID;
        var hN = atob("eC1hcGkta2V5");
        var headers = {};
        headers[hN] = xAK;
        var response = await fetch(url, {
            headers: headers
        });
        var responseData = await response.json();
        if (!responseData.success) return null;
        else return responseData.course;
    } catch (e) {
        return null;
    }
}
class $c24c39c61b4168b8$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    async connectedCallback() {
        var courseID = $c24c39c61b4168b8$var$parseCourseID();
        var realCourseDataPromise = $c24c39c61b4168b8$var$getCourseData(courseID);
        this.innerHTML = $c24c39c61b4168b8$var$generateLoadingHTML();
        // return
        var sleep = new Promise((res)=>setTimeout(res, 300));
        // var sleep = new Promise(res => setTimeout(res, 0));
        var realCourseData = await realCourseDataPromise;
        // return
        if (!realCourseData) {
            location.href = "/404-course";
            return;
        }
        this.storeUTMData(realCourseData);
        var courseType = realCourseData.vertical.toLowerCase();
        if (courseType == "its") courseType = "sales";
        if (courseType == "cyber") courseType = null;
        var courseTypeEvent = new CustomEvent("update-main-menu", {
            detail: courseType
        });
        var mainMenu = document.querySelector("main-menu");
        mainMenu.dispatchEvent(courseTypeEvent);
        await sleep;
        util.setPageTitle($c24c39c61b4168b8$var$getPageTitle(realCourseData));
        util.setPageDescription($c24c39c61b4168b8$var$getPageDescription(realCourseData));
        this.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 100,
            fill: "forwards"
        });
        await new Promise((res)=>setTimeout(res, 100));
        this.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], {
            duration: 200,
            fill: "forwards"
        });
        this.innerHTML = $c24c39c61b4168b8$var$generateHTML(realCourseData);
    }
    storeUTMData(courseData) {
        var utmCourseData = {
            meinnowCourseData: {
                id: courseData.uuid,
                type: courseData.vertical,
                duration: courseData.duration
            }
        };
        (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).store(utmCourseData);
        var resetAppConfigEvent = new CustomEvent("reset-app-config");
        window.dispatchEvent(resetAppConfigEvent);
    }
}
customElements.define($c24c39c61b4168b8$var$tagName, $c24c39c61b4168b8$var$Page);
var $c24c39c61b4168b8$export$2e2bcd8739ae039 = `<${$c24c39c61b4168b8$var$tagName}></${$c24c39c61b4168b8$var$tagName}>`;



const $6111ca6ade013cd4$var$tagName = "details-zum-bildungstraeger-section";
var $6111ca6ade013cd4$var$css = /*css*/ `
  ${$6111ca6ade013cd4$var$tagName} {
    display: block;
    font-family: 'inter-medium';
  }

  .hero-3 {
    font-size: 44px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 5px;
    padding-bottom: 5px;
    font-family: 'inter-bold';
    margin-top: 20px;
  }

  /* Outer wrapper for the two-column or single-column layout */
  ${$6111ca6ade013cd4$var$tagName} .grid-outer-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
  }

  ${$6111ca6ade013cd4$var$tagName} .section-grid {
    max-width: 1100px;
    display: grid;
    gap: 30px;
    grid-template-columns: 1fr 1fr;
  }

  /* The main white box wrapper */
  ${$6111ca6ade013cd4$var$tagName} .section-grid-box {
    background: #FFFFFF;
    border-radius: 20px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    padding: 0;
    position: relative;
  }

  ${$6111ca6ade013cd4$var$tagName} .card-title-area {
    background: var(--blue-brand, #00c8f0);
    color: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 2px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    min-height: 60px; 
  }

  /* Actual text in the blue bar */
  ${$6111ca6ade013cd4$var$tagName} .section-title {
    margin: 0;
    font-family: 'inter-bold';
    font-size: 16px;
    line-height: 1.2rem; 
  }

  /* The arrow icon: hidden on screens >= 500px, visible < 500px. */
  ${$6111ca6ade013cd4$var$tagName} .blue-title-arrow {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    background: url('/assets/images/arrow.png') no-repeat center; 
    background-size: contain;
    transition: transform 0.2s ease;
    margin-left: 10px; 
  }

  @media(min-width: 500px) {
    ${$6111ca6ade013cd4$var$tagName} .blue-title-arrow {
      display: none !important;
    }
  }

  ${$6111ca6ade013cd4$var$tagName} .box-inner {
    padding: 20px 25px;
  }

  ${$6111ca6ade013cd4$var$tagName} .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1em;
  }
  ${$6111ca6ade013cd4$var$tagName} .form-group label {
    margin-bottom: 0.3em;
    font-weight: bold;
    font-family: 'inter-bold';

  }
  ${$6111ca6ade013cd4$var$tagName} .fake-input {
    background-color: #ffffff;
    font-size: 1rem;
  }

  /* On narrower screens (< 900px), switch to single column */
  @media(max-width: 899px){
    ${$6111ca6ade013cd4$var$tagName} .section-grid {
      grid-template-columns: 1fr;
    }
  }

  /* On very small screens (< 500px), hide content by default (accordion) */
  @media(max-width: 499px){
    .hero-3 {
      font-size: 28px;
      margin-bottom: 20px;
      padding-bottom: 10px;
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
    ${$6111ca6ade013cd4$var$tagName} .grid-outer-cont {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }

    ${$6111ca6ade013cd4$var$tagName} .section-grid-box:not(.open) .box-inner {
      display: none;
    }
    ${$6111ca6ade013cd4$var$tagName} .section-grid-box.open .blue-title-arrow {
      transform: rotate(180deg);
    }

    /* Slightly smaller title on tiny screens */
    ${$6111ca6ade013cd4$var$tagName} .section-title {
      font-size: 16px;
      line-height: 1.2rem;
    }
  }

    .description {
        font-family: 'inter';
        font-size: 16px;
        color: #333;
        line-height: 1.5;
        text-align: center;
        max-width: 850px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10px;
        padding-bottom: 15px;
        padding-right:20px;
        padding-left: 20px; 
    }

`;
const $6111ca6ade013cd4$var$renderInnerHTML = (options)=>{
    return /*html*/ `
    <div class="hero-3 centered">Deine Daten f\xfcr deinen Antrag</div>
    <div class="description">
    Hier findest du eine \xdcbersicht der relevanten Daten, die du ben\xf6tigst, um deine Antrag auf einen Bildungsgutschein zu stellen.
        </div>
    <div class="grid-outer-cont">
      <div class="section-grid">

        <!-- LEFT BOX -->
        <div class="section-grid-box">
          <div class="card-title-area">
            <div class="section-title">IT-Vertriebsmanager und CRM Spezialist</div>
            <div class="blue-title-arrow"></div>
          </div>
          <div class="box-inner">
            <div class="form-group">
              <label>Ma\xdfnahmenummer</label>
              <div class="fake-input">843/1062/2025</div>
            </div>
            <div class="form-group">
              <label>Name des Bildungstr\xe4gers</label>
              <div class="fake-input">Franklin Institute of Applied Sciences Pioneer People GmbH</div>
            </div>
            <div class="form-group">
              <label>Land</label>
              <div class="fake-input">Deutschland</div>
            </div>
            <div class="form-group">
              <label>Postleitzahl</label>
              <div class="fake-input">80636</div>
            </div>
            <div class="form-group">
              <label>Ort</label>
              <div class="fake-input">M\xfcnchen</div>
            </div>
            <div class="form-group">
              <label>Stra\xdfe</label>
              <div class="fake-input">Arnulfstra\xdfe</div>
            </div>
            <div class="form-group">
              <label>Hausnummer</label>
              <div class="fake-input">61</div>
            </div>
          </div>
        </div>

        <!-- RIGHT BOX -->
        <div class="section-grid-box">
          <div class="card-title-area">
            <div class="section-title">IT- & Software-Berater f\xfcr digitales Produktmanagement</div>
            <div class="blue-title-arrow"></div>
          </div>
          <div class="box-inner">
            <div class="form-group">
              <label>Ma\xdfnahmenummer</label>
              <div class="fake-input">843/1071/2025</div>
            </div>
            <div class="form-group">
              <label>Name des Bildungstr\xe4gers</label>
              <div class="fake-input">Franklin Institute of Applied Sciences Pioneer People GmbH</div>
            </div>
            <div class="form-group">
              <label>Land</label>
              <div class="fake-input">Deutschland</div>
            </div>
            <div class="form-group">
              <label>Postleitzahl</label>
              <div class="fake-input">80636</div>
            </div>
            <div class="form-group">
              <label>Ort</label>
              <div class="fake-input">M\xfcnchen</div>
            </div>
            <div class="form-group">
              <label>Stra\xdfe</label>
              <div class="fake-input">Arnulfstra\xdfe</div>
            </div>
            <div class="form-group">
              <label>Hausnummer</label>
              <div class="fake-input">61</div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <style>${$6111ca6ade013cd4$var$css}</style>
  `;
};
class $6111ca6ade013cd4$var$CustomElem extends HTMLElement {
    connectedCallback() {
        var d = window.decodeURIComponent;
        this.options = JSON.parse(d(this.getAttribute("element-options") || "{}"));
        this.innerHTML = $6111ca6ade013cd4$var$renderInnerHTML(this.options);
        // Mobile accordion toggle
        const titleBars = this.querySelectorAll(".card-title-area");
        titleBars.forEach((bar)=>{
            bar.addEventListener("click", ()=>{
                const parentBox = bar.closest(".section-grid-box");
                parentBox.classList.toggle("open");
            });
        });
    }
}
customElements.define($6111ca6ade013cd4$var$tagName, $6111ca6ade013cd4$var$CustomElem);
function $6111ca6ade013cd4$var$render(options) {
    var e = window.encodeURIComponent;
    return `<${$6111ca6ade013cd4$var$tagName} element-options="${e(JSON.stringify(options))}"></${$6111ca6ade013cd4$var$tagName}>`;
}
var $6111ca6ade013cd4$export$2e2bcd8739ae039 = $6111ca6ade013cd4$var$render;


const $91e9435b0c9ad32e$var$tagName = "bildungsgutschein-page";
var $91e9435b0c9ad32e$var$pageTitle = "Weiterbildung beim Franklin Institute | Dein Weg zum zukunftssicheren Traumjob";
var $91e9435b0c9ad32e$var$pageDescription = "Entdecke spannende Weiterbildungen beim Franklin Institute of Applied Sciences. Wir freuen uns auf den Kontakt mir dir";
var $91e9435b0c9ad32e$var$videoURL = "https://fast.wistia.com/embed/medias/cdagv2xm9n";
var $91e9435b0c9ad32e$var$css = /*css*/ `
    .video-section {
        display: block;
        text-align: center;
        margin-top: 1rem;
        padding: 20px;
    }
    .video-section iframe {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        aspect-ratio: 16 / 9;
        border-radius: 20px;
        overflow: hidden;
        border: none;
        box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    }
    .section-message {
        font-family: 'inter-bold';
        margin-bottom: 1rem;
        margin-top: -30px;
    }
    .light-blue-text {
        color: var(--blue-brand);
        font-size: clamp(28px, 6.18vw, 45px);
    }
    .centered-text {
        font-size: clamp(28px, 6.18vw, 45px);
        padding-bottom: 20px;
    }
    .video-description {
        margin-top: 30px;
        font-family: 'inter';
        font-size: 16px;
        color: #333;
        line-height: 1.5;
        text-align: center;
        max-width: 850px;
        margin-left: auto;
        margin-right: auto;
    }
    .contact-info {
        margin-top: 0px;
        font-family: 'inter';
        font-size: 16px;
        color: #333;
        line-height: 1.5;
        text-align: center;
        max-width: 850px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 20px;
        padding: 20px;
        padding-top: 0px;

    }
    .contact-link {
        color: var(--blue-brand);
    }
`;
var $91e9435b0c9ad32e$var$template = /*html*/ `
    <style>${$91e9435b0c9ad32e$var$css}</style>

    <!-- Video Section -->
    <div class="video-section">
        <div class="section-message centered-text">
            <span>Dein Weg zum</span>
            <span class="light-blue-text">Bildungsgutschein! <br></span>
        </div>
        <iframe 
            src="${$91e9435b0c9ad32e$var$videoURL}" 
            allow="autoplay; fullscreen" 
            allowfullscreen>
        </iframe>
        <div class="video-description">
            In diesem Video zeigen wir dir, wie du deinen <strong>Bildungsgutschein online auf der Website der Bundesagentur f\xfcr Arbeit beantragen</strong> kannst. 
            Diesen Bildungsgutschein ben\xf6tigst du, um an einer zertifizierten Weiterbildung bei uns teilnehmen zu k\xf6nnen. 
            Wie das funktioniert, wird <strong>im Video Schritt f\xfcr Schritt erkl\xe4rt</strong>.
        </div>
    </div>

    <details-zum-bildungstraeger-section></details-zum-bildungstraeger-section>

    <div class="contact-info">
            Wenn du weitere Fragen hast, kannst du dich jederzeit mit deinem Ansprechpartner in Verbindung setzen. 
            Schreib einfach eine E-Mail an 
            <a href="mailto:Beratung@franklin-institute.de" class="contact-link">Beratung@franklin-institute.de</a> 
            oder ruf uns an unter 
            <a href="tel:+498962826149" class="contact-link">+49 89 62826149</a> 
            oder melde dich per WhatsApp bei deinem Berater.
    </div>
        <div class="feedback-section-wrapper">
            ${(0, $741eb4901885d7cb$export$2e2bcd8739ae039)} 
        </div>
`;
class $91e9435b0c9ad32e$var$Bildungsgutschein extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $91e9435b0c9ad32e$var$template;
    }
}
customElements.define($91e9435b0c9ad32e$var$tagName, $91e9435b0c9ad32e$var$Bildungsgutschein);
var $91e9435b0c9ad32e$export$2e2bcd8739ae039 = `<${$91e9435b0c9ad32e$var$tagName}></${$91e9435b0c9ad32e$var$tagName}>`;


// blog-card-component.js
const $ec95b10ccaebaf9b$var$tagName = "blog-card-component";
const $ec95b10ccaebaf9b$var$css = /*css*/ `
  :host {
    display: flex;
    flex-direction: column;
    width: 320px;
    height: 500px;
    border-radius: 0.8rem;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    font-size: min(16px, 3vw);
    overflow: hidden;
    background: #fff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
  }

  :host(:hover) {
    transform: scale(1.01);
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
  }

  a {
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .thumbnail {
    width: 100%;
    height: 180px;
    object-fit: cover;
    object-position: center;
    background: #ccc;
  }

  .text-cont {
    flex: 1; 
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1em;
    gap: 0.8em;
  }

  .text-content-top {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  .text-title {
    font-size: 1.3em;
    line-height: 1.2em;
    font-family: 'inter-bold';
    color: #333;
  }

  .text-summary {
    font-size: 1em;
    font-family: 'inter-medium';
    line-height: 1.4em;
    color: #555;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }

  .read-time {
    font-size: 0.9em;
    font-family: 'inter-medium';
    color: #777;
  }

  /* Button styles */
  .read-more {
    display: inline-block;
    padding: 0.5em 1em;
    background: var(--blue-brand, #007BFF); /* Fallback to blue if variable not set */
    color: #fff;
    border-radius: 0.5em;
    font-size: 0.9em;
    text-align: center;
    transition: background 0.3s ease;
    margin-top: auto;
  }

  .read-more:hover {
    background: var(--gray-brand, #0056b3); /* Fallback to darker blue */
  }

  @media (max-width: 490px) {
    .text-summary {
      font-size: 1em; /* Adjusted to prevent overflow */
    }

    .text-title {
      font-size: 1.3em;
    }

    .read-time {
      font-size: 1em;
    }

    .read-more {
      font-size: 1em;
    }

    .thumbnail {
      height: 150px;
    }

    :host {
      height: 370px;
      width: 85%;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }
  }
`;
const $ec95b10ccaebaf9b$var$renderInnerHTML = (options)=>{
    return /*html*/ `
      <img src="${options.thumbnail}" alt="${options.title}" class="thumbnail" loading="lazy" />
      <div class="text-cont">
        <div class="text-content-top">
          <div class="text-title">${options.title}</div>
          <div class="text-summary">${options.summary}</div>
          <div class="read-time">${options.read_time}</div>
        </div>
        <div class="read-more">Mehr Lesen</div>
      </div>
    <style>${$ec95b10ccaebaf9b$var$css}</style>
  `;
};
class $ec95b10ccaebaf9b$var$BlogCard extends HTMLElement {
    constructor(){
        super();
        // Attach Shadow DOM
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        try {
            const options = JSON.parse(decodeURIComponent(this.getAttribute("element-options") || "{}"));
            this.shadowRoot.innerHTML = $ec95b10ccaebaf9b$var$renderInnerHTML(options);
        } catch (e) {
            console.error("Failed to parse element-options:", e);
            this.shadowRoot.innerHTML = `<div style="padding: 1em;">Invalid blog post data.</div>`;
        }
        this.removeAttribute("element-options");
    }
}
customElements.define($ec95b10ccaebaf9b$var$tagName, $ec95b10ccaebaf9b$var$BlogCard);
function $ec95b10ccaebaf9b$var$render(options) {
    const e = window.encodeURIComponent;
    return `
    <${$ec95b10ccaebaf9b$var$tagName} element-options="${e(JSON.stringify(options))}">
    </${$ec95b10ccaebaf9b$var$tagName}>
  `;
}
var $ec95b10ccaebaf9b$export$2e2bcd8739ae039 = $ec95b10ccaebaf9b$var$render;




// File: /services/blog.service.js
async function $2ea045d848240224$export$8de12f92128198cc() {
    try {
        const xAK = "lkjsgfgbhkshgusiedorghdskfjvas";
        const limit = 1000;
        const skip = 0;
        const url = `https://app.franklin-institute.de/api-external/blog/getBlogPosts?limit=${limit}&skip=${skip}`;
        const headers = {
            "x-api-key": xAK
        };
        const response = await fetch(url, {
            headers: headers
        });
        const data = await response.json();
        // If data is an array, just return it
        if (Array.isArray(data)) return data;
        // Otherwise return an empty array
        return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}
async function $2ea045d848240224$export$e1b37d1d9997591f(blogId) {
    try {
        const xAK = "lkjsgfgbhkshgusiedorghdskfjvas";
        const finalUrl = `https://app.franklin-institute.de/api-external/blog/getBlogPostById?id=${blogId}`;
        const headers = {
            "x-api-key": xAK
        };
        const response = await fetch(finalUrl, {
            headers: headers
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
}


const $706110047da901e3$var$tagName = "blog-overview-page";
const $706110047da901e3$var$pageTitle = "Blog | Franklin Institute of Applied Sciences";
const $706110047da901e3$var$pageDescription = "Alles rund um Karriere, Weiterbildung und pers\xf6nliche Entwicklung";
// CSS styles for the component including the pagination bar.
const $706110047da901e3$var$css = /*css*/ `
  ${$706110047da901e3$var$tagName} .blog-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 30px 20px;
      padding: 20px;
      padding-bottom: 40px;
      max-width: 1000px;
      margin: 0 auto;
  }

  .light-blue-text {
    color: var(--blue-brand);
    font-size: clamp(28px, 6.18vw, 45px);
    text-align: center;
    font-family: 'inter-bold';
    padding-bottom: 10px;
  }
  
  .centered-text {
    font-size: clamp(28px, 6.18vw, 14px);
    padding-bottom: 20px;
    text-align: center;
    font-family: 'inter-bold';
  }
  
  ${$706110047da901e3$var$tagName} .hero-title {
      text-align: center;
      font-family: 'inter-bold', sans-serif;
      font-size: 2.5rem;
      margin-bottom: 30px;
      color: #333;
  }
  
  /* Skeleton styles */
  ${$706110047da901e3$var$tagName} .skeleton-card {
      display: flex;
      flex-direction: column;
      width: 320px;
      height: 500px;
      border-radius: 0.8rem;
      box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      overflow: hidden;
      background: #fff;
      animation: shimmer 1.5s infinite;
  }
  ${$706110047da901e3$var$tagName} .skeleton-thumbnail {
      width: 100%;
      height: 180px;
      background: #ddd;
  }
  ${$706110047da901e3$var$tagName} .skeleton-text {
      display: flex;
      flex-direction: column;
      gap: 1em;
      padding: 0.8em;
  }
  ${$706110047da901e3$var$tagName} .skeleton-title {
      height: 1.6em;
      background: #ccc;
      border-radius: 0.3em;
      width: 70%;
      margin-top: 0.5em;
  }
  ${$706110047da901e3$var$tagName} .skeleton-title-bar {
      height: 1.6em;
      background: #ccc;
      border-radius: 0.3em;
      width: 90%;
      margin-bottom: 1em;
  }
  ${$706110047da901e3$var$tagName} .skeleton-summary {
      height: 1em;
      background: #ccc;
      border-radius: 0.3em;
      width: 100%;
  }
  ${$706110047da901e3$var$tagName} .skeleton-summary-bar {
      height: 1em;
      background: #ddd;
      border-radius: 0.3em;
      width: 100%;
      margin-bottom: 0.1em;
  }
  ${$706110047da901e3$var$tagName} .skeleton-read-more {
    display: inline-block;
    padding: 15px;
    background: var(--blue-brand, #007BFF);
    color: #fff;
    border-radius: 0.4em;
    margin-top: 1.5em;
    margin-left: 1em;
    margin-right: 1em;
  }
  
  ${$706110047da901e3$var$tagName} a {
    display: block;
    text-decoration: none;
  }
  
  ${$706110047da901e3$var$tagName} a:hover blog-card-component {
    transform: scale(1.01);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  }
  
  @media (max-width: 490px) {
    ${$706110047da901e3$var$tagName} .skeleton-card {
      height: 450px;
    }
    ${$706110047da901e3$var$tagName} .skeleton-read-more {
      margin-bottom: 0.82em;
      padding: 15px;
      margin-left: 0.8em;
      margin-right: 0.8em;
    }
    ${$706110047da901e3$var$tagName} .skeleton-summary {
      height: 0.8em;
    }
    ${$706110047da901e3$var$tagName} .skeleton-summary-bar {
      height: 0.8em;
    }
    ${$706110047da901e3$var$tagName} .skeleton-title {
      height: 1.4em;
    }
    ${$706110047da901e3$var$tagName} .skeleton-title-bar {
      height: 1.4em;
    }
    ${$706110047da901e3$var$tagName} .skeleton-text {
      gap: 0.7em;
    }
  
    .light-blue-text {
      padding-top: 20px;
      font-size: 35px;
    }
    .centered-text {
      font-size: 16px;
    }
  }
  
  @keyframes shimmer {
      0% { background-position: -200px 0; }
      100% { background-position: 200px 0; }
  }
  
  /* Pagination styles */
  ${$706110047da901e3$var$tagName} .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    gap: 5px;
  }
  ${$706110047da901e3$var$tagName} .pagination button {
    padding: 5px 10px;
    border: 1px solid #ccc;
    background: #fff;
    cursor: pointer;
    font-size: 1rem;
  }
  ${$706110047da901e3$var$tagName} .pagination button.active {
    background: var(--blue-brand, #007BFF);
    color: #fff;
    border-color: var(--blue-brand, #007BFF);
  }
  ${$706110047da901e3$var$tagName} .pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
/**
 * Generates the HTML for the pagination bar.
 *
 * @param {number} currentPage - The current page number.
 * @param {number} totalPages - The total number of pages.
 * @returns {string} The HTML for the pagination bar.
 */ function $706110047da901e3$var$generatePaginationHTML(currentPage, totalPages) {
    let pages = "";
    for(let i = 1; i <= totalPages; i++)pages += `<button class="pagination-page ${i === currentPage ? "active" : ""}" data-page="${i}">${i}</button>`;
    return `
    <div class="pagination">
      <button class="pagination-prev" ${currentPage === 1 ? "disabled" : ""}>&lt;</button>
      ${pages}
      <button class="pagination-next" ${currentPage === totalPages ? "disabled" : ""}>&gt;</button>
    </div>
  `;
}
/**
 * Generates the complete HTML for the overview page.
 *
 * @param {Array} blogs - Array of blog post objects (for the current page).
 * @param {number} currentPage - The current page number.
 * @param {number} totalPages - The total number of pages.
 * @returns {string} The full HTML.
 */ function $706110047da901e3$var$generateHTML(blogs, currentPage = 1, totalPages = 1) {
    if (!blogs || blogs.length === 0) return `
      <div class="wrapper">
        <div class="light-blue-text">Neueste Artikel</div>
        <div class="centered-text">Alles rund um Karriere, Weiterbildung und pers\xf6nliche Entwicklung</div>
        <p>No blogs found.</p>
        <style>${$706110047da901e3$var$css}</style>
      </div>
    `;
    return `
    <div class="wrapper">
      <div class="light-blue-text">Neueste Artikel</div>
      <div class="centered-text">Alles rund um Karriere, Weiterbildung und pers\xf6nliche Entwicklung</div>
      <div class="blog-grid">
        ${blogs.map((blog)=>{
        // Use safe fallbacks for missing data.
        const safeTitle = blog.title?.trim() || "Untitled Post";
        const safeSummary = blog.summary?.trim() || "No summary available";
        const safeReadTime = blog.read_time && blog.read_time > 0 ? `${blog.read_time} min Lesedauer` : "N/A";
        const safeThumbnail = blog.thumbnail?.trim() ? blog.thumbnail : "https://via.placeholder.com/300";
        const slug = (0, $1bda09d2dd26bd7c$export$c383cdd2a518017a)(safeTitle);
        return `<a internal href="/blog/${slug}">` + (0, $ec95b10ccaebaf9b$export$2e2bcd8739ae039)({
            title: safeTitle,
            thumbnail: safeThumbnail,
            summary: safeSummary,
            read_time: safeReadTime,
            link: `/blog/${slug}`
        }) + `</a>`;
    }).join("")}
      </div>
      ${$706110047da901e3$var$generatePaginationHTML(currentPage, totalPages)}
    </div>
    <style>${$706110047da901e3$var$css}</style>
  `;
}
class $706110047da901e3$var$BlogOverviewPage extends HTMLElement {
    constructor(){
        super();
        this.currentPage = 1;
        this.itemsPerPage = 9; // Show 9 posts per page.
        this.totalCount = 0; // Total number of posts (set after fetching).
        this.blogData = []; // Full list of posts.
    }
    async connectedCallback() {
        // Set page title and description.
        util.setPageTitle($706110047da901e3$var$pageTitle);
        util.setPageDescription($706110047da901e3$var$pageDescription);
        // Show skeleton view while data is loading.
        this.renderSkeleton();
        try {
            // Fetch **all** blog posts by overriding the default limit.
            const blogDataResponse = await (0, $2ea045d848240224$export$8de12f92128198cc)({
                limit: 1000,
                skip: 0
            });
            // If the API returns an object with a "posts" property, use it.
            let posts = [];
            let total = 0;
            if (blogDataResponse && blogDataResponse.posts && Array.isArray(blogDataResponse.posts)) {
                posts = blogDataResponse.posts;
                total = blogDataResponse.total || posts.length;
            } else if (Array.isArray(blogDataResponse)) {
                posts = blogDataResponse;
                total = posts.length;
            }
            // Sort posts by date (newest first).
            posts.sort((a, b)=>{
                const dateA = new Date(a.date_published);
                const dateB = new Date(b.date_published);
                if (isNaN(dateA)) return 1;
                if (isNaN(dateB)) return -1;
                return dateB - dateA;
            });
            this.blogData = posts;
            this.totalCount = total;
            this.currentPage = 1;
            this.renderPage();
        } catch (error) {
            console.error("Error fetching or processing blog data:", error);
            this.innerHTML = `
        <div class="wrapper">
          <div class="hero-title">Latest Blogs</div>
          <p>Failed to load blogs. Please try again later.</p>
          <style>${$706110047da901e3$var$css}</style>
        </div>
      `;
        }
    }
    renderSkeleton() {
        this.innerHTML = `
      <div class="wrapper">
        <div class="light-blue-text">Neueste Artikel</div>
        <div class="centered-text">Alles rund um Karriere, Weiterbildung und pers\xf6nliche Entwicklung</div>
        <div class="blog-grid">
          ${Array(3).fill(0).map(()=>`
              <div class="skeleton-card">
                <div class="skeleton-thumbnail"></div>
                <div class="skeleton-text">
                  <div class="skeleton-title"></div>
                  <div class="skeleton-title-bar"></div>
                  <div class="skeleton-summary"></div>
                  <div class="skeleton-summary-bar"></div>
                  <div class="skeleton-summary-bar"></div>
                  <div class="skeleton-summary-bar"></div>
                </div>
                <div class="skeleton-read-more"></div>
              </div>
            `).join("")}
        </div>
        <style>${$706110047da901e3$var$css}</style>
      </div>
    `;
    }
    renderPage() {
        // Calculate the total number of pages.
        const totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
        // Slice the full blog list for the current page.
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const currentBlogs = this.blogData.slice(startIndex, startIndex + this.itemsPerPage);
        this.innerHTML = $706110047da901e3$var$generateHTML(currentBlogs, this.currentPage, totalPages);
        // --- Attach event listeners to the pagination buttons ---
        const prevButton = this.querySelector(".pagination-prev");
        const nextButton = this.querySelector(".pagination-next");
        if (prevButton) prevButton.addEventListener("click", ()=>{
            if (this.currentPage > 1) {
                this.currentPage--;
                this.renderPage();
                window.scrollTo(0, 0);
            }
        });
        if (nextButton) nextButton.addEventListener("click", ()=>{
            if (this.currentPage < totalPages) {
                this.currentPage++;
                this.renderPage();
                window.scrollTo(0, 0);
            }
        });
        // Attach event listeners for numbered page buttons.
        const pageButtons = this.querySelectorAll(".pagination-page");
        pageButtons.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                const page = parseInt(event.currentTarget.getAttribute("data-page"));
                if (!isNaN(page) && page !== this.currentPage) {
                    this.currentPage = page;
                    this.renderPage();
                    window.scrollTo(0, 0);
                }
            });
        });
    }
}
customElements.define($706110047da901e3$var$tagName, $706110047da901e3$var$BlogOverviewPage);
var $706110047da901e3$export$2e2bcd8739ae039 = `<${$706110047da901e3$var$tagName}></${$706110047da901e3$var$tagName}>`;



// blog-carousel-component.js



const $d7a0a65865a7b988$var$tagName = "blog-carousel-component";
const $d7a0a65865a7b988$var$css = /*css*/ `
:host {
  display: block;
  width: 100%;
}

.carousel-header {
  font-size: 1.8em;
  font-family: 'inter-bold';
  margin-bottom: -20px;
  color: #333;
  text-align: center;
  padding-top: 30px;
}

/* The wrapper stays centered and has a max-width of 1040px */
.carousel-wrapper {
  position: relative;
  display: flex;
  justify-content: center; 
  align-items: center;     
  width: 1140px;           
  margin: 0 auto;          
  padding: 25px;
  left: 50%;               
  transform: translateX(-50%);
}

.carousel-container {
  display: flex;
  gap: 26px;             
  overflow: hidden;      
  scroll-behavior: smooth;
  padding: 30px;
  width: 100%;           
  width: 998px;      
  margin: 0 auto;        
}

.carousel-item {
  flex: 0 0 auto;         
  width: 320px;
}

/* Hide scrollbar (in case someone tries to scroll horizontally with trackpad) */
.carousel-container::-webkit-scrollbar {
  display: none;
}

/* Arrow buttons (desktop & mobile) */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 2;
  font-size: 1.4em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s ease;
}

.arrow:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.arrow:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.arrow-left {
  left: 10px;
}

.arrow-right {
  right: 10px;
}

${$d7a0a65865a7b988$var$tagName} a {
  display: block;
  text-decoration: none; /* Removes underline from the link */
}

${$d7a0a65865a7b988$var$tagName} a:hover blog-card-component {
  transform: scale(1.01); /* Scale on hover */
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2); /* Add hover shadow */
}

/*Mobile Styles (max-width: 490px)*/
@media (max-width: 490px) {

  .carousel-header {
    margin-bottom: -5px;
  }

  .carousel-wrapper {
    width: 100%;
    padding: 0;
    overflow: hidden;
  }

  .carousel-container {
    width: 95%;
    gap: 55px;
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    box-sizing: border-box;
    padding: 20px 20px;
  }

  .carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    flex: 0 0 100%;
    scroll-snap-align: center;
    
  }

  .arrow {
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
  }
  .arrow-left {
    left: 4px;
  }
  .arrow-right {
    right: 4px;
  }
}
`;
class $d7a0a65865a7b988$var$BlogCarouselComponent extends HTMLElement {
    constructor(){
        super();
    }
    async connectedCallback() {
        this.renderSkeleton(); // Optional placeholder while loading
        // If we want to exclude the current blog by ID, we read `exclude-id`:
        const excludeId = this.getAttribute("exclude-id") || "";
        try {
            // Load all blog posts
            const allBlogs = await (0, $2ea045d848240224$export$8de12f92128198cc)();
            if (!Array.isArray(allBlogs)) throw new Error("Invalid blog data format.");
            // Filter out the excluded blog if needed
            const filteredBlogs = allBlogs.filter((blog)=>String(blog.id) !== excludeId);
            console.log("Number of blog posts in carousel after filtering:", filteredBlogs.length);
            // Sort blogs by date_published descending
            const sortedBlogs = filteredBlogs.sort((a, b)=>new Date(b.date_published) - new Date(a.date_published));
            // Build final HTML
            this.innerHTML = `
        <div class="carousel-header">Weitere Artikel</div>
        <div class="carousel-wrapper">
          <button class="arrow arrow-left" aria-label="Scroll Left">${$d7a0a65865a7b988$var$getLeftArrowSVG()}</button>
          <div class="carousel-container">
            ${sortedBlogs.map((blog)=>{
                const safeTitle = blog.title?.trim() || "Untitled Post";
                const safeSummary = blog.summary?.trim() || "No summary available";
                const safeReadTime = blog.read_time && blog.read_time > 0 ? `${blog.read_time} min read` : "N/A";
                const safeThumbnail = blog.thumbnail?.trim() ? blog.thumbnail : "https://via.placeholder.com/300";
                // Generate a slug from the blog title
                const slug = (0, $1bda09d2dd26bd7c$export$c383cdd2a518017a)(safeTitle);
                return `
                <div class="carousel-item">
                  <a internal href="/blog/${slug}">
                    ${(0, $ec95b10ccaebaf9b$export$2e2bcd8739ae039)({
                    title: safeTitle,
                    thumbnail: safeThumbnail,
                    summary: safeSummary,
                    read_time: safeReadTime,
                    link: `/blog/${slug}`
                })}
                  </a>
                </div>
              `;
            }).join("")}
          </div>
          <button class="arrow arrow-right" aria-label="Scroll Right">${$d7a0a65865a7b988$var$getRightArrowSVG()}</button>
        </div>
        <style>${$d7a0a65865a7b988$var$css}</style>
      `;
            this.setupArrows();
        } catch (error) {
            console.error("Error loading blog posts:", error);
            this.innerHTML = `<p style="color: red; text-align: center;">Failed to load blog posts.</p>`;
        }
    }
    renderSkeleton() {
        this.innerHTML = `
      <div class="carousel-header">Weitere Artikel</div>
      <div class="carousel-wrapper">
        <div class="carousel-container">
          ${Array(3).fill(0).map(()=>`
            <div class="carousel-item">
              <div style="width: 320px; height: 500px; background: #f0f0f0; border-radius: 8px;"></div>
            </div>
          `).join("")}
        </div>
      </div>
      <style>${$d7a0a65865a7b988$var$css}</style>
    `;
    }
    setupArrows() {
        const container = this.querySelector(".carousel-container");
        const btnLeft = this.querySelector(".arrow-left");
        const btnRight = this.querySelector(".arrow-right");
        if (!container || !btnLeft || !btnRight) {
            console.error("Carousel elements not found.");
            return;
        }
        const getScrollAmount = ()=>{
            // We use the width of the first item + the gap
            const containerStyle = window.getComputedStyle(container);
            const gap = parseInt(containerStyle.gap) || 26; // Default gap if not set
            const firstItem = container.querySelector(".carousel-item");
            const itemWidth = firstItem ? firstItem.offsetWidth : 320; // Default to 320 if not found
            const amount = itemWidth + gap + 10;
            console.log("Calculated scrollAmount:", amount);
            return amount; // e.g. 336
        };
        let scrollAmount = getScrollAmount();
        btnLeft.addEventListener("click", ()=>{
            container.scrollBy({
                left: -scrollAmount,
                behavior: "smooth"
            });
        });
        btnRight.addEventListener("click", ()=>{
            container.scrollBy({
                left: scrollAmount,
                behavior: "smooth"
            });
        });
        // Optional: Disable arrows when at the ends
        const updateArrows = ()=>{
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            btnLeft.disabled = container.scrollLeft <= 0;
            btnRight.disabled = container.scrollLeft >= maxScrollLeft - 1;
            // Update aria-disabled for accessibility
            btnLeft.setAttribute("aria-disabled", btnLeft.disabled);
            btnRight.setAttribute("aria-disabled", btnRight.disabled);
            // Style changes
            btnLeft.style.opacity = btnLeft.disabled ? "0.5" : "1";
            btnRight.style.opacity = btnRight.disabled ? "0.5" : "1";
            btnLeft.style.cursor = btnLeft.disabled ? "not-allowed" : "pointer";
            btnRight.style.cursor = btnRight.disabled ? "not-allowed" : "pointer";
            console.log("Left arrow disabled:", btnLeft.disabled, "Right arrow disabled:", btnRight.disabled);
        };
        // Initial check
        updateArrows();
        // Update on scroll
        container.addEventListener("scroll", updateArrows);
        // Update on window resize
        window.addEventListener("resize", ()=>{
            scrollAmount = getScrollAmount();
            updateArrows();
        });
    }
}
// Helper functions to define SVG icons
function $d7a0a65865a7b988$var$getLeftArrowSVG() {
    return `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" 
         xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18L9 12L15 6" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"/>
    </svg>
  `;
}
function $d7a0a65865a7b988$var$getRightArrowSVG() {
    return `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" 
         xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"/>
    </svg>
  `;
}
customElements.define($d7a0a65865a7b988$var$tagName, $d7a0a65865a7b988$var$BlogCarouselComponent);
var $d7a0a65865a7b988$export$2e2bcd8739ae039 = `<${$d7a0a65865a7b988$var$tagName}></${$d7a0a65865a7b988$var$tagName}>`;




// blog-banner.js
const $44ea3766e95fa153$var$style = /*css*/ `
  :host {
    position: relative; 
    display: block;
    margin: 2rem auto;
    max-width: 800px;
    overflow: visible;
  }

  /* Host pseudo-element for the blue background */
  :host::before {
    content: "";
    position: absolute;
    top: 10px;
    left: -8px;
    right: 0;
    bottom: -8px;
    background-color: var(--blue-brand, #008dd5);
    border-radius: 20px;
    z-index: 0;
  }

  .banner-content {
    position: relative;
    padding: 1.5rem 1.8rem;
    font-family: 'inter-medium', sans-serif;
    color: #333;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    z-index: 1;
  }

  h2 {
    margin: 0 0 1rem;
    font-family: 'inter-bold', sans-serif;
    font-size: 1.8rem;
    line-height: 1.2;
    color: #1e2e45;
  }

  p {
    margin: 0 0 1.2rem;
    line-height: 1.5;
    font-size: 1rem;
    color: #444;
  }

  .cta-button {
    display: inline-block;
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    font-family: 'inter-bold', sans-serif;
    background-color: var(--blue-brand, #008dd5);
    color: #fff;
    text-decoration: none;
    border: 2px solid transparent;
    border-radius: 30px;
    transition: background 0.3s ease, transform 0.3s ease, color 0.3s ease, border 0.3s ease;
    cursor: pointer;
  }
  
  .cta-button:hover {
    background-color: #fff;
    color: var(--blue-brand, #008dd5);
    border: 2px solid var(--blue-brand, #008dd5);
    transform: scale(0.98);
  }

  /* Hide the helper inputs */
  input.blog-id,
  input.blog-title {
    display: none;
  }
`;
const $44ea3766e95fa153$var$bannerHTML = {
    allgemein: (ctaUrl)=>/*html*/ `
    <div class="banner-content">
      <h2>KARRIERE IM IT- UND MANAGEMENTBEREICH</h2>
      <p>
        Starte Deine Zukunft im Produkt- oder Vertriebsmanagement mit unserer praxisnahen Weiterbildung.
        In wenigen Monaten lernst Du, Produkte erfolgreich zu entwickeln oder Vertriebsstrategien gezielt umzusetzen.
        Unsere Kurse sind staatlich gef\xf6rdert. Lass Dich beraten!
      </p>
      <a class="cta-button" href="${ctaUrl}">Vereinbare noch Heute Dein unverbindliches Erstgespr\xe4ch</a>
    </div>
  `,
    pm: (ctaUrl)=>/*html*/ `
    <div class="banner-content">
      <h2>Produktmanager als Beruf</h2>
      <p>
        Wenn Du eine Karriere im Produktmanagement anstrebst, bieten wir Dir die passenden Weiterbildungskurse,
        um Dich optimal vorzubereiten. In wenigen Monaten lernst Du alle wichtigen F\xe4higkeiten \u{2013} praxisnah und
        begleitet von erfahrenen Experten. Unsere Kurse vermitteln Dir das notwendige Know-how, um Produkte
        erfolgreich zu planen, zu entwickeln und am Markt zu positionieren. Die Weiterbildung ist staatlich gef\xf6rdert.
        Wir beraten Dich gerne!
      </p>
      <a class="cta-button" href="${ctaUrl}">Vereinbare noch Heute Dein unverbindliches Erstgespr\xe4ch</a>
    </div>
  `,
    sales: (ctaUrl)=>/*html*/ `
    <div class="banner-content">
      <h2>Vertriebsmanager als Beruf</h2>
      <p>
        Wenn Du Deine Zukunft im Vertriebsmanagement siehst, unterst\xfctzen wir Dich mit einer gezielten Weiterbildung.
        Innerhalb weniger Monate eignest Du Dir praxisnah und unter Anleitung erfahrener Experten alle wesentlichen Kenntnisse
        an, um erfolgreich im Vertrieb zu agieren. Du lernst, wie Du Verkaufsstrategien entwickelst, Kunden gewinnst und Ums\xe4tze steigerst.
        Unsere Kurse sind staatlich gef\xf6rdert. Lass Dich von uns beraten!
      </p>
      <a class="cta-button" href="${ctaUrl}">Vereinbare noch Heute Dein unverbindliches Erstgespr\xe4ch</a>
    </div>
  `
};
class $44ea3766e95fa153$var$BlogBanner extends HTMLElement {
    static get observedAttributes() {
        return [
            "cta-url",
            "blog-id",
            "blog-title",
            "category"
        ];
    }
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
        console.log("BlogBanner connected:", {
            ctaUrl: this.getAttribute("cta-url"),
            blogId: this.getAttribute("blog-id"),
            blogTitle: this.getAttribute("blog-title"),
            category: this.getAttribute("category")
        });
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) this.render();
    }
    render() {
        const ctaUrl = this.getAttribute("cta-url") || "";
        const blogId = this.getAttribute("blog-id") || "";
        const blogTitle = this.getAttribute("blog-title") || "";
        const categoryValue = this.getAttribute("category") || "allgemein";
        const templateFn = $44ea3766e95fa153$var$bannerHTML[categoryValue] || $44ea3766e95fa153$var$bannerHTML.allgemein;
        // Set inner HTML and include hidden inputs to hold the blog data.
        this.shadowRoot.innerHTML = `
      ${templateFn(ctaUrl)}
      <input type="hidden" class="blog-id" value="${blogId}">
      <input type="hidden" class="blog-title" value="${blogTitle}">
      <style>${$44ea3766e95fa153$var$style}</style>
    `;
        // (Re)attach the click handler to the CTA button after rendering.
        const btn = this.shadowRoot.querySelector(".cta-button");
        if (btn) btn.onclick = this.handleCTAClick.bind(this);
    }
    handleCTAClick(event) {
        event.preventDefault();
        // Read the blog data from the hidden inputs (ensuring we get the correct values)
        const blogId = this.shadowRoot.querySelector(".blog-id")?.value || "";
        const blogTitle = this.shadowRoot.querySelector(".blog-title")?.value || "";
        let ctaUrl = this.getAttribute("cta-url") || "";
        if (ctaUrl && blogId && blogTitle) try {
            const url = new URL(ctaUrl, window.location.origin);
            url.searchParams.set("blog_id", blogId);
            url.searchParams.set("blog_title", blogTitle);
            console.log("CTA clicked for blog:", {
                blogId: blogId,
                blogTitle: blogTitle,
                url: url.toString()
            });
            window.location.href = url.toString();
        } catch (error) {
            console.error("Error constructing URL:", error);
            window.location.href = ctaUrl;
        }
        else {
            console.warn("Missing blog data. Navigating to base URL:", ctaUrl);
            window.location.href = ctaUrl;
        }
    }
}
customElements.define("blog-banner", $44ea3766e95fa153$var$BlogBanner);
var $44ea3766e95fa153$export$2e2bcd8739ae039 = $44ea3766e95fa153$var$BlogBanner;


// If you use util for setting page title/description, make sure it's imported or available globally.
// import util from '/services/util.js';
const $6c3c7317a3ee7fea$var$tagName = "blog-individual-page";
var $6c3c7317a3ee7fea$var$css = /*css*/ `
  ${$6c3c7317a3ee7fea$var$tagName} {
    display: block;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .blog-title {
    font-size: 2.5em;
    line-height: 1.2;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
    color: #333;
    padding-bottom: 10px;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .blog-meta {
    font-size: 1.1em;
    color: #777;
    text-align: center;
    margin-bottom: 20px;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .blog-summary {
    font-size: 1.1em;
    color: #444;
    margin-bottom: 20px;
    text-align: center;
    font-style: italic;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .blog-summary a,
  ${$6c3c7317a3ee7fea$var$tagName} .section-summary a {
    color: var(--blue-brand);
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 2px; 
  } 

  ${$6c3c7317a3ee7fea$var$tagName} .thumbnail {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .section {
    margin-bottom: 2em;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .section-header {
    font-size: 1.8em;
    font-weight: bold;
    color: #333;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .section-summary {
    margin-bottom: 1em;
    color: #444;
    font-size: 1.05em;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .section-image {
    width: 100%;
    height: auto;
    max-height: 400px;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
    margin-top: 1em;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  }

  /* Skeleton (loading) styles */
  ${$6c3c7317a3ee7fea$var$tagName} .skeleton-title {
    height: 2.5em;
    background: #ccc;
    border-radius: 0.5em;
    margin-bottom: 14px;
    margin-top: 35px;
    animation: shimmer 1.5s infinite;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .skeleton-title-bar {
    height: 2.5em;
    width: 90%;
    background: #ddd;
    border-radius: 0.5em;
    margin: 0 auto 20px;
    animation: shimmer 1.5s infinite;
    margin-bottom: 20px;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .skeleton-meta {
    height: 1.5em;
    width: 35%;
    background: #ddd;
    border-radius: 0.5em;
    margin: 0 auto 20px;
    animation: shimmer 1.5s infinite;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .skeleton-summary {
    height: 1.5em;
    width: 100%;
    background: #ddd;
    border-radius: 0.5em;
    margin: 0 auto 10px;
    animation: shimmer 1.5s infinite;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .skeleton-thumbnail {
    width: 100%;
    height: 400px;
    background: #eee;
    border-radius: 0.4em;
    margin-bottom: 20px;
    animation: shimmer 1.5s infinite;
    margin-top: 20px;
  }

  ${$6c3c7317a3ee7fea$var$tagName} .skeleton-paragraph {
    height: 1.2em;
    background: #ddd;
    border-radius: 0.5em;
    margin-bottom: 10px;
    animation: shimmer 1.5s infinite;
  }

  @keyframes shimmer {
    0% { background-position: -200px 0; }
    100% { background-position: 200px 0; }
  }
`;
function $6c3c7317a3ee7fea$var$getTypeformURL() {
    const baseUrl = "https://franklin-institute.typeform.com/website-leads";
    let utmString = (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).load("?");
    return baseUrl + utmString;
}
function $6c3c7317a3ee7fea$var$renderBlogHTML(blogData) {
    const safeTitle = blogData.title?.trim() || "Untitled Post";
    const safeDate = blogData.date_published ? new Date(blogData.date_published).toLocaleDateString() : "No publish date";
    const safeReadTime = blogData.read_time && blogData.read_time > 0 ? `${blogData.read_time} min Lesedauer` : "N/A";
    const safeSummary = blogData.summary?.trim() || "No summary available";
    const safeThumbnail = blogData.thumbnail?.trim() ? blogData.thumbnail : "https://via.placeholder.com/600x400";
    return /*html*/ `
    <h1 class="blog-title">${safeTitle}</h1>
    <div class="blog-meta">
      Ver\xf6ffentlicht am ${safeDate} | ${safeReadTime}
    </div>
    <h2 class="blog-summary">${safeSummary}</h2>
    <img src="${safeThumbnail}" alt="${safeTitle}" class="thumbnail" />

    <!-- Render the "sections" array if it exists -->
    ${$6c3c7317a3ee7fea$var$renderSections(blogData.sections || [])}

    <style>${$6c3c7317a3ee7fea$var$css}</style>
  `;
}
function $6c3c7317a3ee7fea$var$renderSections(sections = []) {
    return sections.map((section)=>{
        const header = section.header ? section.header.trim() : "No Header";
        // Render paragraphs (each as a <p>)
        let paragraphsHTML = "";
        if (Array.isArray(section.paragraphs)) paragraphsHTML = section.paragraphs.map((p)=>`<p>${p.trim()}</p>`).join("");
        else if (typeof section.paragraphs === "string") paragraphsHTML = `<p>${section.paragraphs.trim()}</p>`;
        // Render additional paragraphs (can be an array or a string)
        let additionalParagraphHTML = "";
        if (section.additional_paragraph) additionalParagraphHTML = `<p>${section.additional_paragraph.trim()}</p>`;
        else if (section.additional_paragraphs) {
            if (Array.isArray(section.additional_paragraphs)) additionalParagraphHTML = section.additional_paragraphs.map((p)=>`<p>${p.trim()}</p>`).join("");
            else if (typeof section.additional_paragraphs === "string") additionalParagraphHTML = `<p>${section.additional_paragraphs.trim()}</p>`;
        }
        // Render section image if provided
        const sectionImage = section.image ? section.image.trim() : "";
        const imageHTML = sectionImage ? `<img src="${sectionImage}" class="section-image" alt="Section image" />` : "";
        // Render list items
        const listItems = Array.isArray(section.list) ? section.list : [];
        const listHTML = listItems.length ? `<ul>${listItems.map((item)=>{
            // If the list item is an object with a "text" property
            if (typeof item === "object" && item.text) {
                let subpointsHTML = "";
                if (Array.isArray(item.subpoints) && item.subpoints.length > 0) subpointsHTML = `<ul>${item.subpoints.map((sub)=>`<li>${sub}</li>`).join("")}</ul>`;
                return `<li>${item.text}${subpointsHTML}</li>`;
            } else // Otherwise, render the item directly (as a string)
            return `<li>${item}</li>`;
        }).join("")}</ul>` : "";
        return /*html*/ `
        <div class="section">
          <div class="section-header">${header}</div>
          <div class="section-summary">
            ${paragraphsHTML}
            ${listHTML}
            ${additionalParagraphHTML}
          </div>
          ${imageHTML}
        </div>
      `;
    }).join("");
}
class $6c3c7317a3ee7fea$var$BlogIndividualPage extends HTMLElement {
    constructor(){
        super();
    }
    async connectedCallback() {
        // 1) Show a skeleton while we fetch data
        this.innerHTML = `
      <div class="skeleton-title"></div>
      <div class="skeleton-title-bar"></div>
      <div class="skeleton-meta"></div>
      ${Array(2).fill(0).map(()=>`<div class="skeleton-summary"></div>`).join("")}
      <div class="skeleton-thumbnail"></div>
      ${Array(6).fill(0).map(()=>`<div class="skeleton-paragraph"></div>`).join("")}
      <style>${$6c3c7317a3ee7fea$var$css}</style>
    `;
        // 2) Extract the slug from the URL path
        const pathParts = window.location.pathname.split("/");
        const rawSlug = pathParts[2] || "";
        const slugFromURL = decodeURIComponent(rawSlug);
        // 3) Get all blogs to find the matching ID by slug
        const allBlogs = await (0, $2ea045d848240224$export$8de12f92128198cc)();
        if (!Array.isArray(allBlogs)) {
            this.innerHTML = `<p>Could not load blog data.</p>`;
            return;
        }
        // 4) Match the blog by slug
        const matchedBlog = allBlogs.find((b)=>(0, $1bda09d2dd26bd7c$export$c383cdd2a518017a)(b.title) === slugFromURL);
        if (!matchedBlog) {
            this.innerHTML = `<h1>404 - Blog Not Found</h1>`;
            return;
        }
        // 5) Fetch the full blog details
        const blogData = await (0, $2ea045d848240224$export$e1b37d1d9997591f)(matchedBlog.id);
        if (!blogData) {
            this.innerHTML = `<p>Could not fetch the full blog details.</p>`;
            return;
        }
        // Remove the skeleton
        this.innerHTML = "";
        // Dynamically set the page title & description
        const dynamicTitle = `${blogData.title} | Franklin Institute of Applied Sciences`;
        const dynamicDescription = blogData.summary?.trim();
        util.setPageTitle(dynamicTitle);
        util.setPageDescription(dynamicDescription);
        // Store UTM data
        this.storeUTMData(blogData);
        // Render the main blog content into a container
        const blogContainer = document.createElement("div");
        blogContainer.innerHTML = $6c3c7317a3ee7fea$var$renderBlogHTML(blogData);
        this.appendChild(blogContainer);
        // Insert a spacer between blog content and banner
        const spacer = document.createElement("div");
        spacer.style.height = "20px";
        this.appendChild(spacer);
        // Instead of the old hero-button, add the new blog-banner.
        if (blogData.category) {
            const finalCTA = $6c3c7317a3ee7fea$var$getTypeformURL();
            const bannerElement = document.createElement("blog-banner");
            bannerElement.setAttribute("category", blogData.category);
            bannerElement.setAttribute("cta-url", finalCTA);
            // Pass blog-id and blog-title so the banner can correctly build its link.
            bannerElement.setAttribute("blog-id", blogData.id);
            bannerElement.setAttribute("blog-title", blogData.title);
            this.appendChild(bannerElement);
        }
        // Append the carousel at the bottom (excluding the current blog)
        if (blogData.id) {
            const carouselElement = document.createElement("blog-carousel-component");
            carouselElement.setAttribute("exclude-id", blogData.id);
            this.appendChild(carouselElement);
        }
        // Update main menu
        var updateMainMenuEvent = new CustomEvent("update-main-menu");
        var mainMenu = document.querySelector("main-menu");
        if (mainMenu) mainMenu.dispatchEvent(updateMainMenuEvent);
    }
    storeUTMData(blogData) {
        const utmBlogData = {
            blogData: {
                id: blogData.id,
                slug: (0, $1bda09d2dd26bd7c$export$c383cdd2a518017a)(blogData.title)
            }
        };
        (0, $12dc7fa94ad8b497$export$2e2bcd8739ae039).store(utmBlogData);
        var resetAppConfigEvent = new CustomEvent("reset-app-config");
        window.dispatchEvent(resetAppConfigEvent);
    }
}
customElements.define($6c3c7317a3ee7fea$var$tagName, $6c3c7317a3ee7fea$var$BlogIndividualPage);
var $6c3c7317a3ee7fea$export$2e2bcd8739ae039 = `<${$6c3c7317a3ee7fea$var$tagName}></${$6c3c7317a3ee7fea$var$tagName}>`;



const $05a52904676c506a$var$tagName = "kontakt-boxes-component";
var $05a52904676c506a$var$contactCss = /*css*/ `
.contact-section {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 60px;
    padding: 40px 350px;
    background-color: #ffffff;
    grid-auto-rows: 1fr;
}

.contact-box {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    transition: transform 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    height: 230px;
    cursor: pointer;
    justify-self: center;
}

.contact-box:hover {
    transform: translateY(-5px);
}

.contact-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
}

.contact-icon {
    width: 50px;
    height: auto;
    margin-bottom: 10px;
}

.icon-phone {
    margin-top: -35px;
    margin-bottom: 0px;
}

/* Titles */
.contact-box h3 {
    font-size: 20px;
    font-family: 'inter-bold', sans-serif;
    margin-bottom: 5px;
    color: #333;
}

/* Secondary text */
.contact-box p {
    font-size: 12px;
    font-family: 'inter-medium', sans-serif;
    color: #555;
    margin: 5px 0;
}

/* Links */
.contact-box a {
    color: var(--blue-brand, #0056b3);
    font-size: 16px;
    text-decoration: none;
    font-family: 'inter-medium', sans-serif;
    margin-top: 5px;
}

.contact-box a:hover {
    border-bottom: 2px solid var(--blue-brand, #007BFF);
}

/* Button Styling */
.contact-box .button {
    width: fit-content;
    padding: 1em 2em;
    color: white;
    background: var(--blue-brand, #007BFF);
    border-radius: 0.3em;
    cursor: pointer;
    box-shadow: 0 0.6em 0.8em rgba(0, 0, 0, 0.2);
    transition: background-color 200ms ease-in-out, transform 200ms;
    text-decoration: none;
    font-size: 16px;
    font-family: 'inter-medium', sans-serif;
    display: inline-block;
    border: none;
    margin-top: 10px;
}

.contact-box .button span {
    font-size: 1.1em;
    border-bottom: 2px solid white;
}

/* Hover Effect */
.contact-box .button:hover {
    background: var(--gray-brand);
    transform: translateY(-2px);
}

@media (max-width: 953px) {
    .contact-section {
        grid-template-columns: 1fr;
        padding: 20px 10px;
    }

    .contact-box {
        max-width: 100%;
    }
}

@media (max-width: 1192px) {
    .contact-section {
        grid-template-columns: 1fr;
        padding: 40px;
    }

    .contact-box {
        max-width: 100%;
    }
}

@media (max-width: 1605px) {
    .contact-section {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        gap: 30px;
        padding: 40px 200px;
    }

    .contact-box:nth-child(2) {
        grid-column: 1 / 3;
        grid-row: 2;
        justify-self: center;
    }
}

@media (max-width: 835px) {
    .contact-section {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        width: 80%;
        length: auto;
        justify-self: center;
        padding: 75px;
    }

    .contact-box:nth-child(2) {
        grid-column: auto;
        grid-row: auto;
    }

    .contact-box {
        width: 80%;
        justify-self: center;
    }
}

@media (max-width: 835px) {
    .contact-section {
        padding: 60px;
    }
}

@media (max-width: 460px) {
    .contact-section {
        padding: 40px;
    }
}
`;
const $05a52904676c506a$var$renderButtonContHTML = (options)=>{
    if (options.ctas.length === 1) return /*html*/ `<a class="button" ${options.ctas[0].internal ? "internal" : ""} ${options.ctas[0].newTab ? 'target="_blank"' : ""} href="${options.ctas[0].href}"><span>${options.ctas[0].label}</span></a>`;
};
var $05a52904676c506a$var$renderInnerHTML = ()=>/*html*/ `
<section class="contact-section">
    <!-- Call Us -->
    <div class="contact-box">
        <div class="contact-content">
            <img src="/assets/images/Phone.png" class="contact-icon icon-phone" alt="Phone Icon">
            <h3>Ruf uns an</h3>
            <p></p>
            <a href="tel:+498962826149">+49 89 62826149</a>
        </div>
    </div>

    <!-- Chat with Us -->
    <div class="contact-box">
        <div class="contact-content">
            <img src="/assets/images/Chat.png" class="contact-icon" alt="Chat Icon">
            <h3>Schreib uns</h3>
            <p>Wir sind von Montag 9:00 CET bis Freitag 19:00 CET erreichbar.</p>
            <a href="https://wa.me/+498962826149" target="_blank">WhatsApp: +49 89 62826149</a>
            <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
        </div>
    </div>

    <!-- Sign Up -->
    <div class="contact-box">
        <div class="contact-content">
            <img src="/assets/images/Anmelden.png" class="contact-icon" alt="Anmelden Icon">
            <h3>Interesse?</h3>
            <p>F\xfcllen Sie unser Formular aus und wir melden uns</p>
            <div class="button-cont">
                ${$05a52904676c506a$var$renderButtonContHTML({
        ctas: [
            {
                label: "Jetzt anmelden!",
                href: config.ctaURLS.main,
                internal: false,
                newTab: true
            }
        ]
    })}
            </div>
        </div>
    </div>
</section>
`;
class $05a52904676c506a$var$KontaktBoxes extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const shadow = this.attachShadow({
            mode: "open"
        });
        const container = document.createElement("div");
        container.innerHTML = $05a52904676c506a$var$renderInnerHTML();
        const style = document.createElement("style");
        style.textContent = $05a52904676c506a$var$contactCss;
        shadow.appendChild(style);
        shadow.appendChild(container);
    }
}
customElements.define($05a52904676c506a$var$tagName, $05a52904676c506a$var$KontaktBoxes);
var $05a52904676c506a$export$2e2bcd8739ae039 = $05a52904676c506a$var$KontaktBoxes;


const $cee34935b3c79c2e$var$tagName = "standorten-section";
const $cee34935b3c79c2e$var$css = /*css*/ `
*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background: #f8f9fa;
  font-family: sans-serif;
  overflow-x: hidden;
}

.locations-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  padding-bottom: 40px;
  justify-content: center;
  margin-top: 25px;
  align-items: stretch;
}

.location-card {
  display: flex;
  flex-direction: row;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  flex: 1 1 calc(50% - 0.5rem);
  min-width: 280px;
  min-height: 200px;
  max-width: calc(50% - 0.5rem);
  justify-content: center;
  align-items: stretch;

}

.location-info {
  padding: 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.location-info img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  object-fit: cover;
  align-self: center;
}

.location-info h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
}

.info-line {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}

.location-icon {
  background-image: url("/assets/images/Place Marker.png");
}

.email-icon {
  background-image: url("/assets/images/Letter.png");
}

.phone-icon {
  background-image: url("/assets/images/Phone.png");
}

.map-container {
  flex: 1;
  min-height: 200px;
}

.map-container iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.locations-title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 1rem 0;
}

.locations-wrapper::after {
  content: "";
  flex: 1 1 calc(50% - 0.5rem);
  max-width: calc(50% - 0.5rem);
  visibility: hidden;
}

/* Responsive layout: stack cards on smaller screens */
@media (max-width: 768px) {
  .locations-wrapper {
    flex-direction: column;
    padding: 1rem;
    align-items: center;
  }
  .location-card {
    max-width: 100%;
    flex: 1 1 100%;
    min-width: unset;
  }

  .locations-wrapper::after {
    display: none; /* No need for centering on mobile */
  }
}

/* Edge case for very small screens */
@media (max-width: 490px) {
  .location-card {
    flex-direction: column;
    width: 90%;
    height: auto;
    margin: 0 auto;
  }

  .info-line {
    font-size: 1rem;
    margin-bottom: 0.3rem;
  }

  .map-container {
    order: 2;
    min-height: 150px;
  }

  .locations-wrapper {
    padding: 0.5rem;
    width: 100%;
    padding-bottom: 40px;
    gap: 2rem;
  }
}

/* Link Styles */
.info-line a {
  color: inherit;
  text-decoration: underline; 
  transition: color 0.3s ease;
}

.info-line a:hover,
.info-line a:focus,
.info-line a:active {
  color: var(--blue-brand);
}
`;
function $cee34935b3c79c2e$var$template() {
    return /*html*/ `
    <div class="locations-wrapper">
      <!-- LOCATION #1: Munich -->
      <div class="location-card">
        <div class="location-info">
          <img 
            src="/assets/images/munich.webp" 
            alt="Munich Office"
          />
          <h2>Munich, DE</h2>
          <div class="info-line">
            <div class="icon location-icon"></div>
            <div>Arnulfstra\xdfe 61, 80636 M\xfcnchen</div>
          </div>
          <div class="info-line">
            <div class="icon email-icon"></div>
            <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
          </div>
        </div>
        <div class="map-container">
          <iframe
            src="https://www.google.com/maps?q=48.147299,11.539513&z=14&output=embed"
            allowfullscreen
            loading="lazy">
          </iframe>
        </div>
      </div>

      <!-- LOCATION #2: Berlin -->
      <div class="location-card">
        <div class="location-info">
          <img 
            src="/assets/images/berlin.webp" 
            alt="Berlin Office"
          />
          <h2>Berlin, DE</h2>
          <div class="info-line">
            <div class="icon location-icon"></div>
            <div>Graefestra\xdfe 11, 10967 Berlin</div>
          </div>
          <div class="info-line">
            <div class="icon email-icon"></div>
            <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
          </div>
        </div>
        <div class="map-container">
          <iframe
            src="https://www.google.com/maps?q=52.493262,13.423519&z=14&output=embed"
            allowfullscreen
            loading="lazy">
          </iframe>
        </div>
      </div>

            <!-- LOCATION #3: Dortmund -->
            <div class="location-card">
            <div class="location-info">
              <img 
                src="/assets/images/dortmund.webp" 
                alt="Dortmund Office"
              />
              <h2>Dortmund, DE</h2>
              <div class="info-line">
                <div class="icon location-icon"></div>
                <div>Florianstra\xdfe 15-21, 44139 Dortmund</div>
              </div>
              <div class="info-line">
                <div class="icon email-icon"></div>
                <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
              </div>
            </div>
            <div class="map-container">
              <iframe
              src="https://www.google.com/maps?q=51.497230,7.465798&z=14&output=embed"
              allowfullscreen
                loading="lazy">
              </iframe>
            </div>
          </div>

          <!-- LOCATION #4: Leipzig -->
          <div class="location-card">
          <div class="location-info">
            <img 
              src="/assets/images/leipzig.webp" 
              alt="Leipzig Office"
            />
            <h2>Leipzig, DE</h2>
            <div class="info-line">
              <div class="icon location-icon"></div>
              <div>Torgauer Stra\xdfe 231-233, 04347 Leipzig</div>
            </div>
            <div class="info-line">
              <div class="icon email-icon"></div>
              <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
            </div>
          </div>
          <div class="map-container">
            <iframe
            src="https://www.google.com/maps?q=51.365556,12.419167&z=14&output=embed"
            allowfullscreen
              loading="lazy">
            </iframe>
          </div>
        </div>

                  <!-- LOCATION #5: Hamburg -->
                  <div class="location-card">
                  <div class="location-info">
                    <img 
                      src="/assets/images/hamburg.webp" 
                      alt="Hamburg Office"
                    />
                    <h2>Hamburg, DE</h2>
                    <div class="info-line">
                      <div class="icon location-icon"></div>
                      <div>Bei den M\xfchren 1, 20457 Hamburg</div>
                    </div>
                    <div class="info-line">
                      <div class="icon email-icon"></div>
                      <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
                    </div>
                  </div>
                  <div class="map-container">
                    <iframe
                    src="https://www.google.com/maps?q=53.548599,9.999190&z=14&output=embed"
                    allowfullscreen
                      loading="lazy">
                    </iframe>
                  </div>
                </div>

                <!-- LOCATION #6: K\xf6ln -->
                <div class="location-card">
                <div class="location-info">
                  <img 
                    src="/assets/images/k\xf6ln.webp" 
                    alt="K\xf6ln Office"
                  />
                  <h2>K\xf6ln, DE</h2>
                  <div class="info-line">
                    <div class="icon location-icon"></div>
                    <div>Lichtstra\xdfe 24, 50825 K\xf6ln</div>
                  </div>
                  <div class="info-line">
                    <div class="icon email-icon"></div>
                    <a href="mailto:Beratung@franklin-institute.de">Beratung@franklin-institute.de</a>
                  </div>
                </div>
                <div class="map-container">
                  <iframe
                  src="https://www.google.com/maps?q=50.949430,6.918560&z=14&output=embed"
                  allowfullscreen
                    loading="lazy">
                  </iframe>
                </div>
              </div>
    </div>
    <style>${$cee34935b3c79c2e$var$css}</style>
  `;
}
class $cee34935b3c79c2e$var$StandortenSection extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $cee34935b3c79c2e$var$template();
    }
}
customElements.define($cee34935b3c79c2e$var$tagName, $cee34935b3c79c2e$var$StandortenSection);
var $cee34935b3c79c2e$export$2e2bcd8739ae039 = `<${$cee34935b3c79c2e$var$tagName}></${$cee34935b3c79c2e$var$tagName}>`;


const $38e22ee6659142c4$var$tagName = "karriere-hero-component";
var $38e22ee6659142c4$var$css = /*css*/ `
  .section {
    width: 100%;
    padding: min(6vw, 40px) 0;
    display: flex;
    justify-content: center;
  }

  .wrapper {
    width: 100%;
    max-width: 1200px;
    padding: 0 20px;
  }

  .two-col-cont-karriere-hero {
    display: flex;
    flex-direction: column;
    gap: 15px; /* Reduced gap from 30px to 15px */
    margin-bottom: 20px; /* Reduced margin-bottom */
  }

  .two-col-cont-karriere-hero>div {
    flex: 1 1 0;
  }

  .hero-3 {
    font-size: 30px;
    font-family: 'inter-bold', sans-serif;
    color: var(--blue-brand);
    text-align: center;
    margin-left: 60px;

  }

  .hero-1 {
    font-size: 30px;
    font-family: 'inter-bold', sans-serif;
    text-align: center;
    margin-left: 60px;

  }

  .hero-1 span {
    color: var(--blue-brand);
  }

  .paragraph {
    font-family: 'inter-light', sans-serif;
    font-size: 18px;
    margin-top: 15px;
    text-align: center;
    margin-left: 60px;
  }

  .karriere-hero-img {
    display: flex;
        position: relative;
        width: 100%;
        aspect-ratio: 1.177 / 1;
        background-image: url('/assets/images/isabel-portrait.jpg');
        background-size: cover;
        border-radius: 0.7rem;
        max-width: 450px;
        margin: 0 auto;
  }

  .karriere-hero-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
    border-radius: 0 0 0.7rem 0.7rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    padding: 10px 20px;
    box-sizing: border-box;
    color: #fff;
  }

  .karriere-hero-text p {
    font-family: 'inter-medium', sans-serif;
    font-size: 1rem;
    font-weight: bold;
    margin: 0;
    line-height: 1.5;
  }

  .karriere-hero-text span {
    font-size: 0.9rem;
    font-weight: normal;
  }

  .contact-button {
    font-family: 'inter-medium', sans-serif;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background: none;
    border: 2px solid #fff;
    border-radius: 0.5rem;
    padding: 10px 20px;
    cursor: pointer;
    margin-top: 8px; /* Slightly reduced */
    transition: background-color 0.3s, color 0.3s;
  }

  .contact-button:hover {
    background-color: #fff;
    color: #000;
  }

  @media (min-width: 800px) {
    .two-col-cont-karriere-hero {
      flex-direction: row;
      gap: 30px; /* Reduced from 50px to 30px */
      align-items: center;
      justify-content: center;
    }

    .paragraph {
      text-align: left;
    }

    .hero-3,
    .hero-1 {
      text-align: left;
    }
  }

  @media (max-width: 800px) {
    .paragraph {
        margin-left: 0;
        padding-bottom: 20px;
      }
  
      .hero-3,
      .hero-1 {
        margin-left: 0;
      }
    }

`;
var $38e22ee6659142c4$var$template = /*html*/ `
<div class="section first-section-karriere">
  <div class="wrapper">
    <div class="two-col-cont-karriere-hero">
      <div>
        <div class="hero-3">Sie sind Vermittler|n</div>
        <div class="hero-1">und haben Fragen<br><span>zu unseren Weiterbildungen?</span></div>
        <div class="paragraph">
        F\xfcr alle Anliegen rund um uns, unsere Weiterbildungen, unser Bewerbungsprozess steht Ihnen Isabel Spiess als Ihre Ansprechpartnerin zur Verf\xfcgung.
        </div>
      </div>
      <div>
        <div class="karriere-hero-img">
          <!-- Black Gradient Overlay -->
          <div class="karriere-hero-overlay">
            <div class="karriere-hero-text">
              <p>Isabel Spiess<br><span>Executive Assistant to the Managing Director</span></p>
              <a href="mailto:isabel.spiess@franklin-institute.de">
                <button class="contact-button">Kontaktaufnahme \u{2192}</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
class $38e22ee6659142c4$var$KarriereHero extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const shadow = this.attachShadow({
            mode: "open"
        });
        const container = document.createElement("div");
        container.innerHTML = $38e22ee6659142c4$var$template;
        const style = document.createElement("style");
        style.textContent = $38e22ee6659142c4$var$css;
        shadow.appendChild(style);
        shadow.appendChild(container);
    }
}
customElements.define($38e22ee6659142c4$var$tagName, $38e22ee6659142c4$var$KarriereHero);
var $38e22ee6659142c4$export$2e2bcd8739ae039 = $38e22ee6659142c4$var$KarriereHero;


const $cadd638c7cf7f3ef$var$tagName = "kontakt-page";
var $cadd638c7cf7f3ef$var$pageTitle = "Kontakt | Franklin Institute of Applied Sciences";
var $cadd638c7cf7f3ef$var$pageDescription = "Nimm Kontakt mit uns auf und finde heraus, welche Weiterbildung zu dir am besten passt.";
var $cadd638c7cf7f3ef$var$css = /*css*/ `
.title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin: 10px;
    margin-bottom: -10px;
  }
`;
function $cadd638c7cf7f3ef$var$template() {
    return /*html*/ `

    <div class="title">Kontakt</div>
    <kontakt-boxes-component></kontakt-boxes-component>

    <karriere-hero-component></karriere-hero-component>

    <div class="title", id="standorten">Unsere Standorte</div>
    <standorten-section></standorten-section>    

    <style>${$cadd638c7cf7f3ef$var$css}</style>
        
    `;
}
// Define the main page component
class $cadd638c7cf7f3ef$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($cadd638c7cf7f3ef$var$pageTitle);
        util.setPageDescription($cadd638c7cf7f3ef$var$pageDescription);
        this.innerHTML = $cadd638c7cf7f3ef$var$template();
    }
}
// Register the main page component
customElements.define($cadd638c7cf7f3ef$var$tagName, $cadd638c7cf7f3ef$var$Page);
var // Export the main component if needed
$cadd638c7cf7f3ef$export$2e2bcd8739ae039 = `<${$cadd638c7cf7f3ef$var$tagName}></${$cadd638c7cf7f3ef$var$tagName}>`;




const $45232328f249cf51$var$tagName = "about-franklin-friends-component";
const $45232328f249cf51$var$css = /*css*/ `
  :host {
    display: block;
    width: 70%;
    margin: 0 auto;
  }

  .franklin-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    padding: 40px 0;
    gap: 40px;
  }

  .franklin-text {
    flex: 1;
    max-width: 50%;
  }

  .franklin-text h2 {
    font-size: clamp(28px, 6.18vw, 45px);
    margin-bottom: 10px;
  }

  .franklin-text p,
  .franklin-text ol {
    font-size: 18px;
    line-height: 1.5;
  }

  .franklin-text ol {
    padding-left: 20px;
  }

  .franklin-text ol li {
    margin-bottom: 10px;
  }

  .franklin-image {
    flex: 1;
    max-width: 50%;
  }

  .franklin-image img {
    max-width: 100%;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    .franklin-container {
      flex-direction: column;
      text-align: left;
    }

    .franklin-text,
    .franklin-image {
      max-width: 100%;
    }
  }
  .light-blue-text {
    color: var(--blue-brand);
    font-size: clamp(28px, 6.18vw, 45px);
}

@media (max-width: 460px) {
  .franklin-text h2 {
    font-size: 40px;
  }
  .light-blue-text {
    font-size: 40px;
  }
}
`;
const $45232328f249cf51$var$renderInnerHTML = ()=>{
    return /*html*/ `
      <div class="franklin-container">
        <div class="franklin-text">
          <h2>Was ist <br><span class="light-blue-text">Franklin Friends?</span></h2>
          <p>
          <strong>Franklin Friends</strong> ist das exklusive Empfehlungsprogramm des Franklin Institute.
            Du kennst jemanden, der von einer Weiterbildung profitieren k\xf6nnte? Dann empfehle
            uns weiter und erhalte daf\xfcr einen exklusiven Empfehlungsbonus!
          </p>
  
          <h3>Und so funktioniert\u{2019}s \u{2013} In 3 einfachen Schritten</h3>
          <ol>
            <li><strong>Empfehlen:</strong> Nutze deinen <strong>individuellen Empfehlungslink</strong> oder unser <strong>Kontaktformular.</strong></li>
            <li><strong>Erfolgreicher Kursstart:</strong> Sobald deine empfohlene Person startet, z\xe4hlt die Empfehlung. F\xfcr deine  <strong>erste erfolgreiche Empfehlung erh\xe4ltst du 400\u{20AC}</strong>.</li>
            <li><strong>Empfehlungsbonus erhalten:</strong> Dein Bonus wird in <strong>monatlichen Raten von 100\u{20AC}</strong> ausgezahlt.</li>
          </ol>
        </div>
        <div class="franklin-image">
          <img src="/assets/images/businesspeople-meeting-office 1.png" alt="Franklin Friends" />
        </div>
      </div>
      <style>${$45232328f249cf51$var$css}</style>
    `;
};
class $45232328f249cf51$var$FranklinFriendsComponent extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = $45232328f249cf51$var$renderInnerHTML();
    }
}
customElements.define($45232328f249cf51$var$tagName, $45232328f249cf51$var$FranklinFriendsComponent);
var $45232328f249cf51$export$2e2bcd8739ae039 = `<${$45232328f249cf51$var$tagName}></${$45232328f249cf51$var$tagName}>`;


const $4601d2328928346a$var$tagName = "franklin-recommendation-component";
const $4601d2328928346a$var$css = /*css*/ `
  :host {
    display: block;
    width: 80%;
    margin: 0 auto;
  }

  .recommendation-container {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    background: #fff;
    padding: 60px;
    padding-top: 20px;
  }

  .recommendation-box {
    flex: 1;
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding-top: 0;
  }

  .recommendation-box h3 {
    font-size: 24px;
  }

  .recommendation-step {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 15px;
  }

  .step-number {
    width: 60px;
    height: 60px;
    background: var(--blue-brand);
    color: white;
    font-size: 28px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }

  .step-content {
    flex: 1;
  }

  .step-content h3 {
    font-size: 20px;
    color: var(--blue-brand);
    margin: 0 0 5px;
  }

  .step-content p {
    font-size: 16px;
    color: #444;
    margin: 0;
  }

  .title {
    font-size: 32px;
    font-weight: bold;
    color: var(--blue-brand);
    text-align: center;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    .recommendation-container {
      flex-direction: column;
    }
  }

  @media (max-width: 460px) {

    :host {
      width: 90%;
    }

    .recommendation-container {
      flex-direction: column;
      padding: 10px;
    }
  
    .recommendation-box h3 {
      text-align: center;
    }
  
    .recommendation-step {
      flex-direction: row;
      align-items: flex-start;
    }
  
    .step-number {
      align-self: flex-start;
    }
  
    .step-content p {
      margin-top: 10px;
    }  

    .step-content h3 {
      text-align: left;
    }
  }
`;
const $4601d2328928346a$var$renderInnerHTML = ()=>{
    return /*html*/ `
    <h2 class="title">Deine M\xf6glichkeiten zur Empfehlung</h2>
    <div class="recommendation-container">
      <div class="recommendation-box">
        <h3>Option 1: Tracking-Link</h3>
        <div class="recommendation-step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Link Erhalten</h3>
            <p>Wir schicken dir einen personalisierten Link zu.</p>
          </div>
        </div>

        <div class="recommendation-step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Teilen & Werben</h3>
            <p>Teile den Link mit potenziellen Interessenten.</p>
          </div>
        </div>

        <div class="recommendation-step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Bonus Erhalten</h3>
            <p>Sobald sich jemand \xfcber diesen Link anmeldet, wird der Kontakt dir zugeordnet und du erh\xe4ltst deinen Bonus!</p>
          </div>
        </div>
      </div>

      <div class="recommendation-box">
        <h3>Option 2: Pers\xf6nliche Empfehlung</h3>
        <div class="recommendation-step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Kontaktdaten \xdcbermitteln</h3>
            <p>\xdcbermittle die Kontaktdaten der Person, die du weiterempfehlen m\xf6chtest, direkt \xfcber ein spezielles Formular \xfcbermitteln.</p>
          </div>
        </div>

        <div class="recommendation-step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Absprache Treffen</h3>
            <p>Bitte informiere die Person, damit sie von unserem Anruf nicht \xfcberrascht wird.</p>
          </div>
        </div>

        <div class="recommendation-step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Bonus Erhalten</h3>
            <p>Sobald sich die Person anmeldet, wird der Kontakt dir zugeordnet und du erh\xe4ltst erh\xe4ltst deinen Bonus!</p>
          </div>
        </div>
      </div>
    </div>
    <style>${$4601d2328928346a$var$css}</style>
  `;
};
class $4601d2328928346a$var$FranklinRecommendationComponent extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = $4601d2328928346a$var$renderInnerHTML();
    }
}
customElements.define($4601d2328928346a$var$tagName, $4601d2328928346a$var$FranklinRecommendationComponent);
var $4601d2328928346a$export$2e2bcd8739ae039 = `<${$4601d2328928346a$var$tagName}></${$4601d2328928346a$var$tagName}>`;



const $20f4b37c2dd6218e$var$tagName = "franklin-friends";
var $20f4b37c2dd6218e$var$pageTitle = "Franklin Friends | Franklin Institute of Applied Sciences";
var $20f4b37c2dd6218e$var$pageDescription = "Franklin Friends ist das exklusive Empfehlungsprogramm des Franklin Institute. Du kennst jemanden, der von einer Weiterbildung profitieren k\xf6nnte? Dann empfehle uns weiter und verdiene dabei bares Geld!";
var $20f4b37c2dd6218e$var$css = /*css*/ `
.title {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin: 10px;
    margin-bottom: -10px;
  }
`;
function $20f4b37c2dd6218e$var$template() {
    return /*html*/ `

    <about-franklin-friends-component></about-franklin-friends-component>
    <div style="display: flex; justify-content: center; margin-top: -25px; margin-bottom: 30px;">
        <a cta-prevent-inner-hover target="_blank" href="${config.ctaURLS.franklinfriends}" class="menu-desktop is-cta">
            ${(0, $a1bb008553eac0d1$export$2e2bcd8739ae039)(`<span>Jetzt starten!</span>`)}
        </a>
    </div>    
    <franklin-recommendation-component></franklin-recommendation-component>

    <div class="double-cta-cont" style="padding: 3em 1rem; background: linear-gradient(to bottom, white 0%, white 50%, var(--gray-brand) 50%, var(--gray-brand) 100%);">
    ${(0, $c10f68591c353a3e$export$2e2bcd8739ae039)({
        texts: [
            "Interressiert?",
            "Dein Empfehlungslink wartet!",
            "Registriere dich jetzt, erhalte deinen individuellen Empfehlungslink und verdiene ganz einfach mit deinen Weiterempfehlungen!"
        ],
        ctas: [
            {
                label: "Jetzt starten!",
                href: config.ctaURLS.franklinfriends,
                internal: false,
                newTab: true
            }
        ]
    })}
</div>

    <style>${$20f4b37c2dd6218e$var$css}</style>
        
    `;
}
// Define the main page component
class $20f4b37c2dd6218e$var$Page extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        util.setPageTitle($20f4b37c2dd6218e$var$pageTitle);
        util.setPageDescription($20f4b37c2dd6218e$var$pageDescription);
        this.innerHTML = $20f4b37c2dd6218e$var$template();
    }
}
// Register the main page component
customElements.define($20f4b37c2dd6218e$var$tagName, $20f4b37c2dd6218e$var$Page);
var // Export the main component if needed
$20f4b37c2dd6218e$export$2e2bcd8739ae039 = `<${$20f4b37c2dd6218e$var$tagName}></${$20f4b37c2dd6218e$var$tagName}>`;



// import Router from '../services/router.js'
const $8c9d82f003a9c3f7$var$tagName = "page-cont";
const $8c9d82f003a9c3f7$var$pages = {
    "/": (0, $92733ef4b7d17708$export$2e2bcd8739ae039),
    "/404": (0, $0e731ffcb5fe0c97$export$2e2bcd8739ae039),
    "/404-course": (0, $1ac07ed33ac075eb$export$2e2bcd8739ae039),
    "/not-found.html": (0, $0e731ffcb5fe0c97$export$2e2bcd8739ae039),
    "/about": (0, $7eab43868532f832$export$2e2bcd8739ae039),
    "/vermittler": (0, $9c894f0eb67aadc7$export$2e2bcd8739ae039),
    "/career": (0, $eb90d02e1cd2e134$export$2e2bcd8739ae039),
    "/courses/pm": (0, $3f499fec838245db$export$2e2bcd8739ae039),
    "/courses/sales": (0, $93ee16d3c36079c1$export$2e2bcd8739ae039),
    "/impressum": (0, $d5fc890d86b7e181$export$2e2bcd8739ae039),
    "/datenschutz": (0, $cc5b2fa8db4fe3c5$export$2e2bcd8739ae039),
    "/partner": (0, $b52b4475956ac080$export$2e2bcd8739ae039),
    "/danke": (0, $86a1ebfadbce19ce$export$2e2bcd8739ae039),
    "/danke-sales": (0, $1e855b9d5d20f2d8$export$2e2bcd8739ae039),
    "/danke-weiterbildungen": (0, $f03f935329ab79c2$export$2e2bcd8739ae039),
    "/danke-angestellt-genaumeinkurs": (0, $c0c990b893a195a8$export$2e2bcd8739ae039),
    "/bildungsgutschein": (0, $91e9435b0c9ad32e$export$2e2bcd8739ae039),
    "/blog": (0, $706110047da901e3$export$2e2bcd8739ae039),
    "/kontakt": (0, $cadd638c7cf7f3ef$export$2e2bcd8739ae039),
    "/franklin-friends": (0, $20f4b37c2dd6218e$export$2e2bcd8739ae039)
};
var $8c9d82f003a9c3f7$var$css = /*css*/ `
    ${$8c9d82f003a9c3f7$var$tagName} div.content-placeholder {
        font-size: 32px;
    }
    ${$8c9d82f003a9c3f7$var$tagName} {
        display: block;
        padding-top: var(--nav-menu-height);
        width: 100%;
        overflow-x: hidden;
        background: white;
    }
    ${$8c9d82f003a9c3f7$var$tagName} .blue-line {
        height: 0.5rem;
        background: var(--blue-wide-gradient);
    }
    ${$8c9d82f003a9c3f7$var$tagName} .page-hero-small {
        font-size: 1.5rem;
        margin-bottom: 1em;
        font-family: 'inter-medium';
    }
    ${$8c9d82f003a9c3f7$var$tagName} .page-hero-medium {
        font-size: clamp(1.6rem, 5vw, 2.2rem);
        margin-bottom: 1em;
        font-family: 'inter-bold';
    }
    ${$8c9d82f003a9c3f7$var$tagName} .page-hero-large {
        font-size: 3rem;
        margin-bottom: 1em;
        font-family: 'inter-bold';
    }
    ${$8c9d82f003a9c3f7$var$tagName} .centered {
        text-align: center;
    }
    ${$8c9d82f003a9c3f7$var$tagName} div.line {
        display: inline-block;
    }
`;
var $8c9d82f003a9c3f7$var$template = /*html*/ `
    <div id="page-container"></div>
    <style>${$8c9d82f003a9c3f7$var$css}</style>
`;
class $8c9d82f003a9c3f7$var$PageCont extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $8c9d82f003a9c3f7$var$template;
        this.navigationEvent = eventBus.register("navigation", ()=>{
            this.handleNavigation();
        });
        this.pageContainer = this.querySelector("#page-container");
        this.handleNavigation();
    }
    handleNavigation() {
        if (location.pathname.slice(0, 8) == "/course/") {
            var pageHTML = (0, $c24c39c61b4168b8$export$2e2bcd8739ae039);
            this.pageContainer.innerHTML = "";
            this.pageContainer.innerHTML = pageHTML;
            return;
        }
        if (location.pathname.startsWith("/blog/") && location.pathname !== "/blog") {
            this.pageContainer.innerHTML = (0, $6c3c7317a3ee7fea$export$2e2bcd8739ae039);
            return;
        }
        var pageHTML = $8c9d82f003a9c3f7$var$pages[location.pathname] || /*html*/ `<div style="height: 1000px;"></div>`;
        this.pageContainer.innerHTML = pageHTML;
    }
    disconnectedCallback() {
        this.navigationEvent.unregister();
    }
}
customElements.define("page-cont", $8c9d82f003a9c3f7$var$PageCont);
var $8c9d82f003a9c3f7$export$2e2bcd8739ae039 = "<page-cont></page-cont>";


const $de08bbf2a41f1ec8$var$tagName = "footer-cont";
var $de08bbf2a41f1ec8$var$css = /*css*/ `
    ${$de08bbf2a41f1ec8$var$tagName} {
        display: block;
        background: var(--gray-brand);
        color: white;
        padding-bottom: calc(var(--cookie-banner-height) + 0.5em);
        padding-top: 3em;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-upper-cont {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3em;
        flex-wrap: wrap;
        gap: 2.5em;
        width: 100%;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-lower-cont {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3em;
        flex-wrap: wrap;
        gap: 3em;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .white-logo {
        display: block;
        width: 18em;
        max-width: 100%;
        aspect-ratio: 255 / 79;
        background-image: url('/assets/images/fias-logo-new-white.svg');
        margin-bottom: 1em;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .white-slogan span {
        color: var(--blue-brand);
    }
    ${$de08bbf2a41f1ec8$var$tagName} .contact-img {
        width: 70px;
        min-width: 70px;
        aspect-ratio: 1/1;
        background-image: url('/assets/images/emil_portrait_footer.jpg');
        border-radius: 100%;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .contact-cont {
        display: flex;
        gap: 16px;
        margin-bottom: 22px;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .contact-text-name {
        font-size: 22px;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icons {
        display: flex;
        gap: 20px;
        margin-bottom: 16px;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icon {
        width: 38px;
        aspect-ratio: 1/1;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: contain;
        transition: 200ms;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icon:hover {
        transform: translateY(-2px);
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icon-facebook {
        background-image: url('/assets/images/icons/icon-fb.svg');
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icon-linkedin {
        background-image: url('/assets/images/icons/icon-li.svg');
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icon-instagram {
        background-image: url('/assets/images/icons/icon-ig.svg');
    }
    ${$de08bbf2a41f1ec8$var$tagName} .social-media-icon-tiktok {
        background-image: url('/assets/images/icons/icon-tt.svg');
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-links-cont {
        display: flex;
        gap: 2.5em;
        flex-wrap: wrap;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-link-block {
        display: flex;
        flex-direction: column;
        gap: 0.8em;
        flex-grow: 1;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-link-block-title {
        font-size: 22px;
        font-family: 'inter-medium';
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-link-block-links {
        display: flex;
        flex-direction: column;
        gap: 0.6em;
        color: #D3D3D3;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-link-block-links a {
        font-size: 18px;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .copyright {
        width: 100%;
        text-align: center;
        color: lightgray;
        margin-top: 1em;
    }

    ${$de08bbf2a41f1ec8$var$tagName} .footer-logo-section {
        display: flex;
        justify-content: left;
        align-items: center;
        gap: 1.5em;
        margin-top: -50px;
        margin-bottom: -20px;
    }
    
    ${$de08bbf2a41f1ec8$var$tagName} .footer-logo {
        display: block;
        width: 150px; 
        height: 150px;
        background-size: contain; 
        background-repeat: no-repeat; 
        background-position: center; 
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-germany-logo {
        background-image: url('/assets/images/Schland_2.png');
        margin-top: 5px;
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-bildung-logo {
        background-image: url('/assets/images/bilungsverband.png');
    }
    ${$de08bbf2a41f1ec8$var$tagName} .footer-certqua-logo {
        background-image: url('/assets/images/Certqua_Zeichen_AZAV.png');
    }
`;
var $de08bbf2a41f1ec8$var$template = /*html*/ `
    <div class="wrapper">
        <div class="footer-upper-cont">
            <div>
                <a href="/" internal class="white-logo bg-img-contain" aria-label="Startseite"></a>
                <div class="white-slogan">
                    <h1 class="no-margin">Wir leben <span>Karriere.</span></h1>
                </div>
            </div>
            <div class="contact-social-media-cont">
                <div class="contact-cont">
                    <div class="contact-img bg-img-contain"></div>
                    <div class="contact-text">
                        <div class="contact-text-name">Dr. Emil Kendziorra</div>
                        <div class="contact-text-title">Bildungsbeauftragter</div>
                    </div>
                </div>
                <div class="social-media-icons">
                    <a class="social-media-icon social-media-icon-linkedin" target="_blank" href="https://de.linkedin.com/school/franklin-institute-of-applied-sciences-pioneer-people-gmbh/" aria-label="Franklin Institute LinkedIn Seite"></a>
                    <a class="social-media-icon social-media-icon-facebook" target="_blank" href="https://m.facebook.com/people/Franklin-Institute-of-Applied-Sciences/100088693976239/" aria-label="Franklin Institute Facebook Seite"></a>
                    <a class="social-media-icon social-media-icon-instagram" target="_blank" href="https://www.instagram.com/franklin_ias/" aria-label="Franklin Institute Instagram Seite"></a>
                    <a class="social-media-icon social-media-icon-tiktok" target="_blank" href="https://www.tiktok.com/@franklin_institute" aria-label="Franklin Institute Tiktok Seite"></a>
                </div>
                <a href="mailto:beratung@franklin-institute.de" class="hover-blue">beratung@franklin-institute.de</a>
            </div>
        </div>
        <div class="footer-lower-cont">
            <div class="footer-links-cont">
                <div class="footer-link-block">
                    <div class="footer-link-block-title">Franklin Institute</div>
                    <div class="footer-link-block-links">
                        <a href="/#faq" internal class="hover-blue">H\xe4ufige Fragen</a>
                        <a href="/about" internal class="hover-blue">\xdcber das FI</a>
                        <a href="/vermittler" internal class="hover-blue">F\xfcr Vermittler</a>
                        <a href="/partner" internal class="hover-blue">F\xfcr Unternehmen</a>
                        <a href="/franklin-friends" internal class="hover-blue">Franklin Friends</a>
                        <a href="/kontakt" internal class="hover-blue">Kontakt</a>
                        <a href="/kontakt#standorten" internal class="hover-blue" id="scroll-to-standorten">Unsere Standorte</a>

                        </div>
                </div>
                <div class="footer-link-block">
                    <div class="footer-link-block-title">Kursangebot</div>
                    <div class="footer-link-block-links">
                        <a href="/courses/pm" internal class="hover-blue">Product Management</a>
                        <a href="/courses/sales" internal class="hover-blue">IT-Sales Manager</a>
                    </div>
                </div>
                <div class="footer-link-block">
                    <div class="footer-link-block-title">Karriere Bei FI</div>
                    <div class="footer-link-block-links">
                        <a href="/career" internal class="hover-blue">Karriere</a>
                    </div>
                </div>
                <div class="footer-link-block">
                    <div class="footer-link-block-title">Rechtliches</div>
                    <div class="footer-link-block-links">
                        <a href="/impressum" internal class="hover-blue">Impressum</a>
                        <a href="/datenschutz" internal class="hover-blue">Datenschutz</a>
                        <a onclick="eventBus.emit('show-cookie-banner')" class="hover-blue" style="cursor: pointer;">Cookie Einstellungen</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-logo-section">
            <div class="footer-logo footer-germany-logo"></div>
            <div class="footer-logo footer-bildung-logo"></div>
            <div class="footer-logo footer-certqua-logo"></div>
        </div>
        <div class="copyright">\xa9 ${new Date().getFullYear()} Pioneer People GmbH</div>
    </div>
    <style>
        ${$de08bbf2a41f1ec8$var$css}
    </style>
`;
class $de08bbf2a41f1ec8$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $de08bbf2a41f1ec8$var$template;
        document.addEventListener("DOMContentLoaded", function() {
            var standortenLink = document.querySelector("#scroll-to-standorten");
            if (standortenLink) standortenLink.addEventListener("click", function(event) {
                event.preventDefault(); // Prevent default anchor behavior
                var targetSection = document.querySelector("#standorten-section");
                if (targetSection) targetSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });
        });
    }
}
customElements.define($de08bbf2a41f1ec8$var$tagName, $de08bbf2a41f1ec8$var$CustomElem);
var $de08bbf2a41f1ec8$export$2e2bcd8739ae039 = "<footer-cont></footer-cont>";


const $c3fa97857733e0d4$var$tagName = "cookie-banner";
const $c3fa97857733e0d4$var$consentCookieName = "cookie-consent-state";
var $c3fa97857733e0d4$var$config = {
    title: "Datenschutzeinstellungen",
    textHTML: `
        Wir nutzen Cookies und andere Technologien, um Inhalte und Anzeigen zu personalisieren und dir die bestm\xf6gliche Nutzung unserer Webseite zu erm\xf6glichen. Die mit Hilfe von Cookies gesammelten Daten werden zur Optimierung der Webseite genutzt. Nat\xfcrlich kannst du deine Entscheidung jederzeit widerrufen oder \xe4ndern. Weitere Informationen findest du in der <a internal href="/datenschutz">Datenschutzerkl\xe4rung</a>.
    `
};
var $c3fa97857733e0d4$var$css = /*css*/ `
    ${$c3fa97857733e0d4$var$tagName} {
        display: none;
        position: fixed;
        bottom: 0;
        background: white;
        width: 100%;
        font-size: 1rem;
        // box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
        z-index: 10001;
    }
    ${$c3fa97857733e0d4$var$tagName} .cookie-buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.5em;
        min-width: 14em;
    }
    ${$c3fa97857733e0d4$var$tagName} button {
        border: none;
        outline: none;
        background: transparent;
        cursor: pointer;
        width: 100%;
        padding: 14px 12px;
        font-family: 'inter-medium', 'sans-serif';
        border-radius: 0.3em;
        box-sizing: border-box;
        font-size: 1.1em;
        white-space: nowrap;
    }
    ${$c3fa97857733e0d4$var$tagName} .cookie-title {
        font-family: 'inter-bold';
        margin-bottom: 0.5em;
        font-size: 1.2em;
    }
    ${$c3fa97857733e0d4$var$tagName} .cookie-text {
        font-size: 0.9em;
        // margin-bottom: 1em;
        line-height: 1.5em;
    }
    ${$c3fa97857733e0d4$var$tagName} .cookie-text a {
        text-decoration: underline;
    }
    ${$c3fa97857733e0d4$var$tagName} #cookie-accept {
        background: var(--gray-brand-gradient);
        // border: 2px solid var(--gray-brand);
        padding: 16px 10px;
        color: white;
        transition: color 300ms;
    }
    ${$c3fa97857733e0d4$var$tagName} #cookie-accept:hover {
        color: var(--blue-brand);
    }
    ${$c3fa97857733e0d4$var$tagName} #cookie-accept span {
        border-bottom: 2px solid var(--blue-brand);
    }
    ${$c3fa97857733e0d4$var$tagName} #cookie-decline {
        // border: 2px solid var(--gray-brand);
        padding: 16px 12px;
        transition: background-color 300ms;
    }
    ${$c3fa97857733e0d4$var$tagName} #cookie-decline:hover {
        background: rgba(0, 0, 0, 0.05);
    }
    ${$c3fa97857733e0d4$var$tagName} .inner {
        max-width: 1920px;
        margin: 0 auto;
        padding: 1em;
        gap: 1em;
        align-items: center;
        font-family: 'inter-light', 'sans-serif';
        display: flex;
    }
    ${$c3fa97857733e0d4$var$tagName} .line {
        height: 0.5rem;
        background: white;
        background: var(--blue-wide-gradient);
        background: var(--light-blue-gradient);
    }
    @media(max-width: 768px){
        ${$c3fa97857733e0d4$var$tagName} .inner {
            flex-direction: column;
        }
        ${$c3fa97857733e0d4$var$tagName} .cookie-buttons {
            width: 100%;
        }
    }
`;
const $c3fa97857733e0d4$var$renderInnerHTML = ()=>{
    return /*html*/ `
        <div class="line"></div>
        <div class="inner">
            <div class="cookie-text-cont">
                <div class="cookie-title">${$c3fa97857733e0d4$var$config.title}</div>
                <div class="cookie-text">${$c3fa97857733e0d4$var$config.textHTML}</div>
            </div>
            <div class="cookie-buttons">
                <button id="cookie-accept"><span>Alle akzeptieren</span></button>
                <button id="cookie-decline">Nur notwendige</button>
            </div>
        </div>
        <style>${$c3fa97857733e0d4$var$css}</style>
    `;
};
class $c3fa97857733e0d4$var$CustomElem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $c3fa97857733e0d4$var$renderInnerHTML();
        this.acceptBtn = this.querySelector("#cookie-accept");
        this.acceptBtn.onclick = ()=>{
            this.accept();
        };
        this.declineBtn = this.querySelector("#cookie-decline");
        this.declineBtn.onclick = ()=>{
            this.decline();
        };
        this.showBannerEvent = eventBus.register("show-cookie-banner", ()=>{
            this.show();
        });
        var currentConsentState = this.readConsentCookie();
        if (!currentConsentState) this.show();
        else if (currentConsentState.marketing) this.accept();
        else this.decline();
    }
    disconnectedCallback() {
        this.showBannerEvent.unregister();
    }
    readConsentCookie() {
        var cookieString = document.cookie;
        if (!cookieString) return null;
        var cookies = cookieString.split(";");
        for(let i = 0; i < cookies.length; i++){
            var c = cookies[i].trim();
            if (c.includes("=")) {
                var name = c.split("=")[0].trim();
                var key = c.split("=")[1];
                if (name == $c3fa97857733e0d4$var$consentCookieName) try {
                    var decodedKey = decodeURIComponent(key);
                    var res = JSON.parse(decodedKey);
                    return res;
                } catch (e) {
                    return null;
                }
            }
        }
    }
    show() {
        document.body.setAttribute("cookie-banner-visible", "true");
        this.style.display = "block";
        document.documentElement.style.setProperty("--cookie-banner-height", `${this.getBoundingClientRect().height}px`);
    }
    hide() {
        document.body.setAttribute("cookie-banner-visible", "false");
        this.style.display = "none";
        document.documentElement.style.setProperty("--cookie-banner-height", `0px`);
    }
    accept() {
        this.hide();
        this.setConsentCookie(true);
        try {
            fbq("consent", "grant");
            ttq.grantConsent();
            ttq.enableCookie();
        } catch  {}
    }
    decline() {
        this.hide();
        this.setConsentCookie(false);
        try {
            fbq("consent", "revoke");
            ttq.revokeConsent();
            ttq.disableCookie();
        } catch  {}
    }
    setConsentCookie(consent) {
        var useCookieValue = encodeURIComponent(JSON.stringify({
            necessary: true,
            marketing: consent,
            statistics: consent
        }));
        document.cookie = `${$c3fa97857733e0d4$var$consentCookieName}=${useCookieValue}; path=/`;
    }
}
customElements.define($c3fa97857733e0d4$var$tagName, $c3fa97857733e0d4$var$CustomElem);
var $c3fa97857733e0d4$export$2e2bcd8739ae039 = `<${$c3fa97857733e0d4$var$tagName}></${$c3fa97857733e0d4$var$tagName}>`;




var $4d4f6843d4cf9c81$var$template = /*html*/ `
    <div class="background"></div>
    ${(0, $467c7a41cb5241d2$export$2e2bcd8739ae039)(`N\xe4chster Starttermin: ${util.formatDate(config.nextStartDate)}`)}
    ${(0, $8c9d82f003a9c3f7$export$2e2bcd8739ae039)}
    ${(0, $de08bbf2a41f1ec8$export$2e2bcd8739ae039)}
    ${(0, $c3fa97857733e0d4$export$2e2bcd8739ae039)}
    <style>
        html, body {
            margin: 0;
            font-family: sans-serif;
        }
        app-cont > .background {
            position: fixed;
            top: -100%;
            left: -100%;
            right: -100%;
            bottom: 50%;
            background: white;
            z-index: -5;
        }
        app-cont a {
            width: fit-content;
        }
    </style>
`;
class $4d4f6843d4cf9c81$var$AppCont extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.innerHTML = $4d4f6843d4cf9c81$var$template;
    }
}
customElements.define("app-cont", $4d4f6843d4cf9c81$var$AppCont);



const $e38c81d8816cc2ca$var$routes = [
    "/",
    "/about",
    "/vermittler",
    "/partner",
    "/404",
    "/404-course",
    "/not-found.html",
    "/career",
    "/courses/pm",
    "/courses/sales",
    "/impressum",
    "/datenschutz",
    "/danke",
    "/danke-sales",
    "/danke-weiterbildungen",
    "/danke-angestellt-genaumeinkurs",
    "/course/",
    "/bildungsgutschein",
    "/blog",
    "/kontakt",
    "/franklin-friends"
];
const $e38c81d8816cc2ca$var$redirects = {
    "/erstgespraech": "/courses/pm"
};
function $e38c81d8816cc2ca$var$route(route, skipEvent = false) {
    var routePath = route.split("#")[0].split("?")[0];
    if (!$e38c81d8816cc2ca$var$routes.includes(routePath) && routePath.slice(0, 8) != "/course/" && !routePath.startsWith("/blog/")) {
        location.href = "/404";
        return;
    }
    history.pushState({}, null, route);
    if (!skipEvent) {
        var eventName = "navigation";
        eventBus.emit(eventName);
    }
}
function $e38c81d8816cc2ca$var$setQueryString(query) {
    var route = location.pathname + "?" + query;
    history.pushState({}, null, route);
    var eventName = "navigation-query";
    eventBus.emit(eventName);
}
function $e38c81d8816cc2ca$var$scrollToTop(instant = false) {
    if (instant) {
        document.documentElement.style.scrollBehavior = "initial";
        setTimeout(()=>{
            document.documentElement.style.scrollBehavior = "smooth";
        }, 500);
        setTimeout(()=>{
            window.scrollTo(0, 0);
        }, 10);
    } else window.scrollTo(0, 0);
}
function $e38c81d8816cc2ca$var$scrollToElement(elemSelector) {
    var elem = document.querySelector(elemSelector);
    if (!elem) return;
    scrollTo(0, window.scrollY + elem.getBoundingClientRect().top - document.querySelector("main-menu .nav-bar-cont").getBoundingClientRect().height);
}
function $e38c81d8816cc2ca$var$handleClicks(e) {
    var useTarget = e.target.closest("a[internal]");
    if (!useTarget) return;
    e.stopPropagation();
    e.preventDefault();
    var useHREF = useTarget.getAttribute("href");
    if (useHREF.includes(location.origin)) useHREF = useHREF.split(location.origin)[1];
    var targetRoute = useHREF.split("#")[0];
    var targetRouteWithHash = useHREF;
    var hash = useHREF.split("#")[1];
    var hashElem = null;
    if (targetRoute == location.pathname) {
        if (targetRouteWithHash != location.pathname + location.hash) $e38c81d8816cc2ca$var$route(targetRouteWithHash, true);
        if (hash) hashElem = document.querySelector("#" + hash);
        if (!hashElem) $e38c81d8816cc2ca$var$scrollToTop();
        else $e38c81d8816cc2ca$var$scrollToElement("#" + hash);
    } else {
        $e38c81d8816cc2ca$var$route(targetRouteWithHash);
        if (hash) hashElem = document.querySelector("#" + hash);
        if (!hashElem) $e38c81d8816cc2ca$var$scrollToTop(true);
        else $e38c81d8816cc2ca$var$scrollToElement("#" + hash);
    }
}
function $e38c81d8816cc2ca$var$init() {
    window.addEventListener("popstate", (e)=>{
        eventBus.emit("navigation");
    });
    var loc = location.pathname;
    if (Object.keys($e38c81d8816cc2ca$var$redirects).includes(loc)) {
        var newLoc = $e38c81d8816cc2ca$var$redirects[loc] + location.search;
        $e38c81d8816cc2ca$var$route($e38c81d8816cc2ca$var$redirects[loc] + location.search);
        return;
    }
    if (!$e38c81d8816cc2ca$var$routes.includes(loc) && loc.slice(0, 8) != "/course/" && !loc.startsWith("/blog/")) {
        location.href = "/404";
        return;
    }
    window.addEventListener("click", $e38c81d8816cc2ca$var$handleClicks);
    window.addEventListener("message", (e)=>{
        eventBus.emit("message", e.data);
    });
}
$e38c81d8816cc2ca$var$init();
var $e38c81d8816cc2ca$export$2e2bcd8739ae039 = {
    route: $e38c81d8816cc2ca$var$route,
    setQueryString: $e38c81d8816cc2ca$var$setQueryString
};





})();
//# sourceMappingURL=script.js.map
